/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./supergraphTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const AccountContactMapFieldsFragmentDoc = gql`
    fragment AccountContactMapFields on AccountContactMapObjectType {
  id
  contactId
  isAdminContact
  label {
    labelText
  }
  contact {
    portalFullName
    contactType
    companyName
  }
  labelGroup {
    id
    displayName
    displayOrder
  }
  positionAcmMaps {
    id
    position {
      id
    }
    lpAccessRoleGrants {
      communicationPref
      lpAccessRole {
        id
        name
      }
    }
  }
}
    `;
export const PositionAcmMapRowFieldsFragmentDoc = gql`
    fragment PositionAcmMapRowFields on PositionAcmMapObjectType {
  id
  position {
    id
    amountCommitted {
      monies
    }
    investmentEntity {
      id
      name
    }
  }
  lpAccessRoleGrants {
    communicationPref
    lpAccessRole {
      id
    }
  }
}
    `;
export const AccountContactMapRowFieldsFragmentDoc = gql`
    fragment AccountContactMapRowFields on AccountContactMapObjectType {
  id
  isAdminContact
  isMainContact
  contact {
    id
    portalFullName
    contactType
    primaryEmail {
      emailAddress
    }
  }
  label {
    labelText
  }
  labelGroup {
    id
    code
    displayName
  }
  positionAcmMaps {
    ...PositionAcmMapRowFields
  }
}
    ${PositionAcmMapRowFieldsFragmentDoc}`;
export const CommunicationPreferenceRoleFieldsFragmentDoc = gql`
    fragment CommunicationPreferenceRoleFields on LpAccessRoleObjectType {
  id
  name
  description
  sortOrder
  newContactDefault
  canInvestorsManage
  lpAccessRoleScopes {
    id
    objectType
    object {
      id
      name
    }
  }
  contactsCount
  isArchived
}
    `;
export const CprMutationErrorFieldsFragmentDoc = gql`
    fragment CprMutationErrorFields on MutationErrorResponse {
  message
  errorCode
}
    `;
export const ContactRelationAccessFieldsFragmentDoc = gql`
    fragment ContactRelationAccessFields on ContactObjectType {
  hasViewContactAccess
  hasEditContactAccess
}
    `;
export const ContactStarredRelationsCardLeanFieldsFragmentDoc = gql`
    fragment ContactStarredRelationsCardLeanFields on ContactObjectType {
  id
  fullName
  jobTitle
  company {
    id
    fullName
  }
  contactType
  thumbnail {
    photoUrl(width: 64, height: 64)
  }
  ...ContactRelationAccessFields
}
    ${ContactRelationAccessFieldsFragmentDoc}`;
export const ContactStarredRelationsRelationRowFieldsFragmentDoc = gql`
    fragment ContactStarredRelationsRelationRowFields on ContactRelationObjectType {
  id
  isContactStarred
  isRelatedContactStarred
  contact {
    ...ContactStarredRelationsCardLeanFields
  }
  relatedContact {
    ...ContactStarredRelationsCardLeanFields
  }
  label
  inverseLabel
  labelSide
  relationLabel {
    sortOrder
  }
  keyPersons {
    isStarred
    relationSide
    contact {
      ...ContactStarredRelationsCardLeanFields
    }
  }
}
    ${ContactStarredRelationsCardLeanFieldsFragmentDoc}`;
export const ContactStarredRelationsListFieldsFragmentDoc = gql`
    fragment ContactStarredRelationsListFields on ContactObjectType {
  ...ContactRelationAccessFields
  relations {
    ...ContactStarredRelationsRelationRowFields
  }
}
    ${ContactRelationAccessFieldsFragmentDoc}
${ContactStarredRelationsRelationRowFieldsFragmentDoc}`;
export const ReportTemplateListFieldsFragmentDoc = gql`
    fragment ReportTemplateListFields on ReportTemplate {
  id
  isActive
  name
  reportType
  updatedAt
  archivedAt
  updatedByUser {
    id
    firstName
    lastName
  }
  archivedByUser {
    id
    firstName
    lastName
  }
  currentVersion {
    id
    status
  }
  versions {
    id
    status
    createdAt
  }
}
    `;
export const AnswerBankAnswerFieldsFragmentDoc = gql`
    fragment AnswerBankAnswerFields on AnswerBankAnswerType {
  id
  answerBankQuestionId
  version
  sourceType
  questionType
  markedNa
  textAnswer
  value
  createdAt
  modifiedAt
  deletedAt
  useCount
  sourceDdqTitle
  sourceLpName
  sourceSubmittedAt
  sourceSubmittedBy {
    id
    fullName
  }
  archivedAt
  archivedBy {
    id
    fullName
  }
  restoredAt
  restoredBy {
    id
    fullName
  }
  lastEditedBy {
    id
    fullName
  }
  tags {
    id
    name
  }
  offerings {
    id
    name
  }
  attachments {
    id
    ddqKbDocumentVersionId
    name
    fileType
  }
}
    `;
export const EmailAttachmentDocumentFieldsFragmentDoc = gql`
    fragment EmailAttachmentDocumentFields on EmailAttachmentObjectType {
  ... on RestrictedDocumentObjectType {
    id
    downloadName
    displayName
  }
  ... on DocumentObjectType {
    id
    downloadName
    displayName
    currentVersion {
      id
      name
      contentType
      extension
      embedUrl
      isPreviewable
    }
  }
}
    `;
export const WalletFieldsFragmentDoc = gql`
    fragment WalletFields on Wallet {
  monies
}
    `;
export const CashFlowHistoryDataFragmentDoc = gql`
    fragment CashFlowHistoryData on CashflowHistoryChartObjectType {
  useContributionsLabel
  contributions {
    date
    runningTotal {
      monies
    }
    transactions {
      id
      amountReceived {
        monies
      }
      capitalCall {
        id
        amountReceived {
          monies
        }
        batch {
          id
          description
          effectiveDate
        }
      }
      batch {
        id
        description
      }
    }
  }
  redemptions {
    date
    runningTotal {
      monies
    }
    transactions {
      id
      amountReceived {
        monies
      }
      batch {
        id
        description
      }
    }
  }
  distributions {
    date
    runningTotal {
      monies
    }
    distributions {
      id
      amountDistributed {
        monies
      }
      batch {
        id
        description
      }
    }
  }
  commitmentDeltas {
    date
    runningTotal {
      monies
    }
    deltas {
      id
      deltaAmountCommitted {
        monies
      }
      fromPosition {
        id
      }
      toPosition {
        id
      }
      fromAccountName
      toAccountName
    }
  }
  currency {
    id
    code
  }
}
    `;
export const PositionAcmMapFieldsFragmentDoc = gql`
    fragment PositionAcmMapFields on PositionAcmMapObjectType {
  id
  position {
    id
  }
  lpAccessRoleGrants {
    communicationPref
    lpAccessRole {
      id
      name
    }
  }
}
    `;
export const PositionTotalsRowFieldsFragmentDoc = gql`
    fragment PositionTotalsRowFields on PositionTotalsRowObjectType {
  investorGroup {
    id
    name
  }
  committed {
    monies
  }
  contributed {
    monies
  }
  capitalOut {
    monies
  }
  distributed {
    monies
  }
  accountValue {
    monies
  }
  capitalAccountBalance {
    monies
  }
  navBalance {
    monies
  }
  investedEquityBalance {
    monies
  }
  unitCount
  unitName
  unitNamePlural
  unitPrecision
  ownershipPercent
  ownershipCalculationMethod
}
    `;
export const MappingUserFieldsFragmentDoc = gql`
    fragment MappingUserFields on UserObjectType {
  id
  fullName
}
    `;
export const MappingFieldsFragmentDoc = gql`
    fragment MappingFields on MappingType {
  id
  name
  fromField
  createdAt
  modifiedAt
  entities {
    id
    name
  }
  createdUser {
    ...MappingUserFields
  }
  lastUpdatedUser {
    ...MappingUserFields
  }
}
    ${MappingUserFieldsFragmentDoc}`;
export const ComplianceCaseFieldsFragmentDoc = gql`
    fragment ComplianceCaseFields on ComplianceCaseType {
  id
  status
  subStatus
  modifiedAt
  resolution
  origin
  programId
  caseType
  comments {
    id
    comment
    format
    internal
    createdBy
  }
  investingProfile {
    riskRating {
      calculatedRating
      overriddenRating
    }
  }
  events(tag: $tag) {
    eventType
    createdAt
  }
}
    `;
export const SnapshotAddressFieldsFragmentDoc = gql`
    fragment SnapshotAddressFields on SnapshotAddressType {
  streetLine1
  streetLine2
  city
  stateProvince
  zipPostalCode
  country
}
    `;
export const SubscriptionSnapshotDetailFieldsFragmentDoc = gql`
    fragment SubscriptionSnapshotDetailFields on SubscriptionSnapshot {
  mainSubscriptionId
  arenaId
  accountId
  positionId
  entityId
  batchId
  prospectId
  accountType
  fundName
  completedAt
  countersignedAt
  subscription {
    prospectName
    invitedDate
    startedDate
    totalInvestment
    numberOfUnits
    unitAmount
    currency
    investmentAmountLabel
    entityName
    status
  }
  account {
    accountTypeOther
    accountTypeJointOther
    name
    isUsPerson
    noTaxId
    taxCountry
    taxIdRedacted
    taxIdEncrypted
    sameDomicileAddress
    mailingAddress {
      ...SnapshotAddressFields
    }
    domicileAddress {
      ...SnapshotAddressFields
    }
    accountTypeSpecific {
      dateOfBirth
      emailAddress
      phoneNumber
      ext
      citizenship
      employer
      jobTitle
      relationship
      formationDate
      isGrantorTrust
      isAcceptableByTrust
      jurisdictionCountry
      jurisdictionState
      erisaQuestion1
      erisaQuestion2
      isDisregardedEntity
      ultimateBeneficialOwner
      taxIdRedacted
      taxIdEncrypted
    }
  }
  subscriberContacts {
    individualContact {
      contactId
      dateOfBirth
      emailAddress
      phoneNumber
      ext
      citizenship
      employer
      jobTitle
    }
    jointOwners {
      contactId
      contactUuid
      name
      dateOfBirth
      emailAddress
      phoneNumber
      ext
      noTaxId
      taxCountry
      taxIdRedacted
      taxIdEncrypted
      citizenship
      isUsPerson
      sameDomicileAddress
      domicileAddress {
        ...SnapshotAddressFields
      }
      employer
      jobTitle
    }
  }
  signatories {
    contactId
    counterpartyType
    counterpartyRole
    entityName
    entityTitle
    name
    jobTitle
    emailAddress
    phoneNumber
    ext
    sameAsInvestorMailingAddress
    mailingAddress {
      ...SnapshotAddressFields
    }
    dateOfBirth
    noTaxId
    taxCountry
    taxIdRedacted
    taxIdEncrypted
    isSignificantBeneficialOwner
    signatureBlockText
  }
  communicationPreferences {
    contactId
    name
    relationship
    emailAddress
    phoneNumber
    ext
    mailingAddress {
      ...SnapshotAddressFields
    }
    distributionListIds
  }
  payments {
    paymentPrefId
  }
  customQuestions {
    sectionId
    promptId
    version
    sectionTitle
    field
    questionForSubscriber
    value
    contactUuid
    selectedChoices {
      choiceId
      text
    }
  }
}
    ${SnapshotAddressFieldsFragmentDoc}`;
export const EntitySectionFieldsFragmentDoc = gql`
    fragment EntitySectionFields on EntitySection {
  included
  hasUnpublishedChanges
  dependsOnSectionIds
  section {
    id
    title
    internalDescription
    enablingLogic
    promptAllResponders
    version
    prompts {
      id
      body
      required
      promptType
      enablingLogic
      increaseTemplate {
        id
        arenaId
        fileName
      }
      templateFile {
        url
        key
        name
      }
      choices {
        id
        body
      }
    }
    footnotes {
      id
      label
      body
    }
    __typename
  }
}
    `;
export const ContactEmailsPhonesFragmentDoc = gql`
    fragment ContactEmailsPhones on ContactObjectType {
  emails {
    id
    emailAddress
    emailType
    isPrimary
  }
  phones {
    id
    phoneNumber
    phoneType
  }
}
    `;
export const DynamicSupportingDocSectionFieldsFragmentDoc = gql`
    fragment DynamicSupportingDocSectionFields on Section {
  __typename
  id
  title
  version
  prompts {
    id
    body
    required
    templateFile {
      url
    }
  }
  footnotes {
    id
    label
    body
  }
}
    `;
export const DynamicSupportingDocLpResponseFieldsFragmentDoc = gql`
    fragment DynamicSupportingDocLpResponseFields on LpResponse {
  id
  promptId
  contactUuid
  files {
    key
    name
    url
  }
  version
}
    `;
export const DynamicCustomSectionPromptFieldsFragmentDoc = gql`
    fragment DynamicCustomSectionPromptFields on Prompt {
  id
  body
  required
  promptType
  choices {
    id
    body
  }
}
    `;
export const DynamicCustomSectionLpPromptFieldsFragmentDoc = gql`
    fragment DynamicCustomSectionLpPromptFields on LpPrompt {
  id
  body
  required
  promptType
  choices {
    id
    body
    followUpPrompts {
      id
      body
      promptType
      required
    }
  }
  applicable
  isFinalPrompt
  hasDependentPrompts
}
    `;
export const DynamicCustomSectionLpResponseFieldsFragmentDoc = gql`
    fragment DynamicCustomSectionLpResponseFields on LpResponse {
  id
  sectionId
  promptId
  version
  contactUuid
  responseType
  value
  valueList
}
    `;
export const FormattedPaymentCountryFragmentDoc = gql`
    fragment FormattedPaymentCountry on CountryObjectType {
  alpha2code
  code
  id
  name
}
    `;
export const FormattedPaymentStateFragmentDoc = gql`
    fragment FormattedPaymentState on StateObjectType {
  code
  id
  name
}
    `;
export const FormattedPaymentSubscriptionAddressFragmentDoc = gql`
    fragment FormattedPaymentSubscriptionAddress on SubscriptionAddressObjectType {
  city
  country {
    ...FormattedPaymentCountry
  }
  postalCode
  region
  state {
    ...FormattedPaymentState
  }
  street
  street2
  street3
}
    ${FormattedPaymentCountryFragmentDoc}
${FormattedPaymentStateFragmentDoc}`;
export const FormattedPaymentCheckFullFragmentDoc = gql`
    fragment FormattedPaymentCheckFull on CheckPaymentPrefObjectType {
  id
  paymentPrefId
  accountHolderType
  address {
    ...FormattedPaymentSubscriptionAddress
  }
  bankCountry {
    ...FormattedPaymentCountry
  }
  bankName
  bankInfoRedacted
  memo
  naturalPersonDateOfBirth
  naturalPersonEmailAddress
  naturalPersonFirstName
  naturalPersonLastName
  naturalPersonMiddleName
  payeeName
  paymentMethod
  useAccountMailingAddress
}
    ${FormattedPaymentSubscriptionAddressFragmentDoc}
${FormattedPaymentCountryFragmentDoc}`;
export const FormattedPaymentAddressFragmentDoc = gql`
    fragment FormattedPaymentAddress on PaymentPrefAddressObjectType {
  city
  country {
    ...FormattedPaymentCountry
  }
  postalCode
  region
  state {
    ...FormattedPaymentState
  }
  street
  street2
  street3
}
    ${FormattedPaymentCountryFragmentDoc}
${FormattedPaymentStateFragmentDoc}`;
export const FormattedPaymentEftFullFragmentDoc = gql`
    fragment FormattedPaymentEftFull on EftPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    name
    institutionNumber
    transitNumber
    address {
      ...FormattedPaymentAddress
    }
  }
  accountName
  accountNumber
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...FormattedPaymentAddress
  }
}
    ${FormattedPaymentAddressFragmentDoc}`;
export const FormattedPaymentSepaFullFragmentDoc = gql`
    fragment FormattedPaymentSepaFull on SepaPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    name
    bicSwiftCode
    address {
      ...FormattedPaymentAddress
    }
  }
  accountName
  iban
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...FormattedPaymentAddress
  }
}
    ${FormattedPaymentAddressFragmentDoc}`;
export const FormattedPaymentBecsFullFragmentDoc = gql`
    fragment FormattedPaymentBecsFull on BecsPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    name
    bsb
    address {
      ...FormattedPaymentAddress
    }
  }
  accountName
  accountNumber
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...FormattedPaymentAddress
  }
}
    ${FormattedPaymentAddressFragmentDoc}`;
export const FormattedPaymentBacsFullFragmentDoc = gql`
    fragment FormattedPaymentBacsFull on BacsPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    name
    sortCode
    address {
      ...FormattedPaymentAddress
    }
  }
  accountName
  accountNumber
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...FormattedPaymentAddress
  }
}
    ${FormattedPaymentAddressFragmentDoc}`;
export const ContactRegardingFieldsFragmentDoc = gql`
    fragment ContactRegardingFields on ContactObjectType {
  id
  fullName
  company {
    id
    fullName
  }
  thumbnail {
    photoUrl(width: 64, height: 64)
    width
    height
  }
  contactType
}
    `;
export const ProspectRegardingFieldsFragmentDoc = gql`
    fragment ProspectRegardingFields on ProspectObjectType {
  id
  title
  formattedTitle
  contacts {
    count
  }
}
    `;
export const PositionRegardingFieldsFragmentDoc = gql`
    fragment PositionRegardingFields on PositionObjectType {
  id
  account {
    id
    name
  }
}
    `;
export const LeadRegardingFieldsFragmentDoc = gql`
    fragment LeadRegardingFields on LeadObjectType {
  id
  fullName
}
    `;
export const AccountRegardingFieldsFragmentDoc = gql`
    fragment AccountRegardingFields on AccountObjectType {
  id
  name
}
    `;
export const CalendarEventObjectFieldsFragmentDoc = gql`
    fragment CalendarEventObjectFields on CalendarEventObjectType {
  title
  description
  startDatetime
  endDatetime
  isAllDay
  id
  createdAt
  location
  user {
    id
    fullName
    emailAddress
  }
  provenance
  entities {
    id
    name
    currency {
      id
      code
      fullName
    }
    lpDisplayName
  }
  offerings {
    id
    name
    currency {
      id
      code
      fullName
    }
    lpDisplayName
  }
  isPrivate
  users {
    id
    fullName
    emailAddress
  }
  attachments {
    documentId
    documentName
    documentVersion {
      id
      downloadUrl
    }
  }
  primaryMeetingUrl
  calendarEventContacts: contacts {
    id
    fullName
    firstName
    lastName
    company {
      fullName
    }
    thumbnail {
      photoUrl(width: 64, height: 64)
      width
      height
    }
    contactType
  }
  __typename
}
    `;
export const AttachmentFieldsFragmentDoc = gql`
    fragment AttachmentFields on ActivityAttachmentObjectType {
  documentId
  documentName
}
    `;
export const EmailObjectFieldsFragmentDoc = gql`
    fragment EmailObjectFields on EmailObjectType {
  id
  emailBodyHtml: bodyHtml
  bodyText
  subject
  regarding {
    ... on ProspectObjectType {
      ...ProspectRegardingFields
    }
  }
  dateSent
  sendFailed
  emailBatchId
  recipientInfo {
    id
    name
    objectType
  }
  emailRecipients: recipients {
    edges {
      node {
        id
        name
        emailAddress
        recipientType
        contactId
      }
    }
  }
  attachments {
    ...AttachmentFields
  }
  emailType
  senderName
  __typename
}
    ${ProspectRegardingFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}`;
export const StoredEmailObjectFieldsFragmentDoc = gql`
    fragment StoredEmailObjectFields on StoredEmailObjectType {
  id
  bodyHtml
  bodyText
  storedEmailSubject: subject
  storedEmailDateSent: dateTime
  storedEmailSender: sender
  activityFeedOwnerName
  entities {
    id
    name
    currency {
      id
      code
      fullName
    }
    lpDisplayName
  }
  offerings {
    id
    name
    currency {
      id
      code
      fullName
    }
    lpDisplayName
  }
  regarding {
    ... on ProspectObjectType {
      ...ProspectRegardingFields
    }
    ... on PositionObjectType {
      ...PositionRegardingFields
    }
    ... on ContactObjectType {
      ...ContactRegardingFields
    }
  }
  storedEmailPeople: people {
    edges {
      node {
        id
        fullName
        firstName
        lastName
        company {
          fullName
        }
        thumbnail {
          photoUrl(width: 64, height: 64)
          width
          height
        }
        contactType
      }
    }
  }
  storedEmailOrganizations: organizations {
    edges {
      node {
        id
        fullName
        firstName
        lastName
        company {
          fullName
        }
        contactType
      }
    }
  }
  attachments {
    ...AttachmentFields
  }
  __typename
}
    ${ProspectRegardingFieldsFragmentDoc}
${PositionRegardingFieldsFragmentDoc}
${ContactRegardingFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}`;
export const ActivityTypeFieldsFragmentDoc = gql`
    fragment ActivityTypeFields on ActivityTypeObjectType {
  id
  name
  arenaId
}
    `;
export const ExtensionFieldFieldsFragmentDoc = gql`
    fragment ExtensionFieldFields on ExtensionFieldTuple {
  extensionField {
    id
    name
    extensionFieldTypeId
    enumValues {
      id
      enumValueCode
      enumValueLabel
      enumName
    }
    isMultivalued
  }
  values {
    id
    enumValue {
      id
      enumValueLabel
      enumName
      enumValueCode
    }
    intValue
    floatValue
    stringValue
    dateValue
    currencyValue {
      monies
    }
  }
}
    `;
export const NoteObjectFieldsFragmentDoc = gql`
    fragment NoteObjectFields on NoteObjectType {
  text
  summary
  noteType
  contentType
  date
  time
  location
  provenance
  id
  bodyText
  bodyHtml
  createdAt
  offerings {
    id
    name
    currency {
      id
      code
      fullName
    }
    lpDisplayName
  }
  entities {
    id
    name
  }
  staff {
    fullName
    id
  }
  people {
    id
    fullName
    firstName
    lastName
    company {
      fullName
    }
    thumbnail {
      photoUrl(width: 64, height: 64)
      width
      height
    }
    contactType
  }
  organizations {
    id
    fullName
    contactType
    thumbnail {
      photoUrl(width: 64, height: 64)
      width
      height
    }
  }
  owner {
    id
    fullName
    firstName
    lastName
  }
  tags {
    id
    tagText
  }
  sortDatetime
  attachments {
    ...AttachmentFields
  }
  activityType {
    ...ActivityTypeFields
  }
  extensionFields {
    ...ExtensionFieldFields
  }
  objectType
  objectId
  objectTitle
  __typename
}
    ${AttachmentFieldsFragmentDoc}
${ActivityTypeFieldsFragmentDoc}
${ExtensionFieldFieldsFragmentDoc}`;
export const ActivityObjectFieldsFragmentDoc = gql`
    fragment ActivityObjectFields on ContactActivityFeedObjectType {
  ... on EmailObjectType {
    ...EmailObjectFields
  }
  ... on StoredEmailObjectType {
    ...StoredEmailObjectFields
  }
  ... on NoteObjectType {
    ...NoteObjectFields
  }
  ... on CalendarEventObjectType {
    ...CalendarEventObjectFields
  }
}
    ${EmailObjectFieldsFragmentDoc}
${StoredEmailObjectFieldsFragmentDoc}
${NoteObjectFieldsFragmentDoc}
${CalendarEventObjectFieldsFragmentDoc}`;
export const ContactActivityFeedFieldsFragmentDoc = gql`
    fragment ContactActivityFeedFields on ContactActivityFeedsObjectType {
  regarding {
    ... on ContactObjectType {
      ...ContactRegardingFields
    }
    ... on ProspectObjectType {
      ...ProspectRegardingFields
    }
    ... on PositionObjectType {
      ...PositionRegardingFields
    }
    ... on LeadObjectType {
      ...LeadRegardingFields
    }
    ... on AccountObjectType {
      ...AccountRegardingFields
    }
    ... on CalendarEventObjectType {
      ...CalendarEventObjectFields
    }
  }
  editedBy
  editedAt
  activityType
  activityObject {
    ...ActivityObjectFields
  }
}
    ${ContactRegardingFieldsFragmentDoc}
${ProspectRegardingFieldsFragmentDoc}
${PositionRegardingFieldsFragmentDoc}
${LeadRegardingFieldsFragmentDoc}
${AccountRegardingFieldsFragmentDoc}
${CalendarEventObjectFieldsFragmentDoc}
${ActivityObjectFieldsFragmentDoc}`;
export const ProspectActivityFeedFieldsFragmentDoc = gql`
    fragment ProspectActivityFeedFields on ProspectActivityFeedObjectType {
  regarding {
    ... on ProspectObjectType {
      ...ProspectRegardingFields
    }
    ... on AccountObjectType {
      ...AccountRegardingFields
    }
    ... on CalendarEventObjectType {
      ...CalendarEventObjectFields
    }
  }
  editedBy
  editedAt
  activityType
  activityObject {
    ...ActivityObjectFields
  }
}
    ${ProspectRegardingFieldsFragmentDoc}
${AccountRegardingFieldsFragmentDoc}
${CalendarEventObjectFieldsFragmentDoc}
${ActivityObjectFieldsFragmentDoc}`;
export const PositionActivityFeedFieldsFragmentDoc = gql`
    fragment PositionActivityFeedFields on PositionActivityFeedsObjectType {
  regarding {
    ... on PositionObjectType {
      ...PositionRegardingFields
    }
    ... on AccountObjectType {
      ...AccountRegardingFields
    }
    ... on CalendarEventObjectType {
      ...CalendarEventObjectFields
    }
  }
  editedBy
  editedAt
  activityType
  activityObject {
    ...ActivityObjectFields
  }
}
    ${PositionRegardingFieldsFragmentDoc}
${AccountRegardingFieldsFragmentDoc}
${CalendarEventObjectFieldsFragmentDoc}
${ActivityObjectFieldsFragmentDoc}`;
export const LeadActivityFeedFieldsFragmentDoc = gql`
    fragment LeadActivityFeedFields on LeadActivityFeedsObjectType {
  regarding {
    ... on LeadObjectType {
      ...LeadRegardingFields
    }
    ... on AccountObjectType {
      ...AccountRegardingFields
    }
  }
  editedBy
  editedAt
  activityType
  activityObject {
    ...ActivityObjectFields
  }
}
    ${LeadRegardingFieldsFragmentDoc}
${AccountRegardingFieldsFragmentDoc}
${ActivityObjectFieldsFragmentDoc}`;
export const OfferingRegardingFieldsFragmentDoc = gql`
    fragment OfferingRegardingFields on OfferingObjectType {
  id
  name
}
    `;
export const EmailBatchObjectFieldsFragmentDoc = gql`
    fragment EmailBatchObjectFields on EmailBatchObjectType {
  id
  body
  subject
  emailBatchSenderName: senderName
  dateSent
  recipients {
    toAddresses {
      name
    }
    ccAddresses {
      name
    }
    bccAddresses {
      name
    }
    recipientTitle
    recipientObjectId
    recipientObjectType
  }
  attachedDocuments {
    ... on DocumentObjectType {
      id
      downloadName
    }
    ... on RestrictedDocumentObjectType {
      id
      downloadName
    }
  }
  sender {
    id
    fullName
    lastName
  }
  __typename
}
    `;
export const CapitalCallBatchObjectFieldsFragmentDoc = gql`
    fragment CapitalCallBatchObjectFields on CapitalCallBatchObjectType {
  id
  description
  entity {
    id
    name
    published
  }
  effectiveDate
  __typename
}
    `;
export const ActivityDistributionBatchFieldsFragmentDoc = gql`
    fragment ActivityDistributionBatchFields on DistributionBatchObjectType {
  id
  description
  effectiveDate
  entity {
    id
    name
  }
  dateRecallable
  excludeFromYield
  periodEndDate
  noun
  viewRoute
  published
  status
  storedTotals {
    id
    amount {
      monies
    }
    amountRecallable {
      monies
    }
  }
  __typename
}
    `;
export const ManagementFeeBatchObjectFieldsFragmentDoc = gql`
    fragment ManagementFeeBatchObjectFields on ManagementFeeBatchObjectType {
  id
  description
  entity {
    id
    name
    published
  }
  dateDue
  __typename
}
    `;
export const NetIncomeBatchObjectFieldsFragmentDoc = gql`
    fragment NetIncomeBatchObjectFields on NetIncomeBatchObjectType {
  id
  description
  entity {
    id
    name
    published
  }
  effectiveDate
  __typename
}
    `;
export const DashboardActivityObjectFieldsFragmentDoc = gql`
    fragment DashboardActivityObjectFields on DashboardActivityUnionFeedObjectType {
  ... on EmailObjectType {
    ...EmailObjectFields
  }
  ... on EmailBatchObjectType {
    ...EmailBatchObjectFields
  }
  ... on NoteObjectType {
    ...NoteObjectFields
  }
  ... on StoredEmailObjectType {
    ...StoredEmailObjectFields
  }
  ... on CapitalCallBatchObjectType {
    ...CapitalCallBatchObjectFields
  }
  ... on DistributionBatchObjectType {
    ...ActivityDistributionBatchFields
  }
  ... on ManagementFeeBatchObjectType {
    ...ManagementFeeBatchObjectFields
  }
  ... on NetIncomeBatchObjectType {
    ...NetIncomeBatchObjectFields
  }
  ... on CalendarEventObjectType {
    ...CalendarEventObjectFields
  }
}
    ${EmailObjectFieldsFragmentDoc}
${EmailBatchObjectFieldsFragmentDoc}
${NoteObjectFieldsFragmentDoc}
${StoredEmailObjectFieldsFragmentDoc}
${CapitalCallBatchObjectFieldsFragmentDoc}
${ActivityDistributionBatchFieldsFragmentDoc}
${ManagementFeeBatchObjectFieldsFragmentDoc}
${NetIncomeBatchObjectFieldsFragmentDoc}
${CalendarEventObjectFieldsFragmentDoc}`;
export const DashboardActivityFeedFieldsFragmentDoc = gql`
    fragment DashboardActivityFeedFields on DashboardActivityFeedObjectType {
  regarding {
    __typename
    ... on ContactObjectType {
      ...ContactRegardingFields
    }
    ... on ProspectObjectType {
      ...ProspectRegardingFields
    }
    ... on PositionObjectType {
      ...PositionRegardingFields
    }
    ... on LeadObjectType {
      ...LeadRegardingFields
    }
    ... on OfferingObjectType {
      ...OfferingRegardingFields
    }
    ... on AccountObjectType {
      ...AccountRegardingFields
    }
    ... on CalendarEventObjectType {
      ...CalendarEventObjectFields
    }
  }
  effectiveDate
  editedBy
  editedAt
  activityType
  activityObject {
    ...DashboardActivityObjectFields
  }
}
    ${ContactRegardingFieldsFragmentDoc}
${ProspectRegardingFieldsFragmentDoc}
${PositionRegardingFieldsFragmentDoc}
${LeadRegardingFieldsFragmentDoc}
${OfferingRegardingFieldsFragmentDoc}
${AccountRegardingFieldsFragmentDoc}
${CalendarEventObjectFieldsFragmentDoc}
${DashboardActivityObjectFieldsFragmentDoc}`;
export const NewProfileFragmentDoc = gql`
    fragment NewProfile on ProfileType {
  id
  complianceObjectType
  legalName
  firstName
  middleName
  lastName
}
    `;
export const CountryFieldsFragmentDoc = gql`
    fragment CountryFields on CountryType {
  id
  name
  alpha2code
}
    `;
export const StateFieldsFragmentDoc = gql`
    fragment StateFields on StateType {
  id
  name
  code
}
    `;
export const ProfileAddressFieldsFragmentDoc = gql`
    fragment ProfileAddressFields on ProfileAddressType {
  id
  street
  street2
  street3
  city
  postalCode
  province
  country {
    ...CountryFields
  }
  state {
    ...StateFields
  }
}
    ${CountryFieldsFragmentDoc}
${StateFieldsFragmentDoc}`;
export const ComplianceDocumentFieldsFragmentDoc = gql`
    fragment ComplianceDocumentFields on DocumentType {
  id
  name
  s3Link
  contentType
  documentPurpose {
    baseType
    expires
    complianceObjectType
  }
  metadata {
    key
    value
    type
  }
}
    `;
export const ProfileFieldsFragmentDoc = gql`
    fragment ProfileFields on ProfileType {
  id
  taxIdType
  taxIdUnencryptedLast4Digits
  complianceObjectType
  addresses {
    ...ProfileAddressFields
  }
  documents {
    ...ComplianceDocumentFields
  }
}
    ${ProfileAddressFieldsFragmentDoc}
${ComplianceDocumentFieldsFragmentDoc}`;
export const EntityProfileFragmentDoc = gql`
    fragment EntityProfile on ProfileType {
  ...ProfileFields
  legalName
  accountType
  dateOfOrganization
  natureOfBusiness
  organizationalJurisdiction {
    ...CountryFields
  }
  entityOwnershipDomiciles {
    id
    countryId
  }
  industries {
    id
    industryId
    industryName
  }
}
    ${ProfileFieldsFragmentDoc}
${CountryFieldsFragmentDoc}`;
export const IndividualProfileFragmentDoc = gql`
    fragment IndividualProfile on ProfileType {
  ...ProfileFields
  dateOfBirth
  firstName
  middleName
  lastName
  countryOfCitizenship {
    ...CountryFields
  }
}
    ${ProfileFieldsFragmentDoc}
${CountryFieldsFragmentDoc}`;
export const ReissuePaymentPrefFullFragmentDoc = gql`
    fragment ReissuePaymentPrefFull on PaymentPrefUnionObjectType {
  __typename
  ... on AchPaymentPrefObjectType {
    bankName
    routingNumber
    accountNumber
    accountName
    accountType
    accountOwnership
    additionalInstructions
  }
  ... on WirePaymentPrefObjectType {
    beneficiaryName
    beneficiaryAccountNumber
    referenceToBeneficiary
    wireObi {
      field0
      field1
      field2
      field3
    }
    bank {
      name
      abaNumber
    }
  }
  ... on CheckPaymentPrefObjectType {
    paymentPrefId
  }
}
    `;
export const PositionDetailsForTableFragmentDoc = gql`
    fragment PositionDetailsForTable on PositionObjectType {
  id
  investmentEntity {
    id
    name
  }
  paymentPref {
    id
    paymentMethod
    paymentPrefFull {
      ... on AchPaymentPrefObjectType {
        accountName
        accountNumber
      }
      ... on WirePaymentPrefObjectType {
        beneficiaryName
        beneficiaryAccountNumber
      }
      ... on CheckPaymentPrefObjectType {
        payeeName
      }
      ... on EftPaymentPrefObjectType {
        accountName
        accountNumber
      }
      ... on SepaPaymentPrefObjectType {
        accountName
        iban
      }
      ... on BecsPaymentPrefObjectType {
        accountName
        accountNumber
      }
      ... on BacsPaymentPrefObjectType {
        accountName
        accountNumber
      }
    }
  }
}
    `;
export const PositionListForTableFragmentDoc = gql`
    fragment PositionListForTable on PositionConnection {
  count
  edges {
    node {
      ...PositionDetailsForTable
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    ${PositionDetailsForTableFragmentDoc}`;
export const CountryFullFragmentDoc = gql`
    fragment CountryFull on CountryObjectType {
  alpha2code
  code
  id
  name
}
    `;
export const StateFullFragmentDoc = gql`
    fragment StateFull on StateObjectType {
  code
  id
  name
}
    `;
export const AchPaymentPrefFullFragmentDoc = gql`
    fragment AchPaymentPrefFull on AchPaymentPrefObjectType {
  id
  paymentPrefId
  accountHolderType
  accountName
  accountNumber
  accountOwnership
  accountType
  additionalInstructions
  bankInfoRedacted
  bankName
  naturalPersonDateOfBirth
  naturalPersonEmailAddress
  naturalPersonFirstName
  naturalPersonLastName
  naturalPersonMiddleName
  paymentMethod
  routingNumber
  signatureFullName
}
    `;
export const SubscriptionAddressFullFragmentDoc = gql`
    fragment SubscriptionAddressFull on SubscriptionAddressObjectType {
  city
  country {
    ...CountryFull
  }
  postalCode
  region
  state {
    ...StateFull
  }
  street
  street2
  street3
}
    ${CountryFullFragmentDoc}
${StateFullFragmentDoc}`;
export const WireBankFullFragmentDoc = gql`
    fragment WireBankFull on WireBankObjectType {
  abaNumber
  address {
    ...SubscriptionAddressFull
  }
  intlRoutingCode
  name
  swiftCode
}
    ${SubscriptionAddressFullFragmentDoc}`;
export const WireExtraFieldFullFragmentDoc = gql`
    fragment WireExtraFieldFull on WireExtraFieldObjectType {
  field0
  field1
  field2
  field3
}
    `;
export const WirePaymentPrefFullFragmentDoc = gql`
    fragment WirePaymentPrefFull on WirePaymentPrefObjectType {
  id
  paymentPrefId
  bank {
    ...WireBankFull
  }
  bankInfoRedacted
  beneficiaryAccountNumber
  beneficiaryAddress {
    ...SubscriptionAddressFull
  }
  beneficiaryName
  beneficiaryType
  intermediaryBank {
    ...WireBankFull
  }
  naturalPersonDateOfBirth
  naturalPersonEmailAddress
  naturalPersonFirstName
  naturalPersonLastName
  naturalPersonMiddleName
  paymentMethod
  referenceToBeneficiary
  wireBbi {
    ...WireExtraFieldFull
  }
  wireObi {
    ...WireExtraFieldFull
  }
}
    ${WireBankFullFragmentDoc}
${SubscriptionAddressFullFragmentDoc}
${WireExtraFieldFullFragmentDoc}`;
export const CheckPaymentPrefFullFragmentDoc = gql`
    fragment CheckPaymentPrefFull on CheckPaymentPrefObjectType {
  id
  paymentPrefId
  accountHolderType
  address {
    ...SubscriptionAddressFull
  }
  bankCountry {
    ...CountryFull
  }
  bankName
  memo
  naturalPersonDateOfBirth
  naturalPersonEmailAddress
  naturalPersonFirstName
  naturalPersonLastName
  naturalPersonMiddleName
  payeeName
  paymentMethod
  useAccountMailingAddress
  bankInfoRedacted
}
    ${SubscriptionAddressFullFragmentDoc}
${CountryFullFragmentDoc}`;
export const PaymentPrefAddressFullFragmentDoc = gql`
    fragment PaymentPrefAddressFull on PaymentPrefAddressObjectType {
  city
  country {
    ...CountryFull
  }
  postalCode
  region
  state {
    ...StateFull
  }
  street
  street2
  street3
}
    ${CountryFullFragmentDoc}
${StateFullFragmentDoc}`;
export const EftBankFullFragmentDoc = gql`
    fragment EftBankFull on EftBankObjectType {
  name
  institutionNumber
  transitNumber
  address {
    ...PaymentPrefAddressFull
  }
}
    ${PaymentPrefAddressFullFragmentDoc}`;
export const EftPaymentPrefFullFragmentDoc = gql`
    fragment EftPaymentPrefFull on EftPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    ...EftBankFull
  }
  accountName
  accountNumber
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...PaymentPrefAddressFull
  }
}
    ${EftBankFullFragmentDoc}
${PaymentPrefAddressFullFragmentDoc}`;
export const SepaBankFullFragmentDoc = gql`
    fragment SepaBankFull on SepaBankObjectType {
  name
  bicSwiftCode
  address {
    ...PaymentPrefAddressFull
  }
}
    ${PaymentPrefAddressFullFragmentDoc}`;
export const SepaPaymentPrefFullFragmentDoc = gql`
    fragment SepaPaymentPrefFull on SepaPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    ...SepaBankFull
  }
  accountName
  iban
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...PaymentPrefAddressFull
  }
}
    ${SepaBankFullFragmentDoc}
${PaymentPrefAddressFullFragmentDoc}`;
export const BecsBankFullFragmentDoc = gql`
    fragment BecsBankFull on BecsBankObjectType {
  name
  bsb
  address {
    ...PaymentPrefAddressFull
  }
}
    ${PaymentPrefAddressFullFragmentDoc}`;
export const BecsPaymentPrefFullFragmentDoc = gql`
    fragment BecsPaymentPrefFull on BecsPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    ...BecsBankFull
  }
  accountName
  accountNumber
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...PaymentPrefAddressFull
  }
}
    ${BecsBankFullFragmentDoc}
${PaymentPrefAddressFullFragmentDoc}`;
export const BacsBankFullFragmentDoc = gql`
    fragment BacsBankFull on BacsBankObjectType {
  name
  sortCode
  address {
    ...PaymentPrefAddressFull
  }
}
    ${PaymentPrefAddressFullFragmentDoc}`;
export const BacsPaymentPrefFullFragmentDoc = gql`
    fragment BacsPaymentPrefFull on BacsPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    ...BacsBankFull
  }
  accountName
  accountNumber
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...PaymentPrefAddressFull
  }
}
    ${BacsBankFullFragmentDoc}
${PaymentPrefAddressFullFragmentDoc}`;
export const DetailedPaymentPrefFragmentDoc = gql`
    fragment DetailedPaymentPref on PaymentPrefObjectType {
  id
  paymentMethod
  checkAddrCity
  checkAddrCountry {
    ...CountryFull
  }
  checkAddrCountryId
  checkAddrPostalCode
  checkAddrRegion
  checkAddrState {
    ...StateFull
  }
  checkAddrStateId
  checkAddrStreet
  checkAddrStreet2
  checkAddrStreet3
  checkMailingAddressSameAsAccount
  checkMemoField
  checkPayeeOverride
  verificationStatus
  wireHasIntermediary
  wireHasInternationalBeneficiaryAddress
  returnCode
  codeReason
  paymentPrefFull {
    __typename
    ... on AchPaymentPrefObjectType {
      ...AchPaymentPrefFull
    }
    ... on WirePaymentPrefObjectType {
      ...WirePaymentPrefFull
    }
    ... on CheckPaymentPrefObjectType {
      ...CheckPaymentPrefFull
    }
    ... on EftPaymentPrefObjectType {
      ...EftPaymentPrefFull
    }
    ... on SepaPaymentPrefObjectType {
      ...SepaPaymentPrefFull
    }
    ... on BecsPaymentPrefObjectType {
      ...BecsPaymentPrefFull
    }
    ... on BacsPaymentPrefObjectType {
      ...BacsPaymentPrefFull
    }
    ... on NonUsPaymentPrefObjectType {
      id
      paymentPrefId
    }
  }
}
    ${CountryFullFragmentDoc}
${StateFullFragmentDoc}
${AchPaymentPrefFullFragmentDoc}
${WirePaymentPrefFullFragmentDoc}
${CheckPaymentPrefFullFragmentDoc}
${EftPaymentPrefFullFragmentDoc}
${SepaPaymentPrefFullFragmentDoc}
${BecsPaymentPrefFullFragmentDoc}
${BacsPaymentPrefFullFragmentDoc}`;
export const AccountDetailsFragmentDoc = gql`
    fragment AccountDetails on AccountObjectType {
  id
  name
  mailingAddress {
    street
    street2
    street3
    city
    region
    state {
      objectName
      objectId
    }
    country {
      objectName
      objectId
    }
    postalCode
  }
}
    `;
export const AchPaymentPrefDisplayFragmentDoc = gql`
    fragment AchPaymentPrefDisplay on AchPaymentPrefObjectType {
  bankName
  routingNumber
  accountNumber
  accountName
  accountType
  accountOwnership
  additionalInstructions
}
    `;
export const WirePaymentPrefDisplayFragmentDoc = gql`
    fragment WirePaymentPrefDisplay on WirePaymentPrefObjectType {
  beneficiaryName
  beneficiaryAccountNumber
  referenceToBeneficiary
  beneficiaryAddress {
    street
    street2
    street3
    city
    postalCode
    region
    state {
      name
    }
    country {
      name
    }
  }
  wireObi {
    field0
    field1
    field2
    field3
  }
  wireBbi {
    field0
    field1
    field2
    field3
  }
  bank {
    name
    abaNumber
    swiftCode
    intlRoutingCode
    address {
      street
      street2
      street3
      city
      postalCode
      region
      state {
        name
      }
      country {
        name
      }
    }
  }
  intermediaryBank {
    name
    address {
      street
      street2
      street3
      city
      postalCode
      region
      state {
        name
      }
      country {
        name
      }
    }
    abaNumber
    swiftCode
    intlRoutingCode
  }
}
    `;
export const InvestmentTotalsFieldsFragmentDoc = gql`
    fragment InvestmentTotalsFields on InvestmentTotals {
  acquisitionDate
  unitCount
  unitCost {
    monies
  }
  unitValue {
    monies
  }
  cost {
    monies
  }
  fairValue {
    monies
  }
  unrealizedGainOrLoss {
    monies
  }
}
    `;
export const DistributionTypeFragmentFragmentDoc = gql`
    fragment DistributionTypeFragment on DistributionTypeObjectType {
  id
  name
  isReturnOfCapital
  isWithholding
  sortOrder
  excludeFromYield
}
    `;
export const DistributionDetailFragmentFragmentDoc = gql`
    fragment DistributionDetailFragment on DistributionDetailObjectType {
  id
  amountDistributed {
    monies
  }
  amountRecallable {
    monies
  }
  sortOrder
  transactionType {
    ...DistributionTypeFragment
  }
}
    ${DistributionTypeFragmentFragmentDoc}`;
export const CurrencyFieldsFederationFragmentDoc = gql`
    fragment CurrencyFieldsFederation on CurrencyObjectType {
  id
  code
  fullName
  symbol
  flagUnicode
}
    `;
export const GetChangeRequestsDocument = gql`
    query GetChangeRequests($objectInput: ChangeRequestQueryInput!) {
  changeRequests(objectInput: $objectInput) {
    ... on ChangeRequestQueryResponse {
      totalCount
      nextCursor
      hasNextPage
      approvalRequests {
        id
        status
        account {
          id
          name
          isInvestmentEntity
        }
        changeRequester {
          ... on UserObjectType {
            id
            userFullName: fullName
            contactFullName
          }
        }
        changeRequest {
          changeRequestType
          changeRequestedObj {
            ... on ChangeRequestedObj {
              name
            }
            ... on ContactObjectType {
              id
              fullName
              portalFullName
            }
            ... on DocumentObjectType {
              id
              name
              isCollection
              mappedMemberCount
            }
          }
        }
        changeRequestArena {
          id
          name
        }
        requestedAt
        statusUpdatedAt
        statusUpdatedBy {
          ... on UserObjectType {
            firstName
            lastName
          }
        }
        note
        approverNote
        objectType
      }
    }
    ... on QueryErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetChangeRequestsQuery__
 *
 * To run a query within a React component, call `useGetChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChangeRequestsQuery({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useGetChangeRequestsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables> & ({ variables: GraphqlTypes.GetChangeRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>(GetChangeRequestsDocument, options);
      }
export function useGetChangeRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>(GetChangeRequestsDocument, options);
        }
// @ts-ignore
export function useGetChangeRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>;
export function useGetChangeRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChangeRequestsQuery | undefined, GraphqlTypes.GetChangeRequestsQueryVariables>;
export function useGetChangeRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>(GetChangeRequestsDocument, options);
        }
export type GetChangeRequestsQueryHookResult = ReturnType<typeof useGetChangeRequestsQuery>;
export type GetChangeRequestsLazyQueryHookResult = ReturnType<typeof useGetChangeRequestsLazyQuery>;
export type GetChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useGetChangeRequestsSuspenseQuery>;
export type GetChangeRequestsQueryResult = Apollo.QueryResult<GraphqlTypes.GetChangeRequestsQuery, GraphqlTypes.GetChangeRequestsQueryVariables>;
export const TransitionDocumentStatusDocument = gql`
    mutation TransitionDocumentStatus($input: TransitionDocumentStatusInput!) {
  transitionDocumentStatus(input: $input) {
    ... on TransitionDocumentStatusResponse {
      document {
        id
        reviewStatus
      }
      message
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type TransitionDocumentStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.TransitionDocumentStatusMutation, GraphqlTypes.TransitionDocumentStatusMutationVariables>;

/**
 * __useTransitionDocumentStatusMutation__
 *
 * To run a mutation, you first call `useTransitionDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionDocumentStatusMutation, { data, loading, error }] = useTransitionDocumentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionDocumentStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.TransitionDocumentStatusMutation, GraphqlTypes.TransitionDocumentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.TransitionDocumentStatusMutation, GraphqlTypes.TransitionDocumentStatusMutationVariables>(TransitionDocumentStatusDocument, options);
      }
export type TransitionDocumentStatusMutationHookResult = ReturnType<typeof useTransitionDocumentStatusMutation>;
export type TransitionDocumentStatusMutationResult = Apollo.MutationResult<GraphqlTypes.TransitionDocumentStatusMutation>;
export type TransitionDocumentStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.TransitionDocumentStatusMutation, GraphqlTypes.TransitionDocumentStatusMutationVariables>;
export const DiscardESignatureDraftDocument = gql`
    mutation DiscardESignatureDraft($objectInput: DiscardESignatureDraftInputObjectType!) {
  discardESignatureDraft(objectInput: $objectInput) {
    ... on ESignatureRequestTemplateObjectType {
      id
      title
      status
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type DiscardESignatureDraftMutationFn = Apollo.MutationFunction<GraphqlTypes.DiscardESignatureDraftMutation, GraphqlTypes.DiscardESignatureDraftMutationVariables>;

/**
 * __useDiscardESignatureDraftMutation__
 *
 * To run a mutation, you first call `useDiscardESignatureDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardESignatureDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardESignatureDraftMutation, { data, loading, error }] = useDiscardESignatureDraftMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDiscardESignatureDraftMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DiscardESignatureDraftMutation, GraphqlTypes.DiscardESignatureDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DiscardESignatureDraftMutation, GraphqlTypes.DiscardESignatureDraftMutationVariables>(DiscardESignatureDraftDocument, options);
      }
export type DiscardESignatureDraftMutationHookResult = ReturnType<typeof useDiscardESignatureDraftMutation>;
export type DiscardESignatureDraftMutationResult = Apollo.MutationResult<GraphqlTypes.DiscardESignatureDraftMutation>;
export type DiscardESignatureDraftMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DiscardESignatureDraftMutation, GraphqlTypes.DiscardESignatureDraftMutationVariables>;
export const EditContactsBulkDocument = gql`
    mutation EditContactsBulk($input: EditContactsBulkInput!) {
  editContactsBulk(input: $input) {
    ... on EditContactsBulkPayload {
      job {
        id
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type EditContactsBulkMutationFn = Apollo.MutationFunction<GraphqlTypes.EditContactsBulkMutation, GraphqlTypes.EditContactsBulkMutationVariables>;

/**
 * __useEditContactsBulkMutation__
 *
 * To run a mutation, you first call `useEditContactsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContactsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContactsBulkMutation, { data, loading, error }] = useEditContactsBulkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditContactsBulkMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditContactsBulkMutation, GraphqlTypes.EditContactsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditContactsBulkMutation, GraphqlTypes.EditContactsBulkMutationVariables>(EditContactsBulkDocument, options);
      }
export type EditContactsBulkMutationHookResult = ReturnType<typeof useEditContactsBulkMutation>;
export type EditContactsBulkMutationResult = Apollo.MutationResult<GraphqlTypes.EditContactsBulkMutation>;
export type EditContactsBulkMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditContactsBulkMutation, GraphqlTypes.EditContactsBulkMutationVariables>;
export const AccountContactLabelGroupsDocument = gql`
    query AccountContactLabelGroups {
  accountContactLabelGroups {
    id
    displayName
    displayOrder
  }
}
    `;

/**
 * __useAccountContactLabelGroupsQuery__
 *
 * To run a query within a React component, call `useAccountContactLabelGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContactLabelGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContactLabelGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountContactLabelGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>(AccountContactLabelGroupsDocument, options);
      }
export function useAccountContactLabelGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>(AccountContactLabelGroupsDocument, options);
        }
// @ts-ignore
export function useAccountContactLabelGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>;
export function useAccountContactLabelGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountContactLabelGroupsQuery | undefined, GraphqlTypes.AccountContactLabelGroupsQueryVariables>;
export function useAccountContactLabelGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>(AccountContactLabelGroupsDocument, options);
        }
export type AccountContactLabelGroupsQueryHookResult = ReturnType<typeof useAccountContactLabelGroupsQuery>;
export type AccountContactLabelGroupsLazyQueryHookResult = ReturnType<typeof useAccountContactLabelGroupsLazyQuery>;
export type AccountContactLabelGroupsSuspenseQueryHookResult = ReturnType<typeof useAccountContactLabelGroupsSuspenseQuery>;
export type AccountContactLabelGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.AccountContactLabelGroupsQuery, GraphqlTypes.AccountContactLabelGroupsQueryVariables>;
export const AccountContactsPrefsPageDocument = gql`
    query AccountContactsPrefsPage($accountId: ID!, $first: Int!, $cursor: String) {
  accountContactsPrefs(accountId: $accountId, first: $first, cursor: $cursor) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalContacts
      firstCursor
      prevCursor
      nextCursor
      lastCursor
    }
    contacts {
      ...AccountContactMapFields
    }
  }
}
    ${AccountContactMapFieldsFragmentDoc}`;

/**
 * __useAccountContactsPrefsPageQuery__
 *
 * To run a query within a React component, call `useAccountContactsPrefsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContactsPrefsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContactsPrefsPageQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useAccountContactsPrefsPageQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables> & ({ variables: GraphqlTypes.AccountContactsPrefsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>(AccountContactsPrefsPageDocument, options);
      }
export function useAccountContactsPrefsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>(AccountContactsPrefsPageDocument, options);
        }
// @ts-ignore
export function useAccountContactsPrefsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>;
export function useAccountContactsPrefsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountContactsPrefsPageQuery | undefined, GraphqlTypes.AccountContactsPrefsPageQueryVariables>;
export function useAccountContactsPrefsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>(AccountContactsPrefsPageDocument, options);
        }
export type AccountContactsPrefsPageQueryHookResult = ReturnType<typeof useAccountContactsPrefsPageQuery>;
export type AccountContactsPrefsPageLazyQueryHookResult = ReturnType<typeof useAccountContactsPrefsPageLazyQuery>;
export type AccountContactsPrefsPageSuspenseQueryHookResult = ReturnType<typeof useAccountContactsPrefsPageSuspenseQuery>;
export type AccountContactsPrefsPageQueryResult = Apollo.QueryResult<GraphqlTypes.AccountContactsPrefsPageQuery, GraphqlTypes.AccountContactsPrefsPageQueryVariables>;
export const AccountPositionsDocument = gql`
    query AccountPositions($accountId: ID!) {
  accounts(accountFilters: {ids: [$accountId]}) {
    edges {
      node {
        id
        positionCount
        positions(first: 3000) {
          edges {
            node {
              id
              investmentEntity {
                name
              }
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAccountPositionsQuery__
 *
 * To run a query within a React component, call `useAccountPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPositionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables> & ({ variables: GraphqlTypes.AccountPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>(AccountPositionsDocument, options);
      }
export function useAccountPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>(AccountPositionsDocument, options);
        }
// @ts-ignore
export function useAccountPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>;
export function useAccountPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountPositionsQuery | undefined, GraphqlTypes.AccountPositionsQueryVariables>;
export function useAccountPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>(AccountPositionsDocument, options);
        }
export type AccountPositionsQueryHookResult = ReturnType<typeof useAccountPositionsQuery>;
export type AccountPositionsLazyQueryHookResult = ReturnType<typeof useAccountPositionsLazyQuery>;
export type AccountPositionsSuspenseQueryHookResult = ReturnType<typeof useAccountPositionsSuspenseQuery>;
export type AccountPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.AccountPositionsQuery, GraphqlTypes.AccountPositionsQueryVariables>;
export const AccountPositionContactsDocument = gql`
    query AccountPositionContacts($accountId: ID!) {
  accountTier(id: $accountId)
  accounts(accountFilters: {ids: [$accountId]}) {
    edges {
      node {
        id
        positionCount
        positions(first: 3000) {
          edges {
            node {
              id
              amountCommitted {
                monies
              }
              investmentEntity {
                name
              }
            }
          }
          pageInfo {
            hasNextPage
          }
        }
        accountContactMaps {
          ...AccountContactMapFields
        }
      }
    }
  }
}
    ${AccountContactMapFieldsFragmentDoc}`;

/**
 * __useAccountPositionContactsQuery__
 *
 * To run a query within a React component, call `useAccountPositionContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPositionContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPositionContactsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountPositionContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables> & ({ variables: GraphqlTypes.AccountPositionContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>(AccountPositionContactsDocument, options);
      }
export function useAccountPositionContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>(AccountPositionContactsDocument, options);
        }
// @ts-ignore
export function useAccountPositionContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>;
export function useAccountPositionContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountPositionContactsQuery | undefined, GraphqlTypes.AccountPositionContactsQueryVariables>;
export function useAccountPositionContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>(AccountPositionContactsDocument, options);
        }
export type AccountPositionContactsQueryHookResult = ReturnType<typeof useAccountPositionContactsQuery>;
export type AccountPositionContactsLazyQueryHookResult = ReturnType<typeof useAccountPositionContactsLazyQuery>;
export type AccountPositionContactsSuspenseQueryHookResult = ReturnType<typeof useAccountPositionContactsSuspenseQuery>;
export type AccountPositionContactsQueryResult = Apollo.QueryResult<GraphqlTypes.AccountPositionContactsQuery, GraphqlTypes.AccountPositionContactsQueryVariables>;
export const RemoveContactFromAccountDocument = gql`
    mutation RemoveContactFromAccount($accountContactMapId: ID!) {
  removeContactFromAccount(accountContactMapId: $accountContactMapId) {
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type RemoveContactFromAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveContactFromAccountMutation, GraphqlTypes.RemoveContactFromAccountMutationVariables>;

/**
 * __useRemoveContactFromAccountMutation__
 *
 * To run a mutation, you first call `useRemoveContactFromAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactFromAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactFromAccountMutation, { data, loading, error }] = useRemoveContactFromAccountMutation({
 *   variables: {
 *      accountContactMapId: // value for 'accountContactMapId'
 *   },
 * });
 */
export function useRemoveContactFromAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveContactFromAccountMutation, GraphqlTypes.RemoveContactFromAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveContactFromAccountMutation, GraphqlTypes.RemoveContactFromAccountMutationVariables>(RemoveContactFromAccountDocument, options);
      }
export type RemoveContactFromAccountMutationHookResult = ReturnType<typeof useRemoveContactFromAccountMutation>;
export type RemoveContactFromAccountMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveContactFromAccountMutation>;
export type RemoveContactFromAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveContactFromAccountMutation, GraphqlTypes.RemoveContactFromAccountMutationVariables>;
export const AddContactToAccountDocument = gql`
    mutation AddContactToAccount($contactInput: AddContactToAccountInput!) {
  addContactToAccount(contactInput: $contactInput) {
    ... on AddContactToAccountPayload {
      accountContactMap {
        ...AccountContactMapFields
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    ${AccountContactMapFieldsFragmentDoc}`;
export type AddContactToAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.AddContactToAccountMutation, GraphqlTypes.AddContactToAccountMutationVariables>;

/**
 * __useAddContactToAccountMutation__
 *
 * To run a mutation, you first call `useAddContactToAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactToAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactToAccountMutation, { data, loading, error }] = useAddContactToAccountMutation({
 *   variables: {
 *      contactInput: // value for 'contactInput'
 *   },
 * });
 */
export function useAddContactToAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddContactToAccountMutation, GraphqlTypes.AddContactToAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddContactToAccountMutation, GraphqlTypes.AddContactToAccountMutationVariables>(AddContactToAccountDocument, options);
      }
export type AddContactToAccountMutationHookResult = ReturnType<typeof useAddContactToAccountMutation>;
export type AddContactToAccountMutationResult = Apollo.MutationResult<GraphqlTypes.AddContactToAccountMutation>;
export type AddContactToAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddContactToAccountMutation, GraphqlTypes.AddContactToAccountMutationVariables>;
export const AddOrganizationContactToAccountDocument = gql`
    mutation AddOrganizationContactToAccount($input: AddOrganizationContactToAccountInput!) {
  addOrganizationContactToAccount(input: $input) {
    ... on AddContactToAccountPayload {
      accountContactMap {
        id
        contactId
        isAdminContact
        label {
          labelText
        }
        contact {
          portalFullName
          contactType
          companyName
        }
        labelGroup {
          id
          displayName
          displayOrder
        }
        positionAcmMaps {
          id
          position {
            id
          }
          lpAccessRoleGrants {
            communicationPref
            lpAccessRole {
              id
              name
            }
          }
        }
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type AddOrganizationContactToAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.AddOrganizationContactToAccountMutation, GraphqlTypes.AddOrganizationContactToAccountMutationVariables>;

/**
 * __useAddOrganizationContactToAccountMutation__
 *
 * To run a mutation, you first call `useAddOrganizationContactToAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationContactToAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationContactToAccountMutation, { data, loading, error }] = useAddOrganizationContactToAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationContactToAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddOrganizationContactToAccountMutation, GraphqlTypes.AddOrganizationContactToAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddOrganizationContactToAccountMutation, GraphqlTypes.AddOrganizationContactToAccountMutationVariables>(AddOrganizationContactToAccountDocument, options);
      }
export type AddOrganizationContactToAccountMutationHookResult = ReturnType<typeof useAddOrganizationContactToAccountMutation>;
export type AddOrganizationContactToAccountMutationResult = Apollo.MutationResult<GraphqlTypes.AddOrganizationContactToAccountMutation>;
export type AddOrganizationContactToAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddOrganizationContactToAccountMutation, GraphqlTypes.AddOrganizationContactToAccountMutationVariables>;
export const EditContactDocument = gql`
    mutation EditContact($input: EditContactInput!) {
  editContact(input: $input) {
    ... on AccountContactMapObjectType {
      ...AccountContactMapFields
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    ${AccountContactMapFieldsFragmentDoc}`;
export type EditContactMutationFn = Apollo.MutationFunction<GraphqlTypes.EditContactMutation, GraphqlTypes.EditContactMutationVariables>;

/**
 * __useEditContactMutation__
 *
 * To run a mutation, you first call `useEditContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editContactMutation, { data, loading, error }] = useEditContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditContactMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditContactMutation, GraphqlTypes.EditContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditContactMutation, GraphqlTypes.EditContactMutationVariables>(EditContactDocument, options);
      }
export type EditContactMutationHookResult = ReturnType<typeof useEditContactMutation>;
export type EditContactMutationResult = Apollo.MutationResult<GraphqlTypes.EditContactMutation>;
export type EditContactMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditContactMutation, GraphqlTypes.EditContactMutationVariables>;
export const AccountTierDocument = gql`
    query AccountTier($accountId: ID!) {
  accountTier(id: $accountId)
}
    `;

/**
 * __useAccountTierQuery__
 *
 * To run a query within a React component, call `useAccountTierQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTierQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountTierQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables> & ({ variables: GraphqlTypes.AccountTierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>(AccountTierDocument, options);
      }
export function useAccountTierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>(AccountTierDocument, options);
        }
// @ts-ignore
export function useAccountTierSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>;
export function useAccountTierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountTierQuery | undefined, GraphqlTypes.AccountTierQueryVariables>;
export function useAccountTierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>(AccountTierDocument, options);
        }
export type AccountTierQueryHookResult = ReturnType<typeof useAccountTierQuery>;
export type AccountTierLazyQueryHookResult = ReturnType<typeof useAccountTierLazyQuery>;
export type AccountTierSuspenseQueryHookResult = ReturnType<typeof useAccountTierSuspenseQuery>;
export type AccountTierQueryResult = Apollo.QueryResult<GraphqlTypes.AccountTierQuery, GraphqlTypes.AccountTierQueryVariables>;
export const AddPositionToContactDocument = gql`
    mutation AddPositionToContact($input: AddPositionToContactInput!) {
  addPositionToContact(input: $input) {
    __typename
    ... on AccountContactMapObjectType {
      ...AccountContactMapRowFields
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    ${AccountContactMapRowFieldsFragmentDoc}`;
export type AddPositionToContactMutationFn = Apollo.MutationFunction<GraphqlTypes.AddPositionToContactMutation, GraphqlTypes.AddPositionToContactMutationVariables>;

/**
 * __useAddPositionToContactMutation__
 *
 * To run a mutation, you first call `useAddPositionToContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPositionToContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPositionToContactMutation, { data, loading, error }] = useAddPositionToContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPositionToContactMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddPositionToContactMutation, GraphqlTypes.AddPositionToContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddPositionToContactMutation, GraphqlTypes.AddPositionToContactMutationVariables>(AddPositionToContactDocument, options);
      }
export type AddPositionToContactMutationHookResult = ReturnType<typeof useAddPositionToContactMutation>;
export type AddPositionToContactMutationResult = Apollo.MutationResult<GraphqlTypes.AddPositionToContactMutation>;
export type AddPositionToContactMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddPositionToContactMutation, GraphqlTypes.AddPositionToContactMutationVariables>;
export const EditAccountContactRowDocument = gql`
    mutation EditAccountContactRow($input: EditContactInput!) {
  editContact(input: $input) {
    __typename
    ... on AccountContactMapObjectType {
      ...AccountContactMapRowFields
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    ${AccountContactMapRowFieldsFragmentDoc}`;
export type EditAccountContactRowMutationFn = Apollo.MutationFunction<GraphqlTypes.EditAccountContactRowMutation, GraphqlTypes.EditAccountContactRowMutationVariables>;

/**
 * __useEditAccountContactRowMutation__
 *
 * To run a mutation, you first call `useEditAccountContactRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAccountContactRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAccountContactRowMutation, { data, loading, error }] = useEditAccountContactRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAccountContactRowMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditAccountContactRowMutation, GraphqlTypes.EditAccountContactRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditAccountContactRowMutation, GraphqlTypes.EditAccountContactRowMutationVariables>(EditAccountContactRowDocument, options);
      }
export type EditAccountContactRowMutationHookResult = ReturnType<typeof useEditAccountContactRowMutation>;
export type EditAccountContactRowMutationResult = Apollo.MutationResult<GraphqlTypes.EditAccountContactRowMutation>;
export type EditAccountContactRowMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditAccountContactRowMutation, GraphqlTypes.EditAccountContactRowMutationVariables>;
export const AddAccountContactRowDocument = gql`
    mutation AddAccountContactRow($contactInput: AddContactToAccountInput!) {
  addContactToAccount(contactInput: $contactInput) {
    __typename
    ... on AddContactToAccountPayload {
      accountContactMap {
        ...AccountContactMapRowFields
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    ${AccountContactMapRowFieldsFragmentDoc}`;
export type AddAccountContactRowMutationFn = Apollo.MutationFunction<GraphqlTypes.AddAccountContactRowMutation, GraphqlTypes.AddAccountContactRowMutationVariables>;

/**
 * __useAddAccountContactRowMutation__
 *
 * To run a mutation, you first call `useAddAccountContactRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountContactRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountContactRowMutation, { data, loading, error }] = useAddAccountContactRowMutation({
 *   variables: {
 *      contactInput: // value for 'contactInput'
 *   },
 * });
 */
export function useAddAccountContactRowMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddAccountContactRowMutation, GraphqlTypes.AddAccountContactRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddAccountContactRowMutation, GraphqlTypes.AddAccountContactRowMutationVariables>(AddAccountContactRowDocument, options);
      }
export type AddAccountContactRowMutationHookResult = ReturnType<typeof useAddAccountContactRowMutation>;
export type AddAccountContactRowMutationResult = Apollo.MutationResult<GraphqlTypes.AddAccountContactRowMutation>;
export type AddAccountContactRowMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddAccountContactRowMutation, GraphqlTypes.AddAccountContactRowMutationVariables>;
export const UpdateContactCommunicationPreferencesDocument = gql`
    mutation UpdateContactCommunicationPreferences($input: UpdateContactCommunicationPreferencesInput!) {
  updateContactCommunicationPreferences(input: $input) {
    __typename
    ... on AccountContactMapObjectType {
      ...AccountContactMapRowFields
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    ${AccountContactMapRowFieldsFragmentDoc}`;
export type UpdateContactCommunicationPreferencesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateContactCommunicationPreferencesMutation, GraphqlTypes.UpdateContactCommunicationPreferencesMutationVariables>;

/**
 * __useUpdateContactCommunicationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateContactCommunicationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactCommunicationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactCommunicationPreferencesMutation, { data, loading, error }] = useUpdateContactCommunicationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactCommunicationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateContactCommunicationPreferencesMutation, GraphqlTypes.UpdateContactCommunicationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateContactCommunicationPreferencesMutation, GraphqlTypes.UpdateContactCommunicationPreferencesMutationVariables>(UpdateContactCommunicationPreferencesDocument, options);
      }
export type UpdateContactCommunicationPreferencesMutationHookResult = ReturnType<typeof useUpdateContactCommunicationPreferencesMutation>;
export type UpdateContactCommunicationPreferencesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateContactCommunicationPreferencesMutation>;
export type UpdateContactCommunicationPreferencesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateContactCommunicationPreferencesMutation, GraphqlTypes.UpdateContactCommunicationPreferencesMutationVariables>;
export const UpdatePositionCommunicationPreferencesDocument = gql`
    mutation UpdatePositionCommunicationPreferences($input: UpdatePositionCommunicationPreferencesInput!) {
  updatePositionCommunicationPreferences(input: $input) {
    __typename
    ... on PositionAcmMapObjectType {
      ...PositionAcmMapRowFields
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    ${PositionAcmMapRowFieldsFragmentDoc}`;
export type UpdatePositionCommunicationPreferencesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePositionCommunicationPreferencesMutation, GraphqlTypes.UpdatePositionCommunicationPreferencesMutationVariables>;

/**
 * __useUpdatePositionCommunicationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdatePositionCommunicationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionCommunicationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionCommunicationPreferencesMutation, { data, loading, error }] = useUpdatePositionCommunicationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePositionCommunicationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePositionCommunicationPreferencesMutation, GraphqlTypes.UpdatePositionCommunicationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePositionCommunicationPreferencesMutation, GraphqlTypes.UpdatePositionCommunicationPreferencesMutationVariables>(UpdatePositionCommunicationPreferencesDocument, options);
      }
export type UpdatePositionCommunicationPreferencesMutationHookResult = ReturnType<typeof useUpdatePositionCommunicationPreferencesMutation>;
export type UpdatePositionCommunicationPreferencesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePositionCommunicationPreferencesMutation>;
export type UpdatePositionCommunicationPreferencesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePositionCommunicationPreferencesMutation, GraphqlTypes.UpdatePositionCommunicationPreferencesMutationVariables>;
export const ExportAccountPositionContactsSettingsDocument = gql`
    mutation ExportAccountPositionContactsSettings($accountIds: [ID], $queryString: String) {
  accountOps {
    communicationSettingsExport(accountIds: $accountIds, queryString: $queryString) {
      job {
        id
      }
    }
  }
}
    `;
export type ExportAccountPositionContactsSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportAccountPositionContactsSettingsMutation, GraphqlTypes.ExportAccountPositionContactsSettingsMutationVariables>;

/**
 * __useExportAccountPositionContactsSettingsMutation__
 *
 * To run a mutation, you first call `useExportAccountPositionContactsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAccountPositionContactsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAccountPositionContactsSettingsMutation, { data, loading, error }] = useExportAccountPositionContactsSettingsMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      queryString: // value for 'queryString'
 *   },
 * });
 */
export function useExportAccountPositionContactsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportAccountPositionContactsSettingsMutation, GraphqlTypes.ExportAccountPositionContactsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportAccountPositionContactsSettingsMutation, GraphqlTypes.ExportAccountPositionContactsSettingsMutationVariables>(ExportAccountPositionContactsSettingsDocument, options);
      }
export type ExportAccountPositionContactsSettingsMutationHookResult = ReturnType<typeof useExportAccountPositionContactsSettingsMutation>;
export type ExportAccountPositionContactsSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.ExportAccountPositionContactsSettingsMutation>;
export type ExportAccountPositionContactsSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportAccountPositionContactsSettingsMutation, GraphqlTypes.ExportAccountPositionContactsSettingsMutationVariables>;
export const GetAccountContactsCommsPrefDocument = gql`
    query GetAccountContactsCommsPref($accountId: ID!, $first: Int, $cursor: String, $keyword: String, $positionIds: [ID!]) {
  accountContactsPrefs(
    accountId: $accountId
    first: $first
    cursor: $cursor
    filters: {keyword: $keyword, positionIds: $positionIds}
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalContacts
      firstCursor
      prevCursor
      nextCursor
      lastCursor
    }
    contacts {
      id
      isAdminContact
      isMainContact
      contact {
        id
        fullName
        contactType
        primaryEmail {
          emailAddress
        }
      }
      label {
        labelText
      }
      labelGroup {
        id
        code
        displayName
      }
      positionAcmMaps {
        id
        position {
          id
          amountCommitted {
            monies
          }
          investmentEntity {
            id
            name
          }
        }
        lpAccessRoleGrants {
          communicationPref
          lpAccessRole {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountContactsCommsPrefQuery__
 *
 * To run a query within a React component, call `useGetAccountContactsCommsPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountContactsCommsPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountContactsCommsPrefQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      keyword: // value for 'keyword'
 *      positionIds: // value for 'positionIds'
 *   },
 * });
 */
export function useGetAccountContactsCommsPrefQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables> & ({ variables: GraphqlTypes.GetAccountContactsCommsPrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>(GetAccountContactsCommsPrefDocument, options);
      }
export function useGetAccountContactsCommsPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>(GetAccountContactsCommsPrefDocument, options);
        }
// @ts-ignore
export function useGetAccountContactsCommsPrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>;
export function useGetAccountContactsCommsPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsCommsPrefQuery | undefined, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>;
export function useGetAccountContactsCommsPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>(GetAccountContactsCommsPrefDocument, options);
        }
export type GetAccountContactsCommsPrefQueryHookResult = ReturnType<typeof useGetAccountContactsCommsPrefQuery>;
export type GetAccountContactsCommsPrefLazyQueryHookResult = ReturnType<typeof useGetAccountContactsCommsPrefLazyQuery>;
export type GetAccountContactsCommsPrefSuspenseQueryHookResult = ReturnType<typeof useGetAccountContactsCommsPrefSuspenseQuery>;
export type GetAccountContactsCommsPrefQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountContactsCommsPrefQuery, GraphqlTypes.GetAccountContactsCommsPrefQueryVariables>;
export const GetActiveCommunicationPreferenceRolesDocument = gql`
    query GetActiveCommunicationPreferenceRoles {
  communicationPreferenceRoles(includeArchived: false) {
    id
    name
    description
    lpAccessRoleScopes {
      id
      objectType
      object {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetActiveCommunicationPreferenceRolesQuery__
 *
 * To run a query within a React component, call `useGetActiveCommunicationPreferenceRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCommunicationPreferenceRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCommunicationPreferenceRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveCommunicationPreferenceRolesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>(GetActiveCommunicationPreferenceRolesDocument, options);
      }
export function useGetActiveCommunicationPreferenceRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>(GetActiveCommunicationPreferenceRolesDocument, options);
        }
// @ts-ignore
export function useGetActiveCommunicationPreferenceRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>;
export function useGetActiveCommunicationPreferenceRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery | undefined, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>;
export function useGetActiveCommunicationPreferenceRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>(GetActiveCommunicationPreferenceRolesDocument, options);
        }
export type GetActiveCommunicationPreferenceRolesQueryHookResult = ReturnType<typeof useGetActiveCommunicationPreferenceRolesQuery>;
export type GetActiveCommunicationPreferenceRolesLazyQueryHookResult = ReturnType<typeof useGetActiveCommunicationPreferenceRolesLazyQuery>;
export type GetActiveCommunicationPreferenceRolesSuspenseQueryHookResult = ReturnType<typeof useGetActiveCommunicationPreferenceRolesSuspenseQuery>;
export type GetActiveCommunicationPreferenceRolesQueryResult = Apollo.QueryResult<GraphqlTypes.GetActiveCommunicationPreferenceRolesQuery, GraphqlTypes.GetActiveCommunicationPreferenceRolesQueryVariables>;
export const GetAccountContactLabelGroupsDocument = gql`
    query GetAccountContactLabelGroups {
  accountContactLabelGroups {
    id
    code
    displayName
    displayOrder
  }
}
    `;

/**
 * __useGetAccountContactLabelGroupsQuery__
 *
 * To run a query within a React component, call `useGetAccountContactLabelGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountContactLabelGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountContactLabelGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountContactLabelGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>(GetAccountContactLabelGroupsDocument, options);
      }
export function useGetAccountContactLabelGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>(GetAccountContactLabelGroupsDocument, options);
        }
// @ts-ignore
export function useGetAccountContactLabelGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>;
export function useGetAccountContactLabelGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactLabelGroupsQuery | undefined, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>;
export function useGetAccountContactLabelGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>(GetAccountContactLabelGroupsDocument, options);
        }
export type GetAccountContactLabelGroupsQueryHookResult = ReturnType<typeof useGetAccountContactLabelGroupsQuery>;
export type GetAccountContactLabelGroupsLazyQueryHookResult = ReturnType<typeof useGetAccountContactLabelGroupsLazyQuery>;
export type GetAccountContactLabelGroupsSuspenseQueryHookResult = ReturnType<typeof useGetAccountContactLabelGroupsSuspenseQuery>;
export type GetAccountContactLabelGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountContactLabelGroupsQuery, GraphqlTypes.GetAccountContactLabelGroupsQueryVariables>;
export const GetAccountPositionsDocument = gql`
    query GetAccountPositions($accountId: ID!, $arenaId: ID!, $first: Int = 3000) {
  accountTier(id: $accountId)
  positions(
    first: $first
    positionFilters: {accountIds: [$accountId], arenaIds: [$arenaId]}
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        amountCommitted {
          monies
        }
        investmentEntity {
          id
          name
        }
        positionAcmMaps {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountPositionsQuery__
 *
 * To run a query within a React component, call `useGetAccountPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountPositionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      arenaId: // value for 'arenaId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetAccountPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables> & ({ variables: GraphqlTypes.GetAccountPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>(GetAccountPositionsDocument, options);
      }
export function useGetAccountPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>(GetAccountPositionsDocument, options);
        }
// @ts-ignore
export function useGetAccountPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>;
export function useGetAccountPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountPositionsQuery | undefined, GraphqlTypes.GetAccountPositionsQueryVariables>;
export function useGetAccountPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>(GetAccountPositionsDocument, options);
        }
export type GetAccountPositionsQueryHookResult = ReturnType<typeof useGetAccountPositionsQuery>;
export type GetAccountPositionsLazyQueryHookResult = ReturnType<typeof useGetAccountPositionsLazyQuery>;
export type GetAccountPositionsSuspenseQueryHookResult = ReturnType<typeof useGetAccountPositionsSuspenseQuery>;
export type GetAccountPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountPositionsQuery, GraphqlTypes.GetAccountPositionsQueryVariables>;
export const GetInvestmentsExportJobDocument = gql`
    query GetInvestmentsExportJob($jobId: ID!) {
  investmentsExportJob(jobId: $jobId) {
    id
    status
    downloadUrl
  }
}
    `;

/**
 * __useGetInvestmentsExportJobQuery__
 *
 * To run a query within a React component, call `useGetInvestmentsExportJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentsExportJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentsExportJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetInvestmentsExportJobQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentsExportJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>(GetInvestmentsExportJobDocument, options);
      }
export function useGetInvestmentsExportJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>(GetInvestmentsExportJobDocument, options);
        }
// @ts-ignore
export function useGetInvestmentsExportJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>;
export function useGetInvestmentsExportJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentsExportJobQuery | undefined, GraphqlTypes.GetInvestmentsExportJobQueryVariables>;
export function useGetInvestmentsExportJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>(GetInvestmentsExportJobDocument, options);
        }
export type GetInvestmentsExportJobQueryHookResult = ReturnType<typeof useGetInvestmentsExportJobQuery>;
export type GetInvestmentsExportJobLazyQueryHookResult = ReturnType<typeof useGetInvestmentsExportJobLazyQuery>;
export type GetInvestmentsExportJobSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentsExportJobSuspenseQuery>;
export type GetInvestmentsExportJobQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentsExportJobQuery, GraphqlTypes.GetInvestmentsExportJobQueryVariables>;
export const UpsertPortalInvestmentConfigDocument = gql`
    mutation UpsertPortalInvestmentConfig($input: UpsertPortalInvestmentConfigInput!) {
  upsertPortalInvestmentConfig(input: $input) {
    ... on PortalInvestmentConfigObjectType {
      title
      isTitleVisible
      columnMetrics {
        sortOrder
        columnName
        customObjectType
        customObjectId
        isGroupingOption
        isDefaultGroupingOption
        isDataColumn
      }
      canGroupColumns
      canFilterVisibility
      showCashflowBarChart
      isInvestmentsTabConfig
      defaultGroupingOption
      groupingOptions
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpsertPortalInvestmentConfigMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertPortalInvestmentConfigMutation, GraphqlTypes.UpsertPortalInvestmentConfigMutationVariables>;

/**
 * __useUpsertPortalInvestmentConfigMutation__
 *
 * To run a mutation, you first call `useUpsertPortalInvestmentConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortalInvestmentConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortalInvestmentConfigMutation, { data, loading, error }] = useUpsertPortalInvestmentConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPortalInvestmentConfigMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertPortalInvestmentConfigMutation, GraphqlTypes.UpsertPortalInvestmentConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertPortalInvestmentConfigMutation, GraphqlTypes.UpsertPortalInvestmentConfigMutationVariables>(UpsertPortalInvestmentConfigDocument, options);
      }
export type UpsertPortalInvestmentConfigMutationHookResult = ReturnType<typeof useUpsertPortalInvestmentConfigMutation>;
export type UpsertPortalInvestmentConfigMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertPortalInvestmentConfigMutation>;
export type UpsertPortalInvestmentConfigMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertPortalInvestmentConfigMutation, GraphqlTypes.UpsertPortalInvestmentConfigMutationVariables>;
export const ExportInvestmentsDocument = gql`
    mutation ExportInvestments($input: ExportInvestmentsInput!) {
  exportInvestments(exportInvestmentsInput: $input) {
    __typename
    ... on ExportInvestmentsObject {
      job {
        id
        status
        jobType
        downloadUrl
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type ExportInvestmentsMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportInvestmentsMutation, GraphqlTypes.ExportInvestmentsMutationVariables>;

/**
 * __useExportInvestmentsMutation__
 *
 * To run a mutation, you first call `useExportInvestmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportInvestmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportInvestmentsMutation, { data, loading, error }] = useExportInvestmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportInvestmentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportInvestmentsMutation, GraphqlTypes.ExportInvestmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportInvestmentsMutation, GraphqlTypes.ExportInvestmentsMutationVariables>(ExportInvestmentsDocument, options);
      }
export type ExportInvestmentsMutationHookResult = ReturnType<typeof useExportInvestmentsMutation>;
export type ExportInvestmentsMutationResult = Apollo.MutationResult<GraphqlTypes.ExportInvestmentsMutation>;
export type ExportInvestmentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportInvestmentsMutation, GraphqlTypes.ExportInvestmentsMutationVariables>;
export const GetPortalInvestmentConfigDocument = gql`
    query GetPortalInvestmentConfig($isInvestmentsTabConfig: Boolean!, $arenaId: ID) {
  portalInvestmentConfig(
    isInvestmentsTabConfig: $isInvestmentsTabConfig
    arenaId: $arenaId
  ) {
    title
    columnMetrics {
      sortOrder
      columnName
      customObjectType
      customObjectId
      isGroupingOption
      isDefaultGroupingOption
      isDataColumn
    }
    isInvestmentsTabConfig
    isTitleVisible
    filterVisibility
    canGroupColumns
    canFilterVisibility
    groupingOptions
    defaultGroupingOption
  }
}
    `;

/**
 * __useGetPortalInvestmentConfigQuery__
 *
 * To run a query within a React component, call `useGetPortalInvestmentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalInvestmentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalInvestmentConfigQuery({
 *   variables: {
 *      isInvestmentsTabConfig: // value for 'isInvestmentsTabConfig'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPortalInvestmentConfigQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables> & ({ variables: GraphqlTypes.GetPortalInvestmentConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>(GetPortalInvestmentConfigDocument, options);
      }
export function useGetPortalInvestmentConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>(GetPortalInvestmentConfigDocument, options);
        }
// @ts-ignore
export function useGetPortalInvestmentConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>;
export function useGetPortalInvestmentConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalInvestmentConfigQuery | undefined, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>;
export function useGetPortalInvestmentConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>(GetPortalInvestmentConfigDocument, options);
        }
export type GetPortalInvestmentConfigQueryHookResult = ReturnType<typeof useGetPortalInvestmentConfigQuery>;
export type GetPortalInvestmentConfigLazyQueryHookResult = ReturnType<typeof useGetPortalInvestmentConfigLazyQuery>;
export type GetPortalInvestmentConfigSuspenseQueryHookResult = ReturnType<typeof useGetPortalInvestmentConfigSuspenseQuery>;
export type GetPortalInvestmentConfigQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalInvestmentConfigQuery, GraphqlTypes.GetPortalInvestmentConfigQueryVariables>;
export const GetPortalInvestmentConfigRestrictedFieldsDocument = gql`
    query GetPortalInvestmentConfigRestrictedFields($isInvestmentsTabConfig: Boolean!) {
  portalInvestmentConfig(isInvestmentsTabConfig: $isInvestmentsTabConfig) {
    restrictedCustomFields {
      extensionFieldId
    }
  }
}
    `;

/**
 * __useGetPortalInvestmentConfigRestrictedFieldsQuery__
 *
 * To run a query within a React component, call `useGetPortalInvestmentConfigRestrictedFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalInvestmentConfigRestrictedFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalInvestmentConfigRestrictedFieldsQuery({
 *   variables: {
 *      isInvestmentsTabConfig: // value for 'isInvestmentsTabConfig'
 *   },
 * });
 */
export function useGetPortalInvestmentConfigRestrictedFieldsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables> & ({ variables: GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>(GetPortalInvestmentConfigRestrictedFieldsDocument, options);
      }
export function useGetPortalInvestmentConfigRestrictedFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>(GetPortalInvestmentConfigRestrictedFieldsDocument, options);
        }
// @ts-ignore
export function useGetPortalInvestmentConfigRestrictedFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>;
export function useGetPortalInvestmentConfigRestrictedFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery | undefined, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>;
export function useGetPortalInvestmentConfigRestrictedFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>(GetPortalInvestmentConfigRestrictedFieldsDocument, options);
        }
export type GetPortalInvestmentConfigRestrictedFieldsQueryHookResult = ReturnType<typeof useGetPortalInvestmentConfigRestrictedFieldsQuery>;
export type GetPortalInvestmentConfigRestrictedFieldsLazyQueryHookResult = ReturnType<typeof useGetPortalInvestmentConfigRestrictedFieldsLazyQuery>;
export type GetPortalInvestmentConfigRestrictedFieldsSuspenseQueryHookResult = ReturnType<typeof useGetPortalInvestmentConfigRestrictedFieldsSuspenseQuery>;
export type GetPortalInvestmentConfigRestrictedFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQuery, GraphqlTypes.GetPortalInvestmentConfigRestrictedFieldsQueryVariables>;
export const GetArenaHideCashFlowBarChartSettingDocument = gql`
    query GetArenaHideCashFlowBarChartSetting {
  currentArena {
    id
    hideCashFlowBarChartInPortal
  }
}
    `;

/**
 * __useGetArenaHideCashFlowBarChartSettingQuery__
 *
 * To run a query within a React component, call `useGetArenaHideCashFlowBarChartSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaHideCashFlowBarChartSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaHideCashFlowBarChartSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArenaHideCashFlowBarChartSettingQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>(GetArenaHideCashFlowBarChartSettingDocument, options);
      }
export function useGetArenaHideCashFlowBarChartSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>(GetArenaHideCashFlowBarChartSettingDocument, options);
        }
// @ts-ignore
export function useGetArenaHideCashFlowBarChartSettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>;
export function useGetArenaHideCashFlowBarChartSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery | undefined, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>;
export function useGetArenaHideCashFlowBarChartSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>(GetArenaHideCashFlowBarChartSettingDocument, options);
        }
export type GetArenaHideCashFlowBarChartSettingQueryHookResult = ReturnType<typeof useGetArenaHideCashFlowBarChartSettingQuery>;
export type GetArenaHideCashFlowBarChartSettingLazyQueryHookResult = ReturnType<typeof useGetArenaHideCashFlowBarChartSettingLazyQuery>;
export type GetArenaHideCashFlowBarChartSettingSuspenseQueryHookResult = ReturnType<typeof useGetArenaHideCashFlowBarChartSettingSuspenseQuery>;
export type GetArenaHideCashFlowBarChartSettingQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaHideCashFlowBarChartSettingQuery, GraphqlTypes.GetArenaHideCashFlowBarChartSettingQueryVariables>;
export const GetExtensionFieldsWithFilterDocument = gql`
    query GetExtensionFieldsWithFilter($objectType: JSQObjectType!, $extensionFieldTypes: [ExtensionFieldType!], $isVisibleInPortal: Boolean) {
  extensionFields(
    objectType: $objectType
    extensionFieldTypes: $extensionFieldTypes
    isVisibleInPortal: $isVisibleInPortal
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetExtensionFieldsWithFilterQuery__
 *
 * To run a query within a React component, call `useGetExtensionFieldsWithFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtensionFieldsWithFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtensionFieldsWithFilterQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      extensionFieldTypes: // value for 'extensionFieldTypes'
 *      isVisibleInPortal: // value for 'isVisibleInPortal'
 *   },
 * });
 */
export function useGetExtensionFieldsWithFilterQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables> & ({ variables: GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>(GetExtensionFieldsWithFilterDocument, options);
      }
export function useGetExtensionFieldsWithFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>(GetExtensionFieldsWithFilterDocument, options);
        }
// @ts-ignore
export function useGetExtensionFieldsWithFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>;
export function useGetExtensionFieldsWithFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionFieldsWithFilterQuery | undefined, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>;
export function useGetExtensionFieldsWithFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>(GetExtensionFieldsWithFilterDocument, options);
        }
export type GetExtensionFieldsWithFilterQueryHookResult = ReturnType<typeof useGetExtensionFieldsWithFilterQuery>;
export type GetExtensionFieldsWithFilterLazyQueryHookResult = ReturnType<typeof useGetExtensionFieldsWithFilterLazyQuery>;
export type GetExtensionFieldsWithFilterSuspenseQueryHookResult = ReturnType<typeof useGetExtensionFieldsWithFilterSuspenseQuery>;
export type GetExtensionFieldsWithFilterQueryResult = Apollo.QueryResult<GraphqlTypes.GetExtensionFieldsWithFilterQuery, GraphqlTypes.GetExtensionFieldsWithFilterQueryVariables>;
export const ListActivityFeedsDataDocument = gql`
    query ListActivityFeedsData($nextPageCursor: String, $limit: Int, $sort: [String!], $activityFeedFilter: ActivityFeedFilterInput, $objectType: Int, $objectId: ID) {
  activityFeeds(
    nextPageCursor: $nextPageCursor
    limit: $limit
    sort: $sort
    activityFeedFilter: $activityFeedFilter
    objectType: $objectType
    objectId: $objectId
  ) {
    ... on ActivityFeedsListWrapperObjectType {
      nextPageCursor
      items {
        ... on ContactActivityFeedsObjectType {
          activityType
          editedAt
          editedBy
          regarding {
            ... on ContactObjectType {
              ...ContactRegardingFields
            }
            ... on ProspectObjectType {
              ...ProspectRegardingFields
            }
            ... on PositionObjectType {
              ...PositionRegardingFields
            }
            ... on LeadObjectType {
              ...LeadRegardingFields
            }
            ... on AccountObjectType {
              ...AccountRegardingFields
            }
            ... on CalendarEventObjectType {
              ...CalendarEventObjectFields
            }
          }
          activityObject {
            ... on EmailObjectType {
              ...EmailObjectFields
            }
            ... on NoteObjectType {
              ...NoteObjectFields
            }
            ... on StoredEmailObjectType {
              ...StoredEmailObjectFields
            }
            ... on CalendarEventObjectType {
              ...CalendarEventObjectFields
            }
          }
        }
        ... on LeadActivityFeedsObjectType {
          activityType
          editedAt
          editedBy
          regarding {
            ... on LeadObjectType {
              ...LeadRegardingFields
            }
            ... on AccountObjectType {
              ...AccountRegardingFields
            }
          }
          activityObject {
            ... on NoteObjectType {
              ...NoteObjectFields
            }
            ... on StoredEmailObjectType {
              ...StoredEmailObjectFields
            }
          }
        }
        ... on PositionActivityFeedsObjectType {
          activityType
          editedAt
          editedBy
          regarding {
            ... on PositionObjectType {
              ...PositionRegardingFields
            }
            ... on AccountObjectType {
              ...AccountRegardingFields
            }
            ... on CalendarEventObjectType {
              ...CalendarEventObjectFields
            }
          }
          activityObject {
            ... on EmailObjectType {
              ...EmailObjectFields
            }
            ... on NoteObjectType {
              ...NoteObjectFields
            }
            ... on StoredEmailObjectType {
              ...StoredEmailObjectFields
            }
            ... on CapitalCallObjectType {
              id
            }
            ... on DistributionObjectType {
              id
            }
            ... on NetIncomeObjectType {
              id
            }
            ... on TransactionObjectType {
              id
            }
            ... on CalendarEventObjectType {
              ...CalendarEventObjectFields
            }
          }
        }
        ... on ProspectActivityFeedObjectType {
          activityType
          editedAt
          editedBy
          regarding {
            ... on ProspectObjectType {
              ...ProspectRegardingFields
            }
            ... on AccountObjectType {
              ...AccountRegardingFields
            }
            ... on CalendarEventObjectType {
              ...CalendarEventObjectFields
            }
          }
          activityObject {
            ... on EmailObjectType {
              ...EmailObjectFields
            }
            ... on NoteObjectType {
              ...NoteObjectFields
            }
            ... on StoredEmailObjectType {
              ...StoredEmailObjectFields
            }
            ... on CapitalCallObjectType {
              id
            }
            ... on DistributionObjectType {
              id
            }
            ... on NetIncomeObjectType {
              id
            }
            ... on TransactionObjectType {
              id
            }
            ... on CalendarEventObjectType {
              ...CalendarEventObjectFields
            }
          }
        }
        ... on DashboardActivityFeedObjectType {
          activityType
          editedAt
          editedBy
          effectiveDate
          regarding {
            __typename
            ... on ContactObjectType {
              ...ContactRegardingFields
            }
            ... on ProspectObjectType {
              ...ProspectRegardingFields
            }
            ... on PositionObjectType {
              ...PositionRegardingFields
            }
            ... on LeadObjectType {
              ...LeadRegardingFields
            }
            ... on OfferingObjectType {
              ...OfferingRegardingFields
            }
            ... on AccountObjectType {
              ...AccountRegardingFields
            }
            ... on CalendarEventObjectType {
              ...CalendarEventObjectFields
            }
          }
          activityObject {
            ... on ManagementFeeBatchObjectType {
              entity {
                id
                name
                published
              }
              dateDue
              id
            }
            ... on DistributionBatchObjectType {
              ...ActivityDistributionBatchFields
            }
            ... on EmailBatchObjectType {
              ...EmailBatchObjectFields
            }
            ... on NetIncomeBatchObjectType {
              ...NetIncomeBatchObjectFields
            }
            ... on CapitalCallBatchObjectType {
              ...CapitalCallBatchObjectFields
            }
            ... on NoteObjectType {
              ...NoteObjectFields
            }
            ... on StoredEmailObjectType {
              ...StoredEmailObjectFields
            }
            ... on CalendarEventObjectType {
              ...CalendarEventObjectFields
            }
          }
        }
        ... on MutationErrorResponse {
          errorCode
          message
        }
      }
    }
  }
}
    ${ContactRegardingFieldsFragmentDoc}
${ProspectRegardingFieldsFragmentDoc}
${PositionRegardingFieldsFragmentDoc}
${LeadRegardingFieldsFragmentDoc}
${AccountRegardingFieldsFragmentDoc}
${CalendarEventObjectFieldsFragmentDoc}
${EmailObjectFieldsFragmentDoc}
${NoteObjectFieldsFragmentDoc}
${StoredEmailObjectFieldsFragmentDoc}
${OfferingRegardingFieldsFragmentDoc}
${ActivityDistributionBatchFieldsFragmentDoc}
${EmailBatchObjectFieldsFragmentDoc}
${NetIncomeBatchObjectFieldsFragmentDoc}
${CapitalCallBatchObjectFieldsFragmentDoc}`;

/**
 * __useListActivityFeedsDataQuery__
 *
 * To run a query within a React component, call `useListActivityFeedsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivityFeedsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivityFeedsDataQuery({
 *   variables: {
 *      nextPageCursor: // value for 'nextPageCursor'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      activityFeedFilter: // value for 'activityFeedFilter'
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useListActivityFeedsDataQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>(ListActivityFeedsDataDocument, options);
      }
export function useListActivityFeedsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>(ListActivityFeedsDataDocument, options);
        }
// @ts-ignore
export function useListActivityFeedsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>;
export function useListActivityFeedsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ListActivityFeedsDataQuery | undefined, GraphqlTypes.ListActivityFeedsDataQueryVariables>;
export function useListActivityFeedsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>(ListActivityFeedsDataDocument, options);
        }
export type ListActivityFeedsDataQueryHookResult = ReturnType<typeof useListActivityFeedsDataQuery>;
export type ListActivityFeedsDataLazyQueryHookResult = ReturnType<typeof useListActivityFeedsDataLazyQuery>;
export type ListActivityFeedsDataSuspenseQueryHookResult = ReturnType<typeof useListActivityFeedsDataSuspenseQuery>;
export type ListActivityFeedsDataQueryResult = Apollo.QueryResult<GraphqlTypes.ListActivityFeedsDataQuery, GraphqlTypes.ListActivityFeedsDataQueryVariables>;
export const GetActivityEntitiesDocument = gql`
    query GetActivityEntities {
  investmentEntities {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetActivityEntitiesQuery__
 *
 * To run a query within a React component, call `useGetActivityEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>(GetActivityEntitiesDocument, options);
      }
export function useGetActivityEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>(GetActivityEntitiesDocument, options);
        }
// @ts-ignore
export function useGetActivityEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>;
export function useGetActivityEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityEntitiesQuery | undefined, GraphqlTypes.GetActivityEntitiesQueryVariables>;
export function useGetActivityEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>(GetActivityEntitiesDocument, options);
        }
export type GetActivityEntitiesQueryHookResult = ReturnType<typeof useGetActivityEntitiesQuery>;
export type GetActivityEntitiesLazyQueryHookResult = ReturnType<typeof useGetActivityEntitiesLazyQuery>;
export type GetActivityEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetActivityEntitiesSuspenseQuery>;
export type GetActivityEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityEntitiesQuery, GraphqlTypes.GetActivityEntitiesQueryVariables>;
export const GetActivityOfferingsDocument = gql`
    query GetActivityOfferings {
  searchAllOfferings {
    edges {
      node {
        id
        lpDisplayName
        name
      }
    }
  }
}
    `;

/**
 * __useGetActivityOfferingsQuery__
 *
 * To run a query within a React component, call `useGetActivityOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityOfferingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>(GetActivityOfferingsDocument, options);
      }
export function useGetActivityOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>(GetActivityOfferingsDocument, options);
        }
// @ts-ignore
export function useGetActivityOfferingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>;
export function useGetActivityOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityOfferingsQuery | undefined, GraphqlTypes.GetActivityOfferingsQueryVariables>;
export function useGetActivityOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>(GetActivityOfferingsDocument, options);
        }
export type GetActivityOfferingsQueryHookResult = ReturnType<typeof useGetActivityOfferingsQuery>;
export type GetActivityOfferingsLazyQueryHookResult = ReturnType<typeof useGetActivityOfferingsLazyQuery>;
export type GetActivityOfferingsSuspenseQueryHookResult = ReturnType<typeof useGetActivityOfferingsSuspenseQuery>;
export type GetActivityOfferingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityOfferingsQuery, GraphqlTypes.GetActivityOfferingsQueryVariables>;
export const GetActivityUsersDocument = gql`
    query GetActivityUsers {
  staffUsers {
    id
    fullName
  }
}
    `;

/**
 * __useGetActivityUsersQuery__
 *
 * To run a query within a React component, call `useGetActivityUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityUsersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>(GetActivityUsersDocument, options);
      }
export function useGetActivityUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>(GetActivityUsersDocument, options);
        }
// @ts-ignore
export function useGetActivityUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>;
export function useGetActivityUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityUsersQuery | undefined, GraphqlTypes.GetActivityUsersQueryVariables>;
export function useGetActivityUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>(GetActivityUsersDocument, options);
        }
export type GetActivityUsersQueryHookResult = ReturnType<typeof useGetActivityUsersQuery>;
export type GetActivityUsersLazyQueryHookResult = ReturnType<typeof useGetActivityUsersLazyQuery>;
export type GetActivityUsersSuspenseQueryHookResult = ReturnType<typeof useGetActivityUsersSuspenseQuery>;
export type GetActivityUsersQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityUsersQuery, GraphqlTypes.GetActivityUsersQueryVariables>;
export const GetActivityContactsDocument = gql`
    query GetActivityContacts($term: String!) {
  searchContacts(term: $term) {
    edges {
      node {
        id
        firstName
        lastName
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetActivityContactsQuery__
 *
 * To run a query within a React component, call `useGetActivityContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityContactsQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetActivityContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables> & ({ variables: GraphqlTypes.GetActivityContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>(GetActivityContactsDocument, options);
      }
export function useGetActivityContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>(GetActivityContactsDocument, options);
        }
// @ts-ignore
export function useGetActivityContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>;
export function useGetActivityContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityContactsQuery | undefined, GraphqlTypes.GetActivityContactsQueryVariables>;
export function useGetActivityContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>(GetActivityContactsDocument, options);
        }
export type GetActivityContactsQueryHookResult = ReturnType<typeof useGetActivityContactsQuery>;
export type GetActivityContactsLazyQueryHookResult = ReturnType<typeof useGetActivityContactsLazyQuery>;
export type GetActivityContactsSuspenseQueryHookResult = ReturnType<typeof useGetActivityContactsSuspenseQuery>;
export type GetActivityContactsQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityContactsQuery, GraphqlTypes.GetActivityContactsQueryVariables>;
export const GetActivityExtensionFieldEnumValuesDocument = gql`
    query GetActivityExtensionFieldEnumValues($enumName: String!) {
  extensionFieldEnumValues(enumName: $enumName) {
    id
    enumValueCode
    enumValueLabel
  }
}
    `;

/**
 * __useGetActivityExtensionFieldEnumValuesQuery__
 *
 * To run a query within a React component, call `useGetActivityExtensionFieldEnumValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityExtensionFieldEnumValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityExtensionFieldEnumValuesQuery({
 *   variables: {
 *      enumName: // value for 'enumName'
 *   },
 * });
 */
export function useGetActivityExtensionFieldEnumValuesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables> & ({ variables: GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>(GetActivityExtensionFieldEnumValuesDocument, options);
      }
export function useGetActivityExtensionFieldEnumValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>(GetActivityExtensionFieldEnumValuesDocument, options);
        }
// @ts-ignore
export function useGetActivityExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>;
export function useGetActivityExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery | undefined, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>;
export function useGetActivityExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>(GetActivityExtensionFieldEnumValuesDocument, options);
        }
export type GetActivityExtensionFieldEnumValuesQueryHookResult = ReturnType<typeof useGetActivityExtensionFieldEnumValuesQuery>;
export type GetActivityExtensionFieldEnumValuesLazyQueryHookResult = ReturnType<typeof useGetActivityExtensionFieldEnumValuesLazyQuery>;
export type GetActivityExtensionFieldEnumValuesSuspenseQueryHookResult = ReturnType<typeof useGetActivityExtensionFieldEnumValuesSuspenseQuery>;
export type GetActivityExtensionFieldEnumValuesQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityExtensionFieldEnumValuesQuery, GraphqlTypes.GetActivityExtensionFieldEnumValuesQueryVariables>;
export const GetTotalDraftItemsDocument = gql`
    query GetTotalDraftItems($objectType: Int, $objectId: ID) {
  totalDraftItems(objectType: $objectType, objectId: $objectId)
}
    `;

/**
 * __useGetTotalDraftItemsQuery__
 *
 * To run a query within a React component, call `useGetTotalDraftItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalDraftItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalDraftItemsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetTotalDraftItemsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>(GetTotalDraftItemsDocument, options);
      }
export function useGetTotalDraftItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>(GetTotalDraftItemsDocument, options);
        }
// @ts-ignore
export function useGetTotalDraftItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>;
export function useGetTotalDraftItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTotalDraftItemsQuery | undefined, GraphqlTypes.GetTotalDraftItemsQueryVariables>;
export function useGetTotalDraftItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>(GetTotalDraftItemsDocument, options);
        }
export type GetTotalDraftItemsQueryHookResult = ReturnType<typeof useGetTotalDraftItemsQuery>;
export type GetTotalDraftItemsLazyQueryHookResult = ReturnType<typeof useGetTotalDraftItemsLazyQuery>;
export type GetTotalDraftItemsSuspenseQueryHookResult = ReturnType<typeof useGetTotalDraftItemsSuspenseQuery>;
export type GetTotalDraftItemsQueryResult = Apollo.QueryResult<GraphqlTypes.GetTotalDraftItemsQuery, GraphqlTypes.GetTotalDraftItemsQueryVariables>;
export const RequestPaymentForBatchDocument = gql`
    mutation RequestPaymentForBatch($transactionBatchCategory: AccountingPayableObjectTypeEnum!, $objectId: Int!, $requestedPaymentDate: Date) {
  requestPaymentForBatch(
    transactionBatchCategory: $transactionBatchCategory
    objectId: $objectId
    requestedPaymentDate: $requestedPaymentDate
  ) {
    response {
      __typename
      ... on BatchPaymentRequestedResponse {
        transactionBatchPayableMetadata {
          id
          objectId
          objectType
          isPaymentRequested
          requestedPaymentDate
        }
      }
      ... on MutationErrorResponse {
        message
        errorCode
      }
    }
  }
}
    `;
export type RequestPaymentForBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.RequestPaymentForBatchMutation, GraphqlTypes.RequestPaymentForBatchMutationVariables>;

/**
 * __useRequestPaymentForBatchMutation__
 *
 * To run a mutation, you first call `useRequestPaymentForBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPaymentForBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPaymentForBatchMutation, { data, loading, error }] = useRequestPaymentForBatchMutation({
 *   variables: {
 *      transactionBatchCategory: // value for 'transactionBatchCategory'
 *      objectId: // value for 'objectId'
 *      requestedPaymentDate: // value for 'requestedPaymentDate'
 *   },
 * });
 */
export function useRequestPaymentForBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RequestPaymentForBatchMutation, GraphqlTypes.RequestPaymentForBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RequestPaymentForBatchMutation, GraphqlTypes.RequestPaymentForBatchMutationVariables>(RequestPaymentForBatchDocument, options);
      }
export type RequestPaymentForBatchMutationHookResult = ReturnType<typeof useRequestPaymentForBatchMutation>;
export type RequestPaymentForBatchMutationResult = Apollo.MutationResult<GraphqlTypes.RequestPaymentForBatchMutation>;
export type RequestPaymentForBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RequestPaymentForBatchMutation, GraphqlTypes.RequestPaymentForBatchMutationVariables>;
export const CancelPaymentRequestForBatchDocument = gql`
    mutation CancelPaymentRequestForBatch($transactionBatchCategory: AccountingPayableObjectTypeEnum!, $objectId: Int!) {
  cancelPaymentRequestForBatch(
    transactionBatchCategory: $transactionBatchCategory
    objectId: $objectId
  ) {
    response {
      __typename
      ... on BatchPaymentRequestedResponse {
        transactionBatchPayableMetadata {
          id
          objectId
          objectType
          isPaymentRequested
          requestedPaymentDate
        }
      }
      ... on MutationErrorResponse {
        message
        errorCode
      }
    }
  }
}
    `;
export type CancelPaymentRequestForBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelPaymentRequestForBatchMutation, GraphqlTypes.CancelPaymentRequestForBatchMutationVariables>;

/**
 * __useCancelPaymentRequestForBatchMutation__
 *
 * To run a mutation, you first call `useCancelPaymentRequestForBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentRequestForBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentRequestForBatchMutation, { data, loading, error }] = useCancelPaymentRequestForBatchMutation({
 *   variables: {
 *      transactionBatchCategory: // value for 'transactionBatchCategory'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useCancelPaymentRequestForBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelPaymentRequestForBatchMutation, GraphqlTypes.CancelPaymentRequestForBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelPaymentRequestForBatchMutation, GraphqlTypes.CancelPaymentRequestForBatchMutationVariables>(CancelPaymentRequestForBatchDocument, options);
      }
export type CancelPaymentRequestForBatchMutationHookResult = ReturnType<typeof useCancelPaymentRequestForBatchMutation>;
export type CancelPaymentRequestForBatchMutationResult = Apollo.MutationResult<GraphqlTypes.CancelPaymentRequestForBatchMutation>;
export type CancelPaymentRequestForBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelPaymentRequestForBatchMutation, GraphqlTypes.CancelPaymentRequestForBatchMutationVariables>;
export const VoidSubscriptionBulkCountersignDocument = gql`
    mutation VoidSubscriptionBulkCountersign($input: VoidBulkCountersignInput!) {
  voidBulkCountersign(objectInput: $input) {
    ... on AsyncJobObjectType {
      id
      status
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type VoidSubscriptionBulkCountersignMutationFn = Apollo.MutationFunction<GraphqlTypes.VoidSubscriptionBulkCountersignMutation, GraphqlTypes.VoidSubscriptionBulkCountersignMutationVariables>;

/**
 * __useVoidSubscriptionBulkCountersignMutation__
 *
 * To run a mutation, you first call `useVoidSubscriptionBulkCountersignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidSubscriptionBulkCountersignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidSubscriptionBulkCountersignMutation, { data, loading, error }] = useVoidSubscriptionBulkCountersignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVoidSubscriptionBulkCountersignMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.VoidSubscriptionBulkCountersignMutation, GraphqlTypes.VoidSubscriptionBulkCountersignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.VoidSubscriptionBulkCountersignMutation, GraphqlTypes.VoidSubscriptionBulkCountersignMutationVariables>(VoidSubscriptionBulkCountersignDocument, options);
      }
export type VoidSubscriptionBulkCountersignMutationHookResult = ReturnType<typeof useVoidSubscriptionBulkCountersignMutation>;
export type VoidSubscriptionBulkCountersignMutationResult = Apollo.MutationResult<GraphqlTypes.VoidSubscriptionBulkCountersignMutation>;
export type VoidSubscriptionBulkCountersignMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.VoidSubscriptionBulkCountersignMutation, GraphqlTypes.VoidSubscriptionBulkCountersignMutationVariables>;
export const DeleteCalendarEventDocument = gql`
    mutation DeleteCalendarEvent($objectInput: DeleteCalendarEventInput!) {
  deleteCalendarEvent(objectInput: $objectInput) {
    calendarEvent {
      id
    }
  }
}
    `;
export type DeleteCalendarEventMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteCalendarEventMutation, GraphqlTypes.DeleteCalendarEventMutationVariables>;

/**
 * __useDeleteCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarEventMutation, { data, loading, error }] = useDeleteCalendarEventMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDeleteCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteCalendarEventMutation, GraphqlTypes.DeleteCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteCalendarEventMutation, GraphqlTypes.DeleteCalendarEventMutationVariables>(DeleteCalendarEventDocument, options);
      }
export type DeleteCalendarEventMutationHookResult = ReturnType<typeof useDeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteCalendarEventMutation, GraphqlTypes.DeleteCalendarEventMutationVariables>;
export const UpdateCalendarEventParticipantsDocument = gql`
    mutation UpdateCalendarEventParticipants($calendarEventId: ID!, $participants: [ID!]) {
  updateCalendarEventParticipants(
    calendarEventId: $calendarEventId
    participants: $participants
  ) {
    calendarEvent {
      id
      users {
        id
        fullName
      }
      contacts {
        id
        fullName
        contactType
      }
      offerings {
        id
        name
      }
      entities {
        id
        name
      }
    }
  }
}
    `;
export type UpdateCalendarEventParticipantsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateCalendarEventParticipantsMutation, GraphqlTypes.UpdateCalendarEventParticipantsMutationVariables>;

/**
 * __useUpdateCalendarEventParticipantsMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarEventParticipantsMutation, { data, loading, error }] = useUpdateCalendarEventParticipantsMutation({
 *   variables: {
 *      calendarEventId: // value for 'calendarEventId'
 *      participants: // value for 'participants'
 *   },
 * });
 */
export function useUpdateCalendarEventParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateCalendarEventParticipantsMutation, GraphqlTypes.UpdateCalendarEventParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateCalendarEventParticipantsMutation, GraphqlTypes.UpdateCalendarEventParticipantsMutationVariables>(UpdateCalendarEventParticipantsDocument, options);
      }
export type UpdateCalendarEventParticipantsMutationHookResult = ReturnType<typeof useUpdateCalendarEventParticipantsMutation>;
export type UpdateCalendarEventParticipantsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateCalendarEventParticipantsMutation>;
export type UpdateCalendarEventParticipantsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateCalendarEventParticipantsMutation, GraphqlTypes.UpdateCalendarEventParticipantsMutationVariables>;
export const GetCalendarEventsDocument = gql`
    query GetCalendarEvents($rangeStart: DateTime!, $rangeEnd: DateTime!, $limit: Int, $objectId: ID, $objectType: JSQObjectType, $showAllWorkspace: Boolean) {
  calendarEvents(
    rangeStart: $rangeStart
    rangeEnd: $rangeEnd
    limit: $limit
    objectId: $objectId
    objectType: $objectType
    showAllWorkspace: $showAllWorkspace
  ) {
    id
    title
    description
    location
    startDatetime
    endDatetime
    isAllDay
    timezone
    calendarId
    primaryMeetingUrl
    createdAt
    conferenceProvider
    integrationId
    user {
      id
      fullName
      emailAddress
    }
    contacts {
      id
      fullName
      contactType
      primaryEmail {
        emailAddress
      }
      thumbnail {
        photoUrl(width: 64, height: 64)
      }
    }
    users {
      id
      fullName
      emailAddress
    }
    offerings {
      id
      name
    }
    entities {
      id
      name
    }
    attachments {
      documentId
      documentName
      documentVersion {
        id
        downloadUrl
      }
    }
    notes {
      id
      text
      createdAt
      editedAt
      provenance
      owner {
        id
        fullName
      }
      editedBy {
        id
        fullName
      }
    }
    provenance
    isPrivate
  }
}
    `;

/**
 * __useGetCalendarEventsQuery__
 *
 * To run a query within a React component, call `useGetCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarEventsQuery({
 *   variables: {
 *      rangeStart: // value for 'rangeStart'
 *      rangeEnd: // value for 'rangeEnd'
 *      limit: // value for 'limit'
 *      objectId: // value for 'objectId'
 *      objectType: // value for 'objectType'
 *      showAllWorkspace: // value for 'showAllWorkspace'
 *   },
 * });
 */
export function useGetCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables> & ({ variables: GraphqlTypes.GetCalendarEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>(GetCalendarEventsDocument, options);
      }
export function useGetCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>(GetCalendarEventsDocument, options);
        }
// @ts-ignore
export function useGetCalendarEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>;
export function useGetCalendarEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCalendarEventsQuery | undefined, GraphqlTypes.GetCalendarEventsQueryVariables>;
export function useGetCalendarEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>(GetCalendarEventsDocument, options);
        }
export type GetCalendarEventsQueryHookResult = ReturnType<typeof useGetCalendarEventsQuery>;
export type GetCalendarEventsLazyQueryHookResult = ReturnType<typeof useGetCalendarEventsLazyQuery>;
export type GetCalendarEventsSuspenseQueryHookResult = ReturnType<typeof useGetCalendarEventsSuspenseQuery>;
export type GetCalendarEventsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCalendarEventsQuery, GraphqlTypes.GetCalendarEventsQueryVariables>;
export const GetCalendarEventDocument = gql`
    query GetCalendarEvent($id: ID!) {
  calendarEvent(id: $id) {
    id
    title
    description
    location
    startDatetime
    endDatetime
    isAllDay
    timezone
    calendarId
    primaryMeetingUrl
    createdAt
    conferenceProvider
    integrationId
    user {
      id
      fullName
      emailAddress
    }
    contacts {
      id
      fullName
      contactType
      primaryEmail {
        emailAddress
      }
      thumbnail {
        photoUrl(width: 64, height: 64)
      }
      company {
        id
        fullName
      }
    }
    users {
      id
      fullName
      emailAddress
    }
    offerings {
      id
      name
    }
    entities {
      id
      name
    }
    attachments {
      documentId
      documentName
      documentVersion {
        id
        downloadUrl
      }
    }
    notes {
      id
      text
      createdAt
      editedAt
      provenance
      owner {
        id
        fullName
      }
      editedBy {
        id
        fullName
      }
    }
    provenance
    isPrivate
  }
}
    `;

/**
 * __useGetCalendarEventQuery__
 *
 * To run a query within a React component, call `useGetCalendarEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCalendarEventQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables> & ({ variables: GraphqlTypes.GetCalendarEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>(GetCalendarEventDocument, options);
      }
export function useGetCalendarEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>(GetCalendarEventDocument, options);
        }
// @ts-ignore
export function useGetCalendarEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>;
export function useGetCalendarEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCalendarEventQuery | undefined, GraphqlTypes.GetCalendarEventQueryVariables>;
export function useGetCalendarEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>(GetCalendarEventDocument, options);
        }
export type GetCalendarEventQueryHookResult = ReturnType<typeof useGetCalendarEventQuery>;
export type GetCalendarEventLazyQueryHookResult = ReturnType<typeof useGetCalendarEventLazyQuery>;
export type GetCalendarEventSuspenseQueryHookResult = ReturnType<typeof useGetCalendarEventSuspenseQuery>;
export type GetCalendarEventQueryResult = Apollo.QueryResult<GraphqlTypes.GetCalendarEventQuery, GraphqlTypes.GetCalendarEventQueryVariables>;
export const CreateCprDocument = gql`
    mutation CreateCpr($input: CreateCprInput!) {
  createCpr(input: $input) {
    __typename
    ... on LpAccessRoleObjectType {
      ...CommunicationPreferenceRoleFields
    }
    ... on MutationErrorResponse {
      ...CprMutationErrorFields
    }
  }
}
    ${CommunicationPreferenceRoleFieldsFragmentDoc}
${CprMutationErrorFieldsFragmentDoc}`;
export type CreateCprMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateCprMutation, GraphqlTypes.CreateCprMutationVariables>;

/**
 * __useCreateCprMutation__
 *
 * To run a mutation, you first call `useCreateCprMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCprMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCprMutation, { data, loading, error }] = useCreateCprMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCprMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateCprMutation, GraphqlTypes.CreateCprMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateCprMutation, GraphqlTypes.CreateCprMutationVariables>(CreateCprDocument, options);
      }
export type CreateCprMutationHookResult = ReturnType<typeof useCreateCprMutation>;
export type CreateCprMutationResult = Apollo.MutationResult<GraphqlTypes.CreateCprMutation>;
export type CreateCprMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateCprMutation, GraphqlTypes.CreateCprMutationVariables>;
export const UpdateCprDocument = gql`
    mutation UpdateCpr($input: UpdateCprInput!) {
  updateCpr(input: $input) {
    __typename
    ... on LpAccessRoleObjectType {
      ...CommunicationPreferenceRoleFields
    }
    ... on MutationErrorResponse {
      ...CprMutationErrorFields
    }
  }
}
    ${CommunicationPreferenceRoleFieldsFragmentDoc}
${CprMutationErrorFieldsFragmentDoc}`;
export type UpdateCprMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateCprMutation, GraphqlTypes.UpdateCprMutationVariables>;

/**
 * __useUpdateCprMutation__
 *
 * To run a mutation, you first call `useUpdateCprMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCprMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCprMutation, { data, loading, error }] = useUpdateCprMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCprMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateCprMutation, GraphqlTypes.UpdateCprMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateCprMutation, GraphqlTypes.UpdateCprMutationVariables>(UpdateCprDocument, options);
      }
export type UpdateCprMutationHookResult = ReturnType<typeof useUpdateCprMutation>;
export type UpdateCprMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateCprMutation>;
export type UpdateCprMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateCprMutation, GraphqlTypes.UpdateCprMutationVariables>;
export const UpdateCprSortOrdersDocument = gql`
    mutation UpdateCprSortOrders($input: UpdateCprSortOrdersInput!) {
  updateCprSortOrders(input: $input) {
    __typename
    ... on UpdateCprSortOrdersSuccess {
      updatedIds
    }
    ... on MutationErrorResponse {
      ...CprMutationErrorFields
    }
  }
}
    ${CprMutationErrorFieldsFragmentDoc}`;
export type UpdateCprSortOrdersMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateCprSortOrdersMutation, GraphqlTypes.UpdateCprSortOrdersMutationVariables>;

/**
 * __useUpdateCprSortOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateCprSortOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCprSortOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCprSortOrdersMutation, { data, loading, error }] = useUpdateCprSortOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCprSortOrdersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateCprSortOrdersMutation, GraphqlTypes.UpdateCprSortOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateCprSortOrdersMutation, GraphqlTypes.UpdateCprSortOrdersMutationVariables>(UpdateCprSortOrdersDocument, options);
      }
export type UpdateCprSortOrdersMutationHookResult = ReturnType<typeof useUpdateCprSortOrdersMutation>;
export type UpdateCprSortOrdersMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateCprSortOrdersMutation>;
export type UpdateCprSortOrdersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateCprSortOrdersMutation, GraphqlTypes.UpdateCprSortOrdersMutationVariables>;
export const ArchiveCprDocument = gql`
    mutation ArchiveCpr($input: CprIdInput!) {
  archiveCpr(input: $input) {
    __typename
    ... on LpAccessRoleObjectType {
      ...CommunicationPreferenceRoleFields
    }
    ... on MutationErrorResponse {
      ...CprMutationErrorFields
    }
  }
}
    ${CommunicationPreferenceRoleFieldsFragmentDoc}
${CprMutationErrorFieldsFragmentDoc}`;
export type ArchiveCprMutationFn = Apollo.MutationFunction<GraphqlTypes.ArchiveCprMutation, GraphqlTypes.ArchiveCprMutationVariables>;

/**
 * __useArchiveCprMutation__
 *
 * To run a mutation, you first call `useArchiveCprMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCprMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCprMutation, { data, loading, error }] = useArchiveCprMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCprMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ArchiveCprMutation, GraphqlTypes.ArchiveCprMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ArchiveCprMutation, GraphqlTypes.ArchiveCprMutationVariables>(ArchiveCprDocument, options);
      }
export type ArchiveCprMutationHookResult = ReturnType<typeof useArchiveCprMutation>;
export type ArchiveCprMutationResult = Apollo.MutationResult<GraphqlTypes.ArchiveCprMutation>;
export type ArchiveCprMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ArchiveCprMutation, GraphqlTypes.ArchiveCprMutationVariables>;
export const UnarchiveCprDocument = gql`
    mutation UnarchiveCpr($input: CprIdInput!) {
  unarchiveCpr(input: $input) {
    __typename
    ... on LpAccessRoleObjectType {
      ...CommunicationPreferenceRoleFields
    }
    ... on MutationErrorResponse {
      ...CprMutationErrorFields
    }
  }
}
    ${CommunicationPreferenceRoleFieldsFragmentDoc}
${CprMutationErrorFieldsFragmentDoc}`;
export type UnarchiveCprMutationFn = Apollo.MutationFunction<GraphqlTypes.UnarchiveCprMutation, GraphqlTypes.UnarchiveCprMutationVariables>;

/**
 * __useUnarchiveCprMutation__
 *
 * To run a mutation, you first call `useUnarchiveCprMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveCprMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveCprMutation, { data, loading, error }] = useUnarchiveCprMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveCprMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UnarchiveCprMutation, GraphqlTypes.UnarchiveCprMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UnarchiveCprMutation, GraphqlTypes.UnarchiveCprMutationVariables>(UnarchiveCprDocument, options);
      }
export type UnarchiveCprMutationHookResult = ReturnType<typeof useUnarchiveCprMutation>;
export type UnarchiveCprMutationResult = Apollo.MutationResult<GraphqlTypes.UnarchiveCprMutation>;
export type UnarchiveCprMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UnarchiveCprMutation, GraphqlTypes.UnarchiveCprMutationVariables>;
export const DeleteCprDocument = gql`
    mutation DeleteCpr($input: CprIdInput!) {
  deleteCpr(input: $input) {
    __typename
    ... on LpAccessRoleObjectType {
      ...CommunicationPreferenceRoleFields
    }
    ... on MutationErrorResponse {
      ...CprMutationErrorFields
    }
  }
}
    ${CommunicationPreferenceRoleFieldsFragmentDoc}
${CprMutationErrorFieldsFragmentDoc}`;
export type DeleteCprMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteCprMutation, GraphqlTypes.DeleteCprMutationVariables>;

/**
 * __useDeleteCprMutation__
 *
 * To run a mutation, you first call `useDeleteCprMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCprMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCprMutation, { data, loading, error }] = useDeleteCprMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCprMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteCprMutation, GraphqlTypes.DeleteCprMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteCprMutation, GraphqlTypes.DeleteCprMutationVariables>(DeleteCprDocument, options);
      }
export type DeleteCprMutationHookResult = ReturnType<typeof useDeleteCprMutation>;
export type DeleteCprMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteCprMutation>;
export type DeleteCprMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteCprMutation, GraphqlTypes.DeleteCprMutationVariables>;
export const GetCommunicationPreferenceRolesDocument = gql`
    query GetCommunicationPreferenceRoles($includeArchived: Boolean) {
  communicationPreferenceRoles(includeArchived: $includeArchived) {
    ...CommunicationPreferenceRoleFields
  }
}
    ${CommunicationPreferenceRoleFieldsFragmentDoc}`;

/**
 * __useGetCommunicationPreferenceRolesQuery__
 *
 * To run a query within a React component, call `useGetCommunicationPreferenceRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunicationPreferenceRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunicationPreferenceRolesQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetCommunicationPreferenceRolesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>(GetCommunicationPreferenceRolesDocument, options);
      }
export function useGetCommunicationPreferenceRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>(GetCommunicationPreferenceRolesDocument, options);
        }
// @ts-ignore
export function useGetCommunicationPreferenceRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>;
export function useGetCommunicationPreferenceRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCommunicationPreferenceRolesQuery | undefined, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>;
export function useGetCommunicationPreferenceRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>(GetCommunicationPreferenceRolesDocument, options);
        }
export type GetCommunicationPreferenceRolesQueryHookResult = ReturnType<typeof useGetCommunicationPreferenceRolesQuery>;
export type GetCommunicationPreferenceRolesLazyQueryHookResult = ReturnType<typeof useGetCommunicationPreferenceRolesLazyQuery>;
export type GetCommunicationPreferenceRolesSuspenseQueryHookResult = ReturnType<typeof useGetCommunicationPreferenceRolesSuspenseQuery>;
export type GetCommunicationPreferenceRolesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCommunicationPreferenceRolesQuery, GraphqlTypes.GetCommunicationPreferenceRolesQueryVariables>;
export const GetDocumentCategoriesForCprDocument = gql`
    query GetDocumentCategoriesForCpr($filters: DocumentCategoriesFilters) {
  documentCategories(filters: $filters) {
    edges {
      node {
        id
        name
        communicationPreferenceRole {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetDocumentCategoriesForCprQuery__
 *
 * To run a query within a React component, call `useGetDocumentCategoriesForCprQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentCategoriesForCprQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentCategoriesForCprQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDocumentCategoriesForCprQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>(GetDocumentCategoriesForCprDocument, options);
      }
export function useGetDocumentCategoriesForCprLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>(GetDocumentCategoriesForCprDocument, options);
        }
// @ts-ignore
export function useGetDocumentCategoriesForCprSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>;
export function useGetDocumentCategoriesForCprSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentCategoriesForCprQuery | undefined, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>;
export function useGetDocumentCategoriesForCprSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>(GetDocumentCategoriesForCprDocument, options);
        }
export type GetDocumentCategoriesForCprQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForCprQuery>;
export type GetDocumentCategoriesForCprLazyQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForCprLazyQuery>;
export type GetDocumentCategoriesForCprSuspenseQueryHookResult = ReturnType<typeof useGetDocumentCategoriesForCprSuspenseQuery>;
export type GetDocumentCategoriesForCprQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentCategoriesForCprQuery, GraphqlTypes.GetDocumentCategoriesForCprQueryVariables>;
export const UpdateIntegrationDetailsConfigurationDocument = gql`
    mutation UpdateIntegrationDetailsConfiguration($updateIntegrationInput: UpdateIntegrationDetailsConfigurationInput!) {
  updateIntegrationDetailsConfiguration(
    updateIntegrationInput: $updateIntegrationInput
  ) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on IntegrationDetailsObjectType {
      provenance
      configurationOptions
      configurationStatus
    }
  }
}
    `;
export type UpdateIntegrationDetailsConfigurationMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateIntegrationDetailsConfigurationMutation, GraphqlTypes.UpdateIntegrationDetailsConfigurationMutationVariables>;

/**
 * __useUpdateIntegrationDetailsConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationDetailsConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationDetailsConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationDetailsConfigurationMutation, { data, loading, error }] = useUpdateIntegrationDetailsConfigurationMutation({
 *   variables: {
 *      updateIntegrationInput: // value for 'updateIntegrationInput'
 *   },
 * });
 */
export function useUpdateIntegrationDetailsConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateIntegrationDetailsConfigurationMutation, GraphqlTypes.UpdateIntegrationDetailsConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateIntegrationDetailsConfigurationMutation, GraphqlTypes.UpdateIntegrationDetailsConfigurationMutationVariables>(UpdateIntegrationDetailsConfigurationDocument, options);
      }
export type UpdateIntegrationDetailsConfigurationMutationHookResult = ReturnType<typeof useUpdateIntegrationDetailsConfigurationMutation>;
export type UpdateIntegrationDetailsConfigurationMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateIntegrationDetailsConfigurationMutation>;
export type UpdateIntegrationDetailsConfigurationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateIntegrationDetailsConfigurationMutation, GraphqlTypes.UpdateIntegrationDetailsConfigurationMutationVariables>;
export const CreateEmailExclusionDocument = gql`
    mutation CreateEmailExclusion($input: EmailExclusionsCreateInput!) {
  createEmailExclusions(input: $input) {
    success
    message
    emailExclusions {
      id
      userId
      exclusionValue
      exclusionScope
      exclusionType
    }
  }
}
    `;
export type CreateEmailExclusionMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateEmailExclusionMutation, GraphqlTypes.CreateEmailExclusionMutationVariables>;

/**
 * __useCreateEmailExclusionMutation__
 *
 * To run a mutation, you first call `useCreateEmailExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailExclusionMutation, { data, loading, error }] = useCreateEmailExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailExclusionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateEmailExclusionMutation, GraphqlTypes.CreateEmailExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateEmailExclusionMutation, GraphqlTypes.CreateEmailExclusionMutationVariables>(CreateEmailExclusionDocument, options);
      }
export type CreateEmailExclusionMutationHookResult = ReturnType<typeof useCreateEmailExclusionMutation>;
export type CreateEmailExclusionMutationResult = Apollo.MutationResult<GraphqlTypes.CreateEmailExclusionMutation>;
export type CreateEmailExclusionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateEmailExclusionMutation, GraphqlTypes.CreateEmailExclusionMutationVariables>;
export const DeleteEmailExclusionDocument = gql`
    mutation DeleteEmailExclusion($input: EmailExclusionsDeleteInput!) {
  deleteEmailExclusions(input: $input) {
    success
    message
  }
}
    `;
export type DeleteEmailExclusionMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteEmailExclusionMutation, GraphqlTypes.DeleteEmailExclusionMutationVariables>;

/**
 * __useDeleteEmailExclusionMutation__
 *
 * To run a mutation, you first call `useDeleteEmailExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailExclusionMutation, { data, loading, error }] = useDeleteEmailExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEmailExclusionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteEmailExclusionMutation, GraphqlTypes.DeleteEmailExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteEmailExclusionMutation, GraphqlTypes.DeleteEmailExclusionMutationVariables>(DeleteEmailExclusionDocument, options);
      }
export type DeleteEmailExclusionMutationHookResult = ReturnType<typeof useDeleteEmailExclusionMutation>;
export type DeleteEmailExclusionMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteEmailExclusionMutation>;
export type DeleteEmailExclusionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteEmailExclusionMutation, GraphqlTypes.DeleteEmailExclusionMutationVariables>;
export const GetIntegrationMicrosoftOauthUrlDocument = gql`
    query GetIntegrationMicrosoftOauthUrl($emailAddress: String!, $activityTypes: [ActivityTypeEnum!]!) {
  integrationMicrosoftOauthUrl(
    emailAddress: $emailAddress
    activityTypes: $activityTypes
  ) {
    url
  }
}
    `;

/**
 * __useGetIntegrationMicrosoftOauthUrlQuery__
 *
 * To run a query within a React component, call `useGetIntegrationMicrosoftOauthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationMicrosoftOauthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationMicrosoftOauthUrlQuery({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      activityTypes: // value for 'activityTypes'
 *   },
 * });
 */
export function useGetIntegrationMicrosoftOauthUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables> & ({ variables: GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>(GetIntegrationMicrosoftOauthUrlDocument, options);
      }
export function useGetIntegrationMicrosoftOauthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>(GetIntegrationMicrosoftOauthUrlDocument, options);
        }
// @ts-ignore
export function useGetIntegrationMicrosoftOauthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>;
export function useGetIntegrationMicrosoftOauthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery | undefined, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>;
export function useGetIntegrationMicrosoftOauthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>(GetIntegrationMicrosoftOauthUrlDocument, options);
        }
export type GetIntegrationMicrosoftOauthUrlQueryHookResult = ReturnType<typeof useGetIntegrationMicrosoftOauthUrlQuery>;
export type GetIntegrationMicrosoftOauthUrlLazyQueryHookResult = ReturnType<typeof useGetIntegrationMicrosoftOauthUrlLazyQuery>;
export type GetIntegrationMicrosoftOauthUrlSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationMicrosoftOauthUrlSuspenseQuery>;
export type GetIntegrationMicrosoftOauthUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationMicrosoftOauthUrlQuery, GraphqlTypes.GetIntegrationMicrosoftOauthUrlQueryVariables>;
export const GetIntegrationGoogleOauthUrlDocument = gql`
    query GetIntegrationGoogleOauthUrl($emailAddress: String!, $activityTypes: [ActivityTypeEnum!]!) {
  integrationGoogleOauthUrl(
    emailAddress: $emailAddress
    activityTypes: $activityTypes
  ) {
    url
  }
}
    `;

/**
 * __useGetIntegrationGoogleOauthUrlQuery__
 *
 * To run a query within a React component, call `useGetIntegrationGoogleOauthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationGoogleOauthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationGoogleOauthUrlQuery({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      activityTypes: // value for 'activityTypes'
 *   },
 * });
 */
export function useGetIntegrationGoogleOauthUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables> & ({ variables: GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>(GetIntegrationGoogleOauthUrlDocument, options);
      }
export function useGetIntegrationGoogleOauthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>(GetIntegrationGoogleOauthUrlDocument, options);
        }
// @ts-ignore
export function useGetIntegrationGoogleOauthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>;
export function useGetIntegrationGoogleOauthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery | undefined, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>;
export function useGetIntegrationGoogleOauthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>(GetIntegrationGoogleOauthUrlDocument, options);
        }
export type GetIntegrationGoogleOauthUrlQueryHookResult = ReturnType<typeof useGetIntegrationGoogleOauthUrlQuery>;
export type GetIntegrationGoogleOauthUrlLazyQueryHookResult = ReturnType<typeof useGetIntegrationGoogleOauthUrlLazyQuery>;
export type GetIntegrationGoogleOauthUrlSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationGoogleOauthUrlSuspenseQuery>;
export type GetIntegrationGoogleOauthUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationGoogleOauthUrlQuery, GraphqlTypes.GetIntegrationGoogleOauthUrlQueryVariables>;
export const GetIntegrationDetailsConnectedAccountsDocument = gql`
    query GetIntegrationDetailsConnectedAccounts($provenance: [String!]!) {
  integrationList(provenance: $provenance) {
    connectionStatus
    provenance
    configurationOptions
    configurationStatus
    connectionId
    id
  }
}
    `;

/**
 * __useGetIntegrationDetailsConnectedAccountsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationDetailsConnectedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationDetailsConnectedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationDetailsConnectedAccountsQuery({
 *   variables: {
 *      provenance: // value for 'provenance'
 *   },
 * });
 */
export function useGetIntegrationDetailsConnectedAccountsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables> & ({ variables: GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>(GetIntegrationDetailsConnectedAccountsDocument, options);
      }
export function useGetIntegrationDetailsConnectedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>(GetIntegrationDetailsConnectedAccountsDocument, options);
        }
// @ts-ignore
export function useGetIntegrationDetailsConnectedAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>;
export function useGetIntegrationDetailsConnectedAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery | undefined, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>;
export function useGetIntegrationDetailsConnectedAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>(GetIntegrationDetailsConnectedAccountsDocument, options);
        }
export type GetIntegrationDetailsConnectedAccountsQueryHookResult = ReturnType<typeof useGetIntegrationDetailsConnectedAccountsQuery>;
export type GetIntegrationDetailsConnectedAccountsLazyQueryHookResult = ReturnType<typeof useGetIntegrationDetailsConnectedAccountsLazyQuery>;
export type GetIntegrationDetailsConnectedAccountsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationDetailsConnectedAccountsSuspenseQuery>;
export type GetIntegrationDetailsConnectedAccountsQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationDetailsConnectedAccountsQuery, GraphqlTypes.GetIntegrationDetailsConnectedAccountsQueryVariables>;
export const GetIntegrationsByProvenanceAndUserIdDocument = gql`
    query GetIntegrationsByProvenanceAndUserId($provenances: [String!]!, $userId: Int!) {
  integrationsByProvenanceAndAssociatedUserId(
    provenance: $provenances
    userId: $userId
  ) {
    id
    provenance
    integrationStatus
    connectionStatus
    connectionStatusDetails
    configurationStatus
    configurationOptions
    configurationStatusDetails
    connectionId
  }
}
    `;

/**
 * __useGetIntegrationsByProvenanceAndUserIdQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsByProvenanceAndUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsByProvenanceAndUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsByProvenanceAndUserIdQuery({
 *   variables: {
 *      provenances: // value for 'provenances'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetIntegrationsByProvenanceAndUserIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables> & ({ variables: GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>(GetIntegrationsByProvenanceAndUserIdDocument, options);
      }
export function useGetIntegrationsByProvenanceAndUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>(GetIntegrationsByProvenanceAndUserIdDocument, options);
        }
// @ts-ignore
export function useGetIntegrationsByProvenanceAndUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>;
export function useGetIntegrationsByProvenanceAndUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery | undefined, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>;
export function useGetIntegrationsByProvenanceAndUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>(GetIntegrationsByProvenanceAndUserIdDocument, options);
        }
export type GetIntegrationsByProvenanceAndUserIdQueryHookResult = ReturnType<typeof useGetIntegrationsByProvenanceAndUserIdQuery>;
export type GetIntegrationsByProvenanceAndUserIdLazyQueryHookResult = ReturnType<typeof useGetIntegrationsByProvenanceAndUserIdLazyQuery>;
export type GetIntegrationsByProvenanceAndUserIdSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationsByProvenanceAndUserIdSuspenseQuery>;
export type GetIntegrationsByProvenanceAndUserIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQuery, GraphqlTypes.GetIntegrationsByProvenanceAndUserIdQueryVariables>;
export const GetArenaScopedEmailExclusionsDocument = gql`
    query GetArenaScopedEmailExclusions($arenaId: Int!, $userId: Int!) {
  getEmailExclusions(arenaId: $arenaId, userId: $userId) {
    success
    message
    emailExclusions {
      id
      arenaId
      userId
      exclusionValue
      exclusionType
      exclusionScope
    }
  }
}
    `;

/**
 * __useGetArenaScopedEmailExclusionsQuery__
 *
 * To run a query within a React component, call `useGetArenaScopedEmailExclusionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaScopedEmailExclusionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaScopedEmailExclusionsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetArenaScopedEmailExclusionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables> & ({ variables: GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>(GetArenaScopedEmailExclusionsDocument, options);
      }
export function useGetArenaScopedEmailExclusionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>(GetArenaScopedEmailExclusionsDocument, options);
        }
// @ts-ignore
export function useGetArenaScopedEmailExclusionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>;
export function useGetArenaScopedEmailExclusionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaScopedEmailExclusionsQuery | undefined, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>;
export function useGetArenaScopedEmailExclusionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>(GetArenaScopedEmailExclusionsDocument, options);
        }
export type GetArenaScopedEmailExclusionsQueryHookResult = ReturnType<typeof useGetArenaScopedEmailExclusionsQuery>;
export type GetArenaScopedEmailExclusionsLazyQueryHookResult = ReturnType<typeof useGetArenaScopedEmailExclusionsLazyQuery>;
export type GetArenaScopedEmailExclusionsSuspenseQueryHookResult = ReturnType<typeof useGetArenaScopedEmailExclusionsSuspenseQuery>;
export type GetArenaScopedEmailExclusionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaScopedEmailExclusionsQuery, GraphqlTypes.GetArenaScopedEmailExclusionsQueryVariables>;
export const ValidateConnectionIdDocument = gql`
    query ValidateConnectionId($prov: String!, $id: String!) {
  validateIntegrationDetailsConnectionIdByProvenance(
    provenance: $prov
    connectionId: $id
  )
}
    `;

/**
 * __useValidateConnectionIdQuery__
 *
 * To run a query within a React component, call `useValidateConnectionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateConnectionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateConnectionIdQuery({
 *   variables: {
 *      prov: // value for 'prov'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateConnectionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables> & ({ variables: GraphqlTypes.ValidateConnectionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>(ValidateConnectionIdDocument, options);
      }
export function useValidateConnectionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>(ValidateConnectionIdDocument, options);
        }
// @ts-ignore
export function useValidateConnectionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>;
export function useValidateConnectionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ValidateConnectionIdQuery | undefined, GraphqlTypes.ValidateConnectionIdQueryVariables>;
export function useValidateConnectionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>(ValidateConnectionIdDocument, options);
        }
export type ValidateConnectionIdQueryHookResult = ReturnType<typeof useValidateConnectionIdQuery>;
export type ValidateConnectionIdLazyQueryHookResult = ReturnType<typeof useValidateConnectionIdLazyQuery>;
export type ValidateConnectionIdSuspenseQueryHookResult = ReturnType<typeof useValidateConnectionIdSuspenseQuery>;
export type ValidateConnectionIdQueryResult = Apollo.QueryResult<GraphqlTypes.ValidateConnectionIdQuery, GraphqlTypes.ValidateConnectionIdQueryVariables>;
export const ContactFormConfigCreateOrUpdateFormFieldConfigsDocument = gql`
    mutation ContactFormConfigCreateOrUpdateFormFieldConfigs($inputs: [UpsertFormFieldConfigsInput!]!) {
  createOrUpdateFormFieldConfigs(inputs: $inputs) {
    __typename
    ... on UpsertFormFieldConfigsSuccess {
      configs {
        id
        fieldIdentifier
        fieldType
        fieldFormat
        extensionFieldId
        isVisible
        isRequired
        sortOrder
        isStandardField
        isCustomField
        isGlobalDefault
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ContactFormConfigCreateOrUpdateFormFieldConfigsMutationFn = Apollo.MutationFunction<GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutation, GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutationVariables>;

/**
 * __useContactFormConfigCreateOrUpdateFormFieldConfigsMutation__
 *
 * To run a mutation, you first call `useContactFormConfigCreateOrUpdateFormFieldConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactFormConfigCreateOrUpdateFormFieldConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactFormConfigCreateOrUpdateFormFieldConfigsMutation, { data, loading, error }] = useContactFormConfigCreateOrUpdateFormFieldConfigsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useContactFormConfigCreateOrUpdateFormFieldConfigsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutation, GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutation, GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutationVariables>(ContactFormConfigCreateOrUpdateFormFieldConfigsDocument, options);
      }
export type ContactFormConfigCreateOrUpdateFormFieldConfigsMutationHookResult = ReturnType<typeof useContactFormConfigCreateOrUpdateFormFieldConfigsMutation>;
export type ContactFormConfigCreateOrUpdateFormFieldConfigsMutationResult = Apollo.MutationResult<GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutation>;
export type ContactFormConfigCreateOrUpdateFormFieldConfigsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutation, GraphqlTypes.ContactFormConfigCreateOrUpdateFormFieldConfigsMutationVariables>;
export const ContactFormConfigGetFormFieldConfigsDocument = gql`
    query ContactFormConfigGetFormFieldConfigs($objectType: JSQObjectType!, $subObjectType: FormFieldSubObjectTypeEnum!) {
  formFieldConfigs(objectType: $objectType, subObjectType: $subObjectType) {
    id
    arenaId
    objectType
    subObjectType
    fieldIdentifier
    fieldType
    fieldFormat
    extensionFieldId
    isVisible
    isRequired
    sortOrder
    isStandardField
    isCustomField
    isGlobalDefault
  }
}
    `;

/**
 * __useContactFormConfigGetFormFieldConfigsQuery__
 *
 * To run a query within a React component, call `useContactFormConfigGetFormFieldConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactFormConfigGetFormFieldConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFormConfigGetFormFieldConfigsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      subObjectType: // value for 'subObjectType'
 *   },
 * });
 */
export function useContactFormConfigGetFormFieldConfigsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables> & ({ variables: GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>(ContactFormConfigGetFormFieldConfigsDocument, options);
      }
export function useContactFormConfigGetFormFieldConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>(ContactFormConfigGetFormFieldConfigsDocument, options);
        }
// @ts-ignore
export function useContactFormConfigGetFormFieldConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>;
export function useContactFormConfigGetFormFieldConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery | undefined, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>;
export function useContactFormConfigGetFormFieldConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>(ContactFormConfigGetFormFieldConfigsDocument, options);
        }
export type ContactFormConfigGetFormFieldConfigsQueryHookResult = ReturnType<typeof useContactFormConfigGetFormFieldConfigsQuery>;
export type ContactFormConfigGetFormFieldConfigsLazyQueryHookResult = ReturnType<typeof useContactFormConfigGetFormFieldConfigsLazyQuery>;
export type ContactFormConfigGetFormFieldConfigsSuspenseQueryHookResult = ReturnType<typeof useContactFormConfigGetFormFieldConfigsSuspenseQuery>;
export type ContactFormConfigGetFormFieldConfigsQueryResult = Apollo.QueryResult<GraphqlTypes.ContactFormConfigGetFormFieldConfigsQuery, GraphqlTypes.ContactFormConfigGetFormFieldConfigsQueryVariables>;
export const CreateContactRelationLabelDocument = gql`
    mutation CreateContactRelationLabel($input: CreateContactRelationLabelInput!) {
  createContactRelationLabel(input: $input) {
    ... on ContactRelationLabelObjectType {
      id
      labelText
      inverseLabelText
      availableTo
      inverseAvailableTo
      isArchived
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type CreateContactRelationLabelMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateContactRelationLabelMutation, GraphqlTypes.CreateContactRelationLabelMutationVariables>;

/**
 * __useCreateContactRelationLabelMutation__
 *
 * To run a mutation, you first call `useCreateContactRelationLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactRelationLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactRelationLabelMutation, { data, loading, error }] = useCreateContactRelationLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactRelationLabelMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateContactRelationLabelMutation, GraphqlTypes.CreateContactRelationLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateContactRelationLabelMutation, GraphqlTypes.CreateContactRelationLabelMutationVariables>(CreateContactRelationLabelDocument, options);
      }
export type CreateContactRelationLabelMutationHookResult = ReturnType<typeof useCreateContactRelationLabelMutation>;
export type CreateContactRelationLabelMutationResult = Apollo.MutationResult<GraphqlTypes.CreateContactRelationLabelMutation>;
export type CreateContactRelationLabelMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateContactRelationLabelMutation, GraphqlTypes.CreateContactRelationLabelMutationVariables>;
export const UpdateContactRelationLabelDocument = gql`
    mutation UpdateContactRelationLabel($input: UpdateContactRelationLabelInput!) {
  updateContactRelationLabel(input: $input) {
    ... on ContactRelationLabelObjectType {
      id
      labelText
      inverseLabelText
      availableTo
      inverseAvailableTo
      isArchived
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpdateContactRelationLabelMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateContactRelationLabelMutation, GraphqlTypes.UpdateContactRelationLabelMutationVariables>;

/**
 * __useUpdateContactRelationLabelMutation__
 *
 * To run a mutation, you first call `useUpdateContactRelationLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactRelationLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactRelationLabelMutation, { data, loading, error }] = useUpdateContactRelationLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactRelationLabelMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateContactRelationLabelMutation, GraphqlTypes.UpdateContactRelationLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateContactRelationLabelMutation, GraphqlTypes.UpdateContactRelationLabelMutationVariables>(UpdateContactRelationLabelDocument, options);
      }
export type UpdateContactRelationLabelMutationHookResult = ReturnType<typeof useUpdateContactRelationLabelMutation>;
export type UpdateContactRelationLabelMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateContactRelationLabelMutation>;
export type UpdateContactRelationLabelMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateContactRelationLabelMutation, GraphqlTypes.UpdateContactRelationLabelMutationVariables>;
export const DeleteContactRelationLabelDocument = gql`
    mutation DeleteContactRelationLabel($input: DeleteContactRelationLabelInput!) {
  deleteContactRelationLabel(input: $input) {
    ... on ContactRelationLabelObjectType {
      id
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DeleteContactRelationLabelMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteContactRelationLabelMutation, GraphqlTypes.DeleteContactRelationLabelMutationVariables>;

/**
 * __useDeleteContactRelationLabelMutation__
 *
 * To run a mutation, you first call `useDeleteContactRelationLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactRelationLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactRelationLabelMutation, { data, loading, error }] = useDeleteContactRelationLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContactRelationLabelMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteContactRelationLabelMutation, GraphqlTypes.DeleteContactRelationLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteContactRelationLabelMutation, GraphqlTypes.DeleteContactRelationLabelMutationVariables>(DeleteContactRelationLabelDocument, options);
      }
export type DeleteContactRelationLabelMutationHookResult = ReturnType<typeof useDeleteContactRelationLabelMutation>;
export type DeleteContactRelationLabelMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteContactRelationLabelMutation>;
export type DeleteContactRelationLabelMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteContactRelationLabelMutation, GraphqlTypes.DeleteContactRelationLabelMutationVariables>;
export const MergeContactRelationLabelDocument = gql`
    mutation MergeContactRelationLabel($input: MergeContactRelationLabelInput!) {
  mergeContactRelationLabel(input: $input) {
    ... on ContactRelationLabelObjectType {
      id
      labelText
      inverseLabelText
      availableTo
      inverseAvailableTo
      isArchived
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type MergeContactRelationLabelMutationFn = Apollo.MutationFunction<GraphqlTypes.MergeContactRelationLabelMutation, GraphqlTypes.MergeContactRelationLabelMutationVariables>;

/**
 * __useMergeContactRelationLabelMutation__
 *
 * To run a mutation, you first call `useMergeContactRelationLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeContactRelationLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeContactRelationLabelMutation, { data, loading, error }] = useMergeContactRelationLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeContactRelationLabelMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.MergeContactRelationLabelMutation, GraphqlTypes.MergeContactRelationLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.MergeContactRelationLabelMutation, GraphqlTypes.MergeContactRelationLabelMutationVariables>(MergeContactRelationLabelDocument, options);
      }
export type MergeContactRelationLabelMutationHookResult = ReturnType<typeof useMergeContactRelationLabelMutation>;
export type MergeContactRelationLabelMutationResult = Apollo.MutationResult<GraphqlTypes.MergeContactRelationLabelMutation>;
export type MergeContactRelationLabelMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.MergeContactRelationLabelMutation, GraphqlTypes.MergeContactRelationLabelMutationVariables>;
export const UpdateContactRelationLabelSortOrdersDocument = gql`
    mutation UpdateContactRelationLabelSortOrders($input: UpdateContactRelationLabelSortOrdersInput!) {
  updateContactRelationLabelSortOrders(input: $input) {
    ... on UpdateContactRelationLabelSortOrdersSuccess {
      updatedLabelIds
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpdateContactRelationLabelSortOrdersMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateContactRelationLabelSortOrdersMutation, GraphqlTypes.UpdateContactRelationLabelSortOrdersMutationVariables>;

/**
 * __useUpdateContactRelationLabelSortOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateContactRelationLabelSortOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactRelationLabelSortOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactRelationLabelSortOrdersMutation, { data, loading, error }] = useUpdateContactRelationLabelSortOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactRelationLabelSortOrdersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateContactRelationLabelSortOrdersMutation, GraphqlTypes.UpdateContactRelationLabelSortOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateContactRelationLabelSortOrdersMutation, GraphqlTypes.UpdateContactRelationLabelSortOrdersMutationVariables>(UpdateContactRelationLabelSortOrdersDocument, options);
      }
export type UpdateContactRelationLabelSortOrdersMutationHookResult = ReturnType<typeof useUpdateContactRelationLabelSortOrdersMutation>;
export type UpdateContactRelationLabelSortOrdersMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateContactRelationLabelSortOrdersMutation>;
export type UpdateContactRelationLabelSortOrdersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateContactRelationLabelSortOrdersMutation, GraphqlTypes.UpdateContactRelationLabelSortOrdersMutationVariables>;
export const GetContactRelationLabelsDocument = gql`
    query GetContactRelationLabels($includeArchived: Boolean) {
  contactRelationLabels(includeArchived: $includeArchived) {
    id
    labelText
    inverseLabelText
    sortOrder
    availableTo
    inverseAvailableTo
    isArchived
  }
}
    `;

/**
 * __useGetContactRelationLabelsQuery__
 *
 * To run a query within a React component, call `useGetContactRelationLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactRelationLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactRelationLabelsQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetContactRelationLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>(GetContactRelationLabelsDocument, options);
      }
export function useGetContactRelationLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>(GetContactRelationLabelsDocument, options);
        }
// @ts-ignore
export function useGetContactRelationLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>;
export function useGetContactRelationLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactRelationLabelsQuery | undefined, GraphqlTypes.GetContactRelationLabelsQueryVariables>;
export function useGetContactRelationLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>(GetContactRelationLabelsDocument, options);
        }
export type GetContactRelationLabelsQueryHookResult = ReturnType<typeof useGetContactRelationLabelsQuery>;
export type GetContactRelationLabelsLazyQueryHookResult = ReturnType<typeof useGetContactRelationLabelsLazyQuery>;
export type GetContactRelationLabelsSuspenseQueryHookResult = ReturnType<typeof useGetContactRelationLabelsSuspenseQuery>;
export type GetContactRelationLabelsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactRelationLabelsQuery, GraphqlTypes.GetContactRelationLabelsQueryVariables>;
export const GetContactRelationLabelUsageCountDocument = gql`
    query GetContactRelationLabelUsageCount($labelId: ID!) {
  contactRelationLabelUsageCount(labelId: $labelId)
}
    `;

/**
 * __useGetContactRelationLabelUsageCountQuery__
 *
 * To run a query within a React component, call `useGetContactRelationLabelUsageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactRelationLabelUsageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactRelationLabelUsageCountQuery({
 *   variables: {
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useGetContactRelationLabelUsageCountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables> & ({ variables: GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>(GetContactRelationLabelUsageCountDocument, options);
      }
export function useGetContactRelationLabelUsageCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>(GetContactRelationLabelUsageCountDocument, options);
        }
// @ts-ignore
export function useGetContactRelationLabelUsageCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>;
export function useGetContactRelationLabelUsageCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactRelationLabelUsageCountQuery | undefined, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>;
export function useGetContactRelationLabelUsageCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>(GetContactRelationLabelUsageCountDocument, options);
        }
export type GetContactRelationLabelUsageCountQueryHookResult = ReturnType<typeof useGetContactRelationLabelUsageCountQuery>;
export type GetContactRelationLabelUsageCountLazyQueryHookResult = ReturnType<typeof useGetContactRelationLabelUsageCountLazyQuery>;
export type GetContactRelationLabelUsageCountSuspenseQueryHookResult = ReturnType<typeof useGetContactRelationLabelUsageCountSuspenseQuery>;
export type GetContactRelationLabelUsageCountQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactRelationLabelUsageCountQuery, GraphqlTypes.GetContactRelationLabelUsageCountQueryVariables>;
export const GetContactPermissionsDocument = gql`
    query GetContactPermissions($contactId: ID!, $globalContactId: String!) {
  currentArena {
    features {
      hasAdvancedPermissions
    }
  }
  currentUser {
    userPermissions {
      canManageContact(globalContactId: $globalContactId)
      canManageOffering
    }
  }
  contact(contactId: $contactId) {
    id
    ...ContactRelationAccessFields
  }
}
    ${ContactRelationAccessFieldsFragmentDoc}`;

/**
 * __useGetContactPermissionsQuery__
 *
 * To run a query within a React component, call `useGetContactPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactPermissionsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      globalContactId: // value for 'globalContactId'
 *   },
 * });
 */
export function useGetContactPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables> & ({ variables: GraphqlTypes.GetContactPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>(GetContactPermissionsDocument, options);
      }
export function useGetContactPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>(GetContactPermissionsDocument, options);
        }
// @ts-ignore
export function useGetContactPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>;
export function useGetContactPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactPermissionsQuery | undefined, GraphqlTypes.GetContactPermissionsQueryVariables>;
export function useGetContactPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>(GetContactPermissionsDocument, options);
        }
export type GetContactPermissionsQueryHookResult = ReturnType<typeof useGetContactPermissionsQuery>;
export type GetContactPermissionsLazyQueryHookResult = ReturnType<typeof useGetContactPermissionsLazyQuery>;
export type GetContactPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetContactPermissionsSuspenseQuery>;
export type GetContactPermissionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactPermissionsQuery, GraphqlTypes.GetContactPermissionsQueryVariables>;
export const GetContactRelationsDocument = gql`
    query GetContactRelations($contactId: ID!) {
  contact(contactId: $contactId) {
    id
    fullName
    contactType
    jobTitle
    ...ContactRelationAccessFields
    isStarredStaff
    isStarredStaffOrg
    staffNotes
    includeInFutureOrgProspects
    company {
      id
      fullName
      contactType
      ...ContactRelationAccessFields
    }
    staff {
      id
      fullName
      jobTitle
      staffNotes
      isStarredStaff
      isStarredStaffOrg
      includeInFutureOrgProspects
      ...ContactRelationAccessFields
    }
    formerStaff {
      id
      jobTitle
      person {
        id
        fullName
        jobTitle
        contactType
        ...ContactRelationAccessFields
      }
    }
    relations {
      id
      notes
      isContactStarred
      isRelatedContactStarred
      contact {
        id
        fullName
        jobTitle
        contactType
        ...ContactRelationAccessFields
        staff {
          id
          fullName
        }
      }
      relatedContact {
        id
        fullName
        jobTitle
        contactType
        ...ContactRelationAccessFields
        staff {
          id
          fullName
        }
      }
      label
      inverseLabel
      labelId
      labelSide
      relationLabel {
        sortOrder
      }
      includeContactInFutureOrgProspects
      includeRelatedContactInFutureOrgProspects
      keyPersons {
        id
        relationSide
        notes
        includeInFutureOrgProspects
        isStarred
        contact {
          id
          fullName
          jobTitle
          ...ContactRelationAccessFields
        }
      }
    }
  }
}
    ${ContactRelationAccessFieldsFragmentDoc}`;

/**
 * __useGetContactRelationsQuery__
 *
 * To run a query within a React component, call `useGetContactRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactRelationsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactRelationsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables> & ({ variables: GraphqlTypes.GetContactRelationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>(GetContactRelationsDocument, options);
      }
export function useGetContactRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>(GetContactRelationsDocument, options);
        }
// @ts-ignore
export function useGetContactRelationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>;
export function useGetContactRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactRelationsQuery | undefined, GraphqlTypes.GetContactRelationsQueryVariables>;
export function useGetContactRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>(GetContactRelationsDocument, options);
        }
export type GetContactRelationsQueryHookResult = ReturnType<typeof useGetContactRelationsQuery>;
export type GetContactRelationsLazyQueryHookResult = ReturnType<typeof useGetContactRelationsLazyQuery>;
export type GetContactRelationsSuspenseQueryHookResult = ReturnType<typeof useGetContactRelationsSuspenseQuery>;
export type GetContactRelationsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactRelationsQuery, GraphqlTypes.GetContactRelationsQueryVariables>;
export const GetContactProspectsMapsPageDocument = gql`
    query GetContactProspectsMapsPage($contactId: ID!, $first: Int!, $after: String) {
  contactProspects(
    contactId: $contactId
    includeInactive: false
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        prospect {
          id
          offeringId
          offeringName
          prospectContactMaps {
            contactId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetContactProspectsMapsPageQuery__
 *
 * To run a query within a React component, call `useGetContactProspectsMapsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactProspectsMapsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactProspectsMapsPageQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetContactProspectsMapsPageQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables> & ({ variables: GraphqlTypes.GetContactProspectsMapsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>(GetContactProspectsMapsPageDocument, options);
      }
export function useGetContactProspectsMapsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>(GetContactProspectsMapsPageDocument, options);
        }
// @ts-ignore
export function useGetContactProspectsMapsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>;
export function useGetContactProspectsMapsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactProspectsMapsPageQuery | undefined, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>;
export function useGetContactProspectsMapsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>(GetContactProspectsMapsPageDocument, options);
        }
export type GetContactProspectsMapsPageQueryHookResult = ReturnType<typeof useGetContactProspectsMapsPageQuery>;
export type GetContactProspectsMapsPageLazyQueryHookResult = ReturnType<typeof useGetContactProspectsMapsPageLazyQuery>;
export type GetContactProspectsMapsPageSuspenseQueryHookResult = ReturnType<typeof useGetContactProspectsMapsPageSuspenseQuery>;
export type GetContactProspectsMapsPageQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactProspectsMapsPageQuery, GraphqlTypes.GetContactProspectsMapsPageQueryVariables>;
export const GetStarredRelationsDocument = gql`
    query GetStarredRelations($contactId: ID!) {
  currentArena {
    features {
      hasAdvancedPermissions
    }
  }
  contact(contactId: $contactId) {
    id
    isStarredStaff
    isStarredStaffOrg
    jobTitle
    staff {
      ...ContactStarredRelationsCardLeanFields
      isStarredStaff
    }
    company {
      id
      fullName
      ...ContactStarredRelationsListFields
    }
    ...ContactStarredRelationsListFields
  }
}
    ${ContactStarredRelationsCardLeanFieldsFragmentDoc}
${ContactStarredRelationsListFieldsFragmentDoc}`;

/**
 * __useGetStarredRelationsQuery__
 *
 * To run a query within a React component, call `useGetStarredRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStarredRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStarredRelationsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetStarredRelationsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables> & ({ variables: GraphqlTypes.GetStarredRelationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>(GetStarredRelationsDocument, options);
      }
export function useGetStarredRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>(GetStarredRelationsDocument, options);
        }
// @ts-ignore
export function useGetStarredRelationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>;
export function useGetStarredRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStarredRelationsQuery | undefined, GraphqlTypes.GetStarredRelationsQueryVariables>;
export function useGetStarredRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>(GetStarredRelationsDocument, options);
        }
export type GetStarredRelationsQueryHookResult = ReturnType<typeof useGetStarredRelationsQuery>;
export type GetStarredRelationsLazyQueryHookResult = ReturnType<typeof useGetStarredRelationsLazyQuery>;
export type GetStarredRelationsSuspenseQueryHookResult = ReturnType<typeof useGetStarredRelationsSuspenseQuery>;
export type GetStarredRelationsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStarredRelationsQuery, GraphqlTypes.GetStarredRelationsQueryVariables>;
export const SubscriptionsInitiateBulkCountersignDocument = gql`
    mutation SubscriptionsInitiateBulkCountersign($objectInput: BulkCountersignInput!) {
  subscriptionsConfigureBulkDocusign(objectInput: $objectInput) {
    ... on MutationErrorResponse {
      message
      errorCode
    }
    ... on AsyncJobObjectType {
      id
      status
      data
    }
  }
}
    `;
export type SubscriptionsInitiateBulkCountersignMutationFn = Apollo.MutationFunction<GraphqlTypes.SubscriptionsInitiateBulkCountersignMutation, GraphqlTypes.SubscriptionsInitiateBulkCountersignMutationVariables>;

/**
 * __useSubscriptionsInitiateBulkCountersignMutation__
 *
 * To run a mutation, you first call `useSubscriptionsInitiateBulkCountersignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsInitiateBulkCountersignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionsInitiateBulkCountersignMutation, { data, loading, error }] = useSubscriptionsInitiateBulkCountersignMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSubscriptionsInitiateBulkCountersignMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubscriptionsInitiateBulkCountersignMutation, GraphqlTypes.SubscriptionsInitiateBulkCountersignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubscriptionsInitiateBulkCountersignMutation, GraphqlTypes.SubscriptionsInitiateBulkCountersignMutationVariables>(SubscriptionsInitiateBulkCountersignDocument, options);
      }
export type SubscriptionsInitiateBulkCountersignMutationHookResult = ReturnType<typeof useSubscriptionsInitiateBulkCountersignMutation>;
export type SubscriptionsInitiateBulkCountersignMutationResult = Apollo.MutationResult<GraphqlTypes.SubscriptionsInitiateBulkCountersignMutation>;
export type SubscriptionsInitiateBulkCountersignMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubscriptionsInitiateBulkCountersignMutation, GraphqlTypes.SubscriptionsInitiateBulkCountersignMutationVariables>;
export const ProspectsReadyForBulkCountersignDocument = gql`
    mutation ProspectsReadyForBulkCountersign($objectInput: ProspectReadyForCountersignInput!) {
  prospectsReadyForBulkCountersign(input: $objectInput) {
    ... on AsyncJobObjectType {
      id
      status
      data
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type ProspectsReadyForBulkCountersignMutationFn = Apollo.MutationFunction<GraphqlTypes.ProspectsReadyForBulkCountersignMutation, GraphqlTypes.ProspectsReadyForBulkCountersignMutationVariables>;

/**
 * __useProspectsReadyForBulkCountersignMutation__
 *
 * To run a mutation, you first call `useProspectsReadyForBulkCountersignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProspectsReadyForBulkCountersignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prospectsReadyForBulkCountersignMutation, { data, loading, error }] = useProspectsReadyForBulkCountersignMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useProspectsReadyForBulkCountersignMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ProspectsReadyForBulkCountersignMutation, GraphqlTypes.ProspectsReadyForBulkCountersignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ProspectsReadyForBulkCountersignMutation, GraphqlTypes.ProspectsReadyForBulkCountersignMutationVariables>(ProspectsReadyForBulkCountersignDocument, options);
      }
export type ProspectsReadyForBulkCountersignMutationHookResult = ReturnType<typeof useProspectsReadyForBulkCountersignMutation>;
export type ProspectsReadyForBulkCountersignMutationResult = Apollo.MutationResult<GraphqlTypes.ProspectsReadyForBulkCountersignMutation>;
export type ProspectsReadyForBulkCountersignMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ProspectsReadyForBulkCountersignMutation, GraphqlTypes.ProspectsReadyForBulkCountersignMutationVariables>;
export const EditPortalHeroMetricsConfigDocument = gql`
    mutation EditPortalHeroMetricsConfig($input: EditPortalHeroMetricsConfigInput!) {
  editPortalHeroMetricsConfig(input: $input) {
    result {
      ... on PortalHeroMetricsConfigObjectType {
        id
        title
        isTitleVisible
        filterVisibility
        canFilterVisibility
        portalHeroMetricsFields {
          id
          fieldType
          fieldName
          sortOrder
        }
        restrictedCustomFields {
          extensionFieldId
        }
      }
      ... on MutationErrorResponse {
        message
        errorCode
      }
    }
  }
}
    `;
export type EditPortalHeroMetricsConfigMutationFn = Apollo.MutationFunction<GraphqlTypes.EditPortalHeroMetricsConfigMutation, GraphqlTypes.EditPortalHeroMetricsConfigMutationVariables>;

/**
 * __useEditPortalHeroMetricsConfigMutation__
 *
 * To run a mutation, you first call `useEditPortalHeroMetricsConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPortalHeroMetricsConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPortalHeroMetricsConfigMutation, { data, loading, error }] = useEditPortalHeroMetricsConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPortalHeroMetricsConfigMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditPortalHeroMetricsConfigMutation, GraphqlTypes.EditPortalHeroMetricsConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditPortalHeroMetricsConfigMutation, GraphqlTypes.EditPortalHeroMetricsConfigMutationVariables>(EditPortalHeroMetricsConfigDocument, options);
      }
export type EditPortalHeroMetricsConfigMutationHookResult = ReturnType<typeof useEditPortalHeroMetricsConfigMutation>;
export type EditPortalHeroMetricsConfigMutationResult = Apollo.MutationResult<GraphqlTypes.EditPortalHeroMetricsConfigMutation>;
export type EditPortalHeroMetricsConfigMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditPortalHeroMetricsConfigMutation, GraphqlTypes.EditPortalHeroMetricsConfigMutationVariables>;
export const ExportPortalHeroMetricsExcelDocument = gql`
    mutation ExportPortalHeroMetricsExcel($targetArenaId: ID!, $metricsFields: [PortalHeroMetricsFieldInput!], $filterVisibility: EntityStatusOptionsEnum!) {
  exportPortalHeroMetricsExcel(
    targetArenaId: $targetArenaId
    metricsFields: $metricsFields
    filterVisibility: $filterVisibility
  ) {
    ... on PortalHeroMetricsExportStatusObjectType {
      jobId
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type ExportPortalHeroMetricsExcelMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportPortalHeroMetricsExcelMutation, GraphqlTypes.ExportPortalHeroMetricsExcelMutationVariables>;

/**
 * __useExportPortalHeroMetricsExcelMutation__
 *
 * To run a mutation, you first call `useExportPortalHeroMetricsExcelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPortalHeroMetricsExcelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPortalHeroMetricsExcelMutation, { data, loading, error }] = useExportPortalHeroMetricsExcelMutation({
 *   variables: {
 *      targetArenaId: // value for 'targetArenaId'
 *      metricsFields: // value for 'metricsFields'
 *      filterVisibility: // value for 'filterVisibility'
 *   },
 * });
 */
export function useExportPortalHeroMetricsExcelMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportPortalHeroMetricsExcelMutation, GraphqlTypes.ExportPortalHeroMetricsExcelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportPortalHeroMetricsExcelMutation, GraphqlTypes.ExportPortalHeroMetricsExcelMutationVariables>(ExportPortalHeroMetricsExcelDocument, options);
      }
export type ExportPortalHeroMetricsExcelMutationHookResult = ReturnType<typeof useExportPortalHeroMetricsExcelMutation>;
export type ExportPortalHeroMetricsExcelMutationResult = Apollo.MutationResult<GraphqlTypes.ExportPortalHeroMetricsExcelMutation>;
export type ExportPortalHeroMetricsExcelMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportPortalHeroMetricsExcelMutation, GraphqlTypes.ExportPortalHeroMetricsExcelMutationVariables>;
export const ApproveReportTemplateVersionDocument = gql`
    mutation ApproveReportTemplateVersion($templateId: Int!, $versionId: Int!) {
  approveReportTemplateVersion(templateId: $templateId, versionId: $versionId) {
    id
    version
    status
  }
}
    `;
export type ApproveReportTemplateVersionMutationFn = Apollo.MutationFunction<GraphqlTypes.ApproveReportTemplateVersionMutation, GraphqlTypes.ApproveReportTemplateVersionMutationVariables>;

/**
 * __useApproveReportTemplateVersionMutation__
 *
 * To run a mutation, you first call `useApproveReportTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveReportTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveReportTemplateVersionMutation, { data, loading, error }] = useApproveReportTemplateVersionMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useApproveReportTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApproveReportTemplateVersionMutation, GraphqlTypes.ApproveReportTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApproveReportTemplateVersionMutation, GraphqlTypes.ApproveReportTemplateVersionMutationVariables>(ApproveReportTemplateVersionDocument, options);
      }
export type ApproveReportTemplateVersionMutationHookResult = ReturnType<typeof useApproveReportTemplateVersionMutation>;
export type ApproveReportTemplateVersionMutationResult = Apollo.MutationResult<GraphqlTypes.ApproveReportTemplateVersionMutation>;
export type ApproveReportTemplateVersionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApproveReportTemplateVersionMutation, GraphqlTypes.ApproveReportTemplateVersionMutationVariables>;
export const DenyReportTemplateVersionDocument = gql`
    mutation DenyReportTemplateVersion($templateId: Int!, $versionId: Int!, $reason: String) {
  denyReportTemplateVersion(
    templateId: $templateId
    versionId: $versionId
    reason: $reason
  ) {
    id
    version
    status
  }
}
    `;
export type DenyReportTemplateVersionMutationFn = Apollo.MutationFunction<GraphqlTypes.DenyReportTemplateVersionMutation, GraphqlTypes.DenyReportTemplateVersionMutationVariables>;

/**
 * __useDenyReportTemplateVersionMutation__
 *
 * To run a mutation, you first call `useDenyReportTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyReportTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyReportTemplateVersionMutation, { data, loading, error }] = useDenyReportTemplateVersionMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      versionId: // value for 'versionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDenyReportTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DenyReportTemplateVersionMutation, GraphqlTypes.DenyReportTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DenyReportTemplateVersionMutation, GraphqlTypes.DenyReportTemplateVersionMutationVariables>(DenyReportTemplateVersionDocument, options);
      }
export type DenyReportTemplateVersionMutationHookResult = ReturnType<typeof useDenyReportTemplateVersionMutation>;
export type DenyReportTemplateVersionMutationResult = Apollo.MutationResult<GraphqlTypes.DenyReportTemplateVersionMutation>;
export type DenyReportTemplateVersionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DenyReportTemplateVersionMutation, GraphqlTypes.DenyReportTemplateVersionMutationVariables>;
export const PreviewReportTemplateVersionDocument = gql`
    mutation PreviewReportTemplateVersion($reportTemplateVersionId: Int!, $previewData: JSON!) {
  previewReportTemplateVersion(
    reportTemplateVersionId: $reportTemplateVersionId
    previewData: $previewData
  ) {
    contentBase64
    contentType
  }
}
    `;
export type PreviewReportTemplateVersionMutationFn = Apollo.MutationFunction<GraphqlTypes.PreviewReportTemplateVersionMutation, GraphqlTypes.PreviewReportTemplateVersionMutationVariables>;

/**
 * __usePreviewReportTemplateVersionMutation__
 *
 * To run a mutation, you first call `usePreviewReportTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewReportTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewReportTemplateVersionMutation, { data, loading, error }] = usePreviewReportTemplateVersionMutation({
 *   variables: {
 *      reportTemplateVersionId: // value for 'reportTemplateVersionId'
 *      previewData: // value for 'previewData'
 *   },
 * });
 */
export function usePreviewReportTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PreviewReportTemplateVersionMutation, GraphqlTypes.PreviewReportTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PreviewReportTemplateVersionMutation, GraphqlTypes.PreviewReportTemplateVersionMutationVariables>(PreviewReportTemplateVersionDocument, options);
      }
export type PreviewReportTemplateVersionMutationHookResult = ReturnType<typeof usePreviewReportTemplateVersionMutation>;
export type PreviewReportTemplateVersionMutationResult = Apollo.MutationResult<GraphqlTypes.PreviewReportTemplateVersionMutation>;
export type PreviewReportTemplateVersionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PreviewReportTemplateVersionMutation, GraphqlTypes.PreviewReportTemplateVersionMutationVariables>;
export const GenerateCustomReportTemplatePreviewPdfDocument = gql`
    mutation GenerateCustomReportTemplatePreviewPdf($reportTemplateId: Int!, $recipientObjectType: CustomReportRecipientObjectType!, $recipientObjectId: Int!, $arenaId: ID, $parameters: JSONString, $reportTemplateVersionId: Int) {
  generateCustomReportTemplatePreviewPdf(
    reportTemplateId: $reportTemplateId
    recipientObjectType: $recipientObjectType
    recipientObjectId: $recipientObjectId
    arenaId: $arenaId
    parameters: $parameters
    reportTemplateVersionId: $reportTemplateVersionId
  ) {
    job {
      id
      status
    }
  }
}
    `;
export type GenerateCustomReportTemplatePreviewPdfMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation, GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutationVariables>;

/**
 * __useGenerateCustomReportTemplatePreviewPdfMutation__
 *
 * To run a mutation, you first call `useGenerateCustomReportTemplatePreviewPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCustomReportTemplatePreviewPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCustomReportTemplatePreviewPdfMutation, { data, loading, error }] = useGenerateCustomReportTemplatePreviewPdfMutation({
 *   variables: {
 *      reportTemplateId: // value for 'reportTemplateId'
 *      recipientObjectType: // value for 'recipientObjectType'
 *      recipientObjectId: // value for 'recipientObjectId'
 *      arenaId: // value for 'arenaId'
 *      parameters: // value for 'parameters'
 *      reportTemplateVersionId: // value for 'reportTemplateVersionId'
 *   },
 * });
 */
export function useGenerateCustomReportTemplatePreviewPdfMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation, GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation, GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutationVariables>(GenerateCustomReportTemplatePreviewPdfDocument, options);
      }
export type GenerateCustomReportTemplatePreviewPdfMutationHookResult = ReturnType<typeof useGenerateCustomReportTemplatePreviewPdfMutation>;
export type GenerateCustomReportTemplatePreviewPdfMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation>;
export type GenerateCustomReportTemplatePreviewPdfMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation, GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutationVariables>;
export const RestoreReportTemplateDocument = gql`
    mutation RestoreReportTemplate($id: Int!) {
  restoreReportTemplate(id: $id) {
    id
    isActive
  }
}
    `;
export type RestoreReportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.RestoreReportTemplateMutation, GraphqlTypes.RestoreReportTemplateMutationVariables>;

/**
 * __useRestoreReportTemplateMutation__
 *
 * To run a mutation, you first call `useRestoreReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreReportTemplateMutation, { data, loading, error }] = useRestoreReportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RestoreReportTemplateMutation, GraphqlTypes.RestoreReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RestoreReportTemplateMutation, GraphqlTypes.RestoreReportTemplateMutationVariables>(RestoreReportTemplateDocument, options);
      }
export type RestoreReportTemplateMutationHookResult = ReturnType<typeof useRestoreReportTemplateMutation>;
export type RestoreReportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.RestoreReportTemplateMutation>;
export type RestoreReportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RestoreReportTemplateMutation, GraphqlTypes.RestoreReportTemplateMutationVariables>;
export const ArchiveReportTemplateDocument = gql`
    mutation ArchiveReportTemplate($id: Int!) {
  archiveReportTemplate(id: $id) {
    id
    isActive
  }
}
    `;
export type ArchiveReportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.ArchiveReportTemplateMutation, GraphqlTypes.ArchiveReportTemplateMutationVariables>;

/**
 * __useArchiveReportTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveReportTemplateMutation, { data, loading, error }] = useArchiveReportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ArchiveReportTemplateMutation, GraphqlTypes.ArchiveReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ArchiveReportTemplateMutation, GraphqlTypes.ArchiveReportTemplateMutationVariables>(ArchiveReportTemplateDocument, options);
      }
export type ArchiveReportTemplateMutationHookResult = ReturnType<typeof useArchiveReportTemplateMutation>;
export type ArchiveReportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.ArchiveReportTemplateMutation>;
export type ArchiveReportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ArchiveReportTemplateMutation, GraphqlTypes.ArchiveReportTemplateMutationVariables>;
export const GetPreviewAccountsByEntityDocument = gql`
    query GetPreviewAccountsByEntity($entityId: ID!) {
  investmentEntity(entityId: $entityId) {
    id
    activeAccounts(sort: NAME_ASC) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPreviewAccountsByEntityQuery__
 *
 * To run a query within a React component, call `useGetPreviewAccountsByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewAccountsByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewAccountsByEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetPreviewAccountsByEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables> & ({ variables: GraphqlTypes.GetPreviewAccountsByEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>(GetPreviewAccountsByEntityDocument, options);
      }
export function useGetPreviewAccountsByEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>(GetPreviewAccountsByEntityDocument, options);
        }
// @ts-ignore
export function useGetPreviewAccountsByEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>;
export function useGetPreviewAccountsByEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewAccountsByEntityQuery | undefined, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>;
export function useGetPreviewAccountsByEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>(GetPreviewAccountsByEntityDocument, options);
        }
export type GetPreviewAccountsByEntityQueryHookResult = ReturnType<typeof useGetPreviewAccountsByEntityQuery>;
export type GetPreviewAccountsByEntityLazyQueryHookResult = ReturnType<typeof useGetPreviewAccountsByEntityLazyQuery>;
export type GetPreviewAccountsByEntitySuspenseQueryHookResult = ReturnType<typeof useGetPreviewAccountsByEntitySuspenseQuery>;
export type GetPreviewAccountsByEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>;
export const GetReportTemplatesByArenaDocument = gql`
    query GetReportTemplatesByArena($arenaId: Int, $isActive: Boolean, $status: ReportTemplateVersionStatus) {
  reportTemplatesByArena(arenaId: $arenaId, isActive: $isActive, status: $status) {
    ...ReportTemplateListFields
  }
}
    ${ReportTemplateListFieldsFragmentDoc}`;

/**
 * __useGetReportTemplatesByArenaQuery__
 *
 * To run a query within a React component, call `useGetReportTemplatesByArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplatesByArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplatesByArenaQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      isActive: // value for 'isActive'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetReportTemplatesByArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>(GetReportTemplatesByArenaDocument, options);
      }
export function useGetReportTemplatesByArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>(GetReportTemplatesByArenaDocument, options);
        }
// @ts-ignore
export function useGetReportTemplatesByArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>;
export function useGetReportTemplatesByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplatesByArenaQuery | undefined, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>;
export function useGetReportTemplatesByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>(GetReportTemplatesByArenaDocument, options);
        }
export type GetReportTemplatesByArenaQueryHookResult = ReturnType<typeof useGetReportTemplatesByArenaQuery>;
export type GetReportTemplatesByArenaLazyQueryHookResult = ReturnType<typeof useGetReportTemplatesByArenaLazyQuery>;
export type GetReportTemplatesByArenaSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplatesByArenaSuspenseQuery>;
export type GetReportTemplatesByArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>;
export const GetReportTemplateForReviewDocument = gql`
    query GetReportTemplateForReview($id: Int!) {
  reportTemplate(id: $id) {
    ...ReportTemplateListFields
    description
    dataPackage {
      id
      arenaId
    }
    createdByUser {
      id
      firstName
      lastName
    }
    currentVersion {
      version
      createdAt
      createdBy
      fileName
      isUploadComplete
      downloadUrl
      queryId
      review {
        deniedReason
        reviewedAt
        reviewedByUser {
          id
          firstName
          lastName
        }
      }
    }
    versions {
      version
      createdBy
      fileName
      isUploadComplete
      downloadUrl
      queryId
      review {
        deniedReason
        reviewedAt
        reviewedByUser {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    ${ReportTemplateListFieldsFragmentDoc}`;

/**
 * __useGetReportTemplateForReviewQuery__
 *
 * To run a query within a React component, call `useGetReportTemplateForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplateForReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplateForReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportTemplateForReviewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables> & ({ variables: GraphqlTypes.GetReportTemplateForReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>(GetReportTemplateForReviewDocument, options);
      }
export function useGetReportTemplateForReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>(GetReportTemplateForReviewDocument, options);
        }
// @ts-ignore
export function useGetReportTemplateForReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>;
export function useGetReportTemplateForReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateForReviewQuery | undefined, GraphqlTypes.GetReportTemplateForReviewQueryVariables>;
export function useGetReportTemplateForReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>(GetReportTemplateForReviewDocument, options);
        }
export type GetReportTemplateForReviewQueryHookResult = ReturnType<typeof useGetReportTemplateForReviewQuery>;
export type GetReportTemplateForReviewLazyQueryHookResult = ReturnType<typeof useGetReportTemplateForReviewLazyQuery>;
export type GetReportTemplateForReviewSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplateForReviewSuspenseQuery>;
export type GetReportTemplateForReviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportTemplateForReviewQuery, GraphqlTypes.GetReportTemplateForReviewQueryVariables>;
export const GetPreviewDateParametersDocument = gql`
    query GetPreviewDateParameters($queryId: Int!, $arenaId: Int) {
  finpubQueryDateParameters(queryId: $queryId, arenaId: $arenaId) {
    parameters
  }
}
    `;

/**
 * __useGetPreviewDateParametersQuery__
 *
 * To run a query within a React component, call `useGetPreviewDateParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewDateParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewDateParametersQuery({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPreviewDateParametersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables> & ({ variables: GraphqlTypes.GetPreviewDateParametersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>(GetPreviewDateParametersDocument, options);
      }
export function useGetPreviewDateParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>(GetPreviewDateParametersDocument, options);
        }
// @ts-ignore
export function useGetPreviewDateParametersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>;
export function useGetPreviewDateParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewDateParametersQuery | undefined, GraphqlTypes.GetPreviewDateParametersQueryVariables>;
export function useGetPreviewDateParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>(GetPreviewDateParametersDocument, options);
        }
export type GetPreviewDateParametersQueryHookResult = ReturnType<typeof useGetPreviewDateParametersQuery>;
export type GetPreviewDateParametersLazyQueryHookResult = ReturnType<typeof useGetPreviewDateParametersLazyQuery>;
export type GetPreviewDateParametersSuspenseQueryHookResult = ReturnType<typeof useGetPreviewDateParametersSuspenseQuery>;
export type GetPreviewDateParametersQueryResult = Apollo.QueryResult<GraphqlTypes.GetPreviewDateParametersQuery, GraphqlTypes.GetPreviewDateParametersQueryVariables>;
export const GetPreviewEntitiesDocument = gql`
    query GetPreviewEntities($arenaId: ID!, $first: Int = 100) {
  investmentEntitiesByArena(arenaId: $arenaId, first: $first, sort: [NAME_ASC]) {
    edges {
      node {
        id
        name
        status
        type {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPreviewEntitiesQuery__
 *
 * To run a query within a React component, call `useGetPreviewEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewEntitiesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetPreviewEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetPreviewEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>(GetPreviewEntitiesDocument, options);
      }
export function useGetPreviewEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>(GetPreviewEntitiesDocument, options);
        }
// @ts-ignore
export function useGetPreviewEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>;
export function useGetPreviewEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewEntitiesQuery | undefined, GraphqlTypes.GetPreviewEntitiesQueryVariables>;
export function useGetPreviewEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>(GetPreviewEntitiesDocument, options);
        }
export type GetPreviewEntitiesQueryHookResult = ReturnType<typeof useGetPreviewEntitiesQuery>;
export type GetPreviewEntitiesLazyQueryHookResult = ReturnType<typeof useGetPreviewEntitiesLazyQuery>;
export type GetPreviewEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetPreviewEntitiesSuspenseQuery>;
export type GetPreviewEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>;
export const UploadHistoricalDdqDocument = gql`
    mutation UploadHistoricalDdq($input: CreateHistoricalDdqUploadInput!) {
  uploadHistoricalDdq(input: $input) {
    id
    title
    extractionStatus
    extractionError
    extractedAnswerCount
  }
}
    `;
export type UploadHistoricalDdqMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadHistoricalDdqMutation, GraphqlTypes.UploadHistoricalDdqMutationVariables>;

/**
 * __useUploadHistoricalDdqMutation__
 *
 * To run a mutation, you first call `useUploadHistoricalDdqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadHistoricalDdqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadHistoricalDdqMutation, { data, loading, error }] = useUploadHistoricalDdqMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadHistoricalDdqMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadHistoricalDdqMutation, GraphqlTypes.UploadHistoricalDdqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadHistoricalDdqMutation, GraphqlTypes.UploadHistoricalDdqMutationVariables>(UploadHistoricalDdqDocument, options);
      }
export type UploadHistoricalDdqMutationHookResult = ReturnType<typeof useUploadHistoricalDdqMutation>;
export type UploadHistoricalDdqMutationResult = Apollo.MutationResult<GraphqlTypes.UploadHistoricalDdqMutation>;
export type UploadHistoricalDdqMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadHistoricalDdqMutation, GraphqlTypes.UploadHistoricalDdqMutationVariables>;
export const HistoricalDdqUploadDocument = gql`
    query HistoricalDdqUpload($arenaId: Int!, $uploadId: ID!) {
  historicalDdqUpload(arenaId: $arenaId, uploadId: $uploadId) {
    id
    title
    extractionStatus
    extractionError
    extractedAnswerCount
  }
}
    `;

/**
 * __useHistoricalDdqUploadQuery__
 *
 * To run a query within a React component, call `useHistoricalDdqUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricalDdqUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricalDdqUploadQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useHistoricalDdqUploadQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables> & ({ variables: GraphqlTypes.HistoricalDdqUploadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>(HistoricalDdqUploadDocument, options);
      }
export function useHistoricalDdqUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>(HistoricalDdqUploadDocument, options);
        }
// @ts-ignore
export function useHistoricalDdqUploadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>;
export function useHistoricalDdqUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.HistoricalDdqUploadQuery | undefined, GraphqlTypes.HistoricalDdqUploadQueryVariables>;
export function useHistoricalDdqUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>(HistoricalDdqUploadDocument, options);
        }
export type HistoricalDdqUploadQueryHookResult = ReturnType<typeof useHistoricalDdqUploadQuery>;
export type HistoricalDdqUploadLazyQueryHookResult = ReturnType<typeof useHistoricalDdqUploadLazyQuery>;
export type HistoricalDdqUploadSuspenseQueryHookResult = ReturnType<typeof useHistoricalDdqUploadSuspenseQuery>;
export type HistoricalDdqUploadQueryResult = Apollo.QueryResult<GraphqlTypes.HistoricalDdqUploadQuery, GraphqlTypes.HistoricalDdqUploadQueryVariables>;
export const CreateAnswerBankEntryDocument = gql`
    mutation CreateAnswerBankEntry($input: CreateAnswerBankEntryInput!) {
  createAnswerBankEntry(input: $input) {
    id
    title
    description
    lastAnswerAt
    answeredInDdqCount
    archivedAt
    createdAt
    modifiedAt
    deletedAt
    answers {
      ...AnswerBankAnswerFields
    }
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type CreateAnswerBankEntryMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateAnswerBankEntryMutation, GraphqlTypes.CreateAnswerBankEntryMutationVariables>;

/**
 * __useCreateAnswerBankEntryMutation__
 *
 * To run a mutation, you first call `useCreateAnswerBankEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerBankEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerBankEntryMutation, { data, loading, error }] = useCreateAnswerBankEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnswerBankEntryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateAnswerBankEntryMutation, GraphqlTypes.CreateAnswerBankEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateAnswerBankEntryMutation, GraphqlTypes.CreateAnswerBankEntryMutationVariables>(CreateAnswerBankEntryDocument, options);
      }
export type CreateAnswerBankEntryMutationHookResult = ReturnType<typeof useCreateAnswerBankEntryMutation>;
export type CreateAnswerBankEntryMutationResult = Apollo.MutationResult<GraphqlTypes.CreateAnswerBankEntryMutation>;
export type CreateAnswerBankEntryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateAnswerBankEntryMutation, GraphqlTypes.CreateAnswerBankEntryMutationVariables>;
export const AddAnswerBankAnswerDocument = gql`
    mutation AddAnswerBankAnswer($input: AddAnswerBankAnswerInput!) {
  addAnswerBankAnswer(input: $input) {
    ...AnswerBankAnswerFields
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type AddAnswerBankAnswerMutationFn = Apollo.MutationFunction<GraphqlTypes.AddAnswerBankAnswerMutation, GraphqlTypes.AddAnswerBankAnswerMutationVariables>;

/**
 * __useAddAnswerBankAnswerMutation__
 *
 * To run a mutation, you first call `useAddAnswerBankAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAnswerBankAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAnswerBankAnswerMutation, { data, loading, error }] = useAddAnswerBankAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAnswerBankAnswerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddAnswerBankAnswerMutation, GraphqlTypes.AddAnswerBankAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddAnswerBankAnswerMutation, GraphqlTypes.AddAnswerBankAnswerMutationVariables>(AddAnswerBankAnswerDocument, options);
      }
export type AddAnswerBankAnswerMutationHookResult = ReturnType<typeof useAddAnswerBankAnswerMutation>;
export type AddAnswerBankAnswerMutationResult = Apollo.MutationResult<GraphqlTypes.AddAnswerBankAnswerMutation>;
export type AddAnswerBankAnswerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddAnswerBankAnswerMutation, GraphqlTypes.AddAnswerBankAnswerMutationVariables>;
export const SwitchAnswerBankAnswerVersionDocument = gql`
    mutation SwitchAnswerBankAnswerVersion($arenaId: Int!, $answerId: ID!) {
  switchAnswerBankAnswerVersion(arenaId: $arenaId, answerId: $answerId) {
    ...AnswerBankAnswerFields
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type SwitchAnswerBankAnswerVersionMutationFn = Apollo.MutationFunction<GraphqlTypes.SwitchAnswerBankAnswerVersionMutation, GraphqlTypes.SwitchAnswerBankAnswerVersionMutationVariables>;

/**
 * __useSwitchAnswerBankAnswerVersionMutation__
 *
 * To run a mutation, you first call `useSwitchAnswerBankAnswerVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchAnswerBankAnswerVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchAnswerBankAnswerVersionMutation, { data, loading, error }] = useSwitchAnswerBankAnswerVersionMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useSwitchAnswerBankAnswerVersionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SwitchAnswerBankAnswerVersionMutation, GraphqlTypes.SwitchAnswerBankAnswerVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SwitchAnswerBankAnswerVersionMutation, GraphqlTypes.SwitchAnswerBankAnswerVersionMutationVariables>(SwitchAnswerBankAnswerVersionDocument, options);
      }
export type SwitchAnswerBankAnswerVersionMutationHookResult = ReturnType<typeof useSwitchAnswerBankAnswerVersionMutation>;
export type SwitchAnswerBankAnswerVersionMutationResult = Apollo.MutationResult<GraphqlTypes.SwitchAnswerBankAnswerVersionMutation>;
export type SwitchAnswerBankAnswerVersionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SwitchAnswerBankAnswerVersionMutation, GraphqlTypes.SwitchAnswerBankAnswerVersionMutationVariables>;
export const SetAnswerBankAnswerTagsDocument = gql`
    mutation SetAnswerBankAnswerTags($input: SetAnswerBankAnswerTagsInput!) {
  setAnswerBankAnswerTags(input: $input) {
    ...AnswerBankAnswerFields
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type SetAnswerBankAnswerTagsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetAnswerBankAnswerTagsMutation, GraphqlTypes.SetAnswerBankAnswerTagsMutationVariables>;

/**
 * __useSetAnswerBankAnswerTagsMutation__
 *
 * To run a mutation, you first call `useSetAnswerBankAnswerTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAnswerBankAnswerTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAnswerBankAnswerTagsMutation, { data, loading, error }] = useSetAnswerBankAnswerTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAnswerBankAnswerTagsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetAnswerBankAnswerTagsMutation, GraphqlTypes.SetAnswerBankAnswerTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetAnswerBankAnswerTagsMutation, GraphqlTypes.SetAnswerBankAnswerTagsMutationVariables>(SetAnswerBankAnswerTagsDocument, options);
      }
export type SetAnswerBankAnswerTagsMutationHookResult = ReturnType<typeof useSetAnswerBankAnswerTagsMutation>;
export type SetAnswerBankAnswerTagsMutationResult = Apollo.MutationResult<GraphqlTypes.SetAnswerBankAnswerTagsMutation>;
export type SetAnswerBankAnswerTagsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetAnswerBankAnswerTagsMutation, GraphqlTypes.SetAnswerBankAnswerTagsMutationVariables>;
export const SetAnswerBankAnswerOfferingsDocument = gql`
    mutation SetAnswerBankAnswerOfferings($input: SetAnswerBankAnswerOfferingsInput!) {
  setAnswerBankAnswerOfferings(input: $input) {
    ...AnswerBankAnswerFields
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type SetAnswerBankAnswerOfferingsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetAnswerBankAnswerOfferingsMutation, GraphqlTypes.SetAnswerBankAnswerOfferingsMutationVariables>;

/**
 * __useSetAnswerBankAnswerOfferingsMutation__
 *
 * To run a mutation, you first call `useSetAnswerBankAnswerOfferingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAnswerBankAnswerOfferingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAnswerBankAnswerOfferingsMutation, { data, loading, error }] = useSetAnswerBankAnswerOfferingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAnswerBankAnswerOfferingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetAnswerBankAnswerOfferingsMutation, GraphqlTypes.SetAnswerBankAnswerOfferingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetAnswerBankAnswerOfferingsMutation, GraphqlTypes.SetAnswerBankAnswerOfferingsMutationVariables>(SetAnswerBankAnswerOfferingsDocument, options);
      }
export type SetAnswerBankAnswerOfferingsMutationHookResult = ReturnType<typeof useSetAnswerBankAnswerOfferingsMutation>;
export type SetAnswerBankAnswerOfferingsMutationResult = Apollo.MutationResult<GraphqlTypes.SetAnswerBankAnswerOfferingsMutation>;
export type SetAnswerBankAnswerOfferingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetAnswerBankAnswerOfferingsMutation, GraphqlTypes.SetAnswerBankAnswerOfferingsMutationVariables>;
export const ArchiveAnswerBankEntryDocument = gql`
    mutation ArchiveAnswerBankEntry($arenaId: Int!, $questionId: ID!) {
  archiveAnswerBankEntry(arenaId: $arenaId, questionId: $questionId) {
    id
    archivedAt
    archivedBy {
      id
      fullName
    }
    restoredAt
    lastAnswerAt
    answers {
      ...AnswerBankAnswerFields
    }
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type ArchiveAnswerBankEntryMutationFn = Apollo.MutationFunction<GraphqlTypes.ArchiveAnswerBankEntryMutation, GraphqlTypes.ArchiveAnswerBankEntryMutationVariables>;

/**
 * __useArchiveAnswerBankEntryMutation__
 *
 * To run a mutation, you first call `useArchiveAnswerBankEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAnswerBankEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAnswerBankEntryMutation, { data, loading, error }] = useArchiveAnswerBankEntryMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useArchiveAnswerBankEntryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ArchiveAnswerBankEntryMutation, GraphqlTypes.ArchiveAnswerBankEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ArchiveAnswerBankEntryMutation, GraphqlTypes.ArchiveAnswerBankEntryMutationVariables>(ArchiveAnswerBankEntryDocument, options);
      }
export type ArchiveAnswerBankEntryMutationHookResult = ReturnType<typeof useArchiveAnswerBankEntryMutation>;
export type ArchiveAnswerBankEntryMutationResult = Apollo.MutationResult<GraphqlTypes.ArchiveAnswerBankEntryMutation>;
export type ArchiveAnswerBankEntryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ArchiveAnswerBankEntryMutation, GraphqlTypes.ArchiveAnswerBankEntryMutationVariables>;
export const RestoreAnswerBankEntryDocument = gql`
    mutation RestoreAnswerBankEntry($arenaId: Int!, $questionId: ID!) {
  restoreAnswerBankEntry(arenaId: $arenaId, questionId: $questionId) {
    id
    archivedAt
    restoredAt
    restoredBy {
      id
      fullName
    }
    lastAnswerAt
    answers {
      ...AnswerBankAnswerFields
    }
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type RestoreAnswerBankEntryMutationFn = Apollo.MutationFunction<GraphqlTypes.RestoreAnswerBankEntryMutation, GraphqlTypes.RestoreAnswerBankEntryMutationVariables>;

/**
 * __useRestoreAnswerBankEntryMutation__
 *
 * To run a mutation, you first call `useRestoreAnswerBankEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreAnswerBankEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreAnswerBankEntryMutation, { data, loading, error }] = useRestoreAnswerBankEntryMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useRestoreAnswerBankEntryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RestoreAnswerBankEntryMutation, GraphqlTypes.RestoreAnswerBankEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RestoreAnswerBankEntryMutation, GraphqlTypes.RestoreAnswerBankEntryMutationVariables>(RestoreAnswerBankEntryDocument, options);
      }
export type RestoreAnswerBankEntryMutationHookResult = ReturnType<typeof useRestoreAnswerBankEntryMutation>;
export type RestoreAnswerBankEntryMutationResult = Apollo.MutationResult<GraphqlTypes.RestoreAnswerBankEntryMutation>;
export type RestoreAnswerBankEntryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RestoreAnswerBankEntryMutation, GraphqlTypes.RestoreAnswerBankEntryMutationVariables>;
export const ArchiveAnswerBankAnswersDocument = gql`
    mutation ArchiveAnswerBankAnswers($input: ArchiveAnswerBankAnswersInput!) {
  archiveAnswerBankAnswers(input: $input) {
    ...AnswerBankAnswerFields
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type ArchiveAnswerBankAnswersMutationFn = Apollo.MutationFunction<GraphqlTypes.ArchiveAnswerBankAnswersMutation, GraphqlTypes.ArchiveAnswerBankAnswersMutationVariables>;

/**
 * __useArchiveAnswerBankAnswersMutation__
 *
 * To run a mutation, you first call `useArchiveAnswerBankAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAnswerBankAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAnswerBankAnswersMutation, { data, loading, error }] = useArchiveAnswerBankAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveAnswerBankAnswersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ArchiveAnswerBankAnswersMutation, GraphqlTypes.ArchiveAnswerBankAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ArchiveAnswerBankAnswersMutation, GraphqlTypes.ArchiveAnswerBankAnswersMutationVariables>(ArchiveAnswerBankAnswersDocument, options);
      }
export type ArchiveAnswerBankAnswersMutationHookResult = ReturnType<typeof useArchiveAnswerBankAnswersMutation>;
export type ArchiveAnswerBankAnswersMutationResult = Apollo.MutationResult<GraphqlTypes.ArchiveAnswerBankAnswersMutation>;
export type ArchiveAnswerBankAnswersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ArchiveAnswerBankAnswersMutation, GraphqlTypes.ArchiveAnswerBankAnswersMutationVariables>;
export const RestoreAnswerBankAnswersDocument = gql`
    mutation RestoreAnswerBankAnswers($input: ArchiveAnswerBankAnswersInput!) {
  restoreAnswerBankAnswers(input: $input) {
    ...AnswerBankAnswerFields
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;
export type RestoreAnswerBankAnswersMutationFn = Apollo.MutationFunction<GraphqlTypes.RestoreAnswerBankAnswersMutation, GraphqlTypes.RestoreAnswerBankAnswersMutationVariables>;

/**
 * __useRestoreAnswerBankAnswersMutation__
 *
 * To run a mutation, you first call `useRestoreAnswerBankAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreAnswerBankAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreAnswerBankAnswersMutation, { data, loading, error }] = useRestoreAnswerBankAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreAnswerBankAnswersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RestoreAnswerBankAnswersMutation, GraphqlTypes.RestoreAnswerBankAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RestoreAnswerBankAnswersMutation, GraphqlTypes.RestoreAnswerBankAnswersMutationVariables>(RestoreAnswerBankAnswersDocument, options);
      }
export type RestoreAnswerBankAnswersMutationHookResult = ReturnType<typeof useRestoreAnswerBankAnswersMutation>;
export type RestoreAnswerBankAnswersMutationResult = Apollo.MutationResult<GraphqlTypes.RestoreAnswerBankAnswersMutation>;
export type RestoreAnswerBankAnswersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RestoreAnswerBankAnswersMutation, GraphqlTypes.RestoreAnswerBankAnswersMutationVariables>;
export const CreateDdqTagDocument = gql`
    mutation CreateDdqTag($input: CreateDdqTagInput!) {
  createDdqTag(input: $input) {
    id
    name
  }
}
    `;
export type CreateDdqTagMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDdqTagMutation, GraphqlTypes.CreateDdqTagMutationVariables>;

/**
 * __useCreateDdqTagMutation__
 *
 * To run a mutation, you first call `useCreateDdqTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDdqTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDdqTagMutation, { data, loading, error }] = useCreateDdqTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDdqTagMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDdqTagMutation, GraphqlTypes.CreateDdqTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDdqTagMutation, GraphqlTypes.CreateDdqTagMutationVariables>(CreateDdqTagDocument, options);
      }
export type CreateDdqTagMutationHookResult = ReturnType<typeof useCreateDdqTagMutation>;
export type CreateDdqTagMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDdqTagMutation>;
export type CreateDdqTagMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDdqTagMutation, GraphqlTypes.CreateDdqTagMutationVariables>;
export const AnswerBankQuestionsDocument = gql`
    query AnswerBankQuestions($arenaId: Int!, $limit: Int, $offset: Int!, $search: String, $tagIds: [ID!], $offeringIds: [Int!], $unscopedOnly: Boolean!, $lpNames: [String!], $dateFrom: DateTime, $dateTo: DateTime, $includeArchived: Boolean!, $sortBy: AnswerBankSortField!, $sortOrder: AnswerBankSortOrder!) {
  answerBankQuestions(
    arenaId: $arenaId
    limit: $limit
    offset: $offset
    search: $search
    tagIds: $tagIds
    offeringIds: $offeringIds
    unscopedOnly: $unscopedOnly
    lpNames: $lpNames
    dateFrom: $dateFrom
    dateTo: $dateTo
    includeArchived: $includeArchived
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    totalCount
    items {
      id
      title
      description
      lastAnswerAt
      answeredInDdqCount
      archivedAt
      archivedBy {
        id
        fullName
      }
      restoredAt
      restoredBy {
        id
        fullName
      }
      createdAt
      modifiedAt
      deletedAt
      answers {
        ...AnswerBankAnswerFields
      }
    }
  }
}
    ${AnswerBankAnswerFieldsFragmentDoc}`;

/**
 * __useAnswerBankQuestionsQuery__
 *
 * To run a query within a React component, call `useAnswerBankQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnswerBankQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnswerBankQuestionsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      tagIds: // value for 'tagIds'
 *      offeringIds: // value for 'offeringIds'
 *      unscopedOnly: // value for 'unscopedOnly'
 *      lpNames: // value for 'lpNames'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      includeArchived: // value for 'includeArchived'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAnswerBankQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables> & ({ variables: GraphqlTypes.AnswerBankQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>(AnswerBankQuestionsDocument, options);
      }
export function useAnswerBankQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>(AnswerBankQuestionsDocument, options);
        }
// @ts-ignore
export function useAnswerBankQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>;
export function useAnswerBankQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AnswerBankQuestionsQuery | undefined, GraphqlTypes.AnswerBankQuestionsQueryVariables>;
export function useAnswerBankQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>(AnswerBankQuestionsDocument, options);
        }
export type AnswerBankQuestionsQueryHookResult = ReturnType<typeof useAnswerBankQuestionsQuery>;
export type AnswerBankQuestionsLazyQueryHookResult = ReturnType<typeof useAnswerBankQuestionsLazyQuery>;
export type AnswerBankQuestionsSuspenseQueryHookResult = ReturnType<typeof useAnswerBankQuestionsSuspenseQuery>;
export type AnswerBankQuestionsQueryResult = Apollo.QueryResult<GraphqlTypes.AnswerBankQuestionsQuery, GraphqlTypes.AnswerBankQuestionsQueryVariables>;
export const AnswerBankFacetsDocument = gql`
    query AnswerBankFacets($arenaId: Int!, $search: String, $tagIds: [ID!], $offeringIds: [Int!], $unscopedOnly: Boolean!, $lpNames: [String!], $dateFrom: DateTime, $dateTo: DateTime, $includeArchived: Boolean!) {
  answerBankFacets(
    arenaId: $arenaId
    search: $search
    tagIds: $tagIds
    offeringIds: $offeringIds
    unscopedOnly: $unscopedOnly
    lpNames: $lpNames
    dateFrom: $dateFrom
    dateTo: $dateTo
    includeArchived: $includeArchived
  ) {
    tags {
      value
      count
    }
    offerings {
      value
      count
    }
    limitedPartners {
      value
      count
    }
  }
}
    `;

/**
 * __useAnswerBankFacetsQuery__
 *
 * To run a query within a React component, call `useAnswerBankFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnswerBankFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnswerBankFacetsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      search: // value for 'search'
 *      tagIds: // value for 'tagIds'
 *      offeringIds: // value for 'offeringIds'
 *      unscopedOnly: // value for 'unscopedOnly'
 *      lpNames: // value for 'lpNames'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useAnswerBankFacetsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables> & ({ variables: GraphqlTypes.AnswerBankFacetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>(AnswerBankFacetsDocument, options);
      }
export function useAnswerBankFacetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>(AnswerBankFacetsDocument, options);
        }
// @ts-ignore
export function useAnswerBankFacetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>;
export function useAnswerBankFacetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AnswerBankFacetsQuery | undefined, GraphqlTypes.AnswerBankFacetsQueryVariables>;
export function useAnswerBankFacetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>(AnswerBankFacetsDocument, options);
        }
export type AnswerBankFacetsQueryHookResult = ReturnType<typeof useAnswerBankFacetsQuery>;
export type AnswerBankFacetsLazyQueryHookResult = ReturnType<typeof useAnswerBankFacetsLazyQuery>;
export type AnswerBankFacetsSuspenseQueryHookResult = ReturnType<typeof useAnswerBankFacetsSuspenseQuery>;
export type AnswerBankFacetsQueryResult = Apollo.QueryResult<GraphqlTypes.AnswerBankFacetsQuery, GraphqlTypes.AnswerBankFacetsQueryVariables>;
export const DdqTagsDocument = gql`
    query DdqTags($arenaId: Int!) {
  ddqTags(arenaId: $arenaId) {
    id
    name
  }
}
    `;

/**
 * __useDdqTagsQuery__
 *
 * To run a query within a React component, call `useDdqTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDdqTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDdqTagsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useDdqTagsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables> & ({ variables: GraphqlTypes.DdqTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>(DdqTagsDocument, options);
      }
export function useDdqTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>(DdqTagsDocument, options);
        }
// @ts-ignore
export function useDdqTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>;
export function useDdqTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DdqTagsQuery | undefined, GraphqlTypes.DdqTagsQueryVariables>;
export function useDdqTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>(DdqTagsDocument, options);
        }
export type DdqTagsQueryHookResult = ReturnType<typeof useDdqTagsQuery>;
export type DdqTagsLazyQueryHookResult = ReturnType<typeof useDdqTagsLazyQuery>;
export type DdqTagsSuspenseQueryHookResult = ReturnType<typeof useDdqTagsSuspenseQuery>;
export type DdqTagsQueryResult = Apollo.QueryResult<GraphqlTypes.DdqTagsQuery, GraphqlTypes.DdqTagsQueryVariables>;
export const ArchiveDdqKbDocumentDocument = gql`
    mutation ArchiveDdqKbDocument($arenaId: Int!, $ddqKbDocumentId: ID!) {
  archiveDdqKbDocument(arenaId: $arenaId, ddqKbDocumentId: $ddqKbDocumentId) {
    id
    archivedAt
  }
}
    `;
export type ArchiveDdqKbDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.ArchiveDdqKbDocumentMutation, GraphqlTypes.ArchiveDdqKbDocumentMutationVariables>;

/**
 * __useArchiveDdqKbDocumentMutation__
 *
 * To run a mutation, you first call `useArchiveDdqKbDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDdqKbDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDdqKbDocumentMutation, { data, loading, error }] = useArchiveDdqKbDocumentMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      ddqKbDocumentId: // value for 'ddqKbDocumentId'
 *   },
 * });
 */
export function useArchiveDdqKbDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ArchiveDdqKbDocumentMutation, GraphqlTypes.ArchiveDdqKbDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ArchiveDdqKbDocumentMutation, GraphqlTypes.ArchiveDdqKbDocumentMutationVariables>(ArchiveDdqKbDocumentDocument, options);
      }
export type ArchiveDdqKbDocumentMutationHookResult = ReturnType<typeof useArchiveDdqKbDocumentMutation>;
export type ArchiveDdqKbDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.ArchiveDdqKbDocumentMutation>;
export type ArchiveDdqKbDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ArchiveDdqKbDocumentMutation, GraphqlTypes.ArchiveDdqKbDocumentMutationVariables>;
export const UnarchiveDdqKbDocumentDocument = gql`
    mutation UnarchiveDdqKbDocument($arenaId: Int!, $ddqKbDocumentId: ID!) {
  unarchiveDdqKbDocument(arenaId: $arenaId, ddqKbDocumentId: $ddqKbDocumentId) {
    id
    archivedAt
  }
}
    `;
export type UnarchiveDdqKbDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.UnarchiveDdqKbDocumentMutation, GraphqlTypes.UnarchiveDdqKbDocumentMutationVariables>;

/**
 * __useUnarchiveDdqKbDocumentMutation__
 *
 * To run a mutation, you first call `useUnarchiveDdqKbDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveDdqKbDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveDdqKbDocumentMutation, { data, loading, error }] = useUnarchiveDdqKbDocumentMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      ddqKbDocumentId: // value for 'ddqKbDocumentId'
 *   },
 * });
 */
export function useUnarchiveDdqKbDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UnarchiveDdqKbDocumentMutation, GraphqlTypes.UnarchiveDdqKbDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UnarchiveDdqKbDocumentMutation, GraphqlTypes.UnarchiveDdqKbDocumentMutationVariables>(UnarchiveDdqKbDocumentDocument, options);
      }
export type UnarchiveDdqKbDocumentMutationHookResult = ReturnType<typeof useUnarchiveDdqKbDocumentMutation>;
export type UnarchiveDdqKbDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.UnarchiveDdqKbDocumentMutation>;
export type UnarchiveDdqKbDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UnarchiveDdqKbDocumentMutation, GraphqlTypes.UnarchiveDdqKbDocumentMutationVariables>;
export const CreateKbFolderDocument = gql`
    mutation CreateKbFolder($arenaId: Int!, $name: String!, $parentFolderSoaId: ID) {
  createKbFolder(
    input: {arenaId: $arenaId, name: $name, parentFolderSoaId: $parentFolderSoaId}
  ) {
    soaId
    name
  }
}
    `;
export type CreateKbFolderMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateKbFolderMutation, GraphqlTypes.CreateKbFolderMutationVariables>;

/**
 * __useCreateKbFolderMutation__
 *
 * To run a mutation, you first call `useCreateKbFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKbFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKbFolderMutation, { data, loading, error }] = useCreateKbFolderMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      name: // value for 'name'
 *      parentFolderSoaId: // value for 'parentFolderSoaId'
 *   },
 * });
 */
export function useCreateKbFolderMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateKbFolderMutation, GraphqlTypes.CreateKbFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateKbFolderMutation, GraphqlTypes.CreateKbFolderMutationVariables>(CreateKbFolderDocument, options);
      }
export type CreateKbFolderMutationHookResult = ReturnType<typeof useCreateKbFolderMutation>;
export type CreateKbFolderMutationResult = Apollo.MutationResult<GraphqlTypes.CreateKbFolderMutation>;
export type CreateKbFolderMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateKbFolderMutation, GraphqlTypes.CreateKbFolderMutationVariables>;
export const GetDdqKbDocumentsDocument = gql`
    query GetDdqKbDocuments($arenaId: Int!, $cursor: String, $limit: Int, $search: String, $offeringIds: [Int!], $fileTypes: [KbDocumentFileType!], $archived: Boolean, $sortBy: KbDocumentSortField, $sortOrder: KbSortOrder) {
  ddqKbDocuments(
    arenaId: $arenaId
    cursor: $cursor
    limit: $limit
    search: $search
    offeringIds: $offeringIds
    fileTypes: $fileTypes
    archived: $archived
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    nextCursor
    items {
      id
      documentId
      name
      fileType
      size
      archivedAt
      offerings {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDdqKbDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDdqKbDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqKbDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqKbDocumentsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      offeringIds: // value for 'offeringIds'
 *      fileTypes: // value for 'fileTypes'
 *      archived: // value for 'archived'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetDdqKbDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetDdqKbDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>(GetDdqKbDocumentsDocument, options);
      }
export function useGetDdqKbDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>(GetDdqKbDocumentsDocument, options);
        }
// @ts-ignore
export function useGetDdqKbDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>;
export function useGetDdqKbDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqKbDocumentsQuery | undefined, GraphqlTypes.GetDdqKbDocumentsQueryVariables>;
export function useGetDdqKbDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>(GetDdqKbDocumentsDocument, options);
        }
export type GetDdqKbDocumentsQueryHookResult = ReturnType<typeof useGetDdqKbDocumentsQuery>;
export type GetDdqKbDocumentsLazyQueryHookResult = ReturnType<typeof useGetDdqKbDocumentsLazyQuery>;
export type GetDdqKbDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetDdqKbDocumentsSuspenseQuery>;
export type GetDdqKbDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqKbDocumentsQuery, GraphqlTypes.GetDdqKbDocumentsQueryVariables>;
export const GetKbFolderContentsDocument = gql`
    query GetKbFolderContents($arenaId: Int!, $folderSoaId: ID, $cursor: String, $limit: Int, $includeArchived: Boolean, $foldersOnly: Boolean) {
  kbFolderContents(
    arenaId: $arenaId
    folderSoaId: $folderSoaId
    cursor: $cursor
    limit: $limit
    includeArchived: $includeArchived
    foldersOnly: $foldersOnly
  ) {
    nextCursor
    folder {
      soaId
      name
    }
    subfolders {
      soaId
      name
      parentFolderSoaId
    }
    documents {
      id
      documentId
      name
      size
      contentType
      offeringIds
      archivedAt
    }
  }
}
    `;

/**
 * __useGetKbFolderContentsQuery__
 *
 * To run a query within a React component, call `useGetKbFolderContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKbFolderContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKbFolderContentsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      folderSoaId: // value for 'folderSoaId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      includeArchived: // value for 'includeArchived'
 *      foldersOnly: // value for 'foldersOnly'
 *   },
 * });
 */
export function useGetKbFolderContentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables> & ({ variables: GraphqlTypes.GetKbFolderContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>(GetKbFolderContentsDocument, options);
      }
export function useGetKbFolderContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>(GetKbFolderContentsDocument, options);
        }
// @ts-ignore
export function useGetKbFolderContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>;
export function useGetKbFolderContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetKbFolderContentsQuery | undefined, GraphqlTypes.GetKbFolderContentsQueryVariables>;
export function useGetKbFolderContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>(GetKbFolderContentsDocument, options);
        }
export type GetKbFolderContentsQueryHookResult = ReturnType<typeof useGetKbFolderContentsQuery>;
export type GetKbFolderContentsLazyQueryHookResult = ReturnType<typeof useGetKbFolderContentsLazyQuery>;
export type GetKbFolderContentsSuspenseQueryHookResult = ReturnType<typeof useGetKbFolderContentsSuspenseQuery>;
export type GetKbFolderContentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetKbFolderContentsQuery, GraphqlTypes.GetKbFolderContentsQueryVariables>;
export const GenerateDdqKbUploadUrlDocument = gql`
    mutation GenerateDdqKbUploadUrl($arenaId: Int!, $filename: String!) {
  generateDdqKbUploadUrl(arenaId: $arenaId, filename: $filename) {
    uploadUrl
    formData
    documentObjectKey
    expiresAt
  }
}
    `;
export type GenerateDdqKbUploadUrlMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateDdqKbUploadUrlMutation, GraphqlTypes.GenerateDdqKbUploadUrlMutationVariables>;

/**
 * __useGenerateDdqKbUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateDdqKbUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDdqKbUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDdqKbUploadUrlMutation, { data, loading, error }] = useGenerateDdqKbUploadUrlMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateDdqKbUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateDdqKbUploadUrlMutation, GraphqlTypes.GenerateDdqKbUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateDdqKbUploadUrlMutation, GraphqlTypes.GenerateDdqKbUploadUrlMutationVariables>(GenerateDdqKbUploadUrlDocument, options);
      }
export type GenerateDdqKbUploadUrlMutationHookResult = ReturnType<typeof useGenerateDdqKbUploadUrlMutation>;
export type GenerateDdqKbUploadUrlMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateDdqKbUploadUrlMutation>;
export type GenerateDdqKbUploadUrlMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateDdqKbUploadUrlMutation, GraphqlTypes.GenerateDdqKbUploadUrlMutationVariables>;
export const UploadDdqKbDocumentDocument = gql`
    mutation UploadDdqKbDocument($input: UploadDdqKbDocumentInput!) {
  uploadDdqKbDocument(input: $input) {
    id
    documentId
    sourceOfferingId
  }
}
    `;
export type UploadDdqKbDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadDdqKbDocumentMutation, GraphqlTypes.UploadDdqKbDocumentMutationVariables>;

/**
 * __useUploadDdqKbDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDdqKbDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDdqKbDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDdqKbDocumentMutation, { data, loading, error }] = useUploadDdqKbDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadDdqKbDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadDdqKbDocumentMutation, GraphqlTypes.UploadDdqKbDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadDdqKbDocumentMutation, GraphqlTypes.UploadDdqKbDocumentMutationVariables>(UploadDdqKbDocumentDocument, options);
      }
export type UploadDdqKbDocumentMutationHookResult = ReturnType<typeof useUploadDdqKbDocumentMutation>;
export type UploadDdqKbDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.UploadDdqKbDocumentMutation>;
export type UploadDdqKbDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadDdqKbDocumentMutation, GraphqlTypes.UploadDdqKbDocumentMutationVariables>;
export const GetDdqKbUploadOfferingsDocument = gql`
    query GetDdqKbUploadOfferings {
  searchAllOfferings {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDdqKbUploadOfferingsQuery__
 *
 * To run a query within a React component, call `useGetDdqKbUploadOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqKbUploadOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqKbUploadOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDdqKbUploadOfferingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>(GetDdqKbUploadOfferingsDocument, options);
      }
export function useGetDdqKbUploadOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>(GetDdqKbUploadOfferingsDocument, options);
        }
// @ts-ignore
export function useGetDdqKbUploadOfferingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>;
export function useGetDdqKbUploadOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqKbUploadOfferingsQuery | undefined, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>;
export function useGetDdqKbUploadOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>(GetDdqKbUploadOfferingsDocument, options);
        }
export type GetDdqKbUploadOfferingsQueryHookResult = ReturnType<typeof useGetDdqKbUploadOfferingsQuery>;
export type GetDdqKbUploadOfferingsLazyQueryHookResult = ReturnType<typeof useGetDdqKbUploadOfferingsLazyQuery>;
export type GetDdqKbUploadOfferingsSuspenseQueryHookResult = ReturnType<typeof useGetDdqKbUploadOfferingsSuspenseQuery>;
export type GetDdqKbUploadOfferingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqKbUploadOfferingsQuery, GraphqlTypes.GetDdqKbUploadOfferingsQueryVariables>;
export const ResetMatchResultsDocument = gql`
    mutation ResetMatchResults($arenaId: ID!, $contactIds: [ID!]!, $resetBy: ID!) {
  resetMatchResults(arenaId: $arenaId, contactIds: $contactIds, resetBy: $resetBy) {
    status
    contactId
    arenaId
  }
}
    `;
export type ResetMatchResultsMutationFn = Apollo.MutationFunction<GraphqlTypes.ResetMatchResultsMutation, GraphqlTypes.ResetMatchResultsMutationVariables>;

/**
 * __useResetMatchResultsMutation__
 *
 * To run a mutation, you first call `useResetMatchResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMatchResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMatchResultsMutation, { data, loading, error }] = useResetMatchResultsMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      contactIds: // value for 'contactIds'
 *      resetBy: // value for 'resetBy'
 *   },
 * });
 */
export function useResetMatchResultsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ResetMatchResultsMutation, GraphqlTypes.ResetMatchResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ResetMatchResultsMutation, GraphqlTypes.ResetMatchResultsMutationVariables>(ResetMatchResultsDocument, options);
      }
export type ResetMatchResultsMutationHookResult = ReturnType<typeof useResetMatchResultsMutation>;
export type ResetMatchResultsMutationResult = Apollo.MutationResult<GraphqlTypes.ResetMatchResultsMutation>;
export type ResetMatchResultsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ResetMatchResultsMutation, GraphqlTypes.ResetMatchResultsMutationVariables>;
export const ImportMarketLensEntitiesDocument = gql`
    mutation ImportMarketLensEntities($input: ImportMarketLensEntitiesInput!) {
  importMarketLensEntities(input: $input) {
    ... on ImportMarketLensEntitiesObject {
      success
      jobId
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ImportMarketLensEntitiesMutationFn = Apollo.MutationFunction<GraphqlTypes.ImportMarketLensEntitiesMutation, GraphqlTypes.ImportMarketLensEntitiesMutationVariables>;

/**
 * __useImportMarketLensEntitiesMutation__
 *
 * To run a mutation, you first call `useImportMarketLensEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMarketLensEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMarketLensEntitiesMutation, { data, loading, error }] = useImportMarketLensEntitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMarketLensEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ImportMarketLensEntitiesMutation, GraphqlTypes.ImportMarketLensEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ImportMarketLensEntitiesMutation, GraphqlTypes.ImportMarketLensEntitiesMutationVariables>(ImportMarketLensEntitiesDocument, options);
      }
export type ImportMarketLensEntitiesMutationHookResult = ReturnType<typeof useImportMarketLensEntitiesMutation>;
export type ImportMarketLensEntitiesMutationResult = Apollo.MutationResult<GraphqlTypes.ImportMarketLensEntitiesMutation>;
export type ImportMarketLensEntitiesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ImportMarketLensEntitiesMutation, GraphqlTypes.ImportMarketLensEntitiesMutationVariables>;
export const DistinctFirmCountriesDocument = gql`
    query DistinctFirmCountries($firmTypes: [String!]) {
  distinctFirmCountries(firmTypes: $firmTypes)
}
    `;

/**
 * __useDistinctFirmCountriesQuery__
 *
 * To run a query within a React component, call `useDistinctFirmCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistinctFirmCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistinctFirmCountriesQuery({
 *   variables: {
 *      firmTypes: // value for 'firmTypes'
 *   },
 * });
 */
export function useDistinctFirmCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>(DistinctFirmCountriesDocument, options);
      }
export function useDistinctFirmCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>(DistinctFirmCountriesDocument, options);
        }
// @ts-ignore
export function useDistinctFirmCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>;
export function useDistinctFirmCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DistinctFirmCountriesQuery | undefined, GraphqlTypes.DistinctFirmCountriesQueryVariables>;
export function useDistinctFirmCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>(DistinctFirmCountriesDocument, options);
        }
export type DistinctFirmCountriesQueryHookResult = ReturnType<typeof useDistinctFirmCountriesQuery>;
export type DistinctFirmCountriesLazyQueryHookResult = ReturnType<typeof useDistinctFirmCountriesLazyQuery>;
export type DistinctFirmCountriesSuspenseQueryHookResult = ReturnType<typeof useDistinctFirmCountriesSuspenseQuery>;
export type DistinctFirmCountriesQueryResult = Apollo.QueryResult<GraphqlTypes.DistinctFirmCountriesQuery, GraphqlTypes.DistinctFirmCountriesQueryVariables>;
export const DistinctFirmStatesDocument = gql`
    query DistinctFirmStates($firmTypes: [String!]) {
  distinctFirmStates(firmTypes: $firmTypes)
}
    `;

/**
 * __useDistinctFirmStatesQuery__
 *
 * To run a query within a React component, call `useDistinctFirmStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistinctFirmStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistinctFirmStatesQuery({
 *   variables: {
 *      firmTypes: // value for 'firmTypes'
 *   },
 * });
 */
export function useDistinctFirmStatesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>(DistinctFirmStatesDocument, options);
      }
export function useDistinctFirmStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>(DistinctFirmStatesDocument, options);
        }
// @ts-ignore
export function useDistinctFirmStatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>;
export function useDistinctFirmStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DistinctFirmStatesQuery | undefined, GraphqlTypes.DistinctFirmStatesQueryVariables>;
export function useDistinctFirmStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>(DistinctFirmStatesDocument, options);
        }
export type DistinctFirmStatesQueryHookResult = ReturnType<typeof useDistinctFirmStatesQuery>;
export type DistinctFirmStatesLazyQueryHookResult = ReturnType<typeof useDistinctFirmStatesLazyQuery>;
export type DistinctFirmStatesSuspenseQueryHookResult = ReturnType<typeof useDistinctFirmStatesSuspenseQuery>;
export type DistinctFirmStatesQueryResult = Apollo.QueryResult<GraphqlTypes.DistinctFirmStatesQuery, GraphqlTypes.DistinctFirmStatesQueryVariables>;
export const DistinctFirmCitiesDocument = gql`
    query DistinctFirmCities($firmTypes: [String!]) {
  distinctFirmCities(firmTypes: $firmTypes)
}
    `;

/**
 * __useDistinctFirmCitiesQuery__
 *
 * To run a query within a React component, call `useDistinctFirmCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistinctFirmCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistinctFirmCitiesQuery({
 *   variables: {
 *      firmTypes: // value for 'firmTypes'
 *   },
 * });
 */
export function useDistinctFirmCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>(DistinctFirmCitiesDocument, options);
      }
export function useDistinctFirmCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>(DistinctFirmCitiesDocument, options);
        }
// @ts-ignore
export function useDistinctFirmCitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>;
export function useDistinctFirmCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DistinctFirmCitiesQuery | undefined, GraphqlTypes.DistinctFirmCitiesQueryVariables>;
export function useDistinctFirmCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>(DistinctFirmCitiesDocument, options);
        }
export type DistinctFirmCitiesQueryHookResult = ReturnType<typeof useDistinctFirmCitiesQuery>;
export type DistinctFirmCitiesLazyQueryHookResult = ReturnType<typeof useDistinctFirmCitiesLazyQuery>;
export type DistinctFirmCitiesSuspenseQueryHookResult = ReturnType<typeof useDistinctFirmCitiesSuspenseQuery>;
export type DistinctFirmCitiesQueryResult = Apollo.QueryResult<GraphqlTypes.DistinctFirmCitiesQuery, GraphqlTypes.DistinctFirmCitiesQueryVariables>;
export const DiscoverMatchedContactDocument = gql`
    query DiscoverMatchedContact($contactId: ID!) {
  contact(contactId: $contactId) {
    id
    fullName
  }
}
    `;

/**
 * __useDiscoverMatchedContactQuery__
 *
 * To run a query within a React component, call `useDiscoverMatchedContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverMatchedContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverMatchedContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useDiscoverMatchedContactQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables> & ({ variables: GraphqlTypes.DiscoverMatchedContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>(DiscoverMatchedContactDocument, options);
      }
export function useDiscoverMatchedContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>(DiscoverMatchedContactDocument, options);
        }
// @ts-ignore
export function useDiscoverMatchedContactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>;
export function useDiscoverMatchedContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DiscoverMatchedContactQuery | undefined, GraphqlTypes.DiscoverMatchedContactQueryVariables>;
export function useDiscoverMatchedContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>(DiscoverMatchedContactDocument, options);
        }
export type DiscoverMatchedContactQueryHookResult = ReturnType<typeof useDiscoverMatchedContactQuery>;
export type DiscoverMatchedContactLazyQueryHookResult = ReturnType<typeof useDiscoverMatchedContactLazyQuery>;
export type DiscoverMatchedContactSuspenseQueryHookResult = ReturnType<typeof useDiscoverMatchedContactSuspenseQuery>;
export type DiscoverMatchedContactQueryResult = Apollo.QueryResult<GraphqlTypes.DiscoverMatchedContactQuery, GraphqlTypes.DiscoverMatchedContactQueryVariables>;
export const BulkImportJsqContactsDocument = gql`
    query BulkImportJsqContacts($contactIds: [ID!]!, $first: Int!) {
  contactsById(contactIds: $contactIds, first: $first) {
    edges {
      node {
        id
        title
        firstName
        middleName
        lastName
        fullName
        jobTitle
        linkedinUrl
        companyName
        websiteUrl
        hasEditContactAccess
        hasViewContactAccess
        company {
          id
          fullName
        }
        primaryEmail {
          emailAddress
        }
        phones {
          phoneNumber
        }
        addresses {
          street
          street2
          city
          region
          state {
            objectName
          }
          postalCode
          country {
            objectName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBulkImportJsqContactsQuery__
 *
 * To run a query within a React component, call `useBulkImportJsqContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkImportJsqContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkImportJsqContactsQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useBulkImportJsqContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables> & ({ variables: GraphqlTypes.BulkImportJsqContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>(BulkImportJsqContactsDocument, options);
      }
export function useBulkImportJsqContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>(BulkImportJsqContactsDocument, options);
        }
// @ts-ignore
export function useBulkImportJsqContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>;
export function useBulkImportJsqContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportJsqContactsQuery | undefined, GraphqlTypes.BulkImportJsqContactsQueryVariables>;
export function useBulkImportJsqContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>(BulkImportJsqContactsDocument, options);
        }
export type BulkImportJsqContactsQueryHookResult = ReturnType<typeof useBulkImportJsqContactsQuery>;
export type BulkImportJsqContactsLazyQueryHookResult = ReturnType<typeof useBulkImportJsqContactsLazyQuery>;
export type BulkImportJsqContactsSuspenseQueryHookResult = ReturnType<typeof useBulkImportJsqContactsSuspenseQuery>;
export type BulkImportJsqContactsQueryResult = Apollo.QueryResult<GraphqlTypes.BulkImportJsqContactsQuery, GraphqlTypes.BulkImportJsqContactsQueryVariables>;
export const FirmContactRelationsDocument = gql`
    query FirmContactRelations($contactId: ID!) {
  contactsById(contactIds: [$contactId], first: 1) {
    edges {
      node {
        id
        relations {
          contact {
            id
          }
          relatedContact {
            id
          }
        }
        staff {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFirmContactRelationsQuery__
 *
 * To run a query within a React component, call `useFirmContactRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmContactRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmContactRelationsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useFirmContactRelationsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables> & ({ variables: GraphqlTypes.FirmContactRelationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>(FirmContactRelationsDocument, options);
      }
export function useFirmContactRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>(FirmContactRelationsDocument, options);
        }
// @ts-ignore
export function useFirmContactRelationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>;
export function useFirmContactRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmContactRelationsQuery | undefined, GraphqlTypes.FirmContactRelationsQueryVariables>;
export function useFirmContactRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>(FirmContactRelationsDocument, options);
        }
export type FirmContactRelationsQueryHookResult = ReturnType<typeof useFirmContactRelationsQuery>;
export type FirmContactRelationsLazyQueryHookResult = ReturnType<typeof useFirmContactRelationsLazyQuery>;
export type FirmContactRelationsSuspenseQueryHookResult = ReturnType<typeof useFirmContactRelationsSuspenseQuery>;
export type FirmContactRelationsQueryResult = Apollo.QueryResult<GraphqlTypes.FirmContactRelationsQuery, GraphqlTypes.FirmContactRelationsQueryVariables>;
export const BulkImportAnchorRelationsDocument = gql`
    query BulkImportAnchorRelations($contactId: ID!) {
  contact(contactId: $contactId) {
    id
    relations {
      id
      notes
      label
      includeContactInFutureOrgProspects
      includeRelatedContactInFutureOrgProspects
      contact {
        id
        fullName
      }
      relatedContact {
        id
        fullName
      }
    }
    staff {
      id
      fullName
      jobTitle
      staffNotes
      includeInFutureOrgProspects
    }
  }
}
    `;

/**
 * __useBulkImportAnchorRelationsQuery__
 *
 * To run a query within a React component, call `useBulkImportAnchorRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkImportAnchorRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkImportAnchorRelationsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useBulkImportAnchorRelationsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables> & ({ variables: GraphqlTypes.BulkImportAnchorRelationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>(BulkImportAnchorRelationsDocument, options);
      }
export function useBulkImportAnchorRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>(BulkImportAnchorRelationsDocument, options);
        }
// @ts-ignore
export function useBulkImportAnchorRelationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>;
export function useBulkImportAnchorRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportAnchorRelationsQuery | undefined, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>;
export function useBulkImportAnchorRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>(BulkImportAnchorRelationsDocument, options);
        }
export type BulkImportAnchorRelationsQueryHookResult = ReturnType<typeof useBulkImportAnchorRelationsQuery>;
export type BulkImportAnchorRelationsLazyQueryHookResult = ReturnType<typeof useBulkImportAnchorRelationsLazyQuery>;
export type BulkImportAnchorRelationsSuspenseQueryHookResult = ReturnType<typeof useBulkImportAnchorRelationsSuspenseQuery>;
export type BulkImportAnchorRelationsQueryResult = Apollo.QueryResult<GraphqlTypes.BulkImportAnchorRelationsQuery, GraphqlTypes.BulkImportAnchorRelationsQueryVariables>;
export const FirmMandatesDocument = gql`
    query FirmMandates($firmGuid: ID!, $arenaId: ID) {
  marketLensFirm(firmGuid: $firmGuid, arenaId: $arenaId) {
    __typename
    ... on MarketLensFirm {
      mandates {
        mandateGuid
        commitment
        currencyCode
        mandateCategory
        mandatePlanType
        rfpIssueDate
        rfpResponseDeadlineDate
        consultantContact
        reasonForHire
        mostRecentMandateStage
        updatedOn
        investmentStyles {
          table
          parentGuid
          universe
          assetClass
          subAssetClass
          sector
          stage
          region
        }
        mandateAssetAllocations {
          mandateAssetAllocationGuid
          isLatest
          strategySequence
          historySequence
          year
          allocationType
          percentage
          updatedOn
        }
        pacingPlans {
          currencyCode
          strategySequence
          historySequence
          isTotals
          year
          yearType
          commitmentRangeMinimum
          commitmentRangeTarget
          commitmentRangeMaximum
          numberOfFundsMinimum
          numberOfFundsTarget
          numberOfFundsMaximum
          commitmentSizePerFundMinimum
          commitmentSizePerFundTarget
          commitmentSizePerFundMaximum
          updatedOn
        }
      }
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useFirmMandatesQuery__
 *
 * To run a query within a React component, call `useFirmMandatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmMandatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmMandatesQuery({
 *   variables: {
 *      firmGuid: // value for 'firmGuid'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFirmMandatesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables> & ({ variables: GraphqlTypes.FirmMandatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>(FirmMandatesDocument, options);
      }
export function useFirmMandatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>(FirmMandatesDocument, options);
        }
// @ts-ignore
export function useFirmMandatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>;
export function useFirmMandatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmMandatesQuery | undefined, GraphqlTypes.FirmMandatesQueryVariables>;
export function useFirmMandatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>(FirmMandatesDocument, options);
        }
export type FirmMandatesQueryHookResult = ReturnType<typeof useFirmMandatesQuery>;
export type FirmMandatesLazyQueryHookResult = ReturnType<typeof useFirmMandatesLazyQuery>;
export type FirmMandatesSuspenseQueryHookResult = ReturnType<typeof useFirmMandatesSuspenseQuery>;
export type FirmMandatesQueryResult = Apollo.QueryResult<GraphqlTypes.FirmMandatesQuery, GraphqlTypes.FirmMandatesQueryVariables>;
export const SearchFirmKeyContactsDocument = gql`
    query SearchFirmKeyContacts($filters: ContactFilters, $offset: Int, $limit: Int, $sort: [String!], $arenaId: ID) {
  searchMarketLensContacts(
    filters: $filters
    offset: $offset
    limit: $limit
    sort: $sort
    arenaId: $arenaId
  ) {
    __typename
    ... on ContactSearchResult {
      items {
        personGuid
        prefix
        suffix
        firstName
        middleName
        lastName
        email
        phone
        linkedinUrl
        currentJobTitle
        boardTitle
        industryFocuses
        regionFocuses
        streetAddress
        streetAddress2
        city
        state
        zipCode
        country
        updatedOn
        specialty
        positions {
          contactType
        }
        matchResult {
          status
          contactId
          confidenceScore
          matchDetails {
            nameSimilarity
            emailSimilarity
            addressSimilarity
          }
        }
      }
      totalCount
      filteredCount
      page
      pageSize
      totalPages
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useSearchFirmKeyContactsQuery__
 *
 * To run a query within a React component, call `useSearchFirmKeyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFirmKeyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFirmKeyContactsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useSearchFirmKeyContactsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>(SearchFirmKeyContactsDocument, options);
      }
export function useSearchFirmKeyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>(SearchFirmKeyContactsDocument, options);
        }
// @ts-ignore
export function useSearchFirmKeyContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>;
export function useSearchFirmKeyContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchFirmKeyContactsQuery | undefined, GraphqlTypes.SearchFirmKeyContactsQueryVariables>;
export function useSearchFirmKeyContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>(SearchFirmKeyContactsDocument, options);
        }
export type SearchFirmKeyContactsQueryHookResult = ReturnType<typeof useSearchFirmKeyContactsQuery>;
export type SearchFirmKeyContactsLazyQueryHookResult = ReturnType<typeof useSearchFirmKeyContactsLazyQuery>;
export type SearchFirmKeyContactsSuspenseQueryHookResult = ReturnType<typeof useSearchFirmKeyContactsSuspenseQuery>;
export type SearchFirmKeyContactsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchFirmKeyContactsQuery, GraphqlTypes.SearchFirmKeyContactsQueryVariables>;
export const FirmServiceProvidersDocument = gql`
    query FirmServiceProviders($firmGuid: ID!, $arenaId: ID) {
  marketLensFirm(firmGuid: $firmGuid, arenaId: $arenaId) {
    __typename
    ... on MarketLensFirm {
      serviceProviders {
        serviceProviderCompositeId
        serviceProviderFirmGuid
        serviceProviderFirmName
        roles
        serviceProviderKeyProfessionals
        marketLensFirm {
          firmName
          phone
          website
          streetAddress
          streetAddress2
          city
          state
          zipCode
          country
          investorType
          investorSubType
          totalAssets
          currencyCode
        }
        matchResult {
          status
          contactId
          confidenceScore
          matchDetails {
            nameSimilarity
            emailSimilarity
            addressSimilarity
          }
          marketLensFirm {
            firmName
            phone
            website
            streetAddress
            streetAddress2
            city
            state
            zipCode
            country
          }
        }
      }
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useFirmServiceProvidersQuery__
 *
 * To run a query within a React component, call `useFirmServiceProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmServiceProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmServiceProvidersQuery({
 *   variables: {
 *      firmGuid: // value for 'firmGuid'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFirmServiceProvidersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables> & ({ variables: GraphqlTypes.FirmServiceProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>(FirmServiceProvidersDocument, options);
      }
export function useFirmServiceProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>(FirmServiceProvidersDocument, options);
        }
// @ts-ignore
export function useFirmServiceProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>;
export function useFirmServiceProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmServiceProvidersQuery | undefined, GraphqlTypes.FirmServiceProvidersQueryVariables>;
export function useFirmServiceProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>(FirmServiceProvidersDocument, options);
        }
export type FirmServiceProvidersQueryHookResult = ReturnType<typeof useFirmServiceProvidersQuery>;
export type FirmServiceProvidersLazyQueryHookResult = ReturnType<typeof useFirmServiceProvidersLazyQuery>;
export type FirmServiceProvidersSuspenseQueryHookResult = ReturnType<typeof useFirmServiceProvidersSuspenseQuery>;
export type FirmServiceProvidersQueryResult = Apollo.QueryResult<GraphqlTypes.FirmServiceProvidersQuery, GraphqlTypes.FirmServiceProvidersQueryVariables>;
export const FirmClientsDocument = gql`
    query FirmClients($firmGuid: ID!, $arenaId: ID) {
  marketLensFirm(firmGuid: $firmGuid, arenaId: $arenaId) {
    __typename
    ... on MarketLensFirm {
      clients {
        serviceProviderCompositeId
        investorFirmGuid
        clientName
        clientType
        investorSubType
        totalAssets
        currencyCode
        servicesRendered
        keyProfessionals
        matchResult {
          status
          contactId
          confidenceScore
          matchDetails {
            nameSimilarity
            emailSimilarity
            addressSimilarity
          }
        }
      }
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useFirmClientsQuery__
 *
 * To run a query within a React component, call `useFirmClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmClientsQuery({
 *   variables: {
 *      firmGuid: // value for 'firmGuid'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFirmClientsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables> & ({ variables: GraphqlTypes.FirmClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>(FirmClientsDocument, options);
      }
export function useFirmClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>(FirmClientsDocument, options);
        }
// @ts-ignore
export function useFirmClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>;
export function useFirmClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmClientsQuery | undefined, GraphqlTypes.FirmClientsQueryVariables>;
export function useFirmClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>(FirmClientsDocument, options);
        }
export type FirmClientsQueryHookResult = ReturnType<typeof useFirmClientsQuery>;
export type FirmClientsLazyQueryHookResult = ReturnType<typeof useFirmClientsLazyQuery>;
export type FirmClientsSuspenseQueryHookResult = ReturnType<typeof useFirmClientsSuspenseQuery>;
export type FirmClientsQueryResult = Apollo.QueryResult<GraphqlTypes.FirmClientsQuery, GraphqlTypes.FirmClientsQueryVariables>;
export const FirmDetailsByGuidDocument = gql`
    query FirmDetailsByGuid($firmGuid: ID!, $arenaId: ID) {
  marketLensFirm(firmGuid: $firmGuid, arenaId: $arenaId) {
    __typename
    ... on MarketLensFirm {
      firmGuid
      firmName
      investorType
      investorSubType
      familyOfficeSubType
      naicCode
      naicType
      country
      state
      city
      website
      phone
      streetAddress
      streetAddress2
      zipCode
      totalAssets
      currencyCode
      definedBenefitAssets
      definedContributionAssets
      otherAssets
      totalEndowmentAndFoundationsAssets
      totalInsuranceLongTermAssets
      totalInsuranceAffiliatedAssets
      totalInsuranceUnaffiliatedAssets
      totalFiduciaryAllocatorAssetsUnaffiliated
      totalClientCount
      publicClientCount
      corporateClientCount
      nonProfitClientCount
      taftHartleyClientCount
      otherClientCount
      updatedOn
      matchResult {
        arenaId
        contactId
        status
        confidenceScore
      }
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useFirmDetailsByGuidQuery__
 *
 * To run a query within a React component, call `useFirmDetailsByGuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmDetailsByGuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmDetailsByGuidQuery({
 *   variables: {
 *      firmGuid: // value for 'firmGuid'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFirmDetailsByGuidQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables> & ({ variables: GraphqlTypes.FirmDetailsByGuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>(FirmDetailsByGuidDocument, options);
      }
export function useFirmDetailsByGuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>(FirmDetailsByGuidDocument, options);
        }
// @ts-ignore
export function useFirmDetailsByGuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>;
export function useFirmDetailsByGuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmDetailsByGuidQuery | undefined, GraphqlTypes.FirmDetailsByGuidQueryVariables>;
export function useFirmDetailsByGuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>(FirmDetailsByGuidDocument, options);
        }
export type FirmDetailsByGuidQueryHookResult = ReturnType<typeof useFirmDetailsByGuidQuery>;
export type FirmDetailsByGuidLazyQueryHookResult = ReturnType<typeof useFirmDetailsByGuidLazyQuery>;
export type FirmDetailsByGuidSuspenseQueryHookResult = ReturnType<typeof useFirmDetailsByGuidSuspenseQuery>;
export type FirmDetailsByGuidQueryResult = Apollo.QueryResult<GraphqlTypes.FirmDetailsByGuidQuery, GraphqlTypes.FirmDetailsByGuidQueryVariables>;
export const FirmInformationDocument = gql`
    query FirmInformation($query: String, $filters: FirmFilters, $offset: Int, $limit: Int, $sort: [String!], $arenaId: ID) {
  searchMarketLensFirms(
    query: $query
    filters: $filters
    offset: $offset
    limit: $limit
    sort: $sort
    arenaId: $arenaId
  ) {
    __typename
    ... on FirmSearchResult {
      items {
        firmGuid
        firmName
        investorType
        investorSubType
        familyOfficeSubType
        naicCode
        naicType
        country
        state
        city
        website
        phone
        streetAddress
        streetAddress2
        zipCode
        totalAssets
        currencyCode
        definedBenefitAssets
        definedContributionAssets
        otherAssets
        totalEndowmentAndFoundationsAssets
        totalInsuranceLongTermAssets
        totalInsuranceAffiliatedAssets
        totalInsuranceUnaffiliatedAssets
        totalFiduciaryAllocatorAssetsUnaffiliated
        totalClientCount
        publicClientCount
        corporateClientCount
        nonProfitClientCount
        taftHartleyClientCount
        otherClientCount
        updatedOn
        matchResult {
          arenaId
          contactId
          status
          confidenceScore
        }
      }
      totalCount
      filteredCount
      page
      pageSize
      totalPages
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useFirmInformationQuery__
 *
 * To run a query within a React component, call `useFirmInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmInformationQuery({
 *   variables: {
 *      query: // value for 'query'
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFirmInformationQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>(FirmInformationDocument, options);
      }
export function useFirmInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>(FirmInformationDocument, options);
        }
// @ts-ignore
export function useFirmInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>;
export function useFirmInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FirmInformationQuery | undefined, GraphqlTypes.FirmInformationQueryVariables>;
export function useFirmInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>(FirmInformationDocument, options);
        }
export type FirmInformationQueryHookResult = ReturnType<typeof useFirmInformationQuery>;
export type FirmInformationLazyQueryHookResult = ReturnType<typeof useFirmInformationLazyQuery>;
export type FirmInformationSuspenseQueryHookResult = ReturnType<typeof useFirmInformationSuspenseQuery>;
export type FirmInformationQueryResult = Apollo.QueryResult<GraphqlTypes.FirmInformationQuery, GraphqlTypes.FirmInformationQueryVariables>;
export const UpdateManualSettlementDocument = gql`
    mutation UpdateManualSettlement($distributionId: ID!, $manualSettlementDate: Date!, $notes: String) {
  updateManualSettlement(
    id: $distributionId
    manualSettlementDate: $manualSettlementDate
    notes: $notes
  ) {
    success
  }
}
    `;
export type UpdateManualSettlementMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateManualSettlementMutation, GraphqlTypes.UpdateManualSettlementMutationVariables>;

/**
 * __useUpdateManualSettlementMutation__
 *
 * To run a mutation, you first call `useUpdateManualSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualSettlementMutation, { data, loading, error }] = useUpdateManualSettlementMutation({
 *   variables: {
 *      distributionId: // value for 'distributionId'
 *      manualSettlementDate: // value for 'manualSettlementDate'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateManualSettlementMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateManualSettlementMutation, GraphqlTypes.UpdateManualSettlementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateManualSettlementMutation, GraphqlTypes.UpdateManualSettlementMutationVariables>(UpdateManualSettlementDocument, options);
      }
export type UpdateManualSettlementMutationHookResult = ReturnType<typeof useUpdateManualSettlementMutation>;
export type UpdateManualSettlementMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateManualSettlementMutation>;
export type UpdateManualSettlementMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateManualSettlementMutation, GraphqlTypes.UpdateManualSettlementMutationVariables>;
export const GetRemainingPositionsByDistributionBatchIdDocument = gql`
    query GetRemainingPositionsByDistributionBatchId($batchId: ID!) {
  distributionBatch(id: $batchId) {
    id
    remainingPositionList {
      id
      text
    }
  }
}
    `;

/**
 * __useGetRemainingPositionsByDistributionBatchIdQuery__
 *
 * To run a query within a React component, call `useGetRemainingPositionsByDistributionBatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemainingPositionsByDistributionBatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemainingPositionsByDistributionBatchIdQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useGetRemainingPositionsByDistributionBatchIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables> & ({ variables: GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>(GetRemainingPositionsByDistributionBatchIdDocument, options);
      }
export function useGetRemainingPositionsByDistributionBatchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>(GetRemainingPositionsByDistributionBatchIdDocument, options);
        }
// @ts-ignore
export function useGetRemainingPositionsByDistributionBatchIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>;
export function useGetRemainingPositionsByDistributionBatchIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery | undefined, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>;
export function useGetRemainingPositionsByDistributionBatchIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>(GetRemainingPositionsByDistributionBatchIdDocument, options);
        }
export type GetRemainingPositionsByDistributionBatchIdQueryHookResult = ReturnType<typeof useGetRemainingPositionsByDistributionBatchIdQuery>;
export type GetRemainingPositionsByDistributionBatchIdLazyQueryHookResult = ReturnType<typeof useGetRemainingPositionsByDistributionBatchIdLazyQuery>;
export type GetRemainingPositionsByDistributionBatchIdSuspenseQueryHookResult = ReturnType<typeof useGetRemainingPositionsByDistributionBatchIdSuspenseQuery>;
export type GetRemainingPositionsByDistributionBatchIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQuery, GraphqlTypes.GetRemainingPositionsByDistributionBatchIdQueryVariables>;
export const GetDistributionBatchCurrencyDocument = gql`
    query GetDistributionBatchCurrency($batchId: ID!) {
  distributionBatch(id: $batchId) {
    id
    entity {
      id
      currency {
        id
        code
      }
    }
  }
}
    `;

/**
 * __useGetDistributionBatchCurrencyQuery__
 *
 * To run a query within a React component, call `useGetDistributionBatchCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionBatchCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionBatchCurrencyQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useGetDistributionBatchCurrencyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables> & ({ variables: GraphqlTypes.GetDistributionBatchCurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>(GetDistributionBatchCurrencyDocument, options);
      }
export function useGetDistributionBatchCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>(GetDistributionBatchCurrencyDocument, options);
        }
// @ts-ignore
export function useGetDistributionBatchCurrencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>;
export function useGetDistributionBatchCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchCurrencyQuery | undefined, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>;
export function useGetDistributionBatchCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>(GetDistributionBatchCurrencyDocument, options);
        }
export type GetDistributionBatchCurrencyQueryHookResult = ReturnType<typeof useGetDistributionBatchCurrencyQuery>;
export type GetDistributionBatchCurrencyLazyQueryHookResult = ReturnType<typeof useGetDistributionBatchCurrencyLazyQuery>;
export type GetDistributionBatchCurrencySuspenseQueryHookResult = ReturnType<typeof useGetDistributionBatchCurrencySuspenseQuery>;
export type GetDistributionBatchCurrencyQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionBatchCurrencyQuery, GraphqlTypes.GetDistributionBatchCurrencyQueryVariables>;
export const StartTransactionDownloadDocument = gql`
    mutation StartTransactionDownload($batchId: Int!, $batchType: JSQObjectType!, $includeTotals: Boolean, $includeCurrentPaymentInfo: Boolean) {
  transactionDownload(
    batchId: $batchId
    batchType: $batchType
    includeTotals: $includeTotals
    includeCurrentPaymentInfo: $includeCurrentPaymentInfo
  ) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on AsyncJobObjectType {
      id
    }
  }
}
    `;
export type StartTransactionDownloadMutationFn = Apollo.MutationFunction<GraphqlTypes.StartTransactionDownloadMutation, GraphqlTypes.StartTransactionDownloadMutationVariables>;

/**
 * __useStartTransactionDownloadMutation__
 *
 * To run a mutation, you first call `useStartTransactionDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTransactionDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTransactionDownloadMutation, { data, loading, error }] = useStartTransactionDownloadMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      batchType: // value for 'batchType'
 *      includeTotals: // value for 'includeTotals'
 *      includeCurrentPaymentInfo: // value for 'includeCurrentPaymentInfo'
 *   },
 * });
 */
export function useStartTransactionDownloadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartTransactionDownloadMutation, GraphqlTypes.StartTransactionDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartTransactionDownloadMutation, GraphqlTypes.StartTransactionDownloadMutationVariables>(StartTransactionDownloadDocument, options);
      }
export type StartTransactionDownloadMutationHookResult = ReturnType<typeof useStartTransactionDownloadMutation>;
export type StartTransactionDownloadMutationResult = Apollo.MutationResult<GraphqlTypes.StartTransactionDownloadMutation>;
export type StartTransactionDownloadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartTransactionDownloadMutation, GraphqlTypes.StartTransactionDownloadMutationVariables>;
export const GetDistributionsForGridDocument = gql`
    query GetDistributionsForGrid($batchId: ID!, $filters: DistributionFilterInput) {
  distributions(distributionBatchId: $batchId, filters: $filters) {
    count
    edges {
      node {
        id
        amountDistributed {
          monies
        }
        amountAdjustments {
          monies
        }
        netAmount {
          monies
        }
        amountPayable {
          monies
        }
        amountReinvested {
          monies
        }
        manualSettlementDate
        payments {
          id
          isVoided
          amount {
            monies
          }
          status
        }
        batch {
          id
          status
        }
        details {
          edges {
            node {
              ...DistributionDetailFragment
            }
          }
        }
        position {
          id
          entityCurrency
          amountCommitted {
            monies
          }
          account {
            id
            name
          }
          transactionTotalsSummary {
            lifetimeAmountDistributed {
              monies
            }
          }
          paymentPref {
            id
            paymentMethod
            verificationStatus
          }
        }
        hideManualSettlementOption
        paymentNotes
      }
    }
  }
}
    ${DistributionDetailFragmentFragmentDoc}`;

/**
 * __useGetDistributionsForGridQuery__
 *
 * To run a query within a React component, call `useGetDistributionsForGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionsForGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionsForGridQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDistributionsForGridQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables> & ({ variables: GraphqlTypes.GetDistributionsForGridQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>(GetDistributionsForGridDocument, options);
      }
export function useGetDistributionsForGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>(GetDistributionsForGridDocument, options);
        }
// @ts-ignore
export function useGetDistributionsForGridSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>;
export function useGetDistributionsForGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionsForGridQuery | undefined, GraphqlTypes.GetDistributionsForGridQueryVariables>;
export function useGetDistributionsForGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>(GetDistributionsForGridDocument, options);
        }
export type GetDistributionsForGridQueryHookResult = ReturnType<typeof useGetDistributionsForGridQuery>;
export type GetDistributionsForGridLazyQueryHookResult = ReturnType<typeof useGetDistributionsForGridLazyQuery>;
export type GetDistributionsForGridSuspenseQueryHookResult = ReturnType<typeof useGetDistributionsForGridSuspenseQuery>;
export type GetDistributionsForGridQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionsForGridQuery, GraphqlTypes.GetDistributionsForGridQueryVariables>;
export const ConfigureDocumentReviewersForEntityDocument = gql`
    mutation ConfigureDocumentReviewersForEntity($approvalMode: DocumentApprovalMode!, $reviewers: [String], $publishers: [String], $objectIds: [String]) {
  configureDocumentReviewers(
    input: {approvalMode: $approvalMode, settingType: ENTITY, objectIds: $objectIds, reviewers: $reviewers, publishers: $publishers}
  ) {
    ... on ConfigureDocumentReviewersResponse {
      settings {
        id
        type
        approvalMode
        objectId
        members {
          memberUserId
          role
          memberUser {
            id
            fullName
            emailAddress
          }
        }
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ConfigureDocumentReviewersForEntityMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigureDocumentReviewersForEntityMutation, GraphqlTypes.ConfigureDocumentReviewersForEntityMutationVariables>;

/**
 * __useConfigureDocumentReviewersForEntityMutation__
 *
 * To run a mutation, you first call `useConfigureDocumentReviewersForEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureDocumentReviewersForEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureDocumentReviewersForEntityMutation, { data, loading, error }] = useConfigureDocumentReviewersForEntityMutation({
 *   variables: {
 *      approvalMode: // value for 'approvalMode'
 *      reviewers: // value for 'reviewers'
 *      publishers: // value for 'publishers'
 *      objectIds: // value for 'objectIds'
 *   },
 * });
 */
export function useConfigureDocumentReviewersForEntityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigureDocumentReviewersForEntityMutation, GraphqlTypes.ConfigureDocumentReviewersForEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigureDocumentReviewersForEntityMutation, GraphqlTypes.ConfigureDocumentReviewersForEntityMutationVariables>(ConfigureDocumentReviewersForEntityDocument, options);
      }
export type ConfigureDocumentReviewersForEntityMutationHookResult = ReturnType<typeof useConfigureDocumentReviewersForEntityMutation>;
export type ConfigureDocumentReviewersForEntityMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigureDocumentReviewersForEntityMutation>;
export type ConfigureDocumentReviewersForEntityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigureDocumentReviewersForEntityMutation, GraphqlTypes.ConfigureDocumentReviewersForEntityMutationVariables>;
export const ConfigureDocumentReviewersForAccountDocument = gql`
    mutation ConfigureDocumentReviewersForAccount($approvalMode: DocumentApprovalMode!, $reviewers: [String], $publishers: [String]) {
  configureDocumentReviewers(
    input: {approvalMode: $approvalMode, settingType: ACCOUNT, reviewers: $reviewers, publishers: $publishers}
  ) {
    ... on ConfigureDocumentReviewersResponse {
      settings {
        id
        type
        approvalMode
        objectId
        members {
          memberUserId
          role
          memberUser {
            id
            fullName
            emailAddress
          }
        }
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ConfigureDocumentReviewersForAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigureDocumentReviewersForAccountMutation, GraphqlTypes.ConfigureDocumentReviewersForAccountMutationVariables>;

/**
 * __useConfigureDocumentReviewersForAccountMutation__
 *
 * To run a mutation, you first call `useConfigureDocumentReviewersForAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureDocumentReviewersForAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureDocumentReviewersForAccountMutation, { data, loading, error }] = useConfigureDocumentReviewersForAccountMutation({
 *   variables: {
 *      approvalMode: // value for 'approvalMode'
 *      reviewers: // value for 'reviewers'
 *      publishers: // value for 'publishers'
 *   },
 * });
 */
export function useConfigureDocumentReviewersForAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigureDocumentReviewersForAccountMutation, GraphqlTypes.ConfigureDocumentReviewersForAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigureDocumentReviewersForAccountMutation, GraphqlTypes.ConfigureDocumentReviewersForAccountMutationVariables>(ConfigureDocumentReviewersForAccountDocument, options);
      }
export type ConfigureDocumentReviewersForAccountMutationHookResult = ReturnType<typeof useConfigureDocumentReviewersForAccountMutation>;
export type ConfigureDocumentReviewersForAccountMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigureDocumentReviewersForAccountMutation>;
export type ConfigureDocumentReviewersForAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigureDocumentReviewersForAccountMutation, GraphqlTypes.ConfigureDocumentReviewersForAccountMutationVariables>;
export const ConfigureDocumentReviewersEntityAsyncDocument = gql`
    mutation ConfigureDocumentReviewersEntityAsync($approvalMode: DocumentApprovalMode!, $objectIds: [String!]!, $reviewers: [String!], $publishers: [String!]) {
  configureDocumentReviewersAsync(
    input: {approvalMode: $approvalMode, settingType: ENTITY, objectIds: $objectIds, reviewers: $reviewers, publishers: $publishers}
  ) {
    ... on AsyncJobObjectType {
      id
      status
      jobType
      progress {
        processedCount
        totalCount
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ConfigureDocumentReviewersEntityAsyncMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutation, GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutationVariables>;

/**
 * __useConfigureDocumentReviewersEntityAsyncMutation__
 *
 * To run a mutation, you first call `useConfigureDocumentReviewersEntityAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureDocumentReviewersEntityAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureDocumentReviewersEntityAsyncMutation, { data, loading, error }] = useConfigureDocumentReviewersEntityAsyncMutation({
 *   variables: {
 *      approvalMode: // value for 'approvalMode'
 *      objectIds: // value for 'objectIds'
 *      reviewers: // value for 'reviewers'
 *      publishers: // value for 'publishers'
 *   },
 * });
 */
export function useConfigureDocumentReviewersEntityAsyncMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutation, GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutation, GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutationVariables>(ConfigureDocumentReviewersEntityAsyncDocument, options);
      }
export type ConfigureDocumentReviewersEntityAsyncMutationHookResult = ReturnType<typeof useConfigureDocumentReviewersEntityAsyncMutation>;
export type ConfigureDocumentReviewersEntityAsyncMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutation>;
export type ConfigureDocumentReviewersEntityAsyncMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutation, GraphqlTypes.ConfigureDocumentReviewersEntityAsyncMutationVariables>;
export const RevertDocumentReviewersOverrideDocument = gql`
    mutation RevertDocumentReviewersOverride($entityId: String!) {
  revertDocumentReviewersOverride(input: {entityId: $entityId}) {
    __typename
    ... on DocumentReviewerSettingsObjectType {
      id
      type
      approvalMode
      objectId
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type RevertDocumentReviewersOverrideMutationFn = Apollo.MutationFunction<GraphqlTypes.RevertDocumentReviewersOverrideMutation, GraphqlTypes.RevertDocumentReviewersOverrideMutationVariables>;

/**
 * __useRevertDocumentReviewersOverrideMutation__
 *
 * To run a mutation, you first call `useRevertDocumentReviewersOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertDocumentReviewersOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertDocumentReviewersOverrideMutation, { data, loading, error }] = useRevertDocumentReviewersOverrideMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useRevertDocumentReviewersOverrideMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RevertDocumentReviewersOverrideMutation, GraphqlTypes.RevertDocumentReviewersOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RevertDocumentReviewersOverrideMutation, GraphqlTypes.RevertDocumentReviewersOverrideMutationVariables>(RevertDocumentReviewersOverrideDocument, options);
      }
export type RevertDocumentReviewersOverrideMutationHookResult = ReturnType<typeof useRevertDocumentReviewersOverrideMutation>;
export type RevertDocumentReviewersOverrideMutationResult = Apollo.MutationResult<GraphqlTypes.RevertDocumentReviewersOverrideMutation>;
export type RevertDocumentReviewersOverrideMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RevertDocumentReviewersOverrideMutation, GraphqlTypes.RevertDocumentReviewersOverrideMutationVariables>;
export const GlobalDocumentReviewerSettingsDocument = gql`
    query GlobalDocumentReviewerSettings {
  entitySettings: documentReviewerSettings(settingType: ENTITY) {
    __typename
    ... on DocumentReviewerSettingsObjectType {
      id
      approvalMode
      type
      objectId
      members {
        role
        memberUser {
          id
          fullName
        }
      }
    }
    ... on GraphQLErrorObject {
      errorCode
      message
    }
  }
  accountSettings: documentReviewerSettings(settingType: ACCOUNT) {
    __typename
    ... on DocumentReviewerSettingsObjectType {
      id
      approvalMode
      type
      objectId
      members {
        role
        memberUser {
          id
          fullName
        }
      }
    }
    ... on GraphQLErrorObject {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGlobalDocumentReviewerSettingsQuery__
 *
 * To run a query within a React component, call `useGlobalDocumentReviewerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalDocumentReviewerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalDocumentReviewerSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalDocumentReviewerSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>(GlobalDocumentReviewerSettingsDocument, options);
      }
export function useGlobalDocumentReviewerSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>(GlobalDocumentReviewerSettingsDocument, options);
        }
// @ts-ignore
export function useGlobalDocumentReviewerSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>;
export function useGlobalDocumentReviewerSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GlobalDocumentReviewerSettingsQuery | undefined, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>;
export function useGlobalDocumentReviewerSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>(GlobalDocumentReviewerSettingsDocument, options);
        }
export type GlobalDocumentReviewerSettingsQueryHookResult = ReturnType<typeof useGlobalDocumentReviewerSettingsQuery>;
export type GlobalDocumentReviewerSettingsLazyQueryHookResult = ReturnType<typeof useGlobalDocumentReviewerSettingsLazyQuery>;
export type GlobalDocumentReviewerSettingsSuspenseQueryHookResult = ReturnType<typeof useGlobalDocumentReviewerSettingsSuspenseQuery>;
export type GlobalDocumentReviewerSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GlobalDocumentReviewerSettingsQuery, GraphqlTypes.GlobalDocumentReviewerSettingsQueryVariables>;
export const GetDocumentReviewerEligibleUsersForEntityDocument = gql`
    query GetDocumentReviewerEligibleUsersForEntity($searchTerm: String, $objectIds: [String]) {
  entityEligibleUsers: documentReviewerEligibleUsers(
    settingType: ENTITY
    searchTerm: $searchTerm
    objectIds: $objectIds
  ) {
    id
    fullName
    emailAddress
  }
}
    `;

/**
 * __useGetDocumentReviewerEligibleUsersForEntityQuery__
 *
 * To run a query within a React component, call `useGetDocumentReviewerEligibleUsersForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentReviewerEligibleUsersForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentReviewerEligibleUsersForEntityQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      objectIds: // value for 'objectIds'
 *   },
 * });
 */
export function useGetDocumentReviewerEligibleUsersForEntityQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>(GetDocumentReviewerEligibleUsersForEntityDocument, options);
      }
export function useGetDocumentReviewerEligibleUsersForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>(GetDocumentReviewerEligibleUsersForEntityDocument, options);
        }
// @ts-ignore
export function useGetDocumentReviewerEligibleUsersForEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>;
export function useGetDocumentReviewerEligibleUsersForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery | undefined, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>;
export function useGetDocumentReviewerEligibleUsersForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>(GetDocumentReviewerEligibleUsersForEntityDocument, options);
        }
export type GetDocumentReviewerEligibleUsersForEntityQueryHookResult = ReturnType<typeof useGetDocumentReviewerEligibleUsersForEntityQuery>;
export type GetDocumentReviewerEligibleUsersForEntityLazyQueryHookResult = ReturnType<typeof useGetDocumentReviewerEligibleUsersForEntityLazyQuery>;
export type GetDocumentReviewerEligibleUsersForEntitySuspenseQueryHookResult = ReturnType<typeof useGetDocumentReviewerEligibleUsersForEntitySuspenseQuery>;
export type GetDocumentReviewerEligibleUsersForEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForEntityQueryVariables>;
export const GetDocumentReviewerEligibleUsersForAccountDocument = gql`
    query GetDocumentReviewerEligibleUsersForAccount($searchTerm: String) {
  accountEligibleUsers: documentReviewerEligibleUsers(
    settingType: ACCOUNT
    searchTerm: $searchTerm
  ) {
    id
    fullName
    emailAddress
  }
}
    `;

/**
 * __useGetDocumentReviewerEligibleUsersForAccountQuery__
 *
 * To run a query within a React component, call `useGetDocumentReviewerEligibleUsersForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentReviewerEligibleUsersForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentReviewerEligibleUsersForAccountQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetDocumentReviewerEligibleUsersForAccountQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>(GetDocumentReviewerEligibleUsersForAccountDocument, options);
      }
export function useGetDocumentReviewerEligibleUsersForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>(GetDocumentReviewerEligibleUsersForAccountDocument, options);
        }
// @ts-ignore
export function useGetDocumentReviewerEligibleUsersForAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>;
export function useGetDocumentReviewerEligibleUsersForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery | undefined, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>;
export function useGetDocumentReviewerEligibleUsersForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>(GetDocumentReviewerEligibleUsersForAccountDocument, options);
        }
export type GetDocumentReviewerEligibleUsersForAccountQueryHookResult = ReturnType<typeof useGetDocumentReviewerEligibleUsersForAccountQuery>;
export type GetDocumentReviewerEligibleUsersForAccountLazyQueryHookResult = ReturnType<typeof useGetDocumentReviewerEligibleUsersForAccountLazyQuery>;
export type GetDocumentReviewerEligibleUsersForAccountSuspenseQueryHookResult = ReturnType<typeof useGetDocumentReviewerEligibleUsersForAccountSuspenseQuery>;
export type GetDocumentReviewerEligibleUsersForAccountQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQuery, GraphqlTypes.GetDocumentReviewerEligibleUsersForAccountQueryVariables>;
export const GetEntityDocumentReviewerSettingsDocument = gql`
    query GetEntityDocumentReviewerSettings($entityId: String!) {
  entitySettings: documentReviewerSettings(
    settingType: ENTITY
    objectId: $entityId
  ) {
    __typename
    ... on DocumentReviewerSettingsObjectType {
      id
      approvalMode
      type
      objectId
      members {
        role
        memberUser {
          id
          fullName
          emailAddress
        }
      }
    }
    ... on GraphQLErrorObject {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetEntityDocumentReviewerSettingsQuery__
 *
 * To run a query within a React component, call `useGetEntityDocumentReviewerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityDocumentReviewerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityDocumentReviewerSettingsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityDocumentReviewerSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables> & ({ variables: GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>(GetEntityDocumentReviewerSettingsDocument, options);
      }
export function useGetEntityDocumentReviewerSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>(GetEntityDocumentReviewerSettingsDocument, options);
        }
// @ts-ignore
export function useGetEntityDocumentReviewerSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>;
export function useGetEntityDocumentReviewerSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery | undefined, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>;
export function useGetEntityDocumentReviewerSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>(GetEntityDocumentReviewerSettingsDocument, options);
        }
export type GetEntityDocumentReviewerSettingsQueryHookResult = ReturnType<typeof useGetEntityDocumentReviewerSettingsQuery>;
export type GetEntityDocumentReviewerSettingsLazyQueryHookResult = ReturnType<typeof useGetEntityDocumentReviewerSettingsLazyQuery>;
export type GetEntityDocumentReviewerSettingsSuspenseQueryHookResult = ReturnType<typeof useGetEntityDocumentReviewerSettingsSuspenseQuery>;
export type GetEntityDocumentReviewerSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityDocumentReviewerSettingsQuery, GraphqlTypes.GetEntityDocumentReviewerSettingsQueryVariables>;
export const UpsertEditorTemplateDocument = gql`
    mutation UpsertEditorTemplate($editorTemplateInput: UpsertEditorTemplateInput!) {
  upsertEditorTemplate(editorTemplateInput: $editorTemplateInput) {
    ... on EditorTemplateObjectType {
      id
      name
      htmlBody
      objectType
      templateMetadata
      templateType
      savedToAllObjects
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UpsertEditorTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertEditorTemplateMutation, GraphqlTypes.UpsertEditorTemplateMutationVariables>;

/**
 * __useUpsertEditorTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertEditorTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEditorTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEditorTemplateMutation, { data, loading, error }] = useUpsertEditorTemplateMutation({
 *   variables: {
 *      editorTemplateInput: // value for 'editorTemplateInput'
 *   },
 * });
 */
export function useUpsertEditorTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertEditorTemplateMutation, GraphqlTypes.UpsertEditorTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertEditorTemplateMutation, GraphqlTypes.UpsertEditorTemplateMutationVariables>(UpsertEditorTemplateDocument, options);
      }
export type UpsertEditorTemplateMutationHookResult = ReturnType<typeof useUpsertEditorTemplateMutation>;
export type UpsertEditorTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertEditorTemplateMutation>;
export type UpsertEditorTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertEditorTemplateMutation, GraphqlTypes.UpsertEditorTemplateMutationVariables>;
export const GenerateEmailAiContentDocument = gql`
    mutation GenerateEmailAIContent($input: GenerateEmailAIContentInput!) {
  generateEmailAiContent(input: $input) {
    ... on GenerateEmailAIContentResult {
      result
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type GenerateEmailAiContentMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateEmailAiContentMutation, GraphqlTypes.GenerateEmailAiContentMutationVariables>;

/**
 * __useGenerateEmailAiContentMutation__
 *
 * To run a mutation, you first call `useGenerateEmailAiContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEmailAiContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEmailAiContentMutation, { data, loading, error }] = useGenerateEmailAiContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEmailAiContentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateEmailAiContentMutation, GraphqlTypes.GenerateEmailAiContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateEmailAiContentMutation, GraphqlTypes.GenerateEmailAiContentMutationVariables>(GenerateEmailAiContentDocument, options);
      }
export type GenerateEmailAiContentMutationHookResult = ReturnType<typeof useGenerateEmailAiContentMutation>;
export type GenerateEmailAiContentMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateEmailAiContentMutation>;
export type GenerateEmailAiContentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateEmailAiContentMutation, GraphqlTypes.GenerateEmailAiContentMutationVariables>;
export const StartEmailBatchVerificationDocument = gql`
    mutation StartEmailBatchVerification($objectInput: EmailBatchRecipientsVerificationInput!) {
  emailBatchRecipientsVerificationTask(objectInput: $objectInput) {
    ... on AsyncJobObjectType {
      id
      data
      progress {
        processedCount
        totalCount
      }
      redisData
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type StartEmailBatchVerificationMutationFn = Apollo.MutationFunction<GraphqlTypes.StartEmailBatchVerificationMutation, GraphqlTypes.StartEmailBatchVerificationMutationVariables>;

/**
 * __useStartEmailBatchVerificationMutation__
 *
 * To run a mutation, you first call `useStartEmailBatchVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEmailBatchVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEmailBatchVerificationMutation, { data, loading, error }] = useStartEmailBatchVerificationMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useStartEmailBatchVerificationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartEmailBatchVerificationMutation, GraphqlTypes.StartEmailBatchVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartEmailBatchVerificationMutation, GraphqlTypes.StartEmailBatchVerificationMutationVariables>(StartEmailBatchVerificationDocument, options);
      }
export type StartEmailBatchVerificationMutationHookResult = ReturnType<typeof useStartEmailBatchVerificationMutation>;
export type StartEmailBatchVerificationMutationResult = Apollo.MutationResult<GraphqlTypes.StartEmailBatchVerificationMutation>;
export type StartEmailBatchVerificationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartEmailBatchVerificationMutation, GraphqlTypes.StartEmailBatchVerificationMutationVariables>;
export const SendEmailBatchDocument = gql`
    mutation SendEmailBatch($objectInput: EmailBatchSendInput!) {
  sendEmailBatch(objectInput: $objectInput) {
    ... on AsyncJobObjectType {
      id
      jobType
      data
      progress {
        processedCount
        totalCount
      }
      status
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type SendEmailBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.SendEmailBatchMutation, GraphqlTypes.SendEmailBatchMutationVariables>;

/**
 * __useSendEmailBatchMutation__
 *
 * To run a mutation, you first call `useSendEmailBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailBatchMutation, { data, loading, error }] = useSendEmailBatchMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSendEmailBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SendEmailBatchMutation, GraphqlTypes.SendEmailBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SendEmailBatchMutation, GraphqlTypes.SendEmailBatchMutationVariables>(SendEmailBatchDocument, options);
      }
export type SendEmailBatchMutationHookResult = ReturnType<typeof useSendEmailBatchMutation>;
export type SendEmailBatchMutationResult = Apollo.MutationResult<GraphqlTypes.SendEmailBatchMutation>;
export type SendEmailBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SendEmailBatchMutation, GraphqlTypes.SendEmailBatchMutationVariables>;
export const NotifyDocumentPublishersDocument = gql`
    mutation NotifyDocumentPublishers($objectInput: NotifyDocumentPublishersInput!) {
  notifyDocumentPublishers(objectInput: $objectInput) {
    ... on NotifyDocumentPublishersSuccessResponse {
      redirectUrl
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type NotifyDocumentPublishersMutationFn = Apollo.MutationFunction<GraphqlTypes.NotifyDocumentPublishersMutation, GraphqlTypes.NotifyDocumentPublishersMutationVariables>;

/**
 * __useNotifyDocumentPublishersMutation__
 *
 * To run a mutation, you first call `useNotifyDocumentPublishersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyDocumentPublishersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyDocumentPublishersMutation, { data, loading, error }] = useNotifyDocumentPublishersMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useNotifyDocumentPublishersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.NotifyDocumentPublishersMutation, GraphqlTypes.NotifyDocumentPublishersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.NotifyDocumentPublishersMutation, GraphqlTypes.NotifyDocumentPublishersMutationVariables>(NotifyDocumentPublishersDocument, options);
      }
export type NotifyDocumentPublishersMutationHookResult = ReturnType<typeof useNotifyDocumentPublishersMutation>;
export type NotifyDocumentPublishersMutationResult = Apollo.MutationResult<GraphqlTypes.NotifyDocumentPublishersMutation>;
export type NotifyDocumentPublishersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.NotifyDocumentPublishersMutation, GraphqlTypes.NotifyDocumentPublishersMutationVariables>;
export const GetEmailPreviewDocument = gql`
    query getEmailPreview($emailBatchId: ID!, $recipientObjectType: JSQObjectType!, $recipientObjectId: Int!) {
  emailPreview(
    emailBatchId: $emailBatchId
    recipientObjectType: $recipientObjectType
    recipientObjectId: $recipientObjectId
  ) {
    recipientTitle
    fromAddress {
      name
      emailAddress
      error
    }
    toAddresses {
      name
      emailAddress
      error
    }
    ccAddresses {
      name
      emailAddress
      error
    }
    bccAddresses {
      name
      emailAddress
      error
    }
    subject
    bodyHtml
    signatureHtml
    errors
    attachedDocuments {
      ...EmailAttachmentDocumentFields
    }
    missingAttachments {
      ...EmailAttachmentDocumentFields
    }
    excludedAttachments {
      ...EmailAttachmentDocumentFields
    }
    groupedAttachments {
      sourceLabel
      sourceObjectType
      sourceObjectId
      attachments {
        ...EmailAttachmentDocumentFields
      }
    }
    groupedAttachmentsV2 {
      sourceLabelParts {
        accounts
        entity
      }
      sourceObjectIds
      sourceObjectType
      attachments {
        ...EmailAttachmentDocumentFields
      }
    }
  }
}
    ${EmailAttachmentDocumentFieldsFragmentDoc}`;

/**
 * __useGetEmailPreviewQuery__
 *
 * To run a query within a React component, call `useGetEmailPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailPreviewQuery({
 *   variables: {
 *      emailBatchId: // value for 'emailBatchId'
 *      recipientObjectType: // value for 'recipientObjectType'
 *      recipientObjectId: // value for 'recipientObjectId'
 *   },
 * });
 */
export function useGetEmailPreviewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables> & ({ variables: GraphqlTypes.GetEmailPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>(GetEmailPreviewDocument, options);
      }
export function useGetEmailPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>(GetEmailPreviewDocument, options);
        }
// @ts-ignore
export function useGetEmailPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>;
export function useGetEmailPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailPreviewQuery | undefined, GraphqlTypes.GetEmailPreviewQueryVariables>;
export function useGetEmailPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>(GetEmailPreviewDocument, options);
        }
export type GetEmailPreviewQueryHookResult = ReturnType<typeof useGetEmailPreviewQuery>;
export type GetEmailPreviewLazyQueryHookResult = ReturnType<typeof useGetEmailPreviewLazyQuery>;
export type GetEmailPreviewSuspenseQueryHookResult = ReturnType<typeof useGetEmailPreviewSuspenseQuery>;
export type GetEmailPreviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailPreviewQuery, GraphqlTypes.GetEmailPreviewQueryVariables>;
export const GetScheduleEmailDevFeatureFlagsDocument = gql`
    query getScheduleEmailDevFeatureFlags {
  devFeatures {
    enableScheduledEmails
  }
}
    `;

/**
 * __useGetScheduleEmailDevFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetScheduleEmailDevFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleEmailDevFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleEmailDevFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScheduleEmailDevFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>(GetScheduleEmailDevFeatureFlagsDocument, options);
      }
export function useGetScheduleEmailDevFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>(GetScheduleEmailDevFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetScheduleEmailDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>;
export function useGetScheduleEmailDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery | undefined, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>;
export function useGetScheduleEmailDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>(GetScheduleEmailDevFeatureFlagsDocument, options);
        }
export type GetScheduleEmailDevFeatureFlagsQueryHookResult = ReturnType<typeof useGetScheduleEmailDevFeatureFlagsQuery>;
export type GetScheduleEmailDevFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetScheduleEmailDevFeatureFlagsLazyQuery>;
export type GetScheduleEmailDevFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetScheduleEmailDevFeatureFlagsSuspenseQuery>;
export type GetScheduleEmailDevFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetScheduleEmailDevFeatureFlagsQuery, GraphqlTypes.GetScheduleEmailDevFeatureFlagsQueryVariables>;
export const UpdateEmailPreferencesDocument = gql`
    mutation UpdateEmailPreferences($objectInput: UpdateEmailPreferencesInput!) {
  updateEmailPreferences(objectInput: $objectInput) {
    ... on EmailPreferencesObjectType {
      __typename
      requireConfirmationBeforeEmailSend
      defaultEmailGranularityAccounts
      defaultEmailGranularityPositions
      defaultEmailSender
    }
    ... on MutationErrorResponse {
      __typename
      message
      errorCode
    }
  }
}
    `;
export type UpdateEmailPreferencesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEmailPreferencesMutation, GraphqlTypes.UpdateEmailPreferencesMutationVariables>;

/**
 * __useUpdateEmailPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateEmailPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailPreferencesMutation, { data, loading, error }] = useUpdateEmailPreferencesMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdateEmailPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEmailPreferencesMutation, GraphqlTypes.UpdateEmailPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEmailPreferencesMutation, GraphqlTypes.UpdateEmailPreferencesMutationVariables>(UpdateEmailPreferencesDocument, options);
      }
export type UpdateEmailPreferencesMutationHookResult = ReturnType<typeof useUpdateEmailPreferencesMutation>;
export type UpdateEmailPreferencesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEmailPreferencesMutation>;
export type UpdateEmailPreferencesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEmailPreferencesMutation, GraphqlTypes.UpdateEmailPreferencesMutationVariables>;
export const EnableInvestranEntitySyncDocument = gql`
    mutation EnableInvestranEntitySync($input: EnableInvestranEntityInput!) {
  enableInvestranEntity(input: $input) {
    ... on EnableEntityResponse {
      success
    }
  }
}
    `;
export type EnableInvestranEntitySyncMutationFn = Apollo.MutationFunction<GraphqlTypes.EnableInvestranEntitySyncMutation, GraphqlTypes.EnableInvestranEntitySyncMutationVariables>;

/**
 * __useEnableInvestranEntitySyncMutation__
 *
 * To run a mutation, you first call `useEnableInvestranEntitySyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableInvestranEntitySyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableInvestranEntitySyncMutation, { data, loading, error }] = useEnableInvestranEntitySyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableInvestranEntitySyncMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EnableInvestranEntitySyncMutation, GraphqlTypes.EnableInvestranEntitySyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EnableInvestranEntitySyncMutation, GraphqlTypes.EnableInvestranEntitySyncMutationVariables>(EnableInvestranEntitySyncDocument, options);
      }
export type EnableInvestranEntitySyncMutationHookResult = ReturnType<typeof useEnableInvestranEntitySyncMutation>;
export type EnableInvestranEntitySyncMutationResult = Apollo.MutationResult<GraphqlTypes.EnableInvestranEntitySyncMutation>;
export type EnableInvestranEntitySyncMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EnableInvestranEntitySyncMutation, GraphqlTypes.EnableInvestranEntitySyncMutationVariables>;
export const DisableInvestranEntitySyncDocument = gql`
    mutation DisableInvestranEntitySync($input: DisableInvestranEntityInput!) {
  disableInvestranEntity(input: $input) {
    ... on DisableEntityResponse {
      success
    }
  }
}
    `;
export type DisableInvestranEntitySyncMutationFn = Apollo.MutationFunction<GraphqlTypes.DisableInvestranEntitySyncMutation, GraphqlTypes.DisableInvestranEntitySyncMutationVariables>;

/**
 * __useDisableInvestranEntitySyncMutation__
 *
 * To run a mutation, you first call `useDisableInvestranEntitySyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableInvestranEntitySyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableInvestranEntitySyncMutation, { data, loading, error }] = useDisableInvestranEntitySyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableInvestranEntitySyncMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DisableInvestranEntitySyncMutation, GraphqlTypes.DisableInvestranEntitySyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DisableInvestranEntitySyncMutation, GraphqlTypes.DisableInvestranEntitySyncMutationVariables>(DisableInvestranEntitySyncDocument, options);
      }
export type DisableInvestranEntitySyncMutationHookResult = ReturnType<typeof useDisableInvestranEntitySyncMutation>;
export type DisableInvestranEntitySyncMutationResult = Apollo.MutationResult<GraphqlTypes.DisableInvestranEntitySyncMutation>;
export type DisableInvestranEntitySyncMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DisableInvestranEntitySyncMutation, GraphqlTypes.DisableInvestranEntitySyncMutationVariables>;
export const GetInvestranEntitySyncStatusDocument = gql`
    query GetInvestranEntitySyncStatus($input: InvestranEntityEnabledInput!) {
  investranEntityEnabled(input: $input) {
    enabled
  }
}
    `;

/**
 * __useGetInvestranEntitySyncStatusQuery__
 *
 * To run a query within a React component, call `useGetInvestranEntitySyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestranEntitySyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestranEntitySyncStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInvestranEntitySyncStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables> & ({ variables: GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>(GetInvestranEntitySyncStatusDocument, options);
      }
export function useGetInvestranEntitySyncStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>(GetInvestranEntitySyncStatusDocument, options);
        }
// @ts-ignore
export function useGetInvestranEntitySyncStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>;
export function useGetInvestranEntitySyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestranEntitySyncStatusQuery | undefined, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>;
export function useGetInvestranEntitySyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>(GetInvestranEntitySyncStatusDocument, options);
        }
export type GetInvestranEntitySyncStatusQueryHookResult = ReturnType<typeof useGetInvestranEntitySyncStatusQuery>;
export type GetInvestranEntitySyncStatusLazyQueryHookResult = ReturnType<typeof useGetInvestranEntitySyncStatusLazyQuery>;
export type GetInvestranEntitySyncStatusSuspenseQueryHookResult = ReturnType<typeof useGetInvestranEntitySyncStatusSuspenseQuery>;
export type GetInvestranEntitySyncStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestranEntitySyncStatusQuery, GraphqlTypes.GetInvestranEntitySyncStatusQueryVariables>;
export const SearchObjectsDocument = gql`
    query SearchObjects($term: String!, $objectType: JSQObjectType, $objectFilter: SearchObjectFilterInputEnum, $limit: Int) {
  searchObjects(
    term: $term
    objectType: $objectType
    objectFilter: $objectFilter
    limit: $limit
  ) {
    results {
      id
      objectType
      subType
      label
      url
      companyName
      exactMatch
    }
    moreAvailable
  }
}
    `;

/**
 * __useSearchObjectsQuery__
 *
 * To run a query within a React component, call `useSearchObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchObjectsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      objectType: // value for 'objectType'
 *      objectFilter: // value for 'objectFilter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchObjectsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables> & ({ variables: GraphqlTypes.SearchObjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>(SearchObjectsDocument, options);
      }
export function useSearchObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>(SearchObjectsDocument, options);
        }
// @ts-ignore
export function useSearchObjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>;
export function useSearchObjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchObjectsQuery | undefined, GraphqlTypes.SearchObjectsQueryVariables>;
export function useSearchObjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>(SearchObjectsDocument, options);
        }
export type SearchObjectsQueryHookResult = ReturnType<typeof useSearchObjectsQuery>;
export type SearchObjectsLazyQueryHookResult = ReturnType<typeof useSearchObjectsLazyQuery>;
export type SearchObjectsSuspenseQueryHookResult = ReturnType<typeof useSearchObjectsSuspenseQuery>;
export type SearchObjectsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchObjectsQuery, GraphqlTypes.SearchObjectsQueryVariables>;
export const CheckContactDuplicatesDocument = gql`
    query CheckContactDuplicates($input: CheckContactDuplicatesInput!) {
  checkContactDuplicates(input: $input) {
    topMatches {
      id
      fullName
    }
    totalMatchesCount
  }
}
    `;

/**
 * __useCheckContactDuplicatesQuery__
 *
 * To run a query within a React component, call `useCheckContactDuplicatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckContactDuplicatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckContactDuplicatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckContactDuplicatesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables> & ({ variables: GraphqlTypes.CheckContactDuplicatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>(CheckContactDuplicatesDocument, options);
      }
export function useCheckContactDuplicatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>(CheckContactDuplicatesDocument, options);
        }
// @ts-ignore
export function useCheckContactDuplicatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>;
export function useCheckContactDuplicatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CheckContactDuplicatesQuery | undefined, GraphqlTypes.CheckContactDuplicatesQueryVariables>;
export function useCheckContactDuplicatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>(CheckContactDuplicatesDocument, options);
        }
export type CheckContactDuplicatesQueryHookResult = ReturnType<typeof useCheckContactDuplicatesQuery>;
export type CheckContactDuplicatesLazyQueryHookResult = ReturnType<typeof useCheckContactDuplicatesLazyQuery>;
export type CheckContactDuplicatesSuspenseQueryHookResult = ReturnType<typeof useCheckContactDuplicatesSuspenseQuery>;
export type CheckContactDuplicatesQueryResult = Apollo.QueryResult<GraphqlTypes.CheckContactDuplicatesQuery, GraphqlTypes.CheckContactDuplicatesQueryVariables>;
export const CreateContactV2Document = gql`
    mutation CreateContactV2($contact: CreateContactV2Input!) {
  createContactV2(contact: $contact) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on ContactObjectType {
      id
      fullName
    }
  }
}
    `;
export type CreateContactV2MutationFn = Apollo.MutationFunction<GraphqlTypes.CreateContactV2Mutation, GraphqlTypes.CreateContactV2MutationVariables>;

/**
 * __useCreateContactV2Mutation__
 *
 * To run a mutation, you first call `useCreateContactV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactV2Mutation, { data, loading, error }] = useCreateContactV2Mutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useCreateContactV2Mutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateContactV2Mutation, GraphqlTypes.CreateContactV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateContactV2Mutation, GraphqlTypes.CreateContactV2MutationVariables>(CreateContactV2Document, options);
      }
export type CreateContactV2MutationHookResult = ReturnType<typeof useCreateContactV2Mutation>;
export type CreateContactV2MutationResult = Apollo.MutationResult<GraphqlTypes.CreateContactV2Mutation>;
export type CreateContactV2MutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateContactV2Mutation, GraphqlTypes.CreateContactV2MutationVariables>;
export const GetContactValidationSchemaDocument = gql`
    query GetContactValidationSchema($objectType: JSQObjectType!, $subObjectType: FormFieldSubObjectTypeEnum!) {
  contactValidationSchema(objectType: $objectType, subObjectType: $subObjectType) {
    objectType
    subObjectType
    fields {
      fieldIdentifier
      fieldType
      fieldFormat
      isVisible
      validationRules {
        format
        isRequired
        isMultivalued
        options {
          value
          label
          sortOrder
        }
      }
    }
  }
}
    `;

/**
 * __useGetContactValidationSchemaQuery__
 *
 * To run a query within a React component, call `useGetContactValidationSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactValidationSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactValidationSchemaQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      subObjectType: // value for 'subObjectType'
 *   },
 * });
 */
export function useGetContactValidationSchemaQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables> & ({ variables: GraphqlTypes.GetContactValidationSchemaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>(GetContactValidationSchemaDocument, options);
      }
export function useGetContactValidationSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>(GetContactValidationSchemaDocument, options);
        }
// @ts-ignore
export function useGetContactValidationSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>;
export function useGetContactValidationSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactValidationSchemaQuery | undefined, GraphqlTypes.GetContactValidationSchemaQueryVariables>;
export function useGetContactValidationSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>(GetContactValidationSchemaDocument, options);
        }
export type GetContactValidationSchemaQueryHookResult = ReturnType<typeof useGetContactValidationSchemaQuery>;
export type GetContactValidationSchemaLazyQueryHookResult = ReturnType<typeof useGetContactValidationSchemaLazyQuery>;
export type GetContactValidationSchemaSuspenseQueryHookResult = ReturnType<typeof useGetContactValidationSchemaSuspenseQuery>;
export type GetContactValidationSchemaQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactValidationSchemaQuery, GraphqlTypes.GetContactValidationSchemaQueryVariables>;
export const SyncContactsToIntegrationTriggerDocument = gql`
    mutation SyncContactsToIntegrationTrigger($integrationEntityDetailsContactSyncInput: IntegrationEntityDetailsContactSyncInput!) {
  integrationEntityDetailsContactSyncTrigger(
    integrationEntityDetailsContactSyncInput: $integrationEntityDetailsContactSyncInput
  ) {
    ... on IntegrationEntityDetailsContactSyncObjectType {
      job {
        id
        jobType
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SyncContactsToIntegrationTriggerMutationFn = Apollo.MutationFunction<GraphqlTypes.SyncContactsToIntegrationTriggerMutation, GraphqlTypes.SyncContactsToIntegrationTriggerMutationVariables>;

/**
 * __useSyncContactsToIntegrationTriggerMutation__
 *
 * To run a mutation, you first call `useSyncContactsToIntegrationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncContactsToIntegrationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncContactsToIntegrationTriggerMutation, { data, loading, error }] = useSyncContactsToIntegrationTriggerMutation({
 *   variables: {
 *      integrationEntityDetailsContactSyncInput: // value for 'integrationEntityDetailsContactSyncInput'
 *   },
 * });
 */
export function useSyncContactsToIntegrationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SyncContactsToIntegrationTriggerMutation, GraphqlTypes.SyncContactsToIntegrationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SyncContactsToIntegrationTriggerMutation, GraphqlTypes.SyncContactsToIntegrationTriggerMutationVariables>(SyncContactsToIntegrationTriggerDocument, options);
      }
export type SyncContactsToIntegrationTriggerMutationHookResult = ReturnType<typeof useSyncContactsToIntegrationTriggerMutation>;
export type SyncContactsToIntegrationTriggerMutationResult = Apollo.MutationResult<GraphqlTypes.SyncContactsToIntegrationTriggerMutation>;
export type SyncContactsToIntegrationTriggerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SyncContactsToIntegrationTriggerMutation, GraphqlTypes.SyncContactsToIntegrationTriggerMutationVariables>;
export const SyncContactToIntegrationTriggerDocument = gql`
    mutation SyncContactToIntegrationTrigger($singleIntegrationEntityDetailsContactSyncInput: SingleIntegrationEntityDetailsContactSyncInput!) {
  singleIntegrationEntityDetailsContactSyncTrigger(
    singleIntegrationEntityDetailsContactSyncInput: $singleIntegrationEntityDetailsContactSyncInput
  ) {
    ... on SingleIntegrationEntityDetailsContactSyncObjectType {
      syncStatus
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SyncContactToIntegrationTriggerMutationFn = Apollo.MutationFunction<GraphqlTypes.SyncContactToIntegrationTriggerMutation, GraphqlTypes.SyncContactToIntegrationTriggerMutationVariables>;

/**
 * __useSyncContactToIntegrationTriggerMutation__
 *
 * To run a mutation, you first call `useSyncContactToIntegrationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncContactToIntegrationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncContactToIntegrationTriggerMutation, { data, loading, error }] = useSyncContactToIntegrationTriggerMutation({
 *   variables: {
 *      singleIntegrationEntityDetailsContactSyncInput: // value for 'singleIntegrationEntityDetailsContactSyncInput'
 *   },
 * });
 */
export function useSyncContactToIntegrationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SyncContactToIntegrationTriggerMutation, GraphqlTypes.SyncContactToIntegrationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SyncContactToIntegrationTriggerMutation, GraphqlTypes.SyncContactToIntegrationTriggerMutationVariables>(SyncContactToIntegrationTriggerDocument, options);
      }
export type SyncContactToIntegrationTriggerMutationHookResult = ReturnType<typeof useSyncContactToIntegrationTriggerMutation>;
export type SyncContactToIntegrationTriggerMutationResult = Apollo.MutationResult<GraphqlTypes.SyncContactToIntegrationTriggerMutation>;
export type SyncContactToIntegrationTriggerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SyncContactToIntegrationTriggerMutation, GraphqlTypes.SyncContactToIntegrationTriggerMutationVariables>;
export const ContactsLastModifiedDocument = gql`
    query ContactsLastModified($contactIds: [ID]!) {
  contactsLastModified(contactIds: $contactIds) {
    id
    activityTime
  }
}
    `;

/**
 * __useContactsLastModifiedQuery__
 *
 * To run a query within a React component, call `useContactsLastModifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsLastModifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsLastModifiedQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useContactsLastModifiedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables> & ({ variables: GraphqlTypes.ContactsLastModifiedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>(ContactsLastModifiedDocument, options);
      }
export function useContactsLastModifiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>(ContactsLastModifiedDocument, options);
        }
// @ts-ignore
export function useContactsLastModifiedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>;
export function useContactsLastModifiedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsLastModifiedQuery | undefined, GraphqlTypes.ContactsLastModifiedQueryVariables>;
export function useContactsLastModifiedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>(ContactsLastModifiedDocument, options);
        }
export type ContactsLastModifiedQueryHookResult = ReturnType<typeof useContactsLastModifiedQuery>;
export type ContactsLastModifiedLazyQueryHookResult = ReturnType<typeof useContactsLastModifiedLazyQuery>;
export type ContactsLastModifiedSuspenseQueryHookResult = ReturnType<typeof useContactsLastModifiedSuspenseQuery>;
export type ContactsLastModifiedQueryResult = Apollo.QueryResult<GraphqlTypes.ContactsLastModifiedQuery, GraphqlTypes.ContactsLastModifiedQueryVariables>;
export const ContactsLastActivityDocument = gql`
    query ContactsLastActivity($contactIds: [ID]!) {
  contactsLastActivity(contactIds: $contactIds) {
    id
    activityTime
    activitySourceModel
    activitySourceSubtype
    activitySubject
  }
}
    `;

/**
 * __useContactsLastActivityQuery__
 *
 * To run a query within a React component, call `useContactsLastActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsLastActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsLastActivityQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useContactsLastActivityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables> & ({ variables: GraphqlTypes.ContactsLastActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>(ContactsLastActivityDocument, options);
      }
export function useContactsLastActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>(ContactsLastActivityDocument, options);
        }
// @ts-ignore
export function useContactsLastActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>;
export function useContactsLastActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsLastActivityQuery | undefined, GraphqlTypes.ContactsLastActivityQueryVariables>;
export function useContactsLastActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>(ContactsLastActivityDocument, options);
        }
export type ContactsLastActivityQueryHookResult = ReturnType<typeof useContactsLastActivityQuery>;
export type ContactsLastActivityLazyQueryHookResult = ReturnType<typeof useContactsLastActivityLazyQuery>;
export type ContactsLastActivitySuspenseQueryHookResult = ReturnType<typeof useContactsLastActivitySuspenseQuery>;
export type ContactsLastActivityQueryResult = Apollo.QueryResult<GraphqlTypes.ContactsLastActivityQuery, GraphqlTypes.ContactsLastActivityQueryVariables>;
export const ContactsLastSyncedEventDocument = gql`
    query ContactsLastSyncedEvent($contactIds: [ID]!) {
  contactsLastSyncedEvent(contactIds: $contactIds) {
    id
    activityTime
    activitySourceModel
    activitySourceSubtype
    activitySubject
  }
}
    `;

/**
 * __useContactsLastSyncedEventQuery__
 *
 * To run a query within a React component, call `useContactsLastSyncedEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsLastSyncedEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsLastSyncedEventQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useContactsLastSyncedEventQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables> & ({ variables: GraphqlTypes.ContactsLastSyncedEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>(ContactsLastSyncedEventDocument, options);
      }
export function useContactsLastSyncedEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>(ContactsLastSyncedEventDocument, options);
        }
// @ts-ignore
export function useContactsLastSyncedEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>;
export function useContactsLastSyncedEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsLastSyncedEventQuery | undefined, GraphqlTypes.ContactsLastSyncedEventQueryVariables>;
export function useContactsLastSyncedEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>(ContactsLastSyncedEventDocument, options);
        }
export type ContactsLastSyncedEventQueryHookResult = ReturnType<typeof useContactsLastSyncedEventQuery>;
export type ContactsLastSyncedEventLazyQueryHookResult = ReturnType<typeof useContactsLastSyncedEventLazyQuery>;
export type ContactsLastSyncedEventSuspenseQueryHookResult = ReturnType<typeof useContactsLastSyncedEventSuspenseQuery>;
export type ContactsLastSyncedEventQueryResult = Apollo.QueryResult<GraphqlTypes.ContactsLastSyncedEventQuery, GraphqlTypes.ContactsLastSyncedEventQueryVariables>;
export const GetNavOptedInTooltipDocument = gql`
    query GetNavOptedInTooltip {
  currentUser {
    id
    navOptedIn
  }
}
    `;

/**
 * __useGetNavOptedInTooltipQuery__
 *
 * To run a query within a React component, call `useGetNavOptedInTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavOptedInTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavOptedInTooltipQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNavOptedInTooltipQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>(GetNavOptedInTooltipDocument, options);
      }
export function useGetNavOptedInTooltipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>(GetNavOptedInTooltipDocument, options);
        }
// @ts-ignore
export function useGetNavOptedInTooltipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>;
export function useGetNavOptedInTooltipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavOptedInTooltipQuery | undefined, GraphqlTypes.GetNavOptedInTooltipQueryVariables>;
export function useGetNavOptedInTooltipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>(GetNavOptedInTooltipDocument, options);
        }
export type GetNavOptedInTooltipQueryHookResult = ReturnType<typeof useGetNavOptedInTooltipQuery>;
export type GetNavOptedInTooltipLazyQueryHookResult = ReturnType<typeof useGetNavOptedInTooltipLazyQuery>;
export type GetNavOptedInTooltipSuspenseQueryHookResult = ReturnType<typeof useGetNavOptedInTooltipSuspenseQuery>;
export type GetNavOptedInTooltipQueryResult = Apollo.QueryResult<GraphqlTypes.GetNavOptedInTooltipQuery, GraphqlTypes.GetNavOptedInTooltipQueryVariables>;
export const GetNavOptedInDocument = gql`
    query GetNavOptedIn {
  currentUser {
    id
    navOptedIn
  }
}
    `;

/**
 * __useGetNavOptedInQuery__
 *
 * To run a query within a React component, call `useGetNavOptedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavOptedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavOptedInQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNavOptedInQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>(GetNavOptedInDocument, options);
      }
export function useGetNavOptedInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>(GetNavOptedInDocument, options);
        }
// @ts-ignore
export function useGetNavOptedInSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>;
export function useGetNavOptedInSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavOptedInQuery | undefined, GraphqlTypes.GetNavOptedInQueryVariables>;
export function useGetNavOptedInSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>(GetNavOptedInDocument, options);
        }
export type GetNavOptedInQueryHookResult = ReturnType<typeof useGetNavOptedInQuery>;
export type GetNavOptedInLazyQueryHookResult = ReturnType<typeof useGetNavOptedInLazyQuery>;
export type GetNavOptedInSuspenseQueryHookResult = ReturnType<typeof useGetNavOptedInSuspenseQuery>;
export type GetNavOptedInQueryResult = Apollo.QueryResult<GraphqlTypes.GetNavOptedInQuery, GraphqlTypes.GetNavOptedInQueryVariables>;
export const SetNavOptedInSettingsDocument = gql`
    mutation SetNavOptedInSettings($isOptedIn: Boolean!) {
  setNavOptedIn(isOptedIn: $isOptedIn) {
    user {
      id
      navOptedIn
    }
  }
}
    `;
export type SetNavOptedInSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetNavOptedInSettingsMutation, GraphqlTypes.SetNavOptedInSettingsMutationVariables>;

/**
 * __useSetNavOptedInSettingsMutation__
 *
 * To run a mutation, you first call `useSetNavOptedInSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNavOptedInSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNavOptedInSettingsMutation, { data, loading, error }] = useSetNavOptedInSettingsMutation({
 *   variables: {
 *      isOptedIn: // value for 'isOptedIn'
 *   },
 * });
 */
export function useSetNavOptedInSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetNavOptedInSettingsMutation, GraphqlTypes.SetNavOptedInSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetNavOptedInSettingsMutation, GraphqlTypes.SetNavOptedInSettingsMutationVariables>(SetNavOptedInSettingsDocument, options);
      }
export type SetNavOptedInSettingsMutationHookResult = ReturnType<typeof useSetNavOptedInSettingsMutation>;
export type SetNavOptedInSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.SetNavOptedInSettingsMutation>;
export type SetNavOptedInSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetNavOptedInSettingsMutation, GraphqlTypes.SetNavOptedInSettingsMutationVariables>;
export const GetNavOptedInSettingsDocument = gql`
    query GetNavOptedInSettings {
  currentUser {
    id
    navOptedIn
  }
}
    `;

/**
 * __useGetNavOptedInSettingsQuery__
 *
 * To run a query within a React component, call `useGetNavOptedInSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavOptedInSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavOptedInSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNavOptedInSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>(GetNavOptedInSettingsDocument, options);
      }
export function useGetNavOptedInSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>(GetNavOptedInSettingsDocument, options);
        }
// @ts-ignore
export function useGetNavOptedInSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>;
export function useGetNavOptedInSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNavOptedInSettingsQuery | undefined, GraphqlTypes.GetNavOptedInSettingsQueryVariables>;
export function useGetNavOptedInSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>(GetNavOptedInSettingsDocument, options);
        }
export type GetNavOptedInSettingsQueryHookResult = ReturnType<typeof useGetNavOptedInSettingsQuery>;
export type GetNavOptedInSettingsLazyQueryHookResult = ReturnType<typeof useGetNavOptedInSettingsLazyQuery>;
export type GetNavOptedInSettingsSuspenseQueryHookResult = ReturnType<typeof useGetNavOptedInSettingsSuspenseQuery>;
export type GetNavOptedInSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetNavOptedInSettingsQuery, GraphqlTypes.GetNavOptedInSettingsQueryVariables>;
export const SearchTicketAccessGroupsDocument = gql`
    query SearchTicketAccessGroups($term: String!) {
  objectGroups(term: $term, authorizedClass: ticket, first: 20) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useSearchTicketAccessGroupsQuery__
 *
 * To run a query within a React component, call `useSearchTicketAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTicketAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTicketAccessGroupsQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchTicketAccessGroupsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables> & ({ variables: GraphqlTypes.SearchTicketAccessGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>(SearchTicketAccessGroupsDocument, options);
      }
export function useSearchTicketAccessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>(SearchTicketAccessGroupsDocument, options);
        }
// @ts-ignore
export function useSearchTicketAccessGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>;
export function useSearchTicketAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTicketAccessGroupsQuery | undefined, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>;
export function useSearchTicketAccessGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>(SearchTicketAccessGroupsDocument, options);
        }
export type SearchTicketAccessGroupsQueryHookResult = ReturnType<typeof useSearchTicketAccessGroupsQuery>;
export type SearchTicketAccessGroupsLazyQueryHookResult = ReturnType<typeof useSearchTicketAccessGroupsLazyQuery>;
export type SearchTicketAccessGroupsSuspenseQueryHookResult = ReturnType<typeof useSearchTicketAccessGroupsSuspenseQuery>;
export type SearchTicketAccessGroupsQueryResult = Apollo.QueryResult<GraphqlTypes.SearchTicketAccessGroupsQuery, GraphqlTypes.SearchTicketAccessGroupsQueryVariables>;
export const GetLpGpTicketDocument = gql`
    query GetLpGpTicket($ticketId: ID!) {
  lpGpTicket(ticketId: $ticketId) {
    id
    subject
    status
    ticketAssignees {
      user {
        id
        fullName
      }
    }
    accessGroups {
      id
      title
    }
    startedByUser {
      id
      fullName
    }
    tags {
      id
      tagText
    }
    objectAssociations {
      associatedObject {
        ... on ContactObjectType {
          id
          fullName
        }
        ... on AccountObjectType {
          id
          name
        }
        ... on OfferingObjectType {
          id
          name
        }
      }
    }
    ticketContacts {
      contact {
        id
        fullName
        companyName
        company {
          id
          fullName
        }
        accounts {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetLpGpTicketQuery__
 *
 * To run a query within a React component, call `useGetLpGpTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLpGpTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLpGpTicketQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetLpGpTicketQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables> & ({ variables: GraphqlTypes.GetLpGpTicketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>(GetLpGpTicketDocument, options);
      }
export function useGetLpGpTicketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>(GetLpGpTicketDocument, options);
        }
// @ts-ignore
export function useGetLpGpTicketSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>;
export function useGetLpGpTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpGpTicketQuery | undefined, GraphqlTypes.GetLpGpTicketQueryVariables>;
export function useGetLpGpTicketSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>(GetLpGpTicketDocument, options);
        }
export type GetLpGpTicketQueryHookResult = ReturnType<typeof useGetLpGpTicketQuery>;
export type GetLpGpTicketLazyQueryHookResult = ReturnType<typeof useGetLpGpTicketLazyQuery>;
export type GetLpGpTicketSuspenseQueryHookResult = ReturnType<typeof useGetLpGpTicketSuspenseQuery>;
export type GetLpGpTicketQueryResult = Apollo.QueryResult<GraphqlTypes.GetLpGpTicketQuery, GraphqlTypes.GetLpGpTicketQueryVariables>;
export const UpdateTicketDocument = gql`
    mutation UpdateTicket($ticketId: ID!, $input: UpdateTicketInput!) {
  updateTicket(ticketId: $ticketId, input: $input) {
    __typename
    ... on TicketObjectType {
      id
      subject
    }
    ... on MutationErrorResponse {
      message
    }
  }
}
    `;
export type UpdateTicketMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateTicketMutation, GraphqlTypes.UpdateTicketMutationVariables>;

/**
 * __useUpdateTicketMutation__
 *
 * To run a mutation, you first call `useUpdateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketMutation, { data, loading, error }] = useUpdateTicketMutation({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTicketMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateTicketMutation, GraphqlTypes.UpdateTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateTicketMutation, GraphqlTypes.UpdateTicketMutationVariables>(UpdateTicketDocument, options);
      }
export type UpdateTicketMutationHookResult = ReturnType<typeof useUpdateTicketMutation>;
export type UpdateTicketMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateTicketMutation>;
export type UpdateTicketMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateTicketMutation, GraphqlTypes.UpdateTicketMutationVariables>;
export const CreateTicketsGpDocument = gql`
    mutation CreateTicketsGp($objectInput: CreateTicketInput!) {
  createTicket(input: $objectInput) {
    __typename
    ... on TicketObjectType {
      id
      subject
      channel
      status
      portalVisibility
      lastMessageAt
      lastMessageByUser {
        id
        fullName
      }
      lastMessageByContact {
        id
        fullName
      }
      ticketAssignees {
        user {
          id
          fullName
        }
      }
      ticketContacts {
        contact {
          id
          fullName
        }
      }
      tags {
        tagText
      }
      objectAssociations {
        associatedObject {
          ... on ContactObjectType {
            id
            fullName
          }
          ... on AccountObjectType {
            id
            name
          }
          ... on OfferingObjectType {
            id
            name
          }
        }
      }
      accessGroups {
        id
        title
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type CreateTicketsGpMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateTicketsGpMutation, GraphqlTypes.CreateTicketsGpMutationVariables>;

/**
 * __useCreateTicketsGpMutation__
 *
 * To run a mutation, you first call `useCreateTicketsGpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketsGpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketsGpMutation, { data, loading, error }] = useCreateTicketsGpMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useCreateTicketsGpMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateTicketsGpMutation, GraphqlTypes.CreateTicketsGpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateTicketsGpMutation, GraphqlTypes.CreateTicketsGpMutationVariables>(CreateTicketsGpDocument, options);
      }
export type CreateTicketsGpMutationHookResult = ReturnType<typeof useCreateTicketsGpMutation>;
export type CreateTicketsGpMutationResult = Apollo.MutationResult<GraphqlTypes.CreateTicketsGpMutation>;
export type CreateTicketsGpMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateTicketsGpMutation, GraphqlTypes.CreateTicketsGpMutationVariables>;
export const FindOrCreateTicketTagDocument = gql`
    mutation FindOrCreateTicketTag($tagText: String!) {
  findOrCreateTag(objectType: ticket, tagText: $tagText) {
    __typename
    ... on TagObjectType {
      id
      tagText
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type FindOrCreateTicketTagMutationFn = Apollo.MutationFunction<GraphqlTypes.FindOrCreateTicketTagMutation, GraphqlTypes.FindOrCreateTicketTagMutationVariables>;

/**
 * __useFindOrCreateTicketTagMutation__
 *
 * To run a mutation, you first call `useFindOrCreateTicketTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateTicketTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateTicketTagMutation, { data, loading, error }] = useFindOrCreateTicketTagMutation({
 *   variables: {
 *      tagText: // value for 'tagText'
 *   },
 * });
 */
export function useFindOrCreateTicketTagMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FindOrCreateTicketTagMutation, GraphqlTypes.FindOrCreateTicketTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FindOrCreateTicketTagMutation, GraphqlTypes.FindOrCreateTicketTagMutationVariables>(FindOrCreateTicketTagDocument, options);
      }
export type FindOrCreateTicketTagMutationHookResult = ReturnType<typeof useFindOrCreateTicketTagMutation>;
export type FindOrCreateTicketTagMutationResult = Apollo.MutationResult<GraphqlTypes.FindOrCreateTicketTagMutation>;
export type FindOrCreateTicketTagMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FindOrCreateTicketTagMutation, GraphqlTypes.FindOrCreateTicketTagMutationVariables>;
export const SearchTicketAssigneeEligibleUsersDocument = gql`
    query SearchTicketAssigneeEligibleUsers($input: TicketAssigneeEligibleUsersInput!) {
  ticketAssigneeEligibleUsers(input: $input) {
    id
    fullName
    emailAddress
  }
}
    `;

/**
 * __useSearchTicketAssigneeEligibleUsersQuery__
 *
 * To run a query within a React component, call `useSearchTicketAssigneeEligibleUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTicketAssigneeEligibleUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTicketAssigneeEligibleUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchTicketAssigneeEligibleUsersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables> & ({ variables: GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>(SearchTicketAssigneeEligibleUsersDocument, options);
      }
export function useSearchTicketAssigneeEligibleUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>(SearchTicketAssigneeEligibleUsersDocument, options);
        }
// @ts-ignore
export function useSearchTicketAssigneeEligibleUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>;
export function useSearchTicketAssigneeEligibleUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery | undefined, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>;
export function useSearchTicketAssigneeEligibleUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>(SearchTicketAssigneeEligibleUsersDocument, options);
        }
export type SearchTicketAssigneeEligibleUsersQueryHookResult = ReturnType<typeof useSearchTicketAssigneeEligibleUsersQuery>;
export type SearchTicketAssigneeEligibleUsersLazyQueryHookResult = ReturnType<typeof useSearchTicketAssigneeEligibleUsersLazyQuery>;
export type SearchTicketAssigneeEligibleUsersSuspenseQueryHookResult = ReturnType<typeof useSearchTicketAssigneeEligibleUsersSuspenseQuery>;
export type SearchTicketAssigneeEligibleUsersQueryResult = Apollo.QueryResult<GraphqlTypes.SearchTicketAssigneeEligibleUsersQuery, GraphqlTypes.SearchTicketAssigneeEligibleUsersQueryVariables>;
export const DistributionListsForAccountDocument = gql`
    query DistributionListsForAccount($accountId: ID!) {
  distributionListsForAccount(accountId: $accountId) {
    id
    name
  }
}
    `;

/**
 * __useDistributionListsForAccountQuery__
 *
 * To run a query within a React component, call `useDistributionListsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionListsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionListsForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDistributionListsForAccountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables> & ({ variables: GraphqlTypes.DistributionListsForAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>(DistributionListsForAccountDocument, options);
      }
export function useDistributionListsForAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>(DistributionListsForAccountDocument, options);
        }
// @ts-ignore
export function useDistributionListsForAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>;
export function useDistributionListsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DistributionListsForAccountQuery | undefined, GraphqlTypes.DistributionListsForAccountQueryVariables>;
export function useDistributionListsForAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>(DistributionListsForAccountDocument, options);
        }
export type DistributionListsForAccountQueryHookResult = ReturnType<typeof useDistributionListsForAccountQuery>;
export type DistributionListsForAccountLazyQueryHookResult = ReturnType<typeof useDistributionListsForAccountLazyQuery>;
export type DistributionListsForAccountSuspenseQueryHookResult = ReturnType<typeof useDistributionListsForAccountSuspenseQuery>;
export type DistributionListsForAccountQueryResult = Apollo.QueryResult<GraphqlTypes.DistributionListsForAccountQuery, GraphqlTypes.DistributionListsForAccountQueryVariables>;
export const ContactsForDistributionListDocument = gql`
    query ContactsForDistributionList($accountId: ID!, $distributionListId: ID!) {
  contactsForDistributionList(
    accountId: $accountId
    distributionListId: $distributionListId
  ) {
    id
    fullName
  }
}
    `;

/**
 * __useContactsForDistributionListQuery__
 *
 * To run a query within a React component, call `useContactsForDistributionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsForDistributionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsForDistributionListQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      distributionListId: // value for 'distributionListId'
 *   },
 * });
 */
export function useContactsForDistributionListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables> & ({ variables: GraphqlTypes.ContactsForDistributionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>(ContactsForDistributionListDocument, options);
      }
export function useContactsForDistributionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>(ContactsForDistributionListDocument, options);
        }
// @ts-ignore
export function useContactsForDistributionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>;
export function useContactsForDistributionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ContactsForDistributionListQuery | undefined, GraphqlTypes.ContactsForDistributionListQueryVariables>;
export function useContactsForDistributionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>(ContactsForDistributionListDocument, options);
        }
export type ContactsForDistributionListQueryHookResult = ReturnType<typeof useContactsForDistributionListQuery>;
export type ContactsForDistributionListLazyQueryHookResult = ReturnType<typeof useContactsForDistributionListLazyQuery>;
export type ContactsForDistributionListSuspenseQueryHookResult = ReturnType<typeof useContactsForDistributionListSuspenseQuery>;
export type ContactsForDistributionListQueryResult = Apollo.QueryResult<GraphqlTypes.ContactsForDistributionListQuery, GraphqlTypes.ContactsForDistributionListQueryVariables>;
export const SearchTicketTagsCatalogDocument = gql`
    query SearchTicketTagsCatalog($term: String, $first: Int = 20) {
  tagsCatalog(objectType: ticket, term: $term, first: $first) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        tagText
      }
    }
  }
}
    `;

/**
 * __useSearchTicketTagsCatalogQuery__
 *
 * To run a query within a React component, call `useSearchTicketTagsCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTicketTagsCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTicketTagsCatalogQuery({
 *   variables: {
 *      term: // value for 'term'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchTicketTagsCatalogQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>(SearchTicketTagsCatalogDocument, options);
      }
export function useSearchTicketTagsCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>(SearchTicketTagsCatalogDocument, options);
        }
// @ts-ignore
export function useSearchTicketTagsCatalogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>;
export function useSearchTicketTagsCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTicketTagsCatalogQuery | undefined, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>;
export function useSearchTicketTagsCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>(SearchTicketTagsCatalogDocument, options);
        }
export type SearchTicketTagsCatalogQueryHookResult = ReturnType<typeof useSearchTicketTagsCatalogQuery>;
export type SearchTicketTagsCatalogLazyQueryHookResult = ReturnType<typeof useSearchTicketTagsCatalogLazyQuery>;
export type SearchTicketTagsCatalogSuspenseQueryHookResult = ReturnType<typeof useSearchTicketTagsCatalogSuspenseQuery>;
export type SearchTicketTagsCatalogQueryResult = Apollo.QueryResult<GraphqlTypes.SearchTicketTagsCatalogQuery, GraphqlTypes.SearchTicketTagsCatalogQueryVariables>;
export const ExportDocumentReviewerSettingsDocument = gql`
    mutation ExportDocumentReviewerSettings($entityIds: [String]!) {
  exportDocumentReviewerSettings(input: {entityIds: $entityIds}) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on AsyncJobObjectType {
      id
      status
      jobType
      data
    }
  }
}
    `;
export type ExportDocumentReviewerSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportDocumentReviewerSettingsMutation, GraphqlTypes.ExportDocumentReviewerSettingsMutationVariables>;

/**
 * __useExportDocumentReviewerSettingsMutation__
 *
 * To run a mutation, you first call `useExportDocumentReviewerSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportDocumentReviewerSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportDocumentReviewerSettingsMutation, { data, loading, error }] = useExportDocumentReviewerSettingsMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useExportDocumentReviewerSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportDocumentReviewerSettingsMutation, GraphqlTypes.ExportDocumentReviewerSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportDocumentReviewerSettingsMutation, GraphqlTypes.ExportDocumentReviewerSettingsMutationVariables>(ExportDocumentReviewerSettingsDocument, options);
      }
export type ExportDocumentReviewerSettingsMutationHookResult = ReturnType<typeof useExportDocumentReviewerSettingsMutation>;
export type ExportDocumentReviewerSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.ExportDocumentReviewerSettingsMutation>;
export type ExportDocumentReviewerSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportDocumentReviewerSettingsMutation, GraphqlTypes.ExportDocumentReviewerSettingsMutationVariables>;
export const StartEntityDocumentExportDocument = gql`
    mutation StartEntityDocumentExport($input: StartEntityDocumentExportInput!) {
  startEntityDocumentExport(input: $input) {
    __typename
    ... on StartEntityDocumentExportObject {
      job {
        id
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type StartEntityDocumentExportMutationFn = Apollo.MutationFunction<GraphqlTypes.StartEntityDocumentExportMutation, GraphqlTypes.StartEntityDocumentExportMutationVariables>;

/**
 * __useStartEntityDocumentExportMutation__
 *
 * To run a mutation, you first call `useStartEntityDocumentExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEntityDocumentExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEntityDocumentExportMutation, { data, loading, error }] = useStartEntityDocumentExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartEntityDocumentExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartEntityDocumentExportMutation, GraphqlTypes.StartEntityDocumentExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartEntityDocumentExportMutation, GraphqlTypes.StartEntityDocumentExportMutationVariables>(StartEntityDocumentExportDocument, options);
      }
export type StartEntityDocumentExportMutationHookResult = ReturnType<typeof useStartEntityDocumentExportMutation>;
export type StartEntityDocumentExportMutationResult = Apollo.MutationResult<GraphqlTypes.StartEntityDocumentExportMutation>;
export type StartEntityDocumentExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartEntityDocumentExportMutation, GraphqlTypes.StartEntityDocumentExportMutationVariables>;
export const EntityDocumentExportCountDocument = gql`
    query EntityDocumentExportCount($entityIds: [ID!]!) {
  entityDocumentExportCount(entityIds: $entityIds) {
    totalDocumentCount
  }
}
    `;

/**
 * __useEntityDocumentExportCountQuery__
 *
 * To run a query within a React component, call `useEntityDocumentExportCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDocumentExportCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDocumentExportCountQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useEntityDocumentExportCountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables> & ({ variables: GraphqlTypes.EntityDocumentExportCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>(EntityDocumentExportCountDocument, options);
      }
export function useEntityDocumentExportCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>(EntityDocumentExportCountDocument, options);
        }
// @ts-ignore
export function useEntityDocumentExportCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>;
export function useEntityDocumentExportCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.EntityDocumentExportCountQuery | undefined, GraphqlTypes.EntityDocumentExportCountQueryVariables>;
export function useEntityDocumentExportCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>(EntityDocumentExportCountDocument, options);
        }
export type EntityDocumentExportCountQueryHookResult = ReturnType<typeof useEntityDocumentExportCountQuery>;
export type EntityDocumentExportCountLazyQueryHookResult = ReturnType<typeof useEntityDocumentExportCountLazyQuery>;
export type EntityDocumentExportCountSuspenseQueryHookResult = ReturnType<typeof useEntityDocumentExportCountSuspenseQuery>;
export type EntityDocumentExportCountQueryResult = Apollo.QueryResult<GraphqlTypes.EntityDocumentExportCountQuery, GraphqlTypes.EntityDocumentExportCountQueryVariables>;
export const GetPublishableDocumentsCountDocument = gql`
    query GetPublishableDocumentsCount {
  publishableDocumentsCount {
    documentCount
    entityCount
  }
}
    `;

/**
 * __useGetPublishableDocumentsCountQuery__
 *
 * To run a query within a React component, call `useGetPublishableDocumentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishableDocumentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishableDocumentsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublishableDocumentsCountQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>(GetPublishableDocumentsCountDocument, options);
      }
export function useGetPublishableDocumentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>(GetPublishableDocumentsCountDocument, options);
        }
// @ts-ignore
export function useGetPublishableDocumentsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>;
export function useGetPublishableDocumentsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPublishableDocumentsCountQuery | undefined, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>;
export function useGetPublishableDocumentsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>(GetPublishableDocumentsCountDocument, options);
        }
export type GetPublishableDocumentsCountQueryHookResult = ReturnType<typeof useGetPublishableDocumentsCountQuery>;
export type GetPublishableDocumentsCountLazyQueryHookResult = ReturnType<typeof useGetPublishableDocumentsCountLazyQuery>;
export type GetPublishableDocumentsCountSuspenseQueryHookResult = ReturnType<typeof useGetPublishableDocumentsCountSuspenseQuery>;
export type GetPublishableDocumentsCountQueryResult = Apollo.QueryResult<GraphqlTypes.GetPublishableDocumentsCountQuery, GraphqlTypes.GetPublishableDocumentsCountQueryVariables>;
export const GetInvestmentEntitiesTotalsDocument = gql`
    query GetInvestmentEntitiesTotals($filters: EntitiesFilters) {
  investmentEntities(filters: $filters) {
    totals {
      status
      currency {
        ...CurrencyFieldsFederation
      }
      investorPositionCount
      investorCommitted {
        monies
      }
      investorContributions {
        monies
      }
      investorCapitalOut {
        monies
      }
    }
  }
}
    ${CurrencyFieldsFederationFragmentDoc}`;

/**
 * __useGetInvestmentEntitiesTotalsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetInvestmentEntitiesTotalsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>(GetInvestmentEntitiesTotalsDocument, options);
      }
export function useGetInvestmentEntitiesTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>(GetInvestmentEntitiesTotalsDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>;
export function useGetInvestmentEntitiesTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesTotalsQuery | undefined, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>;
export function useGetInvestmentEntitiesTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>(GetInvestmentEntitiesTotalsDocument, options);
        }
export type GetInvestmentEntitiesTotalsQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesTotalsQuery>;
export type GetInvestmentEntitiesTotalsLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesTotalsLazyQuery>;
export type GetInvestmentEntitiesTotalsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesTotalsSuspenseQuery>;
export type GetInvestmentEntitiesTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesTotalsQuery, GraphqlTypes.GetInvestmentEntitiesTotalsQueryVariables>;
export const GetActiveOfferingsForIncreaseDocument = gql`
    query GetActiveOfferingsForIncrease($stages: [OfferingStageEnum!]) {
  searchAllOfferings(stages: $stages) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetActiveOfferingsForIncreaseQuery__
 *
 * To run a query within a React component, call `useGetActiveOfferingsForIncreaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveOfferingsForIncreaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveOfferingsForIncreaseQuery({
 *   variables: {
 *      stages: // value for 'stages'
 *   },
 * });
 */
export function useGetActiveOfferingsForIncreaseQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>(GetActiveOfferingsForIncreaseDocument, options);
      }
export function useGetActiveOfferingsForIncreaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>(GetActiveOfferingsForIncreaseDocument, options);
        }
// @ts-ignore
export function useGetActiveOfferingsForIncreaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>;
export function useGetActiveOfferingsForIncreaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActiveOfferingsForIncreaseQuery | undefined, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>;
export function useGetActiveOfferingsForIncreaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>(GetActiveOfferingsForIncreaseDocument, options);
        }
export type GetActiveOfferingsForIncreaseQueryHookResult = ReturnType<typeof useGetActiveOfferingsForIncreaseQuery>;
export type GetActiveOfferingsForIncreaseLazyQueryHookResult = ReturnType<typeof useGetActiveOfferingsForIncreaseLazyQuery>;
export type GetActiveOfferingsForIncreaseSuspenseQueryHookResult = ReturnType<typeof useGetActiveOfferingsForIncreaseSuspenseQuery>;
export type GetActiveOfferingsForIncreaseQueryResult = Apollo.QueryResult<GraphqlTypes.GetActiveOfferingsForIncreaseQuery, GraphqlTypes.GetActiveOfferingsForIncreaseQueryVariables>;
export const GetAccountContactsForIncreaseDocument = gql`
    query GetAccountContactsForIncrease($accountId: ID!) {
  accountContacts(filters: {accountId: [$accountId]}) {
    edges {
      node {
        id
        contactId
        contactDetails {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountContactsForIncreaseQuery__
 *
 * To run a query within a React component, call `useGetAccountContactsForIncreaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountContactsForIncreaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountContactsForIncreaseQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountContactsForIncreaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables> & ({ variables: GraphqlTypes.GetAccountContactsForIncreaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>(GetAccountContactsForIncreaseDocument, options);
      }
export function useGetAccountContactsForIncreaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>(GetAccountContactsForIncreaseDocument, options);
        }
// @ts-ignore
export function useGetAccountContactsForIncreaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>;
export function useGetAccountContactsForIncreaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsForIncreaseQuery | undefined, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>;
export function useGetAccountContactsForIncreaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>(GetAccountContactsForIncreaseDocument, options);
        }
export type GetAccountContactsForIncreaseQueryHookResult = ReturnType<typeof useGetAccountContactsForIncreaseQuery>;
export type GetAccountContactsForIncreaseLazyQueryHookResult = ReturnType<typeof useGetAccountContactsForIncreaseLazyQuery>;
export type GetAccountContactsForIncreaseSuspenseQueryHookResult = ReturnType<typeof useGetAccountContactsForIncreaseSuspenseQuery>;
export type GetAccountContactsForIncreaseQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountContactsForIncreaseQuery, GraphqlTypes.GetAccountContactsForIncreaseQueryVariables>;
export const SearchContactsForIncreaseDocument = gql`
    query SearchContactsForIncrease($term: String!) {
  searchContacts(term: $term) {
    edges {
      node {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useSearchContactsForIncreaseQuery__
 *
 * To run a query within a React component, call `useSearchContactsForIncreaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsForIncreaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsForIncreaseQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchContactsForIncreaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables> & ({ variables: GraphqlTypes.SearchContactsForIncreaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>(SearchContactsForIncreaseDocument, options);
      }
export function useSearchContactsForIncreaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>(SearchContactsForIncreaseDocument, options);
        }
// @ts-ignore
export function useSearchContactsForIncreaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>;
export function useSearchContactsForIncreaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchContactsForIncreaseQuery | undefined, GraphqlTypes.SearchContactsForIncreaseQueryVariables>;
export function useSearchContactsForIncreaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>(SearchContactsForIncreaseDocument, options);
        }
export type SearchContactsForIncreaseQueryHookResult = ReturnType<typeof useSearchContactsForIncreaseQuery>;
export type SearchContactsForIncreaseLazyQueryHookResult = ReturnType<typeof useSearchContactsForIncreaseLazyQuery>;
export type SearchContactsForIncreaseSuspenseQueryHookResult = ReturnType<typeof useSearchContactsForIncreaseSuspenseQuery>;
export type SearchContactsForIncreaseQueryResult = Apollo.QueryResult<GraphqlTypes.SearchContactsForIncreaseQuery, GraphqlTypes.SearchContactsForIncreaseQueryVariables>;
export const GetPendingMarketLensUpdatesDocument = gql`
    query GetPendingMarketLensUpdates($objectInput: ChangeRequestQueryInput!) {
  changeRequests(objectInput: $objectInput) {
    __typename
    ... on ChangeRequestQueryResponse {
      approvalRequests {
        id
        requestedAt
        changeRequest {
          changeRequestedObj {
            ... on MarketLensContactUpdateSignalObjectType {
              header
              contactFirm {
                id
              }
              contactUnderReview {
                id
              }
            }
            ... on MarketLensServiceProviderUpdateSignalObjectType {
              header
              investorFirmContact {
                id
              }
              serviceProviderContact {
                id
              }
            }
          }
        }
      }
    }
    ... on QueryErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetPendingMarketLensUpdatesQuery__
 *
 * To run a query within a React component, call `useGetPendingMarketLensUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingMarketLensUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingMarketLensUpdatesQuery({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useGetPendingMarketLensUpdatesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables> & ({ variables: GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>(GetPendingMarketLensUpdatesDocument, options);
      }
export function useGetPendingMarketLensUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>(GetPendingMarketLensUpdatesDocument, options);
        }
// @ts-ignore
export function useGetPendingMarketLensUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>;
export function useGetPendingMarketLensUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPendingMarketLensUpdatesQuery | undefined, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>;
export function useGetPendingMarketLensUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>(GetPendingMarketLensUpdatesDocument, options);
        }
export type GetPendingMarketLensUpdatesQueryHookResult = ReturnType<typeof useGetPendingMarketLensUpdatesQuery>;
export type GetPendingMarketLensUpdatesLazyQueryHookResult = ReturnType<typeof useGetPendingMarketLensUpdatesLazyQuery>;
export type GetPendingMarketLensUpdatesSuspenseQueryHookResult = ReturnType<typeof useGetPendingMarketLensUpdatesSuspenseQuery>;
export type GetPendingMarketLensUpdatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPendingMarketLensUpdatesQuery, GraphqlTypes.GetPendingMarketLensUpdatesQueryVariables>;
export const GetMarketLensFirmDocument = gql`
    query GetMarketLensFirm($firmGuid: ID!, $arenaId: ID) {
  marketLensFirm(firmGuid: $firmGuid, arenaId: $arenaId) {
    __typename
    ... on MarketLensFirm {
      firmGuid
      firmName
      investorType
      investorTypeLabel
      investorSubType
      investorSubTypeLabel
      totalAssets
      currencyCode
      assetAllocations {
        assetClass
      }
      totalClientCount
      streetAddress
      streetAddress2
      city
      state
      zipCode
      country
      phone
      website
    }
    ... on ValidationError {
      message
    }
  }
}
    `;

/**
 * __useGetMarketLensFirmQuery__
 *
 * To run a query within a React component, call `useGetMarketLensFirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketLensFirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketLensFirmQuery({
 *   variables: {
 *      firmGuid: // value for 'firmGuid'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetMarketLensFirmQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables> & ({ variables: GraphqlTypes.GetMarketLensFirmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>(GetMarketLensFirmDocument, options);
      }
export function useGetMarketLensFirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>(GetMarketLensFirmDocument, options);
        }
// @ts-ignore
export function useGetMarketLensFirmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>;
export function useGetMarketLensFirmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMarketLensFirmQuery | undefined, GraphqlTypes.GetMarketLensFirmQueryVariables>;
export function useGetMarketLensFirmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>(GetMarketLensFirmDocument, options);
        }
export type GetMarketLensFirmQueryHookResult = ReturnType<typeof useGetMarketLensFirmQuery>;
export type GetMarketLensFirmLazyQueryHookResult = ReturnType<typeof useGetMarketLensFirmLazyQuery>;
export type GetMarketLensFirmSuspenseQueryHookResult = ReturnType<typeof useGetMarketLensFirmSuspenseQuery>;
export type GetMarketLensFirmQueryResult = Apollo.QueryResult<GraphqlTypes.GetMarketLensFirmQuery, GraphqlTypes.GetMarketLensFirmQueryVariables>;
export const UpdatePositionAllocationForPublicationDocument = gql`
    mutation UpdatePositionAllocationForPublication($objectInput: UpdatePositionAllocationForPublicationInput!) {
  updatePositionAllocationForPublication(objectInput: $objectInput) {
    ... on AsyncJobObjectType {
      id
      jobType
      status
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UpdatePositionAllocationForPublicationMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePositionAllocationForPublicationMutation, GraphqlTypes.UpdatePositionAllocationForPublicationMutationVariables>;

/**
 * __useUpdatePositionAllocationForPublicationMutation__
 *
 * To run a mutation, you first call `useUpdatePositionAllocationForPublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionAllocationForPublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionAllocationForPublicationMutation, { data, loading, error }] = useUpdatePositionAllocationForPublicationMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdatePositionAllocationForPublicationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePositionAllocationForPublicationMutation, GraphqlTypes.UpdatePositionAllocationForPublicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePositionAllocationForPublicationMutation, GraphqlTypes.UpdatePositionAllocationForPublicationMutationVariables>(UpdatePositionAllocationForPublicationDocument, options);
      }
export type UpdatePositionAllocationForPublicationMutationHookResult = ReturnType<typeof useUpdatePositionAllocationForPublicationMutation>;
export type UpdatePositionAllocationForPublicationMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePositionAllocationForPublicationMutation>;
export type UpdatePositionAllocationForPublicationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePositionAllocationForPublicationMutation, GraphqlTypes.UpdatePositionAllocationForPublicationMutationVariables>;
export const GetUserAnnouncementDocument = gql`
    query GetUserAnnouncement($filter: AnnouncementFilter!) {
  userAnnouncement(filter: $filter) {
    id
    header
    body
    url
    createdAt
    read
    updatedAt
  }
}
    `;

/**
 * __useGetUserAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetUserAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAnnouncementQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUserAnnouncementQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables> & ({ variables: GraphqlTypes.GetUserAnnouncementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>(GetUserAnnouncementDocument, options);
      }
export function useGetUserAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>(GetUserAnnouncementDocument, options);
        }
// @ts-ignore
export function useGetUserAnnouncementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>;
export function useGetUserAnnouncementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUserAnnouncementQuery | undefined, GraphqlTypes.GetUserAnnouncementQueryVariables>;
export function useGetUserAnnouncementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>(GetUserAnnouncementDocument, options);
        }
export type GetUserAnnouncementQueryHookResult = ReturnType<typeof useGetUserAnnouncementQuery>;
export type GetUserAnnouncementLazyQueryHookResult = ReturnType<typeof useGetUserAnnouncementLazyQuery>;
export type GetUserAnnouncementSuspenseQueryHookResult = ReturnType<typeof useGetUserAnnouncementSuspenseQuery>;
export type GetUserAnnouncementQueryResult = Apollo.QueryResult<GraphqlTypes.GetUserAnnouncementQuery, GraphqlTypes.GetUserAnnouncementQueryVariables>;
export const DismissNpsSurveyDocument = gql`
    mutation DismissNPSSurvey($embeddedData: JSONString) {
  dismissNPSSurvey(embeddedData: $embeddedData) {
    __typename
    ... on NPSSurveyActionResponse {
      success
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type DismissNpsSurveyMutationFn = Apollo.MutationFunction<GraphqlTypes.DismissNpsSurveyMutation, GraphqlTypes.DismissNpsSurveyMutationVariables>;

/**
 * __useDismissNpsSurveyMutation__
 *
 * To run a mutation, you first call `useDismissNpsSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissNpsSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissNpsSurveyMutation, { data, loading, error }] = useDismissNpsSurveyMutation({
 *   variables: {
 *      embeddedData: // value for 'embeddedData'
 *   },
 * });
 */
export function useDismissNpsSurveyMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DismissNpsSurveyMutation, GraphqlTypes.DismissNpsSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DismissNpsSurveyMutation, GraphqlTypes.DismissNpsSurveyMutationVariables>(DismissNpsSurveyDocument, options);
      }
export type DismissNpsSurveyMutationHookResult = ReturnType<typeof useDismissNpsSurveyMutation>;
export type DismissNpsSurveyMutationResult = Apollo.MutationResult<GraphqlTypes.DismissNpsSurveyMutation>;
export type DismissNpsSurveyMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DismissNpsSurveyMutation, GraphqlTypes.DismissNpsSurveyMutationVariables>;
export const SubmitNpsSurveyDocument = gql`
    mutation SubmitNPSSurvey {
  submitNPSSurvey {
    __typename
    ... on NPSSurveyActionResponse {
      success
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SubmitNpsSurveyMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitNpsSurveyMutation, GraphqlTypes.SubmitNpsSurveyMutationVariables>;

/**
 * __useSubmitNpsSurveyMutation__
 *
 * To run a mutation, you first call `useSubmitNpsSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNpsSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNpsSurveyMutation, { data, loading, error }] = useSubmitNpsSurveyMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitNpsSurveyMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitNpsSurveyMutation, GraphqlTypes.SubmitNpsSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitNpsSurveyMutation, GraphqlTypes.SubmitNpsSurveyMutationVariables>(SubmitNpsSurveyDocument, options);
      }
export type SubmitNpsSurveyMutationHookResult = ReturnType<typeof useSubmitNpsSurveyMutation>;
export type SubmitNpsSurveyMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitNpsSurveyMutation>;
export type SubmitNpsSurveyMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitNpsSurveyMutation, GraphqlTypes.SubmitNpsSurveyMutationVariables>;
export const NpsSurveyEligibilityDocument = gql`
    query NPSSurveyEligibility {
  getNPSSurveyEligibility {
    showSurvey
    surveyUrl
  }
}
    `;

/**
 * __useNpsSurveyEligibilityQuery__
 *
 * To run a query within a React component, call `useNpsSurveyEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useNpsSurveyEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNpsSurveyEligibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useNpsSurveyEligibilityQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>(NpsSurveyEligibilityDocument, options);
      }
export function useNpsSurveyEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>(NpsSurveyEligibilityDocument, options);
        }
// @ts-ignore
export function useNpsSurveyEligibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>;
export function useNpsSurveyEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.NpsSurveyEligibilityQuery | undefined, GraphqlTypes.NpsSurveyEligibilityQueryVariables>;
export function useNpsSurveyEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>(NpsSurveyEligibilityDocument, options);
        }
export type NpsSurveyEligibilityQueryHookResult = ReturnType<typeof useNpsSurveyEligibilityQuery>;
export type NpsSurveyEligibilityLazyQueryHookResult = ReturnType<typeof useNpsSurveyEligibilityLazyQuery>;
export type NpsSurveyEligibilitySuspenseQueryHookResult = ReturnType<typeof useNpsSurveyEligibilitySuspenseQuery>;
export type NpsSurveyEligibilityQueryResult = Apollo.QueryResult<GraphqlTypes.NpsSurveyEligibilityQuery, GraphqlTypes.NpsSurveyEligibilityQueryVariables>;
export const CreateOrUpdateOfferingCloseRoundDocument = gql`
    mutation CreateOrUpdateOfferingCloseRound($input: CreateOrUpdateOfferingCloseRoundInput!) {
  createOrUpdateOfferingCloseRound(input: $input) {
    ... on OfferingCloseRoundObjectType {
      id
      name
      startDate
      endDate
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type CreateOrUpdateOfferingCloseRoundMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutation, GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutationVariables>;

/**
 * __useCreateOrUpdateOfferingCloseRoundMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateOfferingCloseRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateOfferingCloseRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateOfferingCloseRoundMutation, { data, loading, error }] = useCreateOrUpdateOfferingCloseRoundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateOfferingCloseRoundMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutation, GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutation, GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutationVariables>(CreateOrUpdateOfferingCloseRoundDocument, options);
      }
export type CreateOrUpdateOfferingCloseRoundMutationHookResult = ReturnType<typeof useCreateOrUpdateOfferingCloseRoundMutation>;
export type CreateOrUpdateOfferingCloseRoundMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutation>;
export type CreateOrUpdateOfferingCloseRoundMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutation, GraphqlTypes.CreateOrUpdateOfferingCloseRoundMutationVariables>;
export const DeleteOrArchiveOfferingCloseRoundDocument = gql`
    mutation DeleteOrArchiveOfferingCloseRound($input: DeleteOrArchiveOfferingCloseRoundInput!) {
  deleteOrArchiveOfferingCloseRound(input: $input) {
    ... on MutationSuccessResponse {
      didSucceed
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DeleteOrArchiveOfferingCloseRoundMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutation, GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutationVariables>;

/**
 * __useDeleteOrArchiveOfferingCloseRoundMutation__
 *
 * To run a mutation, you first call `useDeleteOrArchiveOfferingCloseRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrArchiveOfferingCloseRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrArchiveOfferingCloseRoundMutation, { data, loading, error }] = useDeleteOrArchiveOfferingCloseRoundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrArchiveOfferingCloseRoundMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutation, GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutation, GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutationVariables>(DeleteOrArchiveOfferingCloseRoundDocument, options);
      }
export type DeleteOrArchiveOfferingCloseRoundMutationHookResult = ReturnType<typeof useDeleteOrArchiveOfferingCloseRoundMutation>;
export type DeleteOrArchiveOfferingCloseRoundMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutation>;
export type DeleteOrArchiveOfferingCloseRoundMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutation, GraphqlTypes.DeleteOrArchiveOfferingCloseRoundMutationVariables>;
export const UndoArchiveOfferingCloseRoundDocument = gql`
    mutation UndoArchiveOfferingCloseRound($input: UndoArchiveOfferingCloseRoundInput!) {
  undoArchiveOfferingCloseRound(input: $input) {
    ... on MutationSuccessResponse {
      didSucceed
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UndoArchiveOfferingCloseRoundMutationFn = Apollo.MutationFunction<GraphqlTypes.UndoArchiveOfferingCloseRoundMutation, GraphqlTypes.UndoArchiveOfferingCloseRoundMutationVariables>;

/**
 * __useUndoArchiveOfferingCloseRoundMutation__
 *
 * To run a mutation, you first call `useUndoArchiveOfferingCloseRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoArchiveOfferingCloseRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoArchiveOfferingCloseRoundMutation, { data, loading, error }] = useUndoArchiveOfferingCloseRoundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUndoArchiveOfferingCloseRoundMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UndoArchiveOfferingCloseRoundMutation, GraphqlTypes.UndoArchiveOfferingCloseRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UndoArchiveOfferingCloseRoundMutation, GraphqlTypes.UndoArchiveOfferingCloseRoundMutationVariables>(UndoArchiveOfferingCloseRoundDocument, options);
      }
export type UndoArchiveOfferingCloseRoundMutationHookResult = ReturnType<typeof useUndoArchiveOfferingCloseRoundMutation>;
export type UndoArchiveOfferingCloseRoundMutationResult = Apollo.MutationResult<GraphqlTypes.UndoArchiveOfferingCloseRoundMutation>;
export type UndoArchiveOfferingCloseRoundMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UndoArchiveOfferingCloseRoundMutation, GraphqlTypes.UndoArchiveOfferingCloseRoundMutationVariables>;
export const GetOfferingCloseRoundsDocument = gql`
    query GetOfferingCloseRounds($offeringId: ID!) {
  offeringCloseRounds(offeringId: $offeringId) {
    id
    name
    startDate
    endDate
    isArchived
  }
}
    `;

/**
 * __useGetOfferingCloseRoundsQuery__
 *
 * To run a query within a React component, call `useGetOfferingCloseRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferingCloseRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferingCloseRoundsQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useGetOfferingCloseRoundsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables> & ({ variables: GraphqlTypes.GetOfferingCloseRoundsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>(GetOfferingCloseRoundsDocument, options);
      }
export function useGetOfferingCloseRoundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>(GetOfferingCloseRoundsDocument, options);
        }
// @ts-ignore
export function useGetOfferingCloseRoundsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>;
export function useGetOfferingCloseRoundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOfferingCloseRoundsQuery | undefined, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>;
export function useGetOfferingCloseRoundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>(GetOfferingCloseRoundsDocument, options);
        }
export type GetOfferingCloseRoundsQueryHookResult = ReturnType<typeof useGetOfferingCloseRoundsQuery>;
export type GetOfferingCloseRoundsLazyQueryHookResult = ReturnType<typeof useGetOfferingCloseRoundsLazyQuery>;
export type GetOfferingCloseRoundsSuspenseQueryHookResult = ReturnType<typeof useGetOfferingCloseRoundsSuspenseQuery>;
export type GetOfferingCloseRoundsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOfferingCloseRoundsQuery, GraphqlTypes.GetOfferingCloseRoundsQueryVariables>;
export const GetPaymentApplicationForPaymentBannerDocument = gql`
    query GetPaymentApplicationForPaymentBanner($arenaId: ID!) {
  paymentsApplication(objectType: ARENA, objectId: $arenaId) {
    id
  }
}
    `;

/**
 * __useGetPaymentApplicationForPaymentBannerQuery__
 *
 * To run a query within a React component, call `useGetPaymentApplicationForPaymentBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentApplicationForPaymentBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentApplicationForPaymentBannerQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPaymentApplicationForPaymentBannerQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables> & ({ variables: GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>(GetPaymentApplicationForPaymentBannerDocument, options);
      }
export function useGetPaymentApplicationForPaymentBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>(GetPaymentApplicationForPaymentBannerDocument, options);
        }
// @ts-ignore
export function useGetPaymentApplicationForPaymentBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>;
export function useGetPaymentApplicationForPaymentBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery | undefined, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>;
export function useGetPaymentApplicationForPaymentBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>(GetPaymentApplicationForPaymentBannerDocument, options);
        }
export type GetPaymentApplicationForPaymentBannerQueryHookResult = ReturnType<typeof useGetPaymentApplicationForPaymentBannerQuery>;
export type GetPaymentApplicationForPaymentBannerLazyQueryHookResult = ReturnType<typeof useGetPaymentApplicationForPaymentBannerLazyQuery>;
export type GetPaymentApplicationForPaymentBannerSuspenseQueryHookResult = ReturnType<typeof useGetPaymentApplicationForPaymentBannerSuspenseQuery>;
export type GetPaymentApplicationForPaymentBannerQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentApplicationForPaymentBannerQuery, GraphqlTypes.GetPaymentApplicationForPaymentBannerQueryVariables>;
export const ExportInvestmentsForConfigPreviewDocument = gql`
    mutation ExportInvestmentsForConfigPreview($input: ExportInvestmentsInput!) {
  exportInvestments(exportInvestmentsInput: $input) {
    __typename
    ... on ExportInvestmentsObject {
      job {
        id
        status
        downloadUrl
      }
    }
    ... on MutationErrorResponse {
      message
    }
  }
}
    `;
export type ExportInvestmentsForConfigPreviewMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportInvestmentsForConfigPreviewMutation, GraphqlTypes.ExportInvestmentsForConfigPreviewMutationVariables>;

/**
 * __useExportInvestmentsForConfigPreviewMutation__
 *
 * To run a mutation, you first call `useExportInvestmentsForConfigPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportInvestmentsForConfigPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportInvestmentsForConfigPreviewMutation, { data, loading, error }] = useExportInvestmentsForConfigPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportInvestmentsForConfigPreviewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportInvestmentsForConfigPreviewMutation, GraphqlTypes.ExportInvestmentsForConfigPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportInvestmentsForConfigPreviewMutation, GraphqlTypes.ExportInvestmentsForConfigPreviewMutationVariables>(ExportInvestmentsForConfigPreviewDocument, options);
      }
export type ExportInvestmentsForConfigPreviewMutationHookResult = ReturnType<typeof useExportInvestmentsForConfigPreviewMutation>;
export type ExportInvestmentsForConfigPreviewMutationResult = Apollo.MutationResult<GraphqlTypes.ExportInvestmentsForConfigPreviewMutation>;
export type ExportInvestmentsForConfigPreviewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportInvestmentsForConfigPreviewMutation, GraphqlTypes.ExportInvestmentsForConfigPreviewMutationVariables>;
export const PortalConfigInvestmentsExportJobStatusDocument = gql`
    query PortalConfigInvestmentsExportJobStatus($jobId: ID!) {
  investmentsExportJob(jobId: $jobId) {
    id
    status
    downloadUrl
  }
}
    `;

/**
 * __usePortalConfigInvestmentsExportJobStatusQuery__
 *
 * To run a query within a React component, call `usePortalConfigInvestmentsExportJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigInvestmentsExportJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalConfigInvestmentsExportJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function usePortalConfigInvestmentsExportJobStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables> & ({ variables: GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>(PortalConfigInvestmentsExportJobStatusDocument, options);
      }
export function usePortalConfigInvestmentsExportJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>(PortalConfigInvestmentsExportJobStatusDocument, options);
        }
// @ts-ignore
export function usePortalConfigInvestmentsExportJobStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>;
export function usePortalConfigInvestmentsExportJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery | undefined, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>;
export function usePortalConfigInvestmentsExportJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>(PortalConfigInvestmentsExportJobStatusDocument, options);
        }
export type PortalConfigInvestmentsExportJobStatusQueryHookResult = ReturnType<typeof usePortalConfigInvestmentsExportJobStatusQuery>;
export type PortalConfigInvestmentsExportJobStatusLazyQueryHookResult = ReturnType<typeof usePortalConfigInvestmentsExportJobStatusLazyQuery>;
export type PortalConfigInvestmentsExportJobStatusSuspenseQueryHookResult = ReturnType<typeof usePortalConfigInvestmentsExportJobStatusSuspenseQuery>;
export type PortalConfigInvestmentsExportJobStatusQueryResult = Apollo.QueryResult<GraphqlTypes.PortalConfigInvestmentsExportJobStatusQuery, GraphqlTypes.PortalConfigInvestmentsExportJobStatusQueryVariables>;
export const GetContactInvestmentsDocument = gql`
    query getContactInvestments($contactId: ID!, $status: [String!]) {
  contactInvestments(contactId: $contactId, status: $status) {
    objectId
    percentOwnership
    commitment {
      ...WalletFields
    }
    contributions {
      ...WalletFields
    }
    distributions {
      ...WalletFields
    }
    value {
      ...WalletFields
    }
    unfundedCommitment {
      ...WalletFields
    }
    totalExposure {
      ...WalletFields
    }
    equityBalance {
      ...WalletFields
    }
    redemptions {
      ...WalletFields
    }
    unitValue {
      ...WalletFields
    }
    units
    ownershipUnit {
      precisionPortal
    }
    irr
    irr1yr
    irr3yr
    irr5yr
    irr10yr
    dpi
    rvpi
    tvpi
    cocYield
    linkedObject {
      __typename
      ... on PositionObjectType {
        id
        performanceMetrics {
          irrEstimated
        }
        entityCurrency
        transactionTotals {
          lifetimeAmountCalled {
            ...WalletFields
          }
          lifetimeAmountCalledAgainstCommitment {
            ...WalletFields
          }
          totalOutstandingCapitalCalled {
            ...WalletFields
          }
          lifetimeAmountDistributed {
            ...WalletFields
          }
          lifetimeCapitalContributed {
            ...WalletFields
          }
          lifetimeCapitalContributedAgainstCommitment {
            ...WalletFields
          }
          lifetimeAmountRecalled {
            ...WalletFields
          }
          contributionsExcessCommitment {
            ...WalletFields
          }
          lifetimeCapitalOut {
            ...WalletFields
          }
          navBalance {
            ...WalletFields
          }
          lifetimeAmountReturned {
            ...WalletFields
          }
          lifetimeAmountPassedThrough {
            ...WalletFields
          }
          lifetimeWithheld {
            ...WalletFields
          }
          amountRecallable {
            ...WalletFields
          }
          accountValue {
            ...WalletFields
          }
          capitalAccountBalance {
            ...WalletFields
          }
          unitCount
        }
        extensionFields {
          extensionField {
            id
            name
            extensionFieldTypeId
          }
          values {
            stringValue
            intValue
            floatValue
            dateValue
            currencyValue {
              ...WalletFields
            }
            enumValue {
              enumValueLabel
            }
          }
        }
        account {
          name
          dataVaultCustomFields {
            extensionField {
              id
              name
              extensionFieldTypeId
            }
            values {
              stringValue
              intValue
              floatValue
              dateValue
              currencyValue {
                ...WalletFields
              }
              enumValue {
                enumValueLabel
              }
            }
          }
        }
        investmentEntity {
          id
          lpDisplayName
          status
          entityCollection {
            name
          }
          type {
            name
          }
          dataVaultCustomFields {
            extensionField {
              id
              name
              extensionFieldTypeId
            }
            values {
              stringValue
              intValue
              floatValue
              dateValue
              currencyValue {
                ...WalletFields
              }
              enumValue {
                enumValueLabel
              }
            }
          }
          publishedAssetsIndirect {
            edges {
              node {
                id
                locations {
                  edges {
                    node {
                      latitude
                      longitude
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${WalletFieldsFragmentDoc}`;

/**
 * __useGetContactInvestmentsQuery__
 *
 * To run a query within a React component, call `useGetContactInvestmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactInvestmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactInvestmentsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetContactInvestmentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables> & ({ variables: GraphqlTypes.GetContactInvestmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>(GetContactInvestmentsDocument, options);
      }
export function useGetContactInvestmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>(GetContactInvestmentsDocument, options);
        }
// @ts-ignore
export function useGetContactInvestmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>;
export function useGetContactInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactInvestmentsQuery | undefined, GraphqlTypes.GetContactInvestmentsQueryVariables>;
export function useGetContactInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>(GetContactInvestmentsDocument, options);
        }
export type GetContactInvestmentsQueryHookResult = ReturnType<typeof useGetContactInvestmentsQuery>;
export type GetContactInvestmentsLazyQueryHookResult = ReturnType<typeof useGetContactInvestmentsLazyQuery>;
export type GetContactInvestmentsSuspenseQueryHookResult = ReturnType<typeof useGetContactInvestmentsSuspenseQuery>;
export type GetContactInvestmentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactInvestmentsQuery, GraphqlTypes.GetContactInvestmentsQueryVariables>;
export const GetEntityCustomFieldsDocument = gql`
    query GetEntityCustomFields {
  accountExtensionFields: extensionFields(objectType: account) {
    id
    resourceId
    name
    objectType
    extensionFieldTypeId
    isMultivalued
    enumValues {
      id
      enumValueLabel
    }
  }
  positionExtensionFields: extensionFields(
    objectType: position
    isVisibleInPortal: true
  ) {
    id
    resourceId
    name
    objectType
    extensionFieldTypeId
    isMultivalued
    enumValues {
      id
      enumValueLabel
    }
  }
}
    `;

/**
 * __useGetEntityCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetEntityCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntityCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>(GetEntityCustomFieldsDocument, options);
      }
export function useGetEntityCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>(GetEntityCustomFieldsDocument, options);
        }
// @ts-ignore
export function useGetEntityCustomFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>;
export function useGetEntityCustomFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityCustomFieldsQuery | undefined, GraphqlTypes.GetEntityCustomFieldsQueryVariables>;
export function useGetEntityCustomFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>(GetEntityCustomFieldsDocument, options);
        }
export type GetEntityCustomFieldsQueryHookResult = ReturnType<typeof useGetEntityCustomFieldsQuery>;
export type GetEntityCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetEntityCustomFieldsLazyQuery>;
export type GetEntityCustomFieldsSuspenseQueryHookResult = ReturnType<typeof useGetEntityCustomFieldsSuspenseQuery>;
export type GetEntityCustomFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityCustomFieldsQuery, GraphqlTypes.GetEntityCustomFieldsQueryVariables>;
export const GetContactInvestmentsFieldsForInvestmentPageDocument = gql`
    query GetContactInvestmentsFieldsForInvestmentPage {
  contactInvestmentsFields {
    fieldName
    label
  }
}
    `;

/**
 * __useGetContactInvestmentsFieldsForInvestmentPageQuery__
 *
 * To run a query within a React component, call `useGetContactInvestmentsFieldsForInvestmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactInvestmentsFieldsForInvestmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactInvestmentsFieldsForInvestmentPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactInvestmentsFieldsForInvestmentPageQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>(GetContactInvestmentsFieldsForInvestmentPageDocument, options);
      }
export function useGetContactInvestmentsFieldsForInvestmentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>(GetContactInvestmentsFieldsForInvestmentPageDocument, options);
        }
// @ts-ignore
export function useGetContactInvestmentsFieldsForInvestmentPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>;
export function useGetContactInvestmentsFieldsForInvestmentPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery | undefined, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>;
export function useGetContactInvestmentsFieldsForInvestmentPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>(GetContactInvestmentsFieldsForInvestmentPageDocument, options);
        }
export type GetContactInvestmentsFieldsForInvestmentPageQueryHookResult = ReturnType<typeof useGetContactInvestmentsFieldsForInvestmentPageQuery>;
export type GetContactInvestmentsFieldsForInvestmentPageLazyQueryHookResult = ReturnType<typeof useGetContactInvestmentsFieldsForInvestmentPageLazyQuery>;
export type GetContactInvestmentsFieldsForInvestmentPageSuspenseQueryHookResult = ReturnType<typeof useGetContactInvestmentsFieldsForInvestmentPageSuspenseQuery>;
export type GetContactInvestmentsFieldsForInvestmentPageQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQuery, GraphqlTypes.GetContactInvestmentsFieldsForInvestmentPageQueryVariables>;
export const GetCurrentUserPortalExportAccessDocument = gql`
    query GetCurrentUserPortalExportAccess {
  currentUser {
    id
    canManagePortal
    hasAnyAccessibleContacts
  }
}
    `;

/**
 * __useGetCurrentUserPortalExportAccessQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserPortalExportAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserPortalExportAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserPortalExportAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserPortalExportAccessQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>(GetCurrentUserPortalExportAccessDocument, options);
      }
export function useGetCurrentUserPortalExportAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>(GetCurrentUserPortalExportAccessDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserPortalExportAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>;
export function useGetCurrentUserPortalExportAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserPortalExportAccessQuery | undefined, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>;
export function useGetCurrentUserPortalExportAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>(GetCurrentUserPortalExportAccessDocument, options);
        }
export type GetCurrentUserPortalExportAccessQueryHookResult = ReturnType<typeof useGetCurrentUserPortalExportAccessQuery>;
export type GetCurrentUserPortalExportAccessLazyQueryHookResult = ReturnType<typeof useGetCurrentUserPortalExportAccessLazyQuery>;
export type GetCurrentUserPortalExportAccessSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserPortalExportAccessSuspenseQuery>;
export type GetCurrentUserPortalExportAccessQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentUserPortalExportAccessQuery, GraphqlTypes.GetCurrentUserPortalExportAccessQueryVariables>;
export const GetContactAllocationChartDataDocument = gql`
    query getContactAllocationChartData($contactId: ID!, $status: [String!], $accounts: [String!]) {
  contactAllocationChartData(
    contactId: $contactId
    status: $status
    accounts: $accounts
  ) {
    productTypeChartData {
      label
      value
    }
    geoChartData {
      label
      value
    }
  }
}
    `;

/**
 * __useGetContactAllocationChartDataQuery__
 *
 * To run a query within a React component, call `useGetContactAllocationChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactAllocationChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactAllocationChartDataQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      status: // value for 'status'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useGetContactAllocationChartDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables> & ({ variables: GraphqlTypes.GetContactAllocationChartDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>(GetContactAllocationChartDataDocument, options);
      }
export function useGetContactAllocationChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>(GetContactAllocationChartDataDocument, options);
        }
// @ts-ignore
export function useGetContactAllocationChartDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>;
export function useGetContactAllocationChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactAllocationChartDataQuery | undefined, GraphqlTypes.GetContactAllocationChartDataQueryVariables>;
export function useGetContactAllocationChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>(GetContactAllocationChartDataDocument, options);
        }
export type GetContactAllocationChartDataQueryHookResult = ReturnType<typeof useGetContactAllocationChartDataQuery>;
export type GetContactAllocationChartDataLazyQueryHookResult = ReturnType<typeof useGetContactAllocationChartDataLazyQuery>;
export type GetContactAllocationChartDataSuspenseQueryHookResult = ReturnType<typeof useGetContactAllocationChartDataSuspenseQuery>;
export type GetContactAllocationChartDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactAllocationChartDataQuery, GraphqlTypes.GetContactAllocationChartDataQueryVariables>;
export const GetContactCashflowHistoryDataDocument = gql`
    query getContactCashflowHistoryData($contactId: ID!, $status: [String!], $accounts: [String!], $currency: CurrencyCode) {
  contactCashflowHistoryData(
    contactId: $contactId
    status: $status
    accounts: $accounts
    currency: $currency
  ) {
    ...CashFlowHistoryData
  }
}
    ${CashFlowHistoryDataFragmentDoc}`;

/**
 * __useGetContactCashflowHistoryDataQuery__
 *
 * To run a query within a React component, call `useGetContactCashflowHistoryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCashflowHistoryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCashflowHistoryDataQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      status: // value for 'status'
 *      accounts: // value for 'accounts'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetContactCashflowHistoryDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables> & ({ variables: GraphqlTypes.GetContactCashflowHistoryDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>(GetContactCashflowHistoryDataDocument, options);
      }
export function useGetContactCashflowHistoryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>(GetContactCashflowHistoryDataDocument, options);
        }
// @ts-ignore
export function useGetContactCashflowHistoryDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>;
export function useGetContactCashflowHistoryDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactCashflowHistoryDataQuery | undefined, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>;
export function useGetContactCashflowHistoryDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>(GetContactCashflowHistoryDataDocument, options);
        }
export type GetContactCashflowHistoryDataQueryHookResult = ReturnType<typeof useGetContactCashflowHistoryDataQuery>;
export type GetContactCashflowHistoryDataLazyQueryHookResult = ReturnType<typeof useGetContactCashflowHistoryDataLazyQuery>;
export type GetContactCashflowHistoryDataSuspenseQueryHookResult = ReturnType<typeof useGetContactCashflowHistoryDataSuspenseQuery>;
export type GetContactCashflowHistoryDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactCashflowHistoryDataQuery, GraphqlTypes.GetContactCashflowHistoryDataQueryVariables>;
export const UpdatePortalLayoutConfigDocument = gql`
    mutation UpdatePortalLayoutConfig($input: UpdatePortalLayoutConfigInput!) {
  updatePortalLayoutConfig(input: $input) {
    portalLayoutConfigs {
      id
      component
      visible
      createdAt
      modifiedAt
    }
  }
}
    `;
export type UpdatePortalLayoutConfigMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePortalLayoutConfigMutation, GraphqlTypes.UpdatePortalLayoutConfigMutationVariables>;

/**
 * __useUpdatePortalLayoutConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePortalLayoutConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortalLayoutConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortalLayoutConfigMutation, { data, loading, error }] = useUpdatePortalLayoutConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePortalLayoutConfigMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePortalLayoutConfigMutation, GraphqlTypes.UpdatePortalLayoutConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePortalLayoutConfigMutation, GraphqlTypes.UpdatePortalLayoutConfigMutationVariables>(UpdatePortalLayoutConfigDocument, options);
      }
export type UpdatePortalLayoutConfigMutationHookResult = ReturnType<typeof useUpdatePortalLayoutConfigMutation>;
export type UpdatePortalLayoutConfigMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePortalLayoutConfigMutation>;
export type UpdatePortalLayoutConfigMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePortalLayoutConfigMutation, GraphqlTypes.UpdatePortalLayoutConfigMutationVariables>;
export const GetPortalLayoutConfigDocument = gql`
    query GetPortalLayoutConfig($arenaId: ID!) {
  portalLayoutConfig(arenaId: $arenaId) {
    id
    component
    visible
    createdAt
    modifiedAt
  }
}
    `;

/**
 * __useGetPortalLayoutConfigQuery__
 *
 * To run a query within a React component, call `useGetPortalLayoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalLayoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalLayoutConfigQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPortalLayoutConfigQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables> & ({ variables: GraphqlTypes.GetPortalLayoutConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>(GetPortalLayoutConfigDocument, options);
      }
export function useGetPortalLayoutConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>(GetPortalLayoutConfigDocument, options);
        }
// @ts-ignore
export function useGetPortalLayoutConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>;
export function useGetPortalLayoutConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalLayoutConfigQuery | undefined, GraphqlTypes.GetPortalLayoutConfigQueryVariables>;
export function useGetPortalLayoutConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>(GetPortalLayoutConfigDocument, options);
        }
export type GetPortalLayoutConfigQueryHookResult = ReturnType<typeof useGetPortalLayoutConfigQuery>;
export type GetPortalLayoutConfigLazyQueryHookResult = ReturnType<typeof useGetPortalLayoutConfigLazyQuery>;
export type GetPortalLayoutConfigSuspenseQueryHookResult = ReturnType<typeof useGetPortalLayoutConfigSuspenseQuery>;
export type GetPortalLayoutConfigQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalLayoutConfigQuery, GraphqlTypes.GetPortalLayoutConfigQueryVariables>;
export const AddContactToPositionDocument = gql`
    mutation AddContactToPosition($input: AddContactToPositionInput!) {
  addContactToPosition(input: $input) {
    ... on PositionAcmMapObjectType {
      ...PositionAcmMapFields
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    ${PositionAcmMapFieldsFragmentDoc}`;
export type AddContactToPositionMutationFn = Apollo.MutationFunction<GraphqlTypes.AddContactToPositionMutation, GraphqlTypes.AddContactToPositionMutationVariables>;

/**
 * __useAddContactToPositionMutation__
 *
 * To run a mutation, you first call `useAddContactToPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactToPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactToPositionMutation, { data, loading, error }] = useAddContactToPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContactToPositionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddContactToPositionMutation, GraphqlTypes.AddContactToPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddContactToPositionMutation, GraphqlTypes.AddContactToPositionMutationVariables>(AddContactToPositionDocument, options);
      }
export type AddContactToPositionMutationHookResult = ReturnType<typeof useAddContactToPositionMutation>;
export type AddContactToPositionMutationResult = Apollo.MutationResult<GraphqlTypes.AddContactToPositionMutation>;
export type AddContactToPositionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddContactToPositionMutation, GraphqlTypes.AddContactToPositionMutationVariables>;
export const AddContactsToPositionBulkDocument = gql`
    mutation AddContactsToPositionBulk($input: AddContactsToPositionBulkInput!) {
  addContactsToPositionBulk(input: $input) {
    ... on AddContactsToPositionBulkPayload {
      positionAcmMaps {
        id
      }
      skippedPams {
        sourcePamId
        message
        errorCode
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type AddContactsToPositionBulkMutationFn = Apollo.MutationFunction<GraphqlTypes.AddContactsToPositionBulkMutation, GraphqlTypes.AddContactsToPositionBulkMutationVariables>;

/**
 * __useAddContactsToPositionBulkMutation__
 *
 * To run a mutation, you first call `useAddContactsToPositionBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactsToPositionBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactsToPositionBulkMutation, { data, loading, error }] = useAddContactsToPositionBulkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContactsToPositionBulkMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddContactsToPositionBulkMutation, GraphqlTypes.AddContactsToPositionBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddContactsToPositionBulkMutation, GraphqlTypes.AddContactsToPositionBulkMutationVariables>(AddContactsToPositionBulkDocument, options);
      }
export type AddContactsToPositionBulkMutationHookResult = ReturnType<typeof useAddContactsToPositionBulkMutation>;
export type AddContactsToPositionBulkMutationResult = Apollo.MutationResult<GraphqlTypes.AddContactsToPositionBulkMutation>;
export type AddContactsToPositionBulkMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddContactsToPositionBulkMutation, GraphqlTypes.AddContactsToPositionBulkMutationVariables>;
export const RemoveContactFromPositionDocument = gql`
    mutation RemoveContactFromPosition($positionAcmMapId: ID!) {
  removeContactFromPosition(positionAcmMapId: $positionAcmMapId) {
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type RemoveContactFromPositionMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveContactFromPositionMutation, GraphqlTypes.RemoveContactFromPositionMutationVariables>;

/**
 * __useRemoveContactFromPositionMutation__
 *
 * To run a mutation, you first call `useRemoveContactFromPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactFromPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactFromPositionMutation, { data, loading, error }] = useRemoveContactFromPositionMutation({
 *   variables: {
 *      positionAcmMapId: // value for 'positionAcmMapId'
 *   },
 * });
 */
export function useRemoveContactFromPositionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveContactFromPositionMutation, GraphqlTypes.RemoveContactFromPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveContactFromPositionMutation, GraphqlTypes.RemoveContactFromPositionMutationVariables>(RemoveContactFromPositionDocument, options);
      }
export type RemoveContactFromPositionMutationHookResult = ReturnType<typeof useRemoveContactFromPositionMutation>;
export type RemoveContactFromPositionMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveContactFromPositionMutation>;
export type RemoveContactFromPositionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveContactFromPositionMutation, GraphqlTypes.RemoveContactFromPositionMutationVariables>;
export const PositionAcmMapsByIdsDocument = gql`
    query PositionAcmMapsByIds($ids: [ID!]!) {
  positionAcmMapsByIds(input: {ids: $ids}) {
    id
    lpAccessRoleGrants {
      communicationPref
      lpAccessRole {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePositionAcmMapsByIdsQuery__
 *
 * To run a query within a React component, call `usePositionAcmMapsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionAcmMapsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionAcmMapsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePositionAcmMapsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables> & ({ variables: GraphqlTypes.PositionAcmMapsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>(PositionAcmMapsByIdsDocument, options);
      }
export function usePositionAcmMapsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>(PositionAcmMapsByIdsDocument, options);
        }
// @ts-ignore
export function usePositionAcmMapsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>;
export function usePositionAcmMapsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PositionAcmMapsByIdsQuery | undefined, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>;
export function usePositionAcmMapsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>(PositionAcmMapsByIdsDocument, options);
        }
export type PositionAcmMapsByIdsQueryHookResult = ReturnType<typeof usePositionAcmMapsByIdsQuery>;
export type PositionAcmMapsByIdsLazyQueryHookResult = ReturnType<typeof usePositionAcmMapsByIdsLazyQuery>;
export type PositionAcmMapsByIdsSuspenseQueryHookResult = ReturnType<typeof usePositionAcmMapsByIdsSuspenseQuery>;
export type PositionAcmMapsByIdsQueryResult = Apollo.QueryResult<GraphqlTypes.PositionAcmMapsByIdsQuery, GraphqlTypes.PositionAcmMapsByIdsQueryVariables>;
export const AccountNameDocument = gql`
    query AccountName($accountId: ID!) {
  accounts(accountFilters: {ids: [$accountId]}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAccountNameQuery__
 *
 * To run a query within a React component, call `useAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountNameQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountNameQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables> & ({ variables: GraphqlTypes.AccountNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>(AccountNameDocument, options);
      }
export function useAccountNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>(AccountNameDocument, options);
        }
// @ts-ignore
export function useAccountNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>;
export function useAccountNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AccountNameQuery | undefined, GraphqlTypes.AccountNameQueryVariables>;
export function useAccountNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>(AccountNameDocument, options);
        }
export type AccountNameQueryHookResult = ReturnType<typeof useAccountNameQuery>;
export type AccountNameLazyQueryHookResult = ReturnType<typeof useAccountNameLazyQuery>;
export type AccountNameSuspenseQueryHookResult = ReturnType<typeof useAccountNameSuspenseQuery>;
export type AccountNameQueryResult = Apollo.QueryResult<GraphqlTypes.AccountNameQuery, GraphqlTypes.AccountNameQueryVariables>;
export const GetPositionAddCandidatesDocument = gql`
    query GetPositionAddCandidates($accountId: ID!, $first: Int!, $cursor: String, $filters: PscmAccountContactsFilters) {
  accountContactsPrefs(
    accountId: $accountId
    first: $first
    cursor: $cursor
    filters: $filters
  ) {
    pageInfo {
      hasNextPage
      nextCursor
    }
    contacts {
      id
      contactId
      label {
        labelText
      }
      contact {
        id
        fullName
        contactType
        companyName
        primaryEmail {
          emailAddress
        }
      }
      labelGroup {
        id
        displayName
        displayOrder
      }
      positionAcmMaps {
        id
        position {
          id
          investmentEntity {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPositionAddCandidatesQuery__
 *
 * To run a query within a React component, call `useGetPositionAddCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionAddCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionAddCandidatesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPositionAddCandidatesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables> & ({ variables: GraphqlTypes.GetPositionAddCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>(GetPositionAddCandidatesDocument, options);
      }
export function useGetPositionAddCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>(GetPositionAddCandidatesDocument, options);
        }
// @ts-ignore
export function useGetPositionAddCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>;
export function useGetPositionAddCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionAddCandidatesQuery | undefined, GraphqlTypes.GetPositionAddCandidatesQueryVariables>;
export function useGetPositionAddCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>(GetPositionAddCandidatesDocument, options);
        }
export type GetPositionAddCandidatesQueryHookResult = ReturnType<typeof useGetPositionAddCandidatesQuery>;
export type GetPositionAddCandidatesLazyQueryHookResult = ReturnType<typeof useGetPositionAddCandidatesLazyQuery>;
export type GetPositionAddCandidatesSuspenseQueryHookResult = ReturnType<typeof useGetPositionAddCandidatesSuspenseQuery>;
export type GetPositionAddCandidatesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionAddCandidatesQuery, GraphqlTypes.GetPositionAddCandidatesQueryVariables>;
export const GetPositionOverviewSearchedContactsDocument = gql`
    query GetPositionOverviewSearchedContacts($term: String!, $excludeContactIds: [ID], $accountIds: [ID!]!) {
  searchedContacts(term: $term, excludeContactIds: $excludeContactIds) {
    result {
      id
      label
      isOrg
      primaryEmail {
        emailAddress
      }
      accountContactMapsByAccountIds(accountIds: $accountIds) {
        id
        positionAcmMaps {
          id
          position {
            id
            investmentEntity {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPositionOverviewSearchedContactsQuery__
 *
 * To run a query within a React component, call `useGetPositionOverviewSearchedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionOverviewSearchedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionOverviewSearchedContactsQuery({
 *   variables: {
 *      term: // value for 'term'
 *      excludeContactIds: // value for 'excludeContactIds'
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useGetPositionOverviewSearchedContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables> & ({ variables: GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>(GetPositionOverviewSearchedContactsDocument, options);
      }
export function useGetPositionOverviewSearchedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>(GetPositionOverviewSearchedContactsDocument, options);
        }
// @ts-ignore
export function useGetPositionOverviewSearchedContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>;
export function useGetPositionOverviewSearchedContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionOverviewSearchedContactsQuery | undefined, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>;
export function useGetPositionOverviewSearchedContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>(GetPositionOverviewSearchedContactsDocument, options);
        }
export type GetPositionOverviewSearchedContactsQueryHookResult = ReturnType<typeof useGetPositionOverviewSearchedContactsQuery>;
export type GetPositionOverviewSearchedContactsLazyQueryHookResult = ReturnType<typeof useGetPositionOverviewSearchedContactsLazyQuery>;
export type GetPositionOverviewSearchedContactsSuspenseQueryHookResult = ReturnType<typeof useGetPositionOverviewSearchedContactsSuspenseQuery>;
export type GetPositionOverviewSearchedContactsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionOverviewSearchedContactsQuery, GraphqlTypes.GetPositionOverviewSearchedContactsQueryVariables>;
export const AddFromPositionSourcePositionsDocument = gql`
    query AddFromPositionSourcePositions($accountId: ID!, $excludePositionId: ID!, $keyword: String, $positionListCursor: String, $contactCursor: String) {
  accountPositionContacts(
    accountId: $accountId
    excludePositionId: $excludePositionId
    keyword: $keyword
    cursor: $positionListCursor
  ) {
    positions {
      position {
        id
        investmentEntity {
          id
          name
        }
      }
      totalContacts
      matchedContacts
      contacts(cursor: $contactCursor) {
        contacts {
          id
          lpAccessRoleGrants {
            communicationPref
            lpAccessRole {
              id
              name
            }
          }
          accountContactMap {
            id
            contact {
              id
              fullName
              companyName
              primaryEmail {
                emailAddress
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          totalContacts
          firstCursor
          prevCursor
          nextCursor
          lastCursor
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalPositions
      firstCursor
      prevCursor
      nextCursor
      lastCursor
    }
  }
}
    `;

/**
 * __useAddFromPositionSourcePositionsQuery__
 *
 * To run a query within a React component, call `useAddFromPositionSourcePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddFromPositionSourcePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddFromPositionSourcePositionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      excludePositionId: // value for 'excludePositionId'
 *      keyword: // value for 'keyword'
 *      positionListCursor: // value for 'positionListCursor'
 *      contactCursor: // value for 'contactCursor'
 *   },
 * });
 */
export function useAddFromPositionSourcePositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables> & ({ variables: GraphqlTypes.AddFromPositionSourcePositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>(AddFromPositionSourcePositionsDocument, options);
      }
export function useAddFromPositionSourcePositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>(AddFromPositionSourcePositionsDocument, options);
        }
// @ts-ignore
export function useAddFromPositionSourcePositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>;
export function useAddFromPositionSourcePositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AddFromPositionSourcePositionsQuery | undefined, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>;
export function useAddFromPositionSourcePositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>(AddFromPositionSourcePositionsDocument, options);
        }
export type AddFromPositionSourcePositionsQueryHookResult = ReturnType<typeof useAddFromPositionSourcePositionsQuery>;
export type AddFromPositionSourcePositionsLazyQueryHookResult = ReturnType<typeof useAddFromPositionSourcePositionsLazyQuery>;
export type AddFromPositionSourcePositionsSuspenseQueryHookResult = ReturnType<typeof useAddFromPositionSourcePositionsSuspenseQuery>;
export type AddFromPositionSourcePositionsQueryResult = Apollo.QueryResult<GraphqlTypes.AddFromPositionSourcePositionsQuery, GraphqlTypes.AddFromPositionSourcePositionsQueryVariables>;
export const GetEntityPositionTotalsDocument = gql`
    query GetEntityPositionTotals($accountId: ID!) {
  positionTotals(accountId: $accountId) {
    entityTotal {
      ...PositionTotalsRowFields
    }
    investorGroupTotals {
      ...PositionTotalsRowFields
    }
  }
}
    ${PositionTotalsRowFieldsFragmentDoc}`;

/**
 * __useGetEntityPositionTotalsQuery__
 *
 * To run a query within a React component, call `useGetEntityPositionTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityPositionTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityPositionTotalsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetEntityPositionTotalsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables> & ({ variables: GraphqlTypes.GetEntityPositionTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>(GetEntityPositionTotalsDocument, options);
      }
export function useGetEntityPositionTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>(GetEntityPositionTotalsDocument, options);
        }
// @ts-ignore
export function useGetEntityPositionTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>;
export function useGetEntityPositionTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPositionTotalsQuery | undefined, GraphqlTypes.GetEntityPositionTotalsQueryVariables>;
export function useGetEntityPositionTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>(GetEntityPositionTotalsDocument, options);
        }
export type GetEntityPositionTotalsQueryHookResult = ReturnType<typeof useGetEntityPositionTotalsQuery>;
export type GetEntityPositionTotalsLazyQueryHookResult = ReturnType<typeof useGetEntityPositionTotalsLazyQuery>;
export type GetEntityPositionTotalsSuspenseQueryHookResult = ReturnType<typeof useGetEntityPositionTotalsSuspenseQuery>;
export type GetEntityPositionTotalsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityPositionTotalsQuery, GraphqlTypes.GetEntityPositionTotalsQueryVariables>;
export const GetPreqinContactDataDocument = gql`
    query GetPreqinContactData($firmId: Int!) {
  preqinContactData(firmId: $firmId) {
    preqinLink
    firmName
    firmType
    assetClasses
    aum
    location
    address
    phone
    about
    yearEstablished
    staffCount
    peAllocationUsdMn
    peAllocationPct
    reAllocationUsdMn
    reAllocationPct
    hfAllocationUsdMn
    hfAllocationPct
    infAllocationUsdMn
    infAllocationPct
    pdAllocationUsdMn
    pdAllocationPct
    nrAllocationUsdMn
    nrAllocationPct
    lastUpdated
    syncStatus
    staffMembers {
      firstName
      lastName
      role
      email
      phone
      location
      linkedin
    }
  }
}
    `;

/**
 * __useGetPreqinContactDataQuery__
 *
 * To run a query within a React component, call `useGetPreqinContactDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreqinContactDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreqinContactDataQuery({
 *   variables: {
 *      firmId: // value for 'firmId'
 *   },
 * });
 */
export function useGetPreqinContactDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables> & ({ variables: GraphqlTypes.GetPreqinContactDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>(GetPreqinContactDataDocument, options);
      }
export function useGetPreqinContactDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>(GetPreqinContactDataDocument, options);
        }
// @ts-ignore
export function useGetPreqinContactDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>;
export function useGetPreqinContactDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreqinContactDataQuery | undefined, GraphqlTypes.GetPreqinContactDataQueryVariables>;
export function useGetPreqinContactDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>(GetPreqinContactDataDocument, options);
        }
export type GetPreqinContactDataQueryHookResult = ReturnType<typeof useGetPreqinContactDataQuery>;
export type GetPreqinContactDataLazyQueryHookResult = ReturnType<typeof useGetPreqinContactDataLazyQuery>;
export type GetPreqinContactDataSuspenseQueryHookResult = ReturnType<typeof useGetPreqinContactDataSuspenseQuery>;
export type GetPreqinContactDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetPreqinContactDataQuery, GraphqlTypes.GetPreqinContactDataQueryVariables>;
export const CreateBulkContactsDocument = gql`
    mutation CreateBulkContacts($contactsInput: CreateMultipleContactsInput!) {
  createContacts(contactsInput: $contactsInput) {
    ... on CreateMultipleContactsResponse {
      successfulContacts {
        id
        firstName
        lastName
        jobTitle
      }
      failedContacts
      errorMessage
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type CreateBulkContactsMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateBulkContactsMutation, GraphqlTypes.CreateBulkContactsMutationVariables>;

/**
 * __useCreateBulkContactsMutation__
 *
 * To run a mutation, you first call `useCreateBulkContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkContactsMutation, { data, loading, error }] = useCreateBulkContactsMutation({
 *   variables: {
 *      contactsInput: // value for 'contactsInput'
 *   },
 * });
 */
export function useCreateBulkContactsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateBulkContactsMutation, GraphqlTypes.CreateBulkContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateBulkContactsMutation, GraphqlTypes.CreateBulkContactsMutationVariables>(CreateBulkContactsDocument, options);
      }
export type CreateBulkContactsMutationHookResult = ReturnType<typeof useCreateBulkContactsMutation>;
export type CreateBulkContactsMutationResult = Apollo.MutationResult<GraphqlTypes.CreateBulkContactsMutation>;
export type CreateBulkContactsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateBulkContactsMutation, GraphqlTypes.CreateBulkContactsMutationVariables>;
export const GetDashboardsByEmbedLocationDocument = gql`
    query getDashboardsByEmbedLocation($arenaId: Int!, $embedLocation: String!) {
  getDashboardsByEmbedLocation(
    objectInput: {arenaId: $arenaId, embedLocation: $embedLocation}
  ) {
    id
  }
}
    `;

/**
 * __useGetDashboardsByEmbedLocationQuery__
 *
 * To run a query within a React component, call `useGetDashboardsByEmbedLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardsByEmbedLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardsByEmbedLocationQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      embedLocation: // value for 'embedLocation'
 *   },
 * });
 */
export function useGetDashboardsByEmbedLocationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables> & ({ variables: GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>(GetDashboardsByEmbedLocationDocument, options);
      }
export function useGetDashboardsByEmbedLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>(GetDashboardsByEmbedLocationDocument, options);
        }
// @ts-ignore
export function useGetDashboardsByEmbedLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>;
export function useGetDashboardsByEmbedLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDashboardsByEmbedLocationQuery | undefined, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>;
export function useGetDashboardsByEmbedLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>(GetDashboardsByEmbedLocationDocument, options);
        }
export type GetDashboardsByEmbedLocationQueryHookResult = ReturnType<typeof useGetDashboardsByEmbedLocationQuery>;
export type GetDashboardsByEmbedLocationLazyQueryHookResult = ReturnType<typeof useGetDashboardsByEmbedLocationLazyQuery>;
export type GetDashboardsByEmbedLocationSuspenseQueryHookResult = ReturnType<typeof useGetDashboardsByEmbedLocationSuspenseQuery>;
export type GetDashboardsByEmbedLocationQueryResult = Apollo.QueryResult<GraphqlTypes.GetDashboardsByEmbedLocationQuery, GraphqlTypes.GetDashboardsByEmbedLocationQueryVariables>;
export const StartDashboardDataBackfillDocument = gql`
    mutation StartDashboardDataBackfill {
  startDashboardDataBackfill {
    __typename
    ... on StartDashboardDataBackfillResult {
      status
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type StartDashboardDataBackfillMutationFn = Apollo.MutationFunction<GraphqlTypes.StartDashboardDataBackfillMutation, GraphqlTypes.StartDashboardDataBackfillMutationVariables>;

/**
 * __useStartDashboardDataBackfillMutation__
 *
 * To run a mutation, you first call `useStartDashboardDataBackfillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDashboardDataBackfillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDashboardDataBackfillMutation, { data, loading, error }] = useStartDashboardDataBackfillMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartDashboardDataBackfillMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartDashboardDataBackfillMutation, GraphqlTypes.StartDashboardDataBackfillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartDashboardDataBackfillMutation, GraphqlTypes.StartDashboardDataBackfillMutationVariables>(StartDashboardDataBackfillDocument, options);
      }
export type StartDashboardDataBackfillMutationHookResult = ReturnType<typeof useStartDashboardDataBackfillMutation>;
export type StartDashboardDataBackfillMutationResult = Apollo.MutationResult<GraphqlTypes.StartDashboardDataBackfillMutation>;
export type StartDashboardDataBackfillMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartDashboardDataBackfillMutation, GraphqlTypes.StartDashboardDataBackfillMutationVariables>;
export const CreateOrUpdateNoteDocument = gql`
    mutation CreateOrUpdateNote($noteInput: NoteInput!) {
  createOrUpdateNote(noteInput: $noteInput) {
    __typename
    ... on NoteObjectType {
      id
      noteType
      summary
      text
      location
      date
      time
      bodyHtml
      bodyText
      owner {
        id
        fullName
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type CreateOrUpdateNoteMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdateNoteMutation, GraphqlTypes.CreateOrUpdateNoteMutationVariables>;

/**
 * __useCreateOrUpdateNoteMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateNoteMutation, { data, loading, error }] = useCreateOrUpdateNoteMutation({
 *   variables: {
 *      noteInput: // value for 'noteInput'
 *   },
 * });
 */
export function useCreateOrUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdateNoteMutation, GraphqlTypes.CreateOrUpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdateNoteMutation, GraphqlTypes.CreateOrUpdateNoteMutationVariables>(CreateOrUpdateNoteDocument, options);
      }
export type CreateOrUpdateNoteMutationHookResult = ReturnType<typeof useCreateOrUpdateNoteMutation>;
export type CreateOrUpdateNoteMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdateNoteMutation>;
export type CreateOrUpdateNoteMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdateNoteMutation, GraphqlTypes.CreateOrUpdateNoteMutationVariables>;
export const GetDashboardDataBackfillStatusDocument = gql`
    query GetDashboardDataBackfillStatus {
  dashboardBackfillStatus {
    __typename
    ... on DashboardBackfillStatusResult {
      status
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetDashboardDataBackfillStatusQuery__
 *
 * To run a query within a React component, call `useGetDashboardDataBackfillStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardDataBackfillStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardDataBackfillStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardDataBackfillStatusQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>(GetDashboardDataBackfillStatusDocument, options);
      }
export function useGetDashboardDataBackfillStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>(GetDashboardDataBackfillStatusDocument, options);
        }
// @ts-ignore
export function useGetDashboardDataBackfillStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>;
export function useGetDashboardDataBackfillStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDashboardDataBackfillStatusQuery | undefined, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>;
export function useGetDashboardDataBackfillStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>(GetDashboardDataBackfillStatusDocument, options);
        }
export type GetDashboardDataBackfillStatusQueryHookResult = ReturnType<typeof useGetDashboardDataBackfillStatusQuery>;
export type GetDashboardDataBackfillStatusLazyQueryHookResult = ReturnType<typeof useGetDashboardDataBackfillStatusLazyQuery>;
export type GetDashboardDataBackfillStatusSuspenseQueryHookResult = ReturnType<typeof useGetDashboardDataBackfillStatusSuspenseQuery>;
export type GetDashboardDataBackfillStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetDashboardDataBackfillStatusQuery, GraphqlTypes.GetDashboardDataBackfillStatusQueryVariables>;
export const GetSourcesDocument = gql`
    query getSources($arenaId: GlobalID!) {
  sources(arenaId: $arenaId) {
    id
    name
    subName
    mappingGroups {
      id
      name
      mappingType
      baseMapping {
        ...MappingFields
      }
      mappingOverrides {
        ...MappingFields
      }
    }
  }
}
    ${MappingFieldsFragmentDoc}`;

/**
 * __useGetSourcesQuery__
 *
 * To run a query within a React component, call `useGetSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetSourcesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables> & ({ variables: GraphqlTypes.GetSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>(GetSourcesDocument, options);
      }
export function useGetSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>(GetSourcesDocument, options);
        }
// @ts-ignore
export function useGetSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>;
export function useGetSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSourcesQuery | undefined, GraphqlTypes.GetSourcesQueryVariables>;
export function useGetSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>(GetSourcesDocument, options);
        }
export type GetSourcesQueryHookResult = ReturnType<typeof useGetSourcesQuery>;
export type GetSourcesLazyQueryHookResult = ReturnType<typeof useGetSourcesLazyQuery>;
export type GetSourcesSuspenseQueryHookResult = ReturnType<typeof useGetSourcesSuspenseQuery>;
export type GetSourcesQueryResult = Apollo.QueryResult<GraphqlTypes.GetSourcesQuery, GraphqlTypes.GetSourcesQueryVariables>;
export const GetSourceDataTypesDocument = gql`
    query GetSourceDataTypes($sourceId: GlobalID!, $arenaId: GlobalID!) {
  sourceDataTypes(sourceId: $sourceId, arenaId: $arenaId)
}
    `;

/**
 * __useGetSourceDataTypesQuery__
 *
 * To run a query within a React component, call `useGetSourceDataTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceDataTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceDataTypesQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetSourceDataTypesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables> & ({ variables: GraphqlTypes.GetSourceDataTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>(GetSourceDataTypesDocument, options);
      }
export function useGetSourceDataTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>(GetSourceDataTypesDocument, options);
        }
// @ts-ignore
export function useGetSourceDataTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>;
export function useGetSourceDataTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSourceDataTypesQuery | undefined, GraphqlTypes.GetSourceDataTypesQueryVariables>;
export function useGetSourceDataTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>(GetSourceDataTypesDocument, options);
        }
export type GetSourceDataTypesQueryHookResult = ReturnType<typeof useGetSourceDataTypesQuery>;
export type GetSourceDataTypesLazyQueryHookResult = ReturnType<typeof useGetSourceDataTypesLazyQuery>;
export type GetSourceDataTypesSuspenseQueryHookResult = ReturnType<typeof useGetSourceDataTypesSuspenseQuery>;
export type GetSourceDataTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetSourceDataTypesQuery, GraphqlTypes.GetSourceDataTypesQueryVariables>;
export const ProcessTransactionMappingFileDocument = gql`
    mutation processTransactionMappingFile($input: ProcessTransactionMappingInput!) {
  processTransactionMappingFile(input: $input) {
    success
    error {
      errorType
      errorMessage
      rows
    }
  }
}
    `;
export type ProcessTransactionMappingFileMutationFn = Apollo.MutationFunction<GraphqlTypes.ProcessTransactionMappingFileMutation, GraphqlTypes.ProcessTransactionMappingFileMutationVariables>;

/**
 * __useProcessTransactionMappingFileMutation__
 *
 * To run a mutation, you first call `useProcessTransactionMappingFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessTransactionMappingFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processTransactionMappingFileMutation, { data, loading, error }] = useProcessTransactionMappingFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessTransactionMappingFileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ProcessTransactionMappingFileMutation, GraphqlTypes.ProcessTransactionMappingFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ProcessTransactionMappingFileMutation, GraphqlTypes.ProcessTransactionMappingFileMutationVariables>(ProcessTransactionMappingFileDocument, options);
      }
export type ProcessTransactionMappingFileMutationHookResult = ReturnType<typeof useProcessTransactionMappingFileMutation>;
export type ProcessTransactionMappingFileMutationResult = Apollo.MutationResult<GraphqlTypes.ProcessTransactionMappingFileMutation>;
export type ProcessTransactionMappingFileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ProcessTransactionMappingFileMutation, GraphqlTypes.ProcessTransactionMappingFileMutationVariables>;
export const UpdateMappingSettingDocument = gql`
    mutation updateMappingSetting($input: UpdateMappingSettingInput!) {
  updateMappingSetting(input: $input) {
    id
  }
}
    `;
export type UpdateMappingSettingMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateMappingSettingMutation, GraphqlTypes.UpdateMappingSettingMutationVariables>;

/**
 * __useUpdateMappingSettingMutation__
 *
 * To run a mutation, you first call `useUpdateMappingSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMappingSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMappingSettingMutation, { data, loading, error }] = useUpdateMappingSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMappingSettingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateMappingSettingMutation, GraphqlTypes.UpdateMappingSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateMappingSettingMutation, GraphqlTypes.UpdateMappingSettingMutationVariables>(UpdateMappingSettingDocument, options);
      }
export type UpdateMappingSettingMutationHookResult = ReturnType<typeof useUpdateMappingSettingMutation>;
export type UpdateMappingSettingMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateMappingSettingMutation>;
export type UpdateMappingSettingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateMappingSettingMutation, GraphqlTypes.UpdateMappingSettingMutationVariables>;
export const GetPresignedUrlFromGlDocument = gql`
    query getPresignedUrlFromGL {
  s3PresignedUrlObject {
    uploadUrl
    fields {
      key
      policy
      xAmzSecurityToken
      xAmzAlgorithm
      xAmzCredential
      xAmzDate
      xAmzSignature
    }
  }
}
    `;

/**
 * __useGetPresignedUrlFromGlQuery__
 *
 * To run a query within a React component, call `useGetPresignedUrlFromGlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedUrlFromGlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresignedUrlFromGlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPresignedUrlFromGlQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>(GetPresignedUrlFromGlDocument, options);
      }
export function useGetPresignedUrlFromGlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>(GetPresignedUrlFromGlDocument, options);
        }
// @ts-ignore
export function useGetPresignedUrlFromGlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>;
export function useGetPresignedUrlFromGlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPresignedUrlFromGlQuery | undefined, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>;
export function useGetPresignedUrlFromGlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>(GetPresignedUrlFromGlDocument, options);
        }
export type GetPresignedUrlFromGlQueryHookResult = ReturnType<typeof useGetPresignedUrlFromGlQuery>;
export type GetPresignedUrlFromGlLazyQueryHookResult = ReturnType<typeof useGetPresignedUrlFromGlLazyQuery>;
export type GetPresignedUrlFromGlSuspenseQueryHookResult = ReturnType<typeof useGetPresignedUrlFromGlSuspenseQuery>;
export type GetPresignedUrlFromGlQueryResult = Apollo.QueryResult<GraphqlTypes.GetPresignedUrlFromGlQuery, GraphqlTypes.GetPresignedUrlFromGlQueryVariables>;
export const GetMappingFileDocument = gql`
    query GetMappingFile($input: GenerateMappingFileGQLInput!) {
  mappingFile(input: $input)
}
    `;

/**
 * __useGetMappingFileQuery__
 *
 * To run a query within a React component, call `useGetMappingFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMappingFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMappingFileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMappingFileQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables> & ({ variables: GraphqlTypes.GetMappingFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>(GetMappingFileDocument, options);
      }
export function useGetMappingFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>(GetMappingFileDocument, options);
        }
// @ts-ignore
export function useGetMappingFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>;
export function useGetMappingFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetMappingFileQuery | undefined, GraphqlTypes.GetMappingFileQueryVariables>;
export function useGetMappingFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>(GetMappingFileDocument, options);
        }
export type GetMappingFileQueryHookResult = ReturnType<typeof useGetMappingFileQuery>;
export type GetMappingFileLazyQueryHookResult = ReturnType<typeof useGetMappingFileLazyQuery>;
export type GetMappingFileSuspenseQueryHookResult = ReturnType<typeof useGetMappingFileSuspenseQuery>;
export type GetMappingFileQueryResult = Apollo.QueryResult<GraphqlTypes.GetMappingFileQuery, GraphqlTypes.GetMappingFileQueryVariables>;
export const DownloadComplianceDocumentsDocument = gql`
    mutation DownloadComplianceDocuments($objectInput: DownloadComplianceDocumentsInput!) {
  downloadComplianceDocuments(objectInput: $objectInput) {
    __typename
    ... on AsyncJobObjectType {
      id
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type DownloadComplianceDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadComplianceDocumentsMutation, GraphqlTypes.DownloadComplianceDocumentsMutationVariables>;

/**
 * __useDownloadComplianceDocumentsMutation__
 *
 * To run a mutation, you first call `useDownloadComplianceDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadComplianceDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadComplianceDocumentsMutation, { data, loading, error }] = useDownloadComplianceDocumentsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDownloadComplianceDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadComplianceDocumentsMutation, GraphqlTypes.DownloadComplianceDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadComplianceDocumentsMutation, GraphqlTypes.DownloadComplianceDocumentsMutationVariables>(DownloadComplianceDocumentsDocument, options);
      }
export type DownloadComplianceDocumentsMutationHookResult = ReturnType<typeof useDownloadComplianceDocumentsMutation>;
export type DownloadComplianceDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadComplianceDocumentsMutation>;
export type DownloadComplianceDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadComplianceDocumentsMutation, GraphqlTypes.DownloadComplianceDocumentsMutationVariables>;
export const GetComplianceCaseDetailsByObjectIdDocument = gql`
    query GetComplianceCaseDetailsByObjectId($arenaId: Int!, $externalObject: ExternalObjectInput!) {
  complianceCasesByObjectId(arenaId: $arenaId, externalObject: $externalObject) {
    id
    externalObjects {
      id
      objectId
      objectType
      objectTypeEnum
      service
      name
    }
    investingProfile {
      id
      accountType
      complianceObjectType
      firstName
      lastName
      middleName
      legalName
      documents {
        id
        name
        createdAt
        profileId
        s3Link
        contentType
        documentPurpose {
          baseType
        }
        metadata {
          key
          value
          type
        }
      }
      beneficialOwners {
        id
        childProfile {
          id
          firstName
          lastName
          middleName
          legalName
          documents {
            id
            name
            createdAt
            profileId
            s3Link
            contentType
            documentPurpose {
              baseType
            }
            metadata {
              key
              value
              type
            }
          }
        }
      }
      rulesEngine(arenaId: $arenaId, externalObject: $externalObject) {
        documentTypes {
          baseType
          subType
          status
          isMandatory
        }
      }
    }
  }
}
    `;

/**
 * __useGetComplianceCaseDetailsByObjectIdQuery__
 *
 * To run a query within a React component, call `useGetComplianceCaseDetailsByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCaseDetailsByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCaseDetailsByObjectIdQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      externalObject: // value for 'externalObject'
 *   },
 * });
 */
export function useGetComplianceCaseDetailsByObjectIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables> & ({ variables: GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>(GetComplianceCaseDetailsByObjectIdDocument, options);
      }
export function useGetComplianceCaseDetailsByObjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>(GetComplianceCaseDetailsByObjectIdDocument, options);
        }
// @ts-ignore
export function useGetComplianceCaseDetailsByObjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>;
export function useGetComplianceCaseDetailsByObjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery | undefined, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>;
export function useGetComplianceCaseDetailsByObjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>(GetComplianceCaseDetailsByObjectIdDocument, options);
        }
export type GetComplianceCaseDetailsByObjectIdQueryHookResult = ReturnType<typeof useGetComplianceCaseDetailsByObjectIdQuery>;
export type GetComplianceCaseDetailsByObjectIdLazyQueryHookResult = ReturnType<typeof useGetComplianceCaseDetailsByObjectIdLazyQuery>;
export type GetComplianceCaseDetailsByObjectIdSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCaseDetailsByObjectIdSuspenseQuery>;
export type GetComplianceCaseDetailsByObjectIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCaseDetailsByObjectIdQuery, GraphqlTypes.GetComplianceCaseDetailsByObjectIdQueryVariables>;
export const RejectSubscriptionForComplianceDocument = gql`
    mutation RejectSubscriptionForCompliance($subscriptionId: ID!, $internalComments: String, $sendEmailToProspect: Boolean, $emailComments: String) {
  rejectSubscriptionForCompliance(
    objectInput: {subscriptionId: $subscriptionId, internalComments: $internalComments, sendEmailToProspect: $sendEmailToProspect, emailComments: $emailComments}
  ) {
    __typename
    ... on RejectSubscriptionForComplianceSuccessResponse {
      newSubscriptionId
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type RejectSubscriptionForComplianceMutationFn = Apollo.MutationFunction<GraphqlTypes.RejectSubscriptionForComplianceMutation, GraphqlTypes.RejectSubscriptionForComplianceMutationVariables>;

/**
 * __useRejectSubscriptionForComplianceMutation__
 *
 * To run a mutation, you first call `useRejectSubscriptionForComplianceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectSubscriptionForComplianceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectSubscriptionForComplianceMutation, { data, loading, error }] = useRejectSubscriptionForComplianceMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      internalComments: // value for 'internalComments'
 *      sendEmailToProspect: // value for 'sendEmailToProspect'
 *      emailComments: // value for 'emailComments'
 *   },
 * });
 */
export function useRejectSubscriptionForComplianceMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RejectSubscriptionForComplianceMutation, GraphqlTypes.RejectSubscriptionForComplianceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RejectSubscriptionForComplianceMutation, GraphqlTypes.RejectSubscriptionForComplianceMutationVariables>(RejectSubscriptionForComplianceDocument, options);
      }
export type RejectSubscriptionForComplianceMutationHookResult = ReturnType<typeof useRejectSubscriptionForComplianceMutation>;
export type RejectSubscriptionForComplianceMutationResult = Apollo.MutationResult<GraphqlTypes.RejectSubscriptionForComplianceMutation>;
export type RejectSubscriptionForComplianceMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RejectSubscriptionForComplianceMutation, GraphqlTypes.RejectSubscriptionForComplianceMutationVariables>;
export const GetComplianceCasesByObjectIdDocument = gql`
    query getComplianceCasesByObjectId($arenaId: Int!, $externalObject: ExternalObjectInput!, $tag: ComplianceCaseAuditTagType!) {
  complianceCasesByObjectId(arenaId: $arenaId, externalObject: $externalObject) {
    ...ComplianceCaseFields
  }
}
    ${ComplianceCaseFieldsFragmentDoc}`;

/**
 * __useGetComplianceCasesByObjectIdQuery__
 *
 * To run a query within a React component, call `useGetComplianceCasesByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCasesByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCasesByObjectIdQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      externalObject: // value for 'externalObject'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useGetComplianceCasesByObjectIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables> & ({ variables: GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>(GetComplianceCasesByObjectIdDocument, options);
      }
export function useGetComplianceCasesByObjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>(GetComplianceCasesByObjectIdDocument, options);
        }
// @ts-ignore
export function useGetComplianceCasesByObjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>;
export function useGetComplianceCasesByObjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCasesByObjectIdQuery | undefined, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>;
export function useGetComplianceCasesByObjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>(GetComplianceCasesByObjectIdDocument, options);
        }
export type GetComplianceCasesByObjectIdQueryHookResult = ReturnType<typeof useGetComplianceCasesByObjectIdQuery>;
export type GetComplianceCasesByObjectIdLazyQueryHookResult = ReturnType<typeof useGetComplianceCasesByObjectIdLazyQuery>;
export type GetComplianceCasesByObjectIdSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCasesByObjectIdSuspenseQuery>;
export type GetComplianceCasesByObjectIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCasesByObjectIdQuery, GraphqlTypes.GetComplianceCasesByObjectIdQueryVariables>;
export const GetComplianceCasesByPositionIdDocument = gql`
    query getComplianceCasesByPositionId($positionFilterInput: PositionFilterInput!, $tag: ComplianceCaseAuditTagType!) {
  positions(positionFilters: $positionFilterInput) {
    edges {
      node {
        id
        onboardingCase {
          ...ComplianceCaseFields
        }
      }
    }
  }
}
    ${ComplianceCaseFieldsFragmentDoc}`;

/**
 * __useGetComplianceCasesByPositionIdQuery__
 *
 * To run a query within a React component, call `useGetComplianceCasesByPositionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCasesByPositionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCasesByPositionIdQuery({
 *   variables: {
 *      positionFilterInput: // value for 'positionFilterInput'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useGetComplianceCasesByPositionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables> & ({ variables: GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>(GetComplianceCasesByPositionIdDocument, options);
      }
export function useGetComplianceCasesByPositionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>(GetComplianceCasesByPositionIdDocument, options);
        }
// @ts-ignore
export function useGetComplianceCasesByPositionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>;
export function useGetComplianceCasesByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCasesByPositionIdQuery | undefined, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>;
export function useGetComplianceCasesByPositionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>(GetComplianceCasesByPositionIdDocument, options);
        }
export type GetComplianceCasesByPositionIdQueryHookResult = ReturnType<typeof useGetComplianceCasesByPositionIdQuery>;
export type GetComplianceCasesByPositionIdLazyQueryHookResult = ReturnType<typeof useGetComplianceCasesByPositionIdLazyQuery>;
export type GetComplianceCasesByPositionIdSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCasesByPositionIdSuspenseQuery>;
export type GetComplianceCasesByPositionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCasesByPositionIdQuery, GraphqlTypes.GetComplianceCasesByPositionIdQueryVariables>;
export const GetProspectForComplianceReviewDocument = gql`
    query GetProspectForComplianceReview($subscriptionId: ID!) {
  subscriptionById(subscriptionId: $subscriptionId) {
    id
    prospect {
      id
      prospectContactMaps {
        id
        isMainContact
        dataRoomKey
        contact {
          id
          fullName
          primaryEmail {
            id
            emailAddress
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProspectForComplianceReviewQuery__
 *
 * To run a query within a React component, call `useGetProspectForComplianceReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectForComplianceReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectForComplianceReviewQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useGetProspectForComplianceReviewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables> & ({ variables: GraphqlTypes.GetProspectForComplianceReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>(GetProspectForComplianceReviewDocument, options);
      }
export function useGetProspectForComplianceReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>(GetProspectForComplianceReviewDocument, options);
        }
// @ts-ignore
export function useGetProspectForComplianceReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>;
export function useGetProspectForComplianceReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectForComplianceReviewQuery | undefined, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>;
export function useGetProspectForComplianceReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>(GetProspectForComplianceReviewDocument, options);
        }
export type GetProspectForComplianceReviewQueryHookResult = ReturnType<typeof useGetProspectForComplianceReviewQuery>;
export type GetProspectForComplianceReviewLazyQueryHookResult = ReturnType<typeof useGetProspectForComplianceReviewLazyQuery>;
export type GetProspectForComplianceReviewSuspenseQueryHookResult = ReturnType<typeof useGetProspectForComplianceReviewSuspenseQuery>;
export type GetProspectForComplianceReviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetProspectForComplianceReviewQuery, GraphqlTypes.GetProspectForComplianceReviewQueryVariables>;
export const SetEntityCustomSectionsDocument = gql`
    mutation SetEntityCustomSections($objectInput: SetEntitySectionsInput!) {
  subSoaSetEntityCustomSections(objectInput: $objectInput) {
    id
    customSections {
      included
      section {
        id
        internalDescription
        title
        prompts {
          id
          internalTitle
          body
        }
      }
      hasUnpublishedChanges
    }
  }
}
    `;
export type SetEntityCustomSectionsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetEntityCustomSectionsMutation, GraphqlTypes.SetEntityCustomSectionsMutationVariables>;

/**
 * __useSetEntityCustomSectionsMutation__
 *
 * To run a mutation, you first call `useSetEntityCustomSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEntityCustomSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEntityCustomSectionsMutation, { data, loading, error }] = useSetEntityCustomSectionsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSetEntityCustomSectionsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetEntityCustomSectionsMutation, GraphqlTypes.SetEntityCustomSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetEntityCustomSectionsMutation, GraphqlTypes.SetEntityCustomSectionsMutationVariables>(SetEntityCustomSectionsDocument, options);
      }
export type SetEntityCustomSectionsMutationHookResult = ReturnType<typeof useSetEntityCustomSectionsMutation>;
export type SetEntityCustomSectionsMutationResult = Apollo.MutationResult<GraphqlTypes.SetEntityCustomSectionsMutation>;
export type SetEntityCustomSectionsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetEntityCustomSectionsMutation, GraphqlTypes.SetEntityCustomSectionsMutationVariables>;
export const ReorderEntityCustomSectionsDocument = gql`
    mutation ReorderEntityCustomSections($objectInput: ReorderEntitySectionsInput!) {
  subSoaEntityReorderCustomSections(objectInput: $objectInput) {
    ... on MutationErrorResponse {
      message
    }
    ... on EntitySubscriptionSettings {
      id
      customSections {
        included
        section {
          id
          internalDescription
          title
        }
        hasUnpublishedChanges
      }
    }
  }
}
    `;
export type ReorderEntityCustomSectionsMutationFn = Apollo.MutationFunction<GraphqlTypes.ReorderEntityCustomSectionsMutation, GraphqlTypes.ReorderEntityCustomSectionsMutationVariables>;

/**
 * __useReorderEntityCustomSectionsMutation__
 *
 * To run a mutation, you first call `useReorderEntityCustomSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderEntityCustomSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderEntityCustomSectionsMutation, { data, loading, error }] = useReorderEntityCustomSectionsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useReorderEntityCustomSectionsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReorderEntityCustomSectionsMutation, GraphqlTypes.ReorderEntityCustomSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReorderEntityCustomSectionsMutation, GraphqlTypes.ReorderEntityCustomSectionsMutationVariables>(ReorderEntityCustomSectionsDocument, options);
      }
export type ReorderEntityCustomSectionsMutationHookResult = ReturnType<typeof useReorderEntityCustomSectionsMutation>;
export type ReorderEntityCustomSectionsMutationResult = Apollo.MutationResult<GraphqlTypes.ReorderEntityCustomSectionsMutation>;
export type ReorderEntityCustomSectionsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReorderEntityCustomSectionsMutation, GraphqlTypes.ReorderEntityCustomSectionsMutationVariables>;
export const GetInvestmentEntityCustomSubscriptionSettingsDocument = gql`
    query GetInvestmentEntityCustomSubscriptionSettings($entityId: ID!, $arenaId: Int!) {
  investmentEntity(entityId: $entityId) {
    id
    subscriptionSettings(arenaId: $arenaId) {
      id
      customSections {
        included
        section {
          id
          title
          internalDescription
          enablingLogic
          __typename
        }
        hasUnpublishedChanges
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentEntityCustomSubscriptionSettingsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityCustomSubscriptionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityCustomSubscriptionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityCustomSubscriptionSettingsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetInvestmentEntityCustomSubscriptionSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>(GetInvestmentEntityCustomSubscriptionSettingsDocument, options);
      }
export function useGetInvestmentEntityCustomSubscriptionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>(GetInvestmentEntityCustomSubscriptionSettingsDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntityCustomSubscriptionSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>;
export function useGetInvestmentEntityCustomSubscriptionSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery | undefined, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>;
export function useGetInvestmentEntityCustomSubscriptionSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>(GetInvestmentEntityCustomSubscriptionSettingsDocument, options);
        }
export type GetInvestmentEntityCustomSubscriptionSettingsQueryHookResult = ReturnType<typeof useGetInvestmentEntityCustomSubscriptionSettingsQuery>;
export type GetInvestmentEntityCustomSubscriptionSettingsLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityCustomSubscriptionSettingsLazyQuery>;
export type GetInvestmentEntityCustomSubscriptionSettingsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntityCustomSubscriptionSettingsSuspenseQuery>;
export type GetInvestmentEntityCustomSubscriptionSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntityCustomSubscriptionSettingsQueryVariables>;
export const ExportSubscriptionSnapshotsDocument = gql`
    mutation ExportSubscriptionSnapshots($exportInput: ExportSubscriptionSnapshotsInput!) {
  exportSubscriptionSnapshots(exportInput: $exportInput) {
    __typename
    ... on ExportSubscriptionSnapshotsObject {
      job {
        id
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type ExportSubscriptionSnapshotsMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportSubscriptionSnapshotsMutation, GraphqlTypes.ExportSubscriptionSnapshotsMutationVariables>;

/**
 * __useExportSubscriptionSnapshotsMutation__
 *
 * To run a mutation, you first call `useExportSubscriptionSnapshotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportSubscriptionSnapshotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportSubscriptionSnapshotsMutation, { data, loading, error }] = useExportSubscriptionSnapshotsMutation({
 *   variables: {
 *      exportInput: // value for 'exportInput'
 *   },
 * });
 */
export function useExportSubscriptionSnapshotsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportSubscriptionSnapshotsMutation, GraphqlTypes.ExportSubscriptionSnapshotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportSubscriptionSnapshotsMutation, GraphqlTypes.ExportSubscriptionSnapshotsMutationVariables>(ExportSubscriptionSnapshotsDocument, options);
      }
export type ExportSubscriptionSnapshotsMutationHookResult = ReturnType<typeof useExportSubscriptionSnapshotsMutation>;
export type ExportSubscriptionSnapshotsMutationResult = Apollo.MutationResult<GraphqlTypes.ExportSubscriptionSnapshotsMutation>;
export type ExportSubscriptionSnapshotsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportSubscriptionSnapshotsMutation, GraphqlTypes.ExportSubscriptionSnapshotsMutationVariables>;
export const DecryptSubscriptionSnapshotFieldsDocument = gql`
    mutation DecryptSubscriptionSnapshotFields($objectInput: DecryptSubscriptionSnapshotFieldsInput!) {
  decryptSubscriptionSnapshotFields(objectInput: $objectInput) {
    __typename
    ... on DecryptSubscriptionSnapshotFieldsObject {
      taxId
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DecryptSubscriptionSnapshotFieldsMutationFn = Apollo.MutationFunction<GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutation, GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutationVariables>;

/**
 * __useDecryptSubscriptionSnapshotFieldsMutation__
 *
 * To run a mutation, you first call `useDecryptSubscriptionSnapshotFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecryptSubscriptionSnapshotFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decryptSubscriptionSnapshotFieldsMutation, { data, loading, error }] = useDecryptSubscriptionSnapshotFieldsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDecryptSubscriptionSnapshotFieldsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutation, GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutation, GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutationVariables>(DecryptSubscriptionSnapshotFieldsDocument, options);
      }
export type DecryptSubscriptionSnapshotFieldsMutationHookResult = ReturnType<typeof useDecryptSubscriptionSnapshotFieldsMutation>;
export type DecryptSubscriptionSnapshotFieldsMutationResult = Apollo.MutationResult<GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutation>;
export type DecryptSubscriptionSnapshotFieldsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutation, GraphqlTypes.DecryptSubscriptionSnapshotFieldsMutationVariables>;
export const GetSnapshotSummariesDocument = gql`
    query GetSnapshotSummaries($accountId: Int!, $arenaId: Int!) {
  subscriptionSnapshotSummaries(accountId: $accountId, arenaId: $arenaId) {
    edges {
      node {
        mainSubscriptionId
        fundName
        countersignedAt
        subscription {
          totalInvestment
          currency
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetSnapshotSummariesQuery__
 *
 * To run a query within a React component, call `useGetSnapshotSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnapshotSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnapshotSummariesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetSnapshotSummariesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables> & ({ variables: GraphqlTypes.GetSnapshotSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>(GetSnapshotSummariesDocument, options);
      }
export function useGetSnapshotSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>(GetSnapshotSummariesDocument, options);
        }
// @ts-ignore
export function useGetSnapshotSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>;
export function useGetSnapshotSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSnapshotSummariesQuery | undefined, GraphqlTypes.GetSnapshotSummariesQueryVariables>;
export function useGetSnapshotSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>(GetSnapshotSummariesDocument, options);
        }
export type GetSnapshotSummariesQueryHookResult = ReturnType<typeof useGetSnapshotSummariesQuery>;
export type GetSnapshotSummariesLazyQueryHookResult = ReturnType<typeof useGetSnapshotSummariesLazyQuery>;
export type GetSnapshotSummariesSuspenseQueryHookResult = ReturnType<typeof useGetSnapshotSummariesSuspenseQuery>;
export type GetSnapshotSummariesQueryResult = Apollo.QueryResult<GraphqlTypes.GetSnapshotSummariesQuery, GraphqlTypes.GetSnapshotSummariesQueryVariables>;
export const GetSnapshotDocument = gql`
    query GetSnapshot($mainSubscriptionId: Int!) {
  subscriptionSnapshot(mainSubscriptionId: $mainSubscriptionId) {
    ...SubscriptionSnapshotDetailFields
  }
}
    ${SubscriptionSnapshotDetailFieldsFragmentDoc}`;

/**
 * __useGetSnapshotQuery__
 *
 * To run a query within a React component, call `useGetSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnapshotQuery({
 *   variables: {
 *      mainSubscriptionId: // value for 'mainSubscriptionId'
 *   },
 * });
 */
export function useGetSnapshotQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables> & ({ variables: GraphqlTypes.GetSnapshotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>(GetSnapshotDocument, options);
      }
export function useGetSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>(GetSnapshotDocument, options);
        }
// @ts-ignore
export function useGetSnapshotSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>;
export function useGetSnapshotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSnapshotQuery | undefined, GraphqlTypes.GetSnapshotQueryVariables>;
export function useGetSnapshotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>(GetSnapshotDocument, options);
        }
export type GetSnapshotQueryHookResult = ReturnType<typeof useGetSnapshotQuery>;
export type GetSnapshotLazyQueryHookResult = ReturnType<typeof useGetSnapshotLazyQuery>;
export type GetSnapshotSuspenseQueryHookResult = ReturnType<typeof useGetSnapshotSuspenseQuery>;
export type GetSnapshotQueryResult = Apollo.QueryResult<GraphqlTypes.GetSnapshotQuery, GraphqlTypes.GetSnapshotQueryVariables>;
export const GetSnapshotByPositionDocument = gql`
    query GetSnapshotByPosition($positionId: Int!) {
  subscriptionSnapshotByPosition(positionId: $positionId) {
    ...SubscriptionSnapshotDetailFields
  }
}
    ${SubscriptionSnapshotDetailFieldsFragmentDoc}`;

/**
 * __useGetSnapshotByPositionQuery__
 *
 * To run a query within a React component, call `useGetSnapshotByPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnapshotByPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnapshotByPositionQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetSnapshotByPositionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables> & ({ variables: GraphqlTypes.GetSnapshotByPositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>(GetSnapshotByPositionDocument, options);
      }
export function useGetSnapshotByPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>(GetSnapshotByPositionDocument, options);
        }
// @ts-ignore
export function useGetSnapshotByPositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>;
export function useGetSnapshotByPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSnapshotByPositionQuery | undefined, GraphqlTypes.GetSnapshotByPositionQueryVariables>;
export function useGetSnapshotByPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>(GetSnapshotByPositionDocument, options);
        }
export type GetSnapshotByPositionQueryHookResult = ReturnType<typeof useGetSnapshotByPositionQuery>;
export type GetSnapshotByPositionLazyQueryHookResult = ReturnType<typeof useGetSnapshotByPositionLazyQuery>;
export type GetSnapshotByPositionSuspenseQueryHookResult = ReturnType<typeof useGetSnapshotByPositionSuspenseQuery>;
export type GetSnapshotByPositionQueryResult = Apollo.QueryResult<GraphqlTypes.GetSnapshotByPositionQuery, GraphqlTypes.GetSnapshotByPositionQueryVariables>;
export const GetSubscriptionSnapshotExportUrlDocument = gql`
    query GetSubscriptionSnapshotExportUrl($asyncJobId: ID!) {
  subscriptionSnapshotExportUrl(asyncJobId: $asyncJobId)
}
    `;

/**
 * __useGetSubscriptionSnapshotExportUrlQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionSnapshotExportUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionSnapshotExportUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionSnapshotExportUrlQuery({
 *   variables: {
 *      asyncJobId: // value for 'asyncJobId'
 *   },
 * });
 */
export function useGetSubscriptionSnapshotExportUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables> & ({ variables: GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>(GetSubscriptionSnapshotExportUrlDocument, options);
      }
export function useGetSubscriptionSnapshotExportUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>(GetSubscriptionSnapshotExportUrlDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionSnapshotExportUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>;
export function useGetSubscriptionSnapshotExportUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery | undefined, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>;
export function useGetSubscriptionSnapshotExportUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>(GetSubscriptionSnapshotExportUrlDocument, options);
        }
export type GetSubscriptionSnapshotExportUrlQueryHookResult = ReturnType<typeof useGetSubscriptionSnapshotExportUrlQuery>;
export type GetSubscriptionSnapshotExportUrlLazyQueryHookResult = ReturnType<typeof useGetSubscriptionSnapshotExportUrlLazyQuery>;
export type GetSubscriptionSnapshotExportUrlSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionSnapshotExportUrlSuspenseQuery>;
export type GetSubscriptionSnapshotExportUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetSubscriptionSnapshotExportUrlQuery, GraphqlTypes.GetSubscriptionSnapshotExportUrlQueryVariables>;
export const SetEntityIncreaseDocumentsDocument = gql`
    mutation SetEntityIncreaseDocuments($objectInput: SetEntitySectionsInput!) {
  subSoaSetEntityIncreaseDocuments(objectInput: $objectInput) {
    id
    increaseDocuments {
      included
      hasUnpublishedChanges
      section {
        id
        internalDescription
        title
        prompts {
          id
          internalTitle
          body
        }
      }
    }
  }
}
    `;
export type SetEntityIncreaseDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetEntityIncreaseDocumentsMutation, GraphqlTypes.SetEntityIncreaseDocumentsMutationVariables>;

/**
 * __useSetEntityIncreaseDocumentsMutation__
 *
 * To run a mutation, you first call `useSetEntityIncreaseDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEntityIncreaseDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEntityIncreaseDocumentsMutation, { data, loading, error }] = useSetEntityIncreaseDocumentsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSetEntityIncreaseDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetEntityIncreaseDocumentsMutation, GraphqlTypes.SetEntityIncreaseDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetEntityIncreaseDocumentsMutation, GraphqlTypes.SetEntityIncreaseDocumentsMutationVariables>(SetEntityIncreaseDocumentsDocument, options);
      }
export type SetEntityIncreaseDocumentsMutationHookResult = ReturnType<typeof useSetEntityIncreaseDocumentsMutation>;
export type SetEntityIncreaseDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.SetEntityIncreaseDocumentsMutation>;
export type SetEntityIncreaseDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetEntityIncreaseDocumentsMutation, GraphqlTypes.SetEntityIncreaseDocumentsMutationVariables>;
export const SetEntityIncreaseSupportingDocumentsDocument = gql`
    mutation SetEntityIncreaseSupportingDocuments($objectInput: SetEntitySectionsInput!) {
  subSoaSetEntityIncreaseSupportingDocs(objectInput: $objectInput) {
    id
    increaseSupportingDocuments {
      included
      hasUnpublishedChanges
      section {
        id
        internalDescription
        title
        prompts {
          id
          internalTitle
          body
        }
      }
    }
  }
}
    `;
export type SetEntityIncreaseSupportingDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutation, GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutationVariables>;

/**
 * __useSetEntityIncreaseSupportingDocumentsMutation__
 *
 * To run a mutation, you first call `useSetEntityIncreaseSupportingDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEntityIncreaseSupportingDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEntityIncreaseSupportingDocumentsMutation, { data, loading, error }] = useSetEntityIncreaseSupportingDocumentsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSetEntityIncreaseSupportingDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutation, GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutation, GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutationVariables>(SetEntityIncreaseSupportingDocumentsDocument, options);
      }
export type SetEntityIncreaseSupportingDocumentsMutationHookResult = ReturnType<typeof useSetEntityIncreaseSupportingDocumentsMutation>;
export type SetEntityIncreaseSupportingDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutation>;
export type SetEntityIncreaseSupportingDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutation, GraphqlTypes.SetEntityIncreaseSupportingDocumentsMutationVariables>;
export const GetInvestmentEntityPositionIncreaseSettingsDocument = gql`
    query GetInvestmentEntityPositionIncreaseSettings($entityId: ID!, $arenaId: Int!) {
  investmentEntity(entityId: $entityId) {
    id
    positionIncreaseSettings(arenaId: $arenaId) {
      id
      increaseDocuments {
        ...EntitySectionFields
      }
      increaseSupportingDocuments {
        ...EntitySectionFields
      }
    }
  }
}
    ${EntitySectionFieldsFragmentDoc}`;

/**
 * __useGetInvestmentEntityPositionIncreaseSettingsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityPositionIncreaseSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityPositionIncreaseSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityPositionIncreaseSettingsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetInvestmentEntityPositionIncreaseSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>(GetInvestmentEntityPositionIncreaseSettingsDocument, options);
      }
export function useGetInvestmentEntityPositionIncreaseSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>(GetInvestmentEntityPositionIncreaseSettingsDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntityPositionIncreaseSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>;
export function useGetInvestmentEntityPositionIncreaseSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery | undefined, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>;
export function useGetInvestmentEntityPositionIncreaseSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>(GetInvestmentEntityPositionIncreaseSettingsDocument, options);
        }
export type GetInvestmentEntityPositionIncreaseSettingsQueryHookResult = ReturnType<typeof useGetInvestmentEntityPositionIncreaseSettingsQuery>;
export type GetInvestmentEntityPositionIncreaseSettingsLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityPositionIncreaseSettingsLazyQuery>;
export type GetInvestmentEntityPositionIncreaseSettingsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntityPositionIncreaseSettingsSuspenseQuery>;
export type GetInvestmentEntityPositionIncreaseSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQuery, GraphqlTypes.GetInvestmentEntityPositionIncreaseSettingsQueryVariables>;
export const SetEntitySupportingDocumentsDocument = gql`
    mutation SetEntitySupportingDocuments($objectInput: SetEntitySectionsInput!) {
  subSoaSetEntitySupportingDocs(objectInput: $objectInput) {
    id
    supportingDocuments {
      included
      section {
        id
        internalDescription
        title
        prompts {
          id
          internalTitle
          body
        }
      }
      hasUnpublishedChanges
    }
  }
}
    `;
export type SetEntitySupportingDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.SetEntitySupportingDocumentsMutation, GraphqlTypes.SetEntitySupportingDocumentsMutationVariables>;

/**
 * __useSetEntitySupportingDocumentsMutation__
 *
 * To run a mutation, you first call `useSetEntitySupportingDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEntitySupportingDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEntitySupportingDocumentsMutation, { data, loading, error }] = useSetEntitySupportingDocumentsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSetEntitySupportingDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetEntitySupportingDocumentsMutation, GraphqlTypes.SetEntitySupportingDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetEntitySupportingDocumentsMutation, GraphqlTypes.SetEntitySupportingDocumentsMutationVariables>(SetEntitySupportingDocumentsDocument, options);
      }
export type SetEntitySupportingDocumentsMutationHookResult = ReturnType<typeof useSetEntitySupportingDocumentsMutation>;
export type SetEntitySupportingDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.SetEntitySupportingDocumentsMutation>;
export type SetEntitySupportingDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetEntitySupportingDocumentsMutation, GraphqlTypes.SetEntitySupportingDocumentsMutationVariables>;
export const GetInvestmentEntitySubscriptionSettingsDocument = gql`
    query GetInvestmentEntitySubscriptionSettings($entityId: ID!, $arenaId: Int!) {
  investmentEntity(entityId: $entityId) {
    id
    subscriptionSettings(arenaId: $arenaId) {
      id
      supportingDocuments {
        included
        section {
          id
          title
          prompts {
            id
            body
            required
            templateFile {
              url
              key
              name
            }
            enablingLogic
            choices {
              id
              body
            }
            promptType
          }
          internalDescription
          enablingLogic
          promptAllResponders
          version
          footnotes {
            id
            label
            body
          }
          __typename
        }
        hasUnpublishedChanges
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentEntitySubscriptionSettingsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitySubscriptionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitySubscriptionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitySubscriptionSettingsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetInvestmentEntitySubscriptionSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>(GetInvestmentEntitySubscriptionSettingsDocument, options);
      }
export function useGetInvestmentEntitySubscriptionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>(GetInvestmentEntitySubscriptionSettingsDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitySubscriptionSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>;
export function useGetInvestmentEntitySubscriptionSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery | undefined, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>;
export function useGetInvestmentEntitySubscriptionSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>(GetInvestmentEntitySubscriptionSettingsDocument, options);
        }
export type GetInvestmentEntitySubscriptionSettingsQueryHookResult = ReturnType<typeof useGetInvestmentEntitySubscriptionSettingsQuery>;
export type GetInvestmentEntitySubscriptionSettingsLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitySubscriptionSettingsLazyQuery>;
export type GetInvestmentEntitySubscriptionSettingsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitySubscriptionSettingsSuspenseQuery>;
export type GetInvestmentEntitySubscriptionSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQuery, GraphqlTypes.GetInvestmentEntitySubscriptionSettingsQueryVariables>;
export const SearchTicketFacilitatorEligibleUsersDocument = gql`
    query SearchTicketFacilitatorEligibleUsers($searchTerm: String!, $ticketObjectGroupId: ID) {
  ticketFacilitatorEligibleUsers(
    searchTerm: $searchTerm
    ticketObjectGroupId: $ticketObjectGroupId
  ) {
    id
    fullName
    emailAddress
  }
}
    `;

/**
 * __useSearchTicketFacilitatorEligibleUsersQuery__
 *
 * To run a query within a React component, call `useSearchTicketFacilitatorEligibleUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTicketFacilitatorEligibleUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTicketFacilitatorEligibleUsersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      ticketObjectGroupId: // value for 'ticketObjectGroupId'
 *   },
 * });
 */
export function useSearchTicketFacilitatorEligibleUsersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables> & ({ variables: GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>(SearchTicketFacilitatorEligibleUsersDocument, options);
      }
export function useSearchTicketFacilitatorEligibleUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>(SearchTicketFacilitatorEligibleUsersDocument, options);
        }
// @ts-ignore
export function useSearchTicketFacilitatorEligibleUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>;
export function useSearchTicketFacilitatorEligibleUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery | undefined, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>;
export function useSearchTicketFacilitatorEligibleUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>(SearchTicketFacilitatorEligibleUsersDocument, options);
        }
export type SearchTicketFacilitatorEligibleUsersQueryHookResult = ReturnType<typeof useSearchTicketFacilitatorEligibleUsersQuery>;
export type SearchTicketFacilitatorEligibleUsersLazyQueryHookResult = ReturnType<typeof useSearchTicketFacilitatorEligibleUsersLazyQuery>;
export type SearchTicketFacilitatorEligibleUsersSuspenseQueryHookResult = ReturnType<typeof useSearchTicketFacilitatorEligibleUsersSuspenseQuery>;
export type SearchTicketFacilitatorEligibleUsersQueryResult = Apollo.QueryResult<GraphqlTypes.SearchTicketFacilitatorEligibleUsersQuery, GraphqlTypes.SearchTicketFacilitatorEligibleUsersQueryVariables>;
export const PromoteTransactionBatchesDocument = gql`
    mutation PromoteTransactionBatches($batchId: ID!, $objectTypeId: Int!) {
  promoteTransactionBatches(batchId: $batchId, objectTypeId: $objectTypeId) {
    success
    errorMsg
  }
}
    `;
export type PromoteTransactionBatchesMutationFn = Apollo.MutationFunction<GraphqlTypes.PromoteTransactionBatchesMutation, GraphqlTypes.PromoteTransactionBatchesMutationVariables>;

/**
 * __usePromoteTransactionBatchesMutation__
 *
 * To run a mutation, you first call `usePromoteTransactionBatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteTransactionBatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteTransactionBatchesMutation, { data, loading, error }] = usePromoteTransactionBatchesMutation({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      objectTypeId: // value for 'objectTypeId'
 *   },
 * });
 */
export function usePromoteTransactionBatchesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PromoteTransactionBatchesMutation, GraphqlTypes.PromoteTransactionBatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PromoteTransactionBatchesMutation, GraphqlTypes.PromoteTransactionBatchesMutationVariables>(PromoteTransactionBatchesDocument, options);
      }
export type PromoteTransactionBatchesMutationHookResult = ReturnType<typeof usePromoteTransactionBatchesMutation>;
export type PromoteTransactionBatchesMutationResult = Apollo.MutationResult<GraphqlTypes.PromoteTransactionBatchesMutation>;
export type PromoteTransactionBatchesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PromoteTransactionBatchesMutation, GraphqlTypes.PromoteTransactionBatchesMutationVariables>;
export const GetLinkedBatchDocument = gql`
    query GetLinkedBatch($batchId: ID!, $objectType: JSQObjectType!) {
  linkedTransactionBatch(batchId: $batchId, objectType: $objectType) {
    ... on DistributionBatchObjectType {
      id
      description
      status
      __typename
    }
    ... on CapitalCallBatchObjectType {
      id
      description
      status
      __typename
    }
  }
}
    `;

/**
 * __useGetLinkedBatchQuery__
 *
 * To run a query within a React component, call `useGetLinkedBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedBatchQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useGetLinkedBatchQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables> & ({ variables: GraphqlTypes.GetLinkedBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>(GetLinkedBatchDocument, options);
      }
export function useGetLinkedBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>(GetLinkedBatchDocument, options);
        }
// @ts-ignore
export function useGetLinkedBatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>;
export function useGetLinkedBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedBatchQuery | undefined, GraphqlTypes.GetLinkedBatchQueryVariables>;
export function useGetLinkedBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>(GetLinkedBatchDocument, options);
        }
export type GetLinkedBatchQueryHookResult = ReturnType<typeof useGetLinkedBatchQuery>;
export type GetLinkedBatchLazyQueryHookResult = ReturnType<typeof useGetLinkedBatchLazyQuery>;
export type GetLinkedBatchSuspenseQueryHookResult = ReturnType<typeof useGetLinkedBatchSuspenseQuery>;
export type GetLinkedBatchQueryResult = Apollo.QueryResult<GraphqlTypes.GetLinkedBatchQuery, GraphqlTypes.GetLinkedBatchQueryVariables>;
export const TriggerEntitySyncDocument = gql`
    mutation TriggerEntitySync($entityId: ID!, $positionIds: [Int!]) {
  triggerEntitySync(id: $entityId, positionIds: $positionIds) {
    success
    errorMessage
    duplicates {
      id
      name
      objectType
    }
  }
}
    `;
export type TriggerEntitySyncMutationFn = Apollo.MutationFunction<GraphqlTypes.TriggerEntitySyncMutation, GraphqlTypes.TriggerEntitySyncMutationVariables>;

/**
 * __useTriggerEntitySyncMutation__
 *
 * To run a mutation, you first call `useTriggerEntitySyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerEntitySyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerEntitySyncMutation, { data, loading, error }] = useTriggerEntitySyncMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      positionIds: // value for 'positionIds'
 *   },
 * });
 */
export function useTriggerEntitySyncMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.TriggerEntitySyncMutation, GraphqlTypes.TriggerEntitySyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.TriggerEntitySyncMutation, GraphqlTypes.TriggerEntitySyncMutationVariables>(TriggerEntitySyncDocument, options);
      }
export type TriggerEntitySyncMutationHookResult = ReturnType<typeof useTriggerEntitySyncMutation>;
export type TriggerEntitySyncMutationResult = Apollo.MutationResult<GraphqlTypes.TriggerEntitySyncMutation>;
export type TriggerEntitySyncMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.TriggerEntitySyncMutation, GraphqlTypes.TriggerEntitySyncMutationVariables>;
export const CreateContactRelationDocument = gql`
    mutation CreateContactRelation($input: CreateContactRelationInput!) {
  createContactRelation(input: $input) {
    __typename
    ... on ContactRelationObjectType {
      id
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type CreateContactRelationMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateContactRelationMutation, GraphqlTypes.CreateContactRelationMutationVariables>;

/**
 * __useCreateContactRelationMutation__
 *
 * To run a mutation, you first call `useCreateContactRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactRelationMutation, { data, loading, error }] = useCreateContactRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactRelationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateContactRelationMutation, GraphqlTypes.CreateContactRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateContactRelationMutation, GraphqlTypes.CreateContactRelationMutationVariables>(CreateContactRelationDocument, options);
      }
export type CreateContactRelationMutationHookResult = ReturnType<typeof useCreateContactRelationMutation>;
export type CreateContactRelationMutationResult = Apollo.MutationResult<GraphqlTypes.CreateContactRelationMutation>;
export type CreateContactRelationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateContactRelationMutation, GraphqlTypes.CreateContactRelationMutationVariables>;
export const UpdateContactRelationDocument = gql`
    mutation UpdateContactRelation($input: UpdateContactRelationInput!) {
  updateContactRelation(input: $input) {
    __typename
    ... on ContactRelationObjectType {
      id
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpdateContactRelationMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateContactRelationMutation, GraphqlTypes.UpdateContactRelationMutationVariables>;

/**
 * __useUpdateContactRelationMutation__
 *
 * To run a mutation, you first call `useUpdateContactRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactRelationMutation, { data, loading, error }] = useUpdateContactRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactRelationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateContactRelationMutation, GraphqlTypes.UpdateContactRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateContactRelationMutation, GraphqlTypes.UpdateContactRelationMutationVariables>(UpdateContactRelationDocument, options);
      }
export type UpdateContactRelationMutationHookResult = ReturnType<typeof useUpdateContactRelationMutation>;
export type UpdateContactRelationMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateContactRelationMutation>;
export type UpdateContactRelationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateContactRelationMutation, GraphqlTypes.UpdateContactRelationMutationVariables>;
export const PatchContactRelationDocument = gql`
    mutation PatchContactRelation($input: PatchContactRelationInput!) {
  patchContactRelation(input: $input) {
    __typename
    ... on ContactRelationObjectType {
      id
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type PatchContactRelationMutationFn = Apollo.MutationFunction<GraphqlTypes.PatchContactRelationMutation, GraphqlTypes.PatchContactRelationMutationVariables>;

/**
 * __usePatchContactRelationMutation__
 *
 * To run a mutation, you first call `usePatchContactRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchContactRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchContactRelationMutation, { data, loading, error }] = usePatchContactRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchContactRelationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PatchContactRelationMutation, GraphqlTypes.PatchContactRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PatchContactRelationMutation, GraphqlTypes.PatchContactRelationMutationVariables>(PatchContactRelationDocument, options);
      }
export type PatchContactRelationMutationHookResult = ReturnType<typeof usePatchContactRelationMutation>;
export type PatchContactRelationMutationResult = Apollo.MutationResult<GraphqlTypes.PatchContactRelationMutation>;
export type PatchContactRelationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PatchContactRelationMutation, GraphqlTypes.PatchContactRelationMutationVariables>;
export const PatchContactRelationKeyPersonDocument = gql`
    mutation PatchContactRelationKeyPerson($input: PatchContactRelationKeyPersonInput!) {
  patchContactRelationKeyPerson(input: $input) {
    __typename
    ... on ContactRelationKeyPersonType {
      id
      isStarred
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type PatchContactRelationKeyPersonMutationFn = Apollo.MutationFunction<GraphqlTypes.PatchContactRelationKeyPersonMutation, GraphqlTypes.PatchContactRelationKeyPersonMutationVariables>;

/**
 * __usePatchContactRelationKeyPersonMutation__
 *
 * To run a mutation, you first call `usePatchContactRelationKeyPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchContactRelationKeyPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchContactRelationKeyPersonMutation, { data, loading, error }] = usePatchContactRelationKeyPersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchContactRelationKeyPersonMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PatchContactRelationKeyPersonMutation, GraphqlTypes.PatchContactRelationKeyPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PatchContactRelationKeyPersonMutation, GraphqlTypes.PatchContactRelationKeyPersonMutationVariables>(PatchContactRelationKeyPersonDocument, options);
      }
export type PatchContactRelationKeyPersonMutationHookResult = ReturnType<typeof usePatchContactRelationKeyPersonMutation>;
export type PatchContactRelationKeyPersonMutationResult = Apollo.MutationResult<GraphqlTypes.PatchContactRelationKeyPersonMutation>;
export type PatchContactRelationKeyPersonMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PatchContactRelationKeyPersonMutation, GraphqlTypes.PatchContactRelationKeyPersonMutationVariables>;
export const AddStaffToOrganizationDocument = gql`
    mutation AddStaffToOrganization($input: AddStaffToOrganizationInput!) {
  addStaffToOrganization(input: $input) {
    __typename
    ... on ContactObjectType {
      id
      fullName
      jobTitle
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type AddStaffToOrganizationMutationFn = Apollo.MutationFunction<GraphqlTypes.AddStaffToOrganizationMutation, GraphqlTypes.AddStaffToOrganizationMutationVariables>;

/**
 * __useAddStaffToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddStaffToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStaffToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStaffToOrganizationMutation, { data, loading, error }] = useAddStaffToOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStaffToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddStaffToOrganizationMutation, GraphqlTypes.AddStaffToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddStaffToOrganizationMutation, GraphqlTypes.AddStaffToOrganizationMutationVariables>(AddStaffToOrganizationDocument, options);
      }
export type AddStaffToOrganizationMutationHookResult = ReturnType<typeof useAddStaffToOrganizationMutation>;
export type AddStaffToOrganizationMutationResult = Apollo.MutationResult<GraphqlTypes.AddStaffToOrganizationMutation>;
export type AddStaffToOrganizationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddStaffToOrganizationMutation, GraphqlTypes.AddStaffToOrganizationMutationVariables>;
export const UpdateStaffEmploymentDocument = gql`
    mutation UpdateStaffEmployment($input: UpdateStaffEmploymentInput!) {
  updateStaffEmployment(input: $input) {
    __typename
    ... on ContactObjectType {
      id
      fullName
      jobTitle
      staffNotes
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpdateStaffEmploymentMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateStaffEmploymentMutation, GraphqlTypes.UpdateStaffEmploymentMutationVariables>;

/**
 * __useUpdateStaffEmploymentMutation__
 *
 * To run a mutation, you first call `useUpdateStaffEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStaffEmploymentMutation, { data, loading, error }] = useUpdateStaffEmploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStaffEmploymentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateStaffEmploymentMutation, GraphqlTypes.UpdateStaffEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateStaffEmploymentMutation, GraphqlTypes.UpdateStaffEmploymentMutationVariables>(UpdateStaffEmploymentDocument, options);
      }
export type UpdateStaffEmploymentMutationHookResult = ReturnType<typeof useUpdateStaffEmploymentMutation>;
export type UpdateStaffEmploymentMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateStaffEmploymentMutation>;
export type UpdateStaffEmploymentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateStaffEmploymentMutation, GraphqlTypes.UpdateStaffEmploymentMutationVariables>;
export const PatchStaffEmploymentDocument = gql`
    mutation PatchStaffEmployment($input: PatchStaffEmploymentInput!) {
  patchStaffEmployment(input: $input) {
    __typename
    ... on ContactObjectType {
      id
      isStarredStaff
      includeInFutureOrgProspects
      staffNotes
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type PatchStaffEmploymentMutationFn = Apollo.MutationFunction<GraphqlTypes.PatchStaffEmploymentMutation, GraphqlTypes.PatchStaffEmploymentMutationVariables>;

/**
 * __usePatchStaffEmploymentMutation__
 *
 * To run a mutation, you first call `usePatchStaffEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchStaffEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchStaffEmploymentMutation, { data, loading, error }] = usePatchStaffEmploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchStaffEmploymentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PatchStaffEmploymentMutation, GraphqlTypes.PatchStaffEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PatchStaffEmploymentMutation, GraphqlTypes.PatchStaffEmploymentMutationVariables>(PatchStaffEmploymentDocument, options);
      }
export type PatchStaffEmploymentMutationHookResult = ReturnType<typeof usePatchStaffEmploymentMutation>;
export type PatchStaffEmploymentMutationResult = Apollo.MutationResult<GraphqlTypes.PatchStaffEmploymentMutation>;
export type PatchStaffEmploymentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PatchStaffEmploymentMutation, GraphqlTypes.PatchStaffEmploymentMutationVariables>;
export const UpdateContactBioDocument = gql`
    mutation UpdateContactBio($contact: UpdateContactBioInput!) {
  updateContactBio(contact: $contact) {
    __typename
    ... on ContactObjectType {
      id
      jobTitle
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpdateContactBioMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateContactBioMutation, GraphqlTypes.UpdateContactBioMutationVariables>;

/**
 * __useUpdateContactBioMutation__
 *
 * To run a mutation, you first call `useUpdateContactBioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactBioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactBioMutation, { data, loading, error }] = useUpdateContactBioMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useUpdateContactBioMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateContactBioMutation, GraphqlTypes.UpdateContactBioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateContactBioMutation, GraphqlTypes.UpdateContactBioMutationVariables>(UpdateContactBioDocument, options);
      }
export type UpdateContactBioMutationHookResult = ReturnType<typeof useUpdateContactBioMutation>;
export type UpdateContactBioMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateContactBioMutation>;
export type UpdateContactBioMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateContactBioMutation, GraphqlTypes.UpdateContactBioMutationVariables>;
export const ProspectLinkContactDocument = gql`
    mutation ProspectLinkContact($linkInput: ProspectLinkContactInput!) {
  prospectLinkContact(linkInput: $linkInput) {
    __typename
    ... on ProspectObjectType {
      id
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type ProspectLinkContactMutationFn = Apollo.MutationFunction<GraphqlTypes.ProspectLinkContactMutation, GraphqlTypes.ProspectLinkContactMutationVariables>;

/**
 * __useProspectLinkContactMutation__
 *
 * To run a mutation, you first call `useProspectLinkContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProspectLinkContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prospectLinkContactMutation, { data, loading, error }] = useProspectLinkContactMutation({
 *   variables: {
 *      linkInput: // value for 'linkInput'
 *   },
 * });
 */
export function useProspectLinkContactMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ProspectLinkContactMutation, GraphqlTypes.ProspectLinkContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ProspectLinkContactMutation, GraphqlTypes.ProspectLinkContactMutationVariables>(ProspectLinkContactDocument, options);
      }
export type ProspectLinkContactMutationHookResult = ReturnType<typeof useProspectLinkContactMutation>;
export type ProspectLinkContactMutationResult = Apollo.MutationResult<GraphqlTypes.ProspectLinkContactMutation>;
export type ProspectLinkContactMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ProspectLinkContactMutation, GraphqlTypes.ProspectLinkContactMutationVariables>;
export const GetRelationLabelsForUpsertDocument = gql`
    query GetRelationLabelsForUpsert {
  contactRelationLabels {
    id
    labelText
    inverseLabelText
    sortOrder
    availableTo
    inverseAvailableTo
  }
}
    `;

/**
 * __useGetRelationLabelsForUpsertQuery__
 *
 * To run a query within a React component, call `useGetRelationLabelsForUpsertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelationLabelsForUpsertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelationLabelsForUpsertQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRelationLabelsForUpsertQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>(GetRelationLabelsForUpsertDocument, options);
      }
export function useGetRelationLabelsForUpsertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>(GetRelationLabelsForUpsertDocument, options);
        }
// @ts-ignore
export function useGetRelationLabelsForUpsertSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>;
export function useGetRelationLabelsForUpsertSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRelationLabelsForUpsertQuery | undefined, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>;
export function useGetRelationLabelsForUpsertSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>(GetRelationLabelsForUpsertDocument, options);
        }
export type GetRelationLabelsForUpsertQueryHookResult = ReturnType<typeof useGetRelationLabelsForUpsertQuery>;
export type GetRelationLabelsForUpsertLazyQueryHookResult = ReturnType<typeof useGetRelationLabelsForUpsertLazyQuery>;
export type GetRelationLabelsForUpsertSuspenseQueryHookResult = ReturnType<typeof useGetRelationLabelsForUpsertSuspenseQuery>;
export type GetRelationLabelsForUpsertQueryResult = Apollo.QueryResult<GraphqlTypes.GetRelationLabelsForUpsertQuery, GraphqlTypes.GetRelationLabelsForUpsertQueryVariables>;
export const SearchContactsForRelationDocument = gql`
    query SearchContactsForRelation($term: String!, $objectFilter: SearchObjectFilterInputEnum, $first: Int) {
  searchContacts(term: $term, objectFilter: $objectFilter, first: $first) {
    edges {
      node {
        id
        fullName
        contactType
        company {
          id
          fullName
        }
        jobTitle
      }
    }
  }
}
    `;

/**
 * __useSearchContactsForRelationQuery__
 *
 * To run a query within a React component, call `useSearchContactsForRelationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsForRelationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsForRelationQuery({
 *   variables: {
 *      term: // value for 'term'
 *      objectFilter: // value for 'objectFilter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchContactsForRelationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables> & ({ variables: GraphqlTypes.SearchContactsForRelationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>(SearchContactsForRelationDocument, options);
      }
export function useSearchContactsForRelationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>(SearchContactsForRelationDocument, options);
        }
// @ts-ignore
export function useSearchContactsForRelationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>;
export function useSearchContactsForRelationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchContactsForRelationQuery | undefined, GraphqlTypes.SearchContactsForRelationQueryVariables>;
export function useSearchContactsForRelationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>(SearchContactsForRelationDocument, options);
        }
export type SearchContactsForRelationQueryHookResult = ReturnType<typeof useSearchContactsForRelationQuery>;
export type SearchContactsForRelationLazyQueryHookResult = ReturnType<typeof useSearchContactsForRelationLazyQuery>;
export type SearchContactsForRelationSuspenseQueryHookResult = ReturnType<typeof useSearchContactsForRelationSuspenseQuery>;
export type SearchContactsForRelationQueryResult = Apollo.QueryResult<GraphqlTypes.SearchContactsForRelationQuery, GraphqlTypes.SearchContactsForRelationQueryVariables>;
export const GetContactStaffDocument = gql`
    query GetContactStaff($contactId: ID!) {
  contact(contactId: $contactId) {
    id
    staff {
      id
      fullName
      jobTitle
      isStarredStaff
      staffNotes
    }
  }
}
    `;

/**
 * __useGetContactStaffQuery__
 *
 * To run a query within a React component, call `useGetContactStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactStaffQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactStaffQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables> & ({ variables: GraphqlTypes.GetContactStaffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>(GetContactStaffDocument, options);
      }
export function useGetContactStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>(GetContactStaffDocument, options);
        }
// @ts-ignore
export function useGetContactStaffSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>;
export function useGetContactStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactStaffQuery | undefined, GraphqlTypes.GetContactStaffQueryVariables>;
export function useGetContactStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>(GetContactStaffDocument, options);
        }
export type GetContactStaffQueryHookResult = ReturnType<typeof useGetContactStaffQuery>;
export type GetContactStaffLazyQueryHookResult = ReturnType<typeof useGetContactStaffLazyQuery>;
export type GetContactStaffSuspenseQueryHookResult = ReturnType<typeof useGetContactStaffSuspenseQuery>;
export type GetContactStaffQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactStaffQuery, GraphqlTypes.GetContactStaffQueryVariables>;
export const GetContactProspectsForRelationDocument = gql`
    query GetContactProspectsForRelation($contactId: ID!) {
  contactProspects(contactId: $contactId, includeInactive: false) {
    edges {
      node {
        prospectId
        offeringName
        prospect {
          prospectContactMaps {
            contactId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetContactProspectsForRelationQuery__
 *
 * To run a query within a React component, call `useGetContactProspectsForRelationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactProspectsForRelationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactProspectsForRelationQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetContactProspectsForRelationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables> & ({ variables: GraphqlTypes.GetContactProspectsForRelationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>(GetContactProspectsForRelationDocument, options);
      }
export function useGetContactProspectsForRelationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>(GetContactProspectsForRelationDocument, options);
        }
// @ts-ignore
export function useGetContactProspectsForRelationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>;
export function useGetContactProspectsForRelationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactProspectsForRelationQuery | undefined, GraphqlTypes.GetContactProspectsForRelationQueryVariables>;
export function useGetContactProspectsForRelationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>(GetContactProspectsForRelationDocument, options);
        }
export type GetContactProspectsForRelationQueryHookResult = ReturnType<typeof useGetContactProspectsForRelationQuery>;
export type GetContactProspectsForRelationLazyQueryHookResult = ReturnType<typeof useGetContactProspectsForRelationLazyQuery>;
export type GetContactProspectsForRelationSuspenseQueryHookResult = ReturnType<typeof useGetContactProspectsForRelationSuspenseQuery>;
export type GetContactProspectsForRelationQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactProspectsForRelationQuery, GraphqlTypes.GetContactProspectsForRelationQueryVariables>;
export const GetContactsByIdConnectDocument = gql`
    query GetContactsByIdConnect($contactIds: [ID!]!, $first: Int!, $after: String) {
  contactsById(contactIds: $contactIds, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        linkedinUrl
        emails {
          id
          emailAddress
          emailType
          isPrimary
        }
        phones {
          id
          phoneNumber
          phoneType
        }
      }
    }
  }
}
    `;

/**
 * __useGetContactsByIdConnectQuery__
 *
 * To run a query within a React component, call `useGetContactsByIdConnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByIdConnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByIdConnectQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetContactsByIdConnectQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables> & ({ variables: GraphqlTypes.GetContactsByIdConnectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>(GetContactsByIdConnectDocument, options);
      }
export function useGetContactsByIdConnectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>(GetContactsByIdConnectDocument, options);
        }
// @ts-ignore
export function useGetContactsByIdConnectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>;
export function useGetContactsByIdConnectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsByIdConnectQuery | undefined, GraphqlTypes.GetContactsByIdConnectQueryVariables>;
export function useGetContactsByIdConnectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>(GetContactsByIdConnectDocument, options);
        }
export type GetContactsByIdConnectQueryHookResult = ReturnType<typeof useGetContactsByIdConnectQuery>;
export type GetContactsByIdConnectLazyQueryHookResult = ReturnType<typeof useGetContactsByIdConnectLazyQuery>;
export type GetContactsByIdConnectSuspenseQueryHookResult = ReturnType<typeof useGetContactsByIdConnectSuspenseQuery>;
export type GetContactsByIdConnectQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsByIdConnectQuery, GraphqlTypes.GetContactsByIdConnectQueryVariables>;
export const SetNavOptedInDocument = gql`
    mutation SetNavOptedIn($isOptedIn: Boolean!) {
  setNavOptedIn(isOptedIn: $isOptedIn) {
    user {
      id
      navOptedIn
    }
  }
}
    `;
export type SetNavOptedInMutationFn = Apollo.MutationFunction<GraphqlTypes.SetNavOptedInMutation, GraphqlTypes.SetNavOptedInMutationVariables>;

/**
 * __useSetNavOptedInMutation__
 *
 * To run a mutation, you first call `useSetNavOptedInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNavOptedInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNavOptedInMutation, { data, loading, error }] = useSetNavOptedInMutation({
 *   variables: {
 *      isOptedIn: // value for 'isOptedIn'
 *   },
 * });
 */
export function useSetNavOptedInMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetNavOptedInMutation, GraphqlTypes.SetNavOptedInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetNavOptedInMutation, GraphqlTypes.SetNavOptedInMutationVariables>(SetNavOptedInDocument, options);
      }
export type SetNavOptedInMutationHookResult = ReturnType<typeof useSetNavOptedInMutation>;
export type SetNavOptedInMutationResult = Apollo.MutationResult<GraphqlTypes.SetNavOptedInMutation>;
export type SetNavOptedInMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetNavOptedInMutation, GraphqlTypes.SetNavOptedInMutationVariables>;
export const MarketLensPersonByGuidDocument = gql`
    query MarketLensPersonByGuid($personGuid: ID!, $arenaId: ID) {
  marketLensContact(personGuid: $personGuid, arenaId: $arenaId) {
    __typename
    ... on MarketLensContact {
      prefix
      firstName
      middleName
      lastName
      suffix
      email
      phone
      linkedinUrl
      currentJobTitle
      streetAddress
      streetAddress2
      city
      state
      zipCode
      country
      specialty
      positions {
        contactType
      }
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useMarketLensPersonByGuidQuery__
 *
 * To run a query within a React component, call `useMarketLensPersonByGuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketLensPersonByGuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketLensPersonByGuidQuery({
 *   variables: {
 *      personGuid: // value for 'personGuid'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useMarketLensPersonByGuidQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables> & ({ variables: GraphqlTypes.MarketLensPersonByGuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>(MarketLensPersonByGuidDocument, options);
      }
export function useMarketLensPersonByGuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>(MarketLensPersonByGuidDocument, options);
        }
// @ts-ignore
export function useMarketLensPersonByGuidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>;
export function useMarketLensPersonByGuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensPersonByGuidQuery | undefined, GraphqlTypes.MarketLensPersonByGuidQueryVariables>;
export function useMarketLensPersonByGuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>(MarketLensPersonByGuidDocument, options);
        }
export type MarketLensPersonByGuidQueryHookResult = ReturnType<typeof useMarketLensPersonByGuidQuery>;
export type MarketLensPersonByGuidLazyQueryHookResult = ReturnType<typeof useMarketLensPersonByGuidLazyQuery>;
export type MarketLensPersonByGuidSuspenseQueryHookResult = ReturnType<typeof useMarketLensPersonByGuidSuspenseQuery>;
export type MarketLensPersonByGuidQueryResult = Apollo.QueryResult<GraphqlTypes.MarketLensPersonByGuidQuery, GraphqlTypes.MarketLensPersonByGuidQueryVariables>;
export const GetReviewDrawerSignalDocument = gql`
    query GetReviewDrawerSignal($objectInput: ChangeRequestQueryInput!) {
  changeRequests(objectInput: $objectInput) {
    __typename
    ... on ChangeRequestQueryResponse {
      approvalRequests {
        id
        status
        requestedAt
        changeRequest {
          changeRequestType
          changeRequestedObj {
            __typename
            ... on MarketLensContactUpdateSignalObjectType {
              changeType
              marketLensGuid
              marketLensFirmGuid
              description
              contactUnderReview {
                id
              }
              contactFirm {
                id
              }
            }
            ... on MarketLensServiceProviderUpdateSignalObjectType {
              changeType
              marketLensServiceProviderGuid
              marketLensInvestorFirmGuid
              description
              serviceProviderContact {
                id
              }
              investorFirmContact {
                id
              }
            }
          }
        }
      }
    }
    ... on QueryErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetReviewDrawerSignalQuery__
 *
 * To run a query within a React component, call `useGetReviewDrawerSignalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewDrawerSignalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewDrawerSignalQuery({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useGetReviewDrawerSignalQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables> & ({ variables: GraphqlTypes.GetReviewDrawerSignalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>(GetReviewDrawerSignalDocument, options);
      }
export function useGetReviewDrawerSignalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>(GetReviewDrawerSignalDocument, options);
        }
// @ts-ignore
export function useGetReviewDrawerSignalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>;
export function useGetReviewDrawerSignalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewDrawerSignalQuery | undefined, GraphqlTypes.GetReviewDrawerSignalQueryVariables>;
export function useGetReviewDrawerSignalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>(GetReviewDrawerSignalDocument, options);
        }
export type GetReviewDrawerSignalQueryHookResult = ReturnType<typeof useGetReviewDrawerSignalQuery>;
export type GetReviewDrawerSignalLazyQueryHookResult = ReturnType<typeof useGetReviewDrawerSignalLazyQuery>;
export type GetReviewDrawerSignalSuspenseQueryHookResult = ReturnType<typeof useGetReviewDrawerSignalSuspenseQuery>;
export type GetReviewDrawerSignalQueryResult = Apollo.QueryResult<GraphqlTypes.GetReviewDrawerSignalQuery, GraphqlTypes.GetReviewDrawerSignalQueryVariables>;
export const ReviewDrawerProspectRostersDocument = gql`
    query ReviewDrawerProspectRosters($contactId: ID!, $first: Int!) {
  contactProspects(contactId: $contactId, includeInactive: false, first: $first) {
    edges {
      node {
        isProspectClosed
        prospect {
          id
          offeringId
          offeringName
          prospectContactMaps {
            contactId
            contact {
              id
              fullName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReviewDrawerProspectRostersQuery__
 *
 * To run a query within a React component, call `useReviewDrawerProspectRostersQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewDrawerProspectRostersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewDrawerProspectRostersQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useReviewDrawerProspectRostersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables> & ({ variables: GraphqlTypes.ReviewDrawerProspectRostersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>(ReviewDrawerProspectRostersDocument, options);
      }
export function useReviewDrawerProspectRostersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>(ReviewDrawerProspectRostersDocument, options);
        }
// @ts-ignore
export function useReviewDrawerProspectRostersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>;
export function useReviewDrawerProspectRostersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ReviewDrawerProspectRostersQuery | undefined, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>;
export function useReviewDrawerProspectRostersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>(ReviewDrawerProspectRostersDocument, options);
        }
export type ReviewDrawerProspectRostersQueryHookResult = ReturnType<typeof useReviewDrawerProspectRostersQuery>;
export type ReviewDrawerProspectRostersLazyQueryHookResult = ReturnType<typeof useReviewDrawerProspectRostersLazyQuery>;
export type ReviewDrawerProspectRostersSuspenseQueryHookResult = ReturnType<typeof useReviewDrawerProspectRostersSuspenseQuery>;
export type ReviewDrawerProspectRostersQueryResult = Apollo.QueryResult<GraphqlTypes.ReviewDrawerProspectRostersQuery, GraphqlTypes.ReviewDrawerProspectRostersQueryVariables>;
export const GetSearchedContactsFederatedDocument = gql`
    query GetSearchedContactsFederated($term: String!, $excludeContactIds: [ID], $excludeContactsOnAccountId: ID) {
  searchedContacts(
    term: $term
    excludeContactIds: $excludeContactIds
    excludeContactsOnAccountId: $excludeContactsOnAccountId
  ) {
    result {
      id
      label
      isOrg
    }
  }
}
    `;

/**
 * __useGetSearchedContactsFederatedQuery__
 *
 * To run a query within a React component, call `useGetSearchedContactsFederatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchedContactsFederatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchedContactsFederatedQuery({
 *   variables: {
 *      term: // value for 'term'
 *      excludeContactIds: // value for 'excludeContactIds'
 *      excludeContactsOnAccountId: // value for 'excludeContactsOnAccountId'
 *   },
 * });
 */
export function useGetSearchedContactsFederatedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables> & ({ variables: GraphqlTypes.GetSearchedContactsFederatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>(GetSearchedContactsFederatedDocument, options);
      }
export function useGetSearchedContactsFederatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>(GetSearchedContactsFederatedDocument, options);
        }
// @ts-ignore
export function useGetSearchedContactsFederatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>;
export function useGetSearchedContactsFederatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSearchedContactsFederatedQuery | undefined, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>;
export function useGetSearchedContactsFederatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>(GetSearchedContactsFederatedDocument, options);
        }
export type GetSearchedContactsFederatedQueryHookResult = ReturnType<typeof useGetSearchedContactsFederatedQuery>;
export type GetSearchedContactsFederatedLazyQueryHookResult = ReturnType<typeof useGetSearchedContactsFederatedLazyQuery>;
export type GetSearchedContactsFederatedSuspenseQueryHookResult = ReturnType<typeof useGetSearchedContactsFederatedSuspenseQuery>;
export type GetSearchedContactsFederatedQueryResult = Apollo.QueryResult<GraphqlTypes.GetSearchedContactsFederatedQuery, GraphqlTypes.GetSearchedContactsFederatedQueryVariables>;
export const GetCoBrowseDevFeatureFlagsDocument = gql`
    query GetCoBrowseDevFeatureFlags {
  devFeatures {
    enableCoBrowseFeature
  }
}
    `;

/**
 * __useGetCoBrowseDevFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetCoBrowseDevFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoBrowseDevFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoBrowseDevFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoBrowseDevFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>(GetCoBrowseDevFeatureFlagsDocument, options);
      }
export function useGetCoBrowseDevFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>(GetCoBrowseDevFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useGetCoBrowseDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>;
export function useGetCoBrowseDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery | undefined, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>;
export function useGetCoBrowseDevFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>(GetCoBrowseDevFeatureFlagsDocument, options);
        }
export type GetCoBrowseDevFeatureFlagsQueryHookResult = ReturnType<typeof useGetCoBrowseDevFeatureFlagsQuery>;
export type GetCoBrowseDevFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetCoBrowseDevFeatureFlagsLazyQuery>;
export type GetCoBrowseDevFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetCoBrowseDevFeatureFlagsSuspenseQuery>;
export type GetCoBrowseDevFeatureFlagsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCoBrowseDevFeatureFlagsQuery, GraphqlTypes.GetCoBrowseDevFeatureFlagsQueryVariables>;
export const GetDynamicSupportingDocumentsDocument = gql`
    query GetDynamicSupportingDocuments($dataRoomKey: String!, $arenaDomain: String!) {
  subscriptionByDataRoomKey(dataRoomKey: $dataRoomKey, arenaDomain: $arenaDomain) {
    id
    supportingDocumentsRequested {
      section {
        ...DynamicSupportingDocSectionFields
      }
      promptResponder {
        contactUuid
        name
      }
    }
    supportingDocumentsResponses {
      ...DynamicSupportingDocLpResponseFields
    }
  }
}
    ${DynamicSupportingDocSectionFieldsFragmentDoc}
${DynamicSupportingDocLpResponseFieldsFragmentDoc}`;

/**
 * __useGetDynamicSupportingDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDynamicSupportingDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicSupportingDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicSupportingDocumentsQuery({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useGetDynamicSupportingDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables> & ({ variables: GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>(GetDynamicSupportingDocumentsDocument, options);
      }
export function useGetDynamicSupportingDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>(GetDynamicSupportingDocumentsDocument, options);
        }
// @ts-ignore
export function useGetDynamicSupportingDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>;
export function useGetDynamicSupportingDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDynamicSupportingDocumentsQuery | undefined, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>;
export function useGetDynamicSupportingDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>(GetDynamicSupportingDocumentsDocument, options);
        }
export type GetDynamicSupportingDocumentsQueryHookResult = ReturnType<typeof useGetDynamicSupportingDocumentsQuery>;
export type GetDynamicSupportingDocumentsLazyQueryHookResult = ReturnType<typeof useGetDynamicSupportingDocumentsLazyQuery>;
export type GetDynamicSupportingDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetDynamicSupportingDocumentsSuspenseQuery>;
export type GetDynamicSupportingDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDynamicSupportingDocumentsQuery, GraphqlTypes.GetDynamicSupportingDocumentsQueryVariables>;
export const GetEmailDistributionListDocument = gql`
    query GetEmailDistributionList($arenaId: String!, $includeDeleted: Boolean, $investorCanManage: Boolean) {
  emailDistributionList(
    arenaId: $arenaId
    includeDeleted: $includeDeleted
    investorCanManage: $investorCanManage
  ) {
    id
    name
    description
    canInvestorsManage
    sortOrder
    newContactDefault
    documentCategories {
      id
      name
    }
  }
}
    `;

/**
 * __useGetEmailDistributionListQuery__
 *
 * To run a query within a React component, call `useGetEmailDistributionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailDistributionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailDistributionListQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      includeDeleted: // value for 'includeDeleted'
 *      investorCanManage: // value for 'investorCanManage'
 *   },
 * });
 */
export function useGetEmailDistributionListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables> & ({ variables: GraphqlTypes.GetEmailDistributionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>(GetEmailDistributionListDocument, options);
      }
export function useGetEmailDistributionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>(GetEmailDistributionListDocument, options);
        }
// @ts-ignore
export function useGetEmailDistributionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>;
export function useGetEmailDistributionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEmailDistributionListQuery | undefined, GraphqlTypes.GetEmailDistributionListQueryVariables>;
export function useGetEmailDistributionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>(GetEmailDistributionListDocument, options);
        }
export type GetEmailDistributionListQueryHookResult = ReturnType<typeof useGetEmailDistributionListQuery>;
export type GetEmailDistributionListLazyQueryHookResult = ReturnType<typeof useGetEmailDistributionListLazyQuery>;
export type GetEmailDistributionListSuspenseQueryHookResult = ReturnType<typeof useGetEmailDistributionListSuspenseQuery>;
export type GetEmailDistributionListQueryResult = Apollo.QueryResult<GraphqlTypes.GetEmailDistributionListQuery, GraphqlTypes.GetEmailDistributionListQueryVariables>;
export const GetAccountContactsIdsDocument = gql`
    query GetAccountContactsIds($filters: AccountContactsFilters) {
  accountContacts(filters: $filters) {
    edges {
      node {
        id
        accountId
        accountName
        arenaName
        contactId
        contactDetails {
          id
          fullName
          primaryEmail {
            id
            emailAddress
          }
          portalFullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountContactsIdsQuery__
 *
 * To run a query within a React component, call `useGetAccountContactsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountContactsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountContactsIdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAccountContactsIdsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>(GetAccountContactsIdsDocument, options);
      }
export function useGetAccountContactsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>(GetAccountContactsIdsDocument, options);
        }
// @ts-ignore
export function useGetAccountContactsIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>;
export function useGetAccountContactsIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsIdsQuery | undefined, GraphqlTypes.GetAccountContactsIdsQueryVariables>;
export function useGetAccountContactsIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>(GetAccountContactsIdsDocument, options);
        }
export type GetAccountContactsIdsQueryHookResult = ReturnType<typeof useGetAccountContactsIdsQuery>;
export type GetAccountContactsIdsLazyQueryHookResult = ReturnType<typeof useGetAccountContactsIdsLazyQuery>;
export type GetAccountContactsIdsSuspenseQueryHookResult = ReturnType<typeof useGetAccountContactsIdsSuspenseQuery>;
export type GetAccountContactsIdsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountContactsIdsQuery, GraphqlTypes.GetAccountContactsIdsQueryVariables>;
export const GetAccountContactsDocument = gql`
    query GetAccountContacts($first: Int!, $after: String, $filters: AccountContactsFilters) {
  accountContacts(first: $first, after: $after, filters: $filters) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        isAdminContact
        isMainContact
        accountId
        accountName
        arenaId
        arenaName
        contactId
        modifiedAt
        hasPortalAccount
        contactDetails {
          id
          portalFullName
          primaryEmail {
            id
            emailAddress
          }
          firstName
          lastName
        }
        label {
          id
          labelText
        }
        communicationPrefs {
          id
          emailDistributionList {
            name
            id
            description
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountContactsQuery__
 *
 * To run a query within a React component, call `useGetAccountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountContactsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAccountContactsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables> & ({ variables: GraphqlTypes.GetAccountContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>(GetAccountContactsDocument, options);
      }
export function useGetAccountContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>(GetAccountContactsDocument, options);
        }
// @ts-ignore
export function useGetAccountContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>;
export function useGetAccountContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountContactsQuery | undefined, GraphqlTypes.GetAccountContactsQueryVariables>;
export function useGetAccountContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>(GetAccountContactsDocument, options);
        }
export type GetAccountContactsQueryHookResult = ReturnType<typeof useGetAccountContactsQuery>;
export type GetAccountContactsLazyQueryHookResult = ReturnType<typeof useGetAccountContactsLazyQuery>;
export type GetAccountContactsSuspenseQueryHookResult = ReturnType<typeof useGetAccountContactsSuspenseQuery>;
export type GetAccountContactsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountContactsQuery, GraphqlTypes.GetAccountContactsQueryVariables>;
export const GetRecentRequestDocument = gql`
    query GetRecentRequest($input: RecentlyAddedInput!) {
  recentChangeRequests(objectInput: $input) {
    ... on RecentlyAddedContactsResponse {
      responses {
        requestId
        requestType
        requestPayload
        status
      }
    }
    ... on QueryErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetRecentRequestQuery__
 *
 * To run a query within a React component, call `useGetRecentRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentRequestQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRecentRequestQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables> & ({ variables: GraphqlTypes.GetRecentRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>(GetRecentRequestDocument, options);
      }
export function useGetRecentRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>(GetRecentRequestDocument, options);
        }
// @ts-ignore
export function useGetRecentRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>;
export function useGetRecentRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRecentRequestQuery | undefined, GraphqlTypes.GetRecentRequestQueryVariables>;
export function useGetRecentRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>(GetRecentRequestDocument, options);
        }
export type GetRecentRequestQueryHookResult = ReturnType<typeof useGetRecentRequestQuery>;
export type GetRecentRequestLazyQueryHookResult = ReturnType<typeof useGetRecentRequestLazyQuery>;
export type GetRecentRequestSuspenseQueryHookResult = ReturnType<typeof useGetRecentRequestSuspenseQuery>;
export type GetRecentRequestQueryResult = Apollo.QueryResult<GraphqlTypes.GetRecentRequestQuery, GraphqlTypes.GetRecentRequestQueryVariables>;
export const GetDynamicCustomSectionsDocument = gql`
    query GetDynamicCustomSections($dataRoomKey: String!, $arenaDomain: String!) {
  subscriptionByDataRoomKey(dataRoomKey: $dataRoomKey, arenaDomain: $arenaDomain) {
    __typename
    id
    customSectionsRequested {
      __typename
      section {
        ...DynamicSupportingDocSectionFields
      }
      promptResponder {
        __typename
        contactUuid
        name
      }
      status
    }
  }
}
    ${DynamicSupportingDocSectionFieldsFragmentDoc}`;

/**
 * __useGetDynamicCustomSectionsQuery__
 *
 * To run a query within a React component, call `useGetDynamicCustomSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicCustomSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicCustomSectionsQuery({
 *   variables: {
 *      dataRoomKey: // value for 'dataRoomKey'
 *      arenaDomain: // value for 'arenaDomain'
 *   },
 * });
 */
export function useGetDynamicCustomSectionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables> & ({ variables: GraphqlTypes.GetDynamicCustomSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>(GetDynamicCustomSectionsDocument, options);
      }
export function useGetDynamicCustomSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>(GetDynamicCustomSectionsDocument, options);
        }
// @ts-ignore
export function useGetDynamicCustomSectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>;
export function useGetDynamicCustomSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDynamicCustomSectionsQuery | undefined, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>;
export function useGetDynamicCustomSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>(GetDynamicCustomSectionsDocument, options);
        }
export type GetDynamicCustomSectionsQueryHookResult = ReturnType<typeof useGetDynamicCustomSectionsQuery>;
export type GetDynamicCustomSectionsLazyQueryHookResult = ReturnType<typeof useGetDynamicCustomSectionsLazyQuery>;
export type GetDynamicCustomSectionsSuspenseQueryHookResult = ReturnType<typeof useGetDynamicCustomSectionsSuspenseQuery>;
export type GetDynamicCustomSectionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDynamicCustomSectionsQuery, GraphqlTypes.GetDynamicCustomSectionsQueryVariables>;
export const AcceptNewManagerInvitationDocument = gql`
    mutation AcceptNewManagerInvitation($objectInput: AcceptPortalInvitationInput!) {
  acceptPortalInvitation(objectInput: $objectInput) {
    __typename
    ... on MutationSuccessResponse {
      didSucceed
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type AcceptNewManagerInvitationMutationFn = Apollo.MutationFunction<GraphqlTypes.AcceptNewManagerInvitationMutation, GraphqlTypes.AcceptNewManagerInvitationMutationVariables>;

/**
 * __useAcceptNewManagerInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptNewManagerInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptNewManagerInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptNewManagerInvitationMutation, { data, loading, error }] = useAcceptNewManagerInvitationMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useAcceptNewManagerInvitationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AcceptNewManagerInvitationMutation, GraphqlTypes.AcceptNewManagerInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AcceptNewManagerInvitationMutation, GraphqlTypes.AcceptNewManagerInvitationMutationVariables>(AcceptNewManagerInvitationDocument, options);
      }
export type AcceptNewManagerInvitationMutationHookResult = ReturnType<typeof useAcceptNewManagerInvitationMutation>;
export type AcceptNewManagerInvitationMutationResult = Apollo.MutationResult<GraphqlTypes.AcceptNewManagerInvitationMutation>;
export type AcceptNewManagerInvitationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AcceptNewManagerInvitationMutation, GraphqlTypes.AcceptNewManagerInvitationMutationVariables>;
export const DeclineNewManagerInvitationDocument = gql`
    mutation DeclineNewManagerInvitation($objectInput: DeclinePortalInvitationInput!) {
  declinePortalInvitation(objectInput: $objectInput) {
    __typename
    ... on MutationSuccessResponse {
      didSucceed
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type DeclineNewManagerInvitationMutationFn = Apollo.MutationFunction<GraphqlTypes.DeclineNewManagerInvitationMutation, GraphqlTypes.DeclineNewManagerInvitationMutationVariables>;

/**
 * __useDeclineNewManagerInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineNewManagerInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineNewManagerInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineNewManagerInvitationMutation, { data, loading, error }] = useDeclineNewManagerInvitationMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDeclineNewManagerInvitationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeclineNewManagerInvitationMutation, GraphqlTypes.DeclineNewManagerInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeclineNewManagerInvitationMutation, GraphqlTypes.DeclineNewManagerInvitationMutationVariables>(DeclineNewManagerInvitationDocument, options);
      }
export type DeclineNewManagerInvitationMutationHookResult = ReturnType<typeof useDeclineNewManagerInvitationMutation>;
export type DeclineNewManagerInvitationMutationResult = Apollo.MutationResult<GraphqlTypes.DeclineNewManagerInvitationMutation>;
export type DeclineNewManagerInvitationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeclineNewManagerInvitationMutation, GraphqlTypes.DeclineNewManagerInvitationMutationVariables>;
export const ExcelExportInvestmentsPortalDocument = gql`
    mutation ExcelExportInvestmentsPortal($managerArenaId: ID, $filters: InvestmentFilters, $headers: [String!]!, $exportInvestmentInput: PortalExportInvestmentsInput) {
  excelExportInvestmentsPortal(
    managerArenaId: $managerArenaId
    filters: $filters
    headers: $headers
    exportInvestmentInput: $exportInvestmentInput
  ) {
    __typename
    ... on ExcelExportInvestmentsPortalObject {
      job {
        id
        status
        jobType
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type ExcelExportInvestmentsPortalMutationFn = Apollo.MutationFunction<GraphqlTypes.ExcelExportInvestmentsPortalMutation, GraphqlTypes.ExcelExportInvestmentsPortalMutationVariables>;

/**
 * __useExcelExportInvestmentsPortalMutation__
 *
 * To run a mutation, you first call `useExcelExportInvestmentsPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcelExportInvestmentsPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excelExportInvestmentsPortalMutation, { data, loading, error }] = useExcelExportInvestmentsPortalMutation({
 *   variables: {
 *      managerArenaId: // value for 'managerArenaId'
 *      filters: // value for 'filters'
 *      headers: // value for 'headers'
 *      exportInvestmentInput: // value for 'exportInvestmentInput'
 *   },
 * });
 */
export function useExcelExportInvestmentsPortalMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExcelExportInvestmentsPortalMutation, GraphqlTypes.ExcelExportInvestmentsPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExcelExportInvestmentsPortalMutation, GraphqlTypes.ExcelExportInvestmentsPortalMutationVariables>(ExcelExportInvestmentsPortalDocument, options);
      }
export type ExcelExportInvestmentsPortalMutationHookResult = ReturnType<typeof useExcelExportInvestmentsPortalMutation>;
export type ExcelExportInvestmentsPortalMutationResult = Apollo.MutationResult<GraphqlTypes.ExcelExportInvestmentsPortalMutation>;
export type ExcelExportInvestmentsPortalMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExcelExportInvestmentsPortalMutation, GraphqlTypes.ExcelExportInvestmentsPortalMutationVariables>;
export const GetLpEarliestTicketCreatedAtDocument = gql`
    query GetLpEarliestTicketCreatedAt($arenaId: ID, $filters: LpTicketFilterInput) {
  lpEarliestTicketCreatedAt(arenaId: $arenaId, filters: $filters)
}
    `;

/**
 * __useGetLpEarliestTicketCreatedAtQuery__
 *
 * To run a query within a React component, call `useGetLpEarliestTicketCreatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLpEarliestTicketCreatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLpEarliestTicketCreatedAtQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetLpEarliestTicketCreatedAtQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>(GetLpEarliestTicketCreatedAtDocument, options);
      }
export function useGetLpEarliestTicketCreatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>(GetLpEarliestTicketCreatedAtDocument, options);
        }
// @ts-ignore
export function useGetLpEarliestTicketCreatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>;
export function useGetLpEarliestTicketCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery | undefined, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>;
export function useGetLpEarliestTicketCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>(GetLpEarliestTicketCreatedAtDocument, options);
        }
export type GetLpEarliestTicketCreatedAtQueryHookResult = ReturnType<typeof useGetLpEarliestTicketCreatedAtQuery>;
export type GetLpEarliestTicketCreatedAtLazyQueryHookResult = ReturnType<typeof useGetLpEarliestTicketCreatedAtLazyQuery>;
export type GetLpEarliestTicketCreatedAtSuspenseQueryHookResult = ReturnType<typeof useGetLpEarliestTicketCreatedAtSuspenseQuery>;
export type GetLpEarliestTicketCreatedAtQueryResult = Apollo.QueryResult<GraphqlTypes.GetLpEarliestTicketCreatedAtQuery, GraphqlTypes.GetLpEarliestTicketCreatedAtQueryVariables>;
export const GetLpTicketsDocument = gql`
    query GetLpTickets($arenaId: ID, $filters: LpTicketFilterInput, $sort: LpTicketSortInput, $cursor: String) {
  lpTickets(arenaId: $arenaId, filters: $filters, sort: $sort, cursor: $cursor) {
    tickets {
      id
      subject
      lastMessagePreview
      status
      lastMessageAt
      hasUnread
      startedByUser {
        id
        globalUserId
        fullName
      }
      arena {
        id
        name
        logoUrl
      }
    }
    hasNextPage
    nextCursor
  }
}
    `;

/**
 * __useGetLpTicketsQuery__
 *
 * To run a query within a React component, call `useGetLpTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLpTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLpTicketsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetLpTicketsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>(GetLpTicketsDocument, options);
      }
export function useGetLpTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>(GetLpTicketsDocument, options);
        }
// @ts-ignore
export function useGetLpTicketsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>;
export function useGetLpTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpTicketsQuery | undefined, GraphqlTypes.GetLpTicketsQueryVariables>;
export function useGetLpTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>(GetLpTicketsDocument, options);
        }
export type GetLpTicketsQueryHookResult = ReturnType<typeof useGetLpTicketsQuery>;
export type GetLpTicketsLazyQueryHookResult = ReturnType<typeof useGetLpTicketsLazyQuery>;
export type GetLpTicketsSuspenseQueryHookResult = ReturnType<typeof useGetLpTicketsSuspenseQuery>;
export type GetLpTicketsQueryResult = Apollo.QueryResult<GraphqlTypes.GetLpTicketsQuery, GraphqlTypes.GetLpTicketsQueryVariables>;
export const GetLpTicketUnreadCountDocument = gql`
    query GetLpTicketUnreadCount($arenaId: ID) {
  lpTicketUnreadCount(arenaId: $arenaId)
}
    `;

/**
 * __useGetLpTicketUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetLpTicketUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLpTicketUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLpTicketUnreadCountQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetLpTicketUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>(GetLpTicketUnreadCountDocument, options);
      }
export function useGetLpTicketUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>(GetLpTicketUnreadCountDocument, options);
        }
// @ts-ignore
export function useGetLpTicketUnreadCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>;
export function useGetLpTicketUnreadCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLpTicketUnreadCountQuery | undefined, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>;
export function useGetLpTicketUnreadCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>(GetLpTicketUnreadCountDocument, options);
        }
export type GetLpTicketUnreadCountQueryHookResult = ReturnType<typeof useGetLpTicketUnreadCountQuery>;
export type GetLpTicketUnreadCountLazyQueryHookResult = ReturnType<typeof useGetLpTicketUnreadCountLazyQuery>;
export type GetLpTicketUnreadCountSuspenseQueryHookResult = ReturnType<typeof useGetLpTicketUnreadCountSuspenseQuery>;
export type GetLpTicketUnreadCountQueryResult = Apollo.QueryResult<GraphqlTypes.GetLpTicketUnreadCountQuery, GraphqlTypes.GetLpTicketUnreadCountQueryVariables>;
export const GetPortalScheduleOfInvestmentsDocument = gql`
    query GetPortalScheduleOfInvestments($entitySoiInput: EntitySoiInput!) {
  portalScheduleOfInvestments(input: $entitySoiInput) {
    totals {
      ...InvestmentTotalsFields
    }
    investments {
      opcoId
      name
      currency
      totals {
        ...InvestmentTotalsFields
      }
      positionsOwned {
        id
        name
        status
        totals {
          ...InvestmentTotalsFields
        }
        lots {
          ...InvestmentTotalsFields
        }
      }
    }
  }
}
    ${InvestmentTotalsFieldsFragmentDoc}`;

/**
 * __useGetPortalScheduleOfInvestmentsQuery__
 *
 * To run a query within a React component, call `useGetPortalScheduleOfInvestmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalScheduleOfInvestmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalScheduleOfInvestmentsQuery({
 *   variables: {
 *      entitySoiInput: // value for 'entitySoiInput'
 *   },
 * });
 */
export function useGetPortalScheduleOfInvestmentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables> & ({ variables: GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>(GetPortalScheduleOfInvestmentsDocument, options);
      }
export function useGetPortalScheduleOfInvestmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>(GetPortalScheduleOfInvestmentsDocument, options);
        }
// @ts-ignore
export function useGetPortalScheduleOfInvestmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>;
export function useGetPortalScheduleOfInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery | undefined, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>;
export function useGetPortalScheduleOfInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>(GetPortalScheduleOfInvestmentsDocument, options);
        }
export type GetPortalScheduleOfInvestmentsQueryHookResult = ReturnType<typeof useGetPortalScheduleOfInvestmentsQuery>;
export type GetPortalScheduleOfInvestmentsLazyQueryHookResult = ReturnType<typeof useGetPortalScheduleOfInvestmentsLazyQuery>;
export type GetPortalScheduleOfInvestmentsSuspenseQueryHookResult = ReturnType<typeof useGetPortalScheduleOfInvestmentsSuspenseQuery>;
export type GetPortalScheduleOfInvestmentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalScheduleOfInvestmentsQuery, GraphqlTypes.GetPortalScheduleOfInvestmentsQueryVariables>;
export const GetDistributionDetailsByIdDocument = gql`
    query getDistributionDetailsById($id: ID!) {
  distribution(distributionId: $id) {
    id
    hideCommitment
    paymentNotes
    manualSettlementDate
    amountPayable {
      monies
    }
    amountDistributed {
      monies
    }
    amountAdjustments {
      monies
    }
    amountReinvested {
      monies
    }
    netAmount {
      monies
    }
    waterfallStats {
      items {
        label
        grossDistributionAmount {
          monies
        }
        tiers {
          label
          amount {
            monies
          }
        }
      }
      errorReason
    }
    batch {
      id
      dateRecallable
      effectiveDate
      description
      batchCategory
      waterfall {
        id
        lastError
      }
    }
    details {
      edges {
        node {
          id
          amountDistributed {
            monies
          }
          amountRecallable {
            monies
          }
          sortOrder
          transactionType {
            id
            name
            isWithholding
            sortOrder
          }
        }
      }
    }
    metrics {
      distributionsToDate {
        monies
      }
      distributionsTotal {
        monies
      }
    }
    payments {
      id
      settlementDate
      status
      isPaid
      isVoided
      amount {
        monies
      }
      paymentPref {
        id
        paymentMethod
      }
      paymentBatch {
        id
        effectiveDate
        transmissionDate
        cancellationDate
        descriptiveDate
        status
      }
    }
    automatedPayments {
      id
      amount
      status
      method
      direction
      settledAt
      failedAt
      transmittedAt
      paymentPref {
        id
      }
    }
    position {
      id
      entityCurrency
      amountCommitted {
        monies
      }
      ownershipUnit {
        id
        shortName
        precisionMetrics
        precisionPortal
        isMethodUnit
      }
    }
    positionDelta {
      id
      deltaUnitCount
    }
    pricePerUnit {
      monies
    }
  }
}
    `;

/**
 * __useGetDistributionDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetDistributionDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDistributionDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables> & ({ variables: GraphqlTypes.GetDistributionDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>(GetDistributionDetailsByIdDocument, options);
      }
export function useGetDistributionDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>(GetDistributionDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetDistributionDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>;
export function useGetDistributionDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionDetailsByIdQuery | undefined, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>;
export function useGetDistributionDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>(GetDistributionDetailsByIdDocument, options);
        }
export type GetDistributionDetailsByIdQueryHookResult = ReturnType<typeof useGetDistributionDetailsByIdQuery>;
export type GetDistributionDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetDistributionDetailsByIdLazyQuery>;
export type GetDistributionDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetDistributionDetailsByIdSuspenseQuery>;
export type GetDistributionDetailsByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionDetailsByIdQuery, GraphqlTypes.GetDistributionDetailsByIdQueryVariables>;
export const GetCompletePaymentPrefDocument = gql`
    query GetCompletePaymentPref($id: ID!) {
  paymentPrefs(paymentPrefIds: [$id]) {
    id
    paymentPrefFull {
      __typename
      ... on AchPaymentPrefObjectType {
        ...AchPaymentPrefDisplay
      }
      ... on WirePaymentPrefObjectType {
        ...WirePaymentPrefDisplay
      }
      ... on EftPaymentPrefObjectType {
        ...FormattedPaymentEftFull
      }
      ... on SepaPaymentPrefObjectType {
        ...FormattedPaymentSepaFull
      }
      ... on BecsPaymentPrefObjectType {
        ...FormattedPaymentBecsFull
      }
      ... on BacsPaymentPrefObjectType {
        ...FormattedPaymentBacsFull
      }
      ... on CheckPaymentPrefObjectType {
        ...FormattedPaymentCheckFull
      }
    }
  }
}
    ${AchPaymentPrefDisplayFragmentDoc}
${WirePaymentPrefDisplayFragmentDoc}
${FormattedPaymentEftFullFragmentDoc}
${FormattedPaymentSepaFullFragmentDoc}
${FormattedPaymentBecsFullFragmentDoc}
${FormattedPaymentBacsFullFragmentDoc}
${FormattedPaymentCheckFullFragmentDoc}`;

/**
 * __useGetCompletePaymentPrefQuery__
 *
 * To run a query within a React component, call `useGetCompletePaymentPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletePaymentPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletePaymentPrefQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompletePaymentPrefQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables> & ({ variables: GraphqlTypes.GetCompletePaymentPrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>(GetCompletePaymentPrefDocument, options);
      }
export function useGetCompletePaymentPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>(GetCompletePaymentPrefDocument, options);
        }
// @ts-ignore
export function useGetCompletePaymentPrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>;
export function useGetCompletePaymentPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCompletePaymentPrefQuery | undefined, GraphqlTypes.GetCompletePaymentPrefQueryVariables>;
export function useGetCompletePaymentPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>(GetCompletePaymentPrefDocument, options);
        }
export type GetCompletePaymentPrefQueryHookResult = ReturnType<typeof useGetCompletePaymentPrefQuery>;
export type GetCompletePaymentPrefLazyQueryHookResult = ReturnType<typeof useGetCompletePaymentPrefLazyQuery>;
export type GetCompletePaymentPrefSuspenseQueryHookResult = ReturnType<typeof useGetCompletePaymentPrefSuspenseQuery>;
export type GetCompletePaymentPrefQueryResult = Apollo.QueryResult<GraphqlTypes.GetCompletePaymentPrefQuery, GraphqlTypes.GetCompletePaymentPrefQueryVariables>;
export const SubmitChangeRequestDocument = gql`
    mutation SubmitChangeRequest($input: ChangeRequestInput!) {
  submitChangeRequest(objectInput: $input) {
    ... on SubmitChangeRequestResponse {
      responses {
        requestId
        requestType
        requestPayload
        actions
        status
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SubmitChangeRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitChangeRequestMutation, GraphqlTypes.SubmitChangeRequestMutationVariables>;

/**
 * __useSubmitChangeRequestMutation__
 *
 * To run a mutation, you first call `useSubmitChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitChangeRequestMutation, { data, loading, error }] = useSubmitChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitChangeRequestMutation, GraphqlTypes.SubmitChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitChangeRequestMutation, GraphqlTypes.SubmitChangeRequestMutationVariables>(SubmitChangeRequestDocument, options);
      }
export type SubmitChangeRequestMutationHookResult = ReturnType<typeof useSubmitChangeRequestMutation>;
export type SubmitChangeRequestMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitChangeRequestMutation>;
export type SubmitChangeRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitChangeRequestMutation, GraphqlTypes.SubmitChangeRequestMutationVariables>;
export const DuplicateProspectDocument = gql`
    mutation DuplicateProspect($objectInput: DuplicateProspectInput!) {
  duplicateProspect(objectInput: $objectInput) {
    __typename
    ... on DuplicateProspectObjectType {
      prospectId
      contactId
      arenaId
      offeringId
      entityId
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DuplicateProspectMutationFn = Apollo.MutationFunction<GraphqlTypes.DuplicateProspectMutation, GraphqlTypes.DuplicateProspectMutationVariables>;

/**
 * __useDuplicateProspectMutation__
 *
 * To run a mutation, you first call `useDuplicateProspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProspectMutation, { data, loading, error }] = useDuplicateProspectMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDuplicateProspectMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DuplicateProspectMutation, GraphqlTypes.DuplicateProspectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DuplicateProspectMutation, GraphqlTypes.DuplicateProspectMutationVariables>(DuplicateProspectDocument, options);
      }
export type DuplicateProspectMutationHookResult = ReturnType<typeof useDuplicateProspectMutation>;
export type DuplicateProspectMutationResult = Apollo.MutationResult<GraphqlTypes.DuplicateProspectMutation>;
export type DuplicateProspectMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DuplicateProspectMutation, GraphqlTypes.DuplicateProspectMutationVariables>;
export const GetCaseArenaByProfileDocument = gql`
    query GetCaseArenaByProfile($externalObject: ExternalObjectInput!) {
  complianceCaseArenaByProfile(externalObject: $externalObject) {
    arenaId
    arenaName
  }
}
    `;

/**
 * __useGetCaseArenaByProfileQuery__
 *
 * To run a query within a React component, call `useGetCaseArenaByProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseArenaByProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseArenaByProfileQuery({
 *   variables: {
 *      externalObject: // value for 'externalObject'
 *   },
 * });
 */
export function useGetCaseArenaByProfileQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables> & ({ variables: GraphqlTypes.GetCaseArenaByProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>(GetCaseArenaByProfileDocument, options);
      }
export function useGetCaseArenaByProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>(GetCaseArenaByProfileDocument, options);
        }
// @ts-ignore
export function useGetCaseArenaByProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>;
export function useGetCaseArenaByProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseArenaByProfileQuery | undefined, GraphqlTypes.GetCaseArenaByProfileQueryVariables>;
export function useGetCaseArenaByProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>(GetCaseArenaByProfileDocument, options);
        }
export type GetCaseArenaByProfileQueryHookResult = ReturnType<typeof useGetCaseArenaByProfileQuery>;
export type GetCaseArenaByProfileLazyQueryHookResult = ReturnType<typeof useGetCaseArenaByProfileLazyQuery>;
export type GetCaseArenaByProfileSuspenseQueryHookResult = ReturnType<typeof useGetCaseArenaByProfileSuspenseQuery>;
export type GetCaseArenaByProfileQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>;
export const GetAccountsDocument = gql`
    query GetAccounts($first: Int!, $after: String, $sort: [UnifiedPortalAccountQuerySortEnum], $filters: PortalAccountFilters) {
  unifiedPortalAccounts(
    first: $first
    after: $after
    sort: $sort
    filters: $filters
  ) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        canViewAccountDetails
        canEditAccountDetails
        canLpcmManageContacts
        canAccessLpcm
        isInvestmentEntity
        gpDisplayName
        taxIdRedacted
        arenaId
        arena {
          id
          name
          logoBackgroundColor
          useBgColorForPortalIcons
          logoUrl
          headerLogoUrl
          features {
            hasEditableLpPaymentPreferences
          }
        }
        contacts {
          count
          edges {
            node {
              id
              portalFullName
            }
          }
        }
        mailingAddress {
          street
          street2
          street3
          city
          region
          addressType
          country {
            objectId
            objectName
          }
          state {
            objectId
            objectName
          }
          postalCode
        }
        paymentPrefs {
          id
          paymentMethod
          bankInfoRedacted
          checkAddrCity
          checkAddrStreet
          checkAddrStreet2
          checkAddrStreet3
          checkAddrRegion
          checkAddrState {
            name
          }
          checkAddrCountry {
            name
          }
          checkAddrPostalCode
          checkMailingAddressSameAsAccount
        }
        paymentMethodSupportedCounts {
          ach
          wire
          check
        }
        hasPendingPaymentRequest
        positions {
          count
          edges {
            node {
              id
              investmentEntity {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables> & ({ variables: GraphqlTypes.GetAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
// @ts-ignore
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountsQuery | undefined, GraphqlTypes.GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>;
export const ExportActivityFeedsDocument = gql`
    mutation ExportActivityFeeds($exportActivitiesFeedsInput: ExportActivitiesFeedsInput!) {
  exportActivitiesFeeds(exportActivitiesFeedsInput: $exportActivitiesFeedsInput) {
    ... on ExportActivitiesFeedsObject {
      job {
        id
        status
        jobType
        data
      }
    }
  }
}
    `;
export type ExportActivityFeedsMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportActivityFeedsMutation, GraphqlTypes.ExportActivityFeedsMutationVariables>;

/**
 * __useExportActivityFeedsMutation__
 *
 * To run a mutation, you first call `useExportActivityFeedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportActivityFeedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportActivityFeedsMutation, { data, loading, error }] = useExportActivityFeedsMutation({
 *   variables: {
 *      exportActivitiesFeedsInput: // value for 'exportActivitiesFeedsInput'
 *   },
 * });
 */
export function useExportActivityFeedsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportActivityFeedsMutation, GraphqlTypes.ExportActivityFeedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportActivityFeedsMutation, GraphqlTypes.ExportActivityFeedsMutationVariables>(ExportActivityFeedsDocument, options);
      }
export type ExportActivityFeedsMutationHookResult = ReturnType<typeof useExportActivityFeedsMutation>;
export type ExportActivityFeedsMutationResult = Apollo.MutationResult<GraphqlTypes.ExportActivityFeedsMutation>;
export type ExportActivityFeedsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportActivityFeedsMutation, GraphqlTypes.ExportActivityFeedsMutationVariables>;
export const CreateOrUpdateActivityTypeDocument = gql`
    mutation CreateOrUpdateActivityType($input: CreateOrUpdateActivityTypeInput!) {
  createOrUpdateActivityType(activityTypeInput: $input) {
    ... on ActivityTypeObjectType {
      id
      name
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type CreateOrUpdateActivityTypeMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOrUpdateActivityTypeMutation, GraphqlTypes.CreateOrUpdateActivityTypeMutationVariables>;

/**
 * __useCreateOrUpdateActivityTypeMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateActivityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateActivityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateActivityTypeMutation, { data, loading, error }] = useCreateOrUpdateActivityTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateActivityTypeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOrUpdateActivityTypeMutation, GraphqlTypes.CreateOrUpdateActivityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOrUpdateActivityTypeMutation, GraphqlTypes.CreateOrUpdateActivityTypeMutationVariables>(CreateOrUpdateActivityTypeDocument, options);
      }
export type CreateOrUpdateActivityTypeMutationHookResult = ReturnType<typeof useCreateOrUpdateActivityTypeMutation>;
export type CreateOrUpdateActivityTypeMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOrUpdateActivityTypeMutation>;
export type CreateOrUpdateActivityTypeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOrUpdateActivityTypeMutation, GraphqlTypes.CreateOrUpdateActivityTypeMutationVariables>;
export const DeleteActivityTypeDocument = gql`
    mutation DeleteActivityType($activityTypeId: Int!) {
  deleteOrArchiveActivityType(activityTypeId: $activityTypeId) {
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DeleteActivityTypeMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteActivityTypeMutation, GraphqlTypes.DeleteActivityTypeMutationVariables>;

/**
 * __useDeleteActivityTypeMutation__
 *
 * To run a mutation, you first call `useDeleteActivityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityTypeMutation, { data, loading, error }] = useDeleteActivityTypeMutation({
 *   variables: {
 *      activityTypeId: // value for 'activityTypeId'
 *   },
 * });
 */
export function useDeleteActivityTypeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteActivityTypeMutation, GraphqlTypes.DeleteActivityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteActivityTypeMutation, GraphqlTypes.DeleteActivityTypeMutationVariables>(DeleteActivityTypeDocument, options);
      }
export type DeleteActivityTypeMutationHookResult = ReturnType<typeof useDeleteActivityTypeMutation>;
export type DeleteActivityTypeMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteActivityTypeMutation>;
export type DeleteActivityTypeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteActivityTypeMutation, GraphqlTypes.DeleteActivityTypeMutationVariables>;
export const UnarchiveActivityTypeDocument = gql`
    mutation UnarchiveActivityType($activityTypeId: Int!) {
  unarchiveActivityType(activityTypeId: $activityTypeId) {
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UnarchiveActivityTypeMutationFn = Apollo.MutationFunction<GraphqlTypes.UnarchiveActivityTypeMutation, GraphqlTypes.UnarchiveActivityTypeMutationVariables>;

/**
 * __useUnarchiveActivityTypeMutation__
 *
 * To run a mutation, you first call `useUnarchiveActivityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveActivityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveActivityTypeMutation, { data, loading, error }] = useUnarchiveActivityTypeMutation({
 *   variables: {
 *      activityTypeId: // value for 'activityTypeId'
 *   },
 * });
 */
export function useUnarchiveActivityTypeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UnarchiveActivityTypeMutation, GraphqlTypes.UnarchiveActivityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UnarchiveActivityTypeMutation, GraphqlTypes.UnarchiveActivityTypeMutationVariables>(UnarchiveActivityTypeDocument, options);
      }
export type UnarchiveActivityTypeMutationHookResult = ReturnType<typeof useUnarchiveActivityTypeMutation>;
export type UnarchiveActivityTypeMutationResult = Apollo.MutationResult<GraphqlTypes.UnarchiveActivityTypeMutation>;
export type UnarchiveActivityTypeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UnarchiveActivityTypeMutation, GraphqlTypes.UnarchiveActivityTypeMutationVariables>;
export const CreateActivityDocument = gql`
    mutation CreateActivity($input: CreateOrUpdateActivityInput!) {
  createOrUpdateActivity(activityInput: $input) {
    ... on NoteObjectType {
      id
      noteType
      summary
      text
      location
      date
      time
      bodyHtml
      bodyText
      owner {
        id
        fullName
      }
      offerings {
        id
        name
      }
      organizations {
        id
        fullName
      }
      entities {
        id
        name
      }
      staff {
        id
        fullName
      }
      people {
        id
        fullName
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type CreateActivityMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateActivityMutation, GraphqlTypes.CreateActivityMutationVariables>;

/**
 * __useCreateActivityMutation__
 *
 * To run a mutation, you first call `useCreateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityMutation, { data, loading, error }] = useCreateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActivityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateActivityMutation, GraphqlTypes.CreateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateActivityMutation, GraphqlTypes.CreateActivityMutationVariables>(CreateActivityDocument, options);
      }
export type CreateActivityMutationHookResult = ReturnType<typeof useCreateActivityMutation>;
export type CreateActivityMutationResult = Apollo.MutationResult<GraphqlTypes.CreateActivityMutation>;
export type CreateActivityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateActivityMutation, GraphqlTypes.CreateActivityMutationVariables>;
export const DeleteNotesDocument = gql`
    mutation DeleteNotes($nodeIds: [ID!]!) {
  deleteNotes(deleteNotesInput: {noteIds: $nodeIds}) {
    ... on NoteDeletedCountObjectType {
      deletedCount
    }
    ... on MutationErrorResponse {
      errorCode
    }
  }
}
    `;
export type DeleteNotesMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteNotesMutation, GraphqlTypes.DeleteNotesMutationVariables>;

/**
 * __useDeleteNotesMutation__
 *
 * To run a mutation, you first call `useDeleteNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotesMutation, { data, loading, error }] = useDeleteNotesMutation({
 *   variables: {
 *      nodeIds: // value for 'nodeIds'
 *   },
 * });
 */
export function useDeleteNotesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteNotesMutation, GraphqlTypes.DeleteNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteNotesMutation, GraphqlTypes.DeleteNotesMutationVariables>(DeleteNotesDocument, options);
      }
export type DeleteNotesMutationHookResult = ReturnType<typeof useDeleteNotesMutation>;
export type DeleteNotesMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteNotesMutation>;
export type DeleteNotesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteNotesMutation, GraphqlTypes.DeleteNotesMutationVariables>;
export const GenerateActivityAiSummaryContentDocument = gql`
    mutation GenerateActivityAiSummaryContent($input: ActivityAISummaryInput!) {
  generateActivityAiSummaryContent(activityAiInput: $input) {
    ... on ActivityAISummaryResponse {
      result {
        content
        id
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type GenerateActivityAiSummaryContentMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateActivityAiSummaryContentMutation, GraphqlTypes.GenerateActivityAiSummaryContentMutationVariables>;

/**
 * __useGenerateActivityAiSummaryContentMutation__
 *
 * To run a mutation, you first call `useGenerateActivityAiSummaryContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateActivityAiSummaryContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateActivityAiSummaryContentMutation, { data, loading, error }] = useGenerateActivityAiSummaryContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateActivityAiSummaryContentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateActivityAiSummaryContentMutation, GraphqlTypes.GenerateActivityAiSummaryContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateActivityAiSummaryContentMutation, GraphqlTypes.GenerateActivityAiSummaryContentMutationVariables>(GenerateActivityAiSummaryContentDocument, options);
      }
export type GenerateActivityAiSummaryContentMutationHookResult = ReturnType<typeof useGenerateActivityAiSummaryContentMutation>;
export type GenerateActivityAiSummaryContentMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateActivityAiSummaryContentMutation>;
export type GenerateActivityAiSummaryContentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateActivityAiSummaryContentMutation, GraphqlTypes.GenerateActivityAiSummaryContentMutationVariables>;
export const GetActivityTypeListDocument = gql`
    query GetActivityTypeList($includeDeleted: Boolean = false) {
  activityTypes(includeDeleted: $includeDeleted) {
    id
    name
    arenaId
    extensionFields {
      id
      name
    }
    isArchived
  }
}
    `;

/**
 * __useGetActivityTypeListQuery__
 *
 * To run a query within a React component, call `useGetActivityTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityTypeListQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useGetActivityTypeListQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>(GetActivityTypeListDocument, options);
      }
export function useGetActivityTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>(GetActivityTypeListDocument, options);
        }
// @ts-ignore
export function useGetActivityTypeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>;
export function useGetActivityTypeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityTypeListQuery | undefined, GraphqlTypes.GetActivityTypeListQueryVariables>;
export function useGetActivityTypeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>(GetActivityTypeListDocument, options);
        }
export type GetActivityTypeListQueryHookResult = ReturnType<typeof useGetActivityTypeListQuery>;
export type GetActivityTypeListLazyQueryHookResult = ReturnType<typeof useGetActivityTypeListLazyQuery>;
export type GetActivityTypeListSuspenseQueryHookResult = ReturnType<typeof useGetActivityTypeListSuspenseQuery>;
export type GetActivityTypeListQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityTypeListQuery, GraphqlTypes.GetActivityTypeListQueryVariables>;
export const GetActivityTypesForArenaDocument = gql`
    query GetActivityTypesForArena {
  activityTypes {
    id
    name
    arenaId
  }
}
    `;

/**
 * __useGetActivityTypesForArenaQuery__
 *
 * To run a query within a React component, call `useGetActivityTypesForArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityTypesForArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityTypesForArenaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityTypesForArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>(GetActivityTypesForArenaDocument, options);
      }
export function useGetActivityTypesForArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>(GetActivityTypesForArenaDocument, options);
        }
// @ts-ignore
export function useGetActivityTypesForArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>;
export function useGetActivityTypesForArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityTypesForArenaQuery | undefined, GraphqlTypes.GetActivityTypesForArenaQueryVariables>;
export function useGetActivityTypesForArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>(GetActivityTypesForArenaDocument, options);
        }
export type GetActivityTypesForArenaQueryHookResult = ReturnType<typeof useGetActivityTypesForArenaQuery>;
export type GetActivityTypesForArenaLazyQueryHookResult = ReturnType<typeof useGetActivityTypesForArenaLazyQuery>;
export type GetActivityTypesForArenaSuspenseQueryHookResult = ReturnType<typeof useGetActivityTypesForArenaSuspenseQuery>;
export type GetActivityTypesForArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityTypesForArenaQuery, GraphqlTypes.GetActivityTypesForArenaQueryVariables>;
export const GetActivityTypesForArenaForGridFilterDocument = gql`
    query GetActivityTypesForArenaForGridFilter {
  activityTypesForGridFilter {
    id
    name
    arenaId
  }
}
    `;

/**
 * __useGetActivityTypesForArenaForGridFilterQuery__
 *
 * To run a query within a React component, call `useGetActivityTypesForArenaForGridFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityTypesForArenaForGridFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityTypesForArenaForGridFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityTypesForArenaForGridFilterQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>(GetActivityTypesForArenaForGridFilterDocument, options);
      }
export function useGetActivityTypesForArenaForGridFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>(GetActivityTypesForArenaForGridFilterDocument, options);
        }
// @ts-ignore
export function useGetActivityTypesForArenaForGridFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>;
export function useGetActivityTypesForArenaForGridFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery | undefined, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>;
export function useGetActivityTypesForArenaForGridFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>(GetActivityTypesForArenaForGridFilterDocument, options);
        }
export type GetActivityTypesForArenaForGridFilterQueryHookResult = ReturnType<typeof useGetActivityTypesForArenaForGridFilterQuery>;
export type GetActivityTypesForArenaForGridFilterLazyQueryHookResult = ReturnType<typeof useGetActivityTypesForArenaForGridFilterLazyQuery>;
export type GetActivityTypesForArenaForGridFilterSuspenseQueryHookResult = ReturnType<typeof useGetActivityTypesForArenaForGridFilterSuspenseQuery>;
export type GetActivityTypesForArenaForGridFilterQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityTypesForArenaForGridFilterQuery, GraphqlTypes.GetActivityTypesForArenaForGridFilterQueryVariables>;
export const GetActivityTypeMetadataDocument = gql`
    query GetActivityTypeMetadata($activityTypeId: ID!) {
  activityTypeById(activityTypeId: $activityTypeId) {
    id
    name
    arenaId
    extensionFields {
      id
      name
      extensionFieldTypeId
      enumName
      isMultivalued
      enumValues {
        id
        enumName
        enumValueCode
        enumValueLabel
      }
    }
    isArchived
  }
}
    `;

/**
 * __useGetActivityTypeMetadataQuery__
 *
 * To run a query within a React component, call `useGetActivityTypeMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityTypeMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityTypeMetadataQuery({
 *   variables: {
 *      activityTypeId: // value for 'activityTypeId'
 *   },
 * });
 */
export function useGetActivityTypeMetadataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables> & ({ variables: GraphqlTypes.GetActivityTypeMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>(GetActivityTypeMetadataDocument, options);
      }
export function useGetActivityTypeMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>(GetActivityTypeMetadataDocument, options);
        }
// @ts-ignore
export function useGetActivityTypeMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>;
export function useGetActivityTypeMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityTypeMetadataQuery | undefined, GraphqlTypes.GetActivityTypeMetadataQueryVariables>;
export function useGetActivityTypeMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>(GetActivityTypeMetadataDocument, options);
        }
export type GetActivityTypeMetadataQueryHookResult = ReturnType<typeof useGetActivityTypeMetadataQuery>;
export type GetActivityTypeMetadataLazyQueryHookResult = ReturnType<typeof useGetActivityTypeMetadataLazyQuery>;
export type GetActivityTypeMetadataSuspenseQueryHookResult = ReturnType<typeof useGetActivityTypeMetadataSuspenseQuery>;
export type GetActivityTypeMetadataQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityTypeMetadataQuery, GraphqlTypes.GetActivityTypeMetadataQueryVariables>;
export const GetActivityDetailsByIdDocument = gql`
    query GetActivityDetailsById($activityId: ID!) {
  activities(id: $activityId) {
    owner {
      id
      firstName
      lastName
    }
    createdAt
    canEdit
    id
    isDraft
    text
    summary
    location
    date
    time
    sortDatetime
    noteType
    objectType
    objectId
    activityTypeId
    activityType {
      name
      extensionFields {
        id
        name
        extensionFieldTypeId
        enumName
        isMultivalued
        enumValues {
          id
          enumName
          enumValueCode
          enumValueLabel
        }
      }
    }
    attachments {
      documentId
      documentName
      documentVersion {
        id
        name
        size
        contentType
        extension
        downloadUrl
      }
    }
    tags {
      id
      tagText
    }
    people {
      id
      firstName
      lastName
      fullName
      company {
        id
        fullName
      }
      thumbnail {
        photoUrl(width: 64, height: 64)
        width
        height
      }
    }
    staff {
      id
      firstName
      lastName
      emailAddress
      companyName
    }
    organizations {
      id
      fullName
      thumbnail {
        photoUrl(width: 64, height: 64)
        width
        height
      }
    }
    entities {
      id
      name
    }
    offerings {
      id
      name
    }
    extensionFields {
      extensionField {
        id
        name
        extensionFieldTypeId
        enumName
        isMultivalued
        enumValues {
          id
          enumName
          enumValueCode
          enumValueLabel
        }
        activeEnumValues {
          id
          enumName
          enumValueCode
          enumValueLabel
        }
      }
      values {
        objectId
        intValue
        floatValue
        stringValue
        dateValue
        extensionField {
          id
          name
          extensionFieldTypeId
          enumName
          isMultivalued
          enumValues {
            id
            enumName
            enumValueCode
            enumValueLabel
          }
        }
        currencyValue {
          monies
        }
        enumValue {
          enumName
          enumValueCode
          enumValueLabel
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetActivityDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetActivityDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityDetailsByIdQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useGetActivityDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables> & ({ variables: GraphqlTypes.GetActivityDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>(GetActivityDetailsByIdDocument, options);
      }
export function useGetActivityDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>(GetActivityDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetActivityDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>;
export function useGetActivityDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActivityDetailsByIdQuery | undefined, GraphqlTypes.GetActivityDetailsByIdQueryVariables>;
export function useGetActivityDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>(GetActivityDetailsByIdDocument, options);
        }
export type GetActivityDetailsByIdQueryHookResult = ReturnType<typeof useGetActivityDetailsByIdQuery>;
export type GetActivityDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetActivityDetailsByIdLazyQuery>;
export type GetActivityDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetActivityDetailsByIdSuspenseQuery>;
export type GetActivityDetailsByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetActivityDetailsByIdQuery, GraphqlTypes.GetActivityDetailsByIdQueryVariables>;
export const GetContactActivityFeedListDocument = gql`
    query GetContactActivityFeedList($contactId: ID!, $nextPageCursor: String, $activityFeedFilter: ActivityFeedFilterInput) {
  contactActivityFeeds(
    contactId: $contactId
    nextPageCursor: $nextPageCursor
    activityFeedFilter: $activityFeedFilter
  ) {
    items {
      ...ContactActivityFeedFields
    }
    nextPageCursor
  }
}
    ${ContactActivityFeedFieldsFragmentDoc}`;

/**
 * __useGetContactActivityFeedListQuery__
 *
 * To run a query within a React component, call `useGetContactActivityFeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactActivityFeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactActivityFeedListQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      nextPageCursor: // value for 'nextPageCursor'
 *      activityFeedFilter: // value for 'activityFeedFilter'
 *   },
 * });
 */
export function useGetContactActivityFeedListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables> & ({ variables: GraphqlTypes.GetContactActivityFeedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>(GetContactActivityFeedListDocument, options);
      }
export function useGetContactActivityFeedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>(GetContactActivityFeedListDocument, options);
        }
// @ts-ignore
export function useGetContactActivityFeedListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>;
export function useGetContactActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactActivityFeedListQuery | undefined, GraphqlTypes.GetContactActivityFeedListQueryVariables>;
export function useGetContactActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>(GetContactActivityFeedListDocument, options);
        }
export type GetContactActivityFeedListQueryHookResult = ReturnType<typeof useGetContactActivityFeedListQuery>;
export type GetContactActivityFeedListLazyQueryHookResult = ReturnType<typeof useGetContactActivityFeedListLazyQuery>;
export type GetContactActivityFeedListSuspenseQueryHookResult = ReturnType<typeof useGetContactActivityFeedListSuspenseQuery>;
export type GetContactActivityFeedListQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactActivityFeedListQuery, GraphqlTypes.GetContactActivityFeedListQueryVariables>;
export const GetProspectActivityFeedListDocument = gql`
    query GetProspectActivityFeedList($prospectId: ID!, $nextPageCursor: String, $activityFeedFilter: ActivityFeedFilterInput) {
  prospectActivityFeeds(
    prospectId: $prospectId
    nextPageCursor: $nextPageCursor
    activityFeedFilter: $activityFeedFilter
  ) {
    items {
      ...ProspectActivityFeedFields
    }
    nextPageCursor
  }
}
    ${ProspectActivityFeedFieldsFragmentDoc}`;

/**
 * __useGetProspectActivityFeedListQuery__
 *
 * To run a query within a React component, call `useGetProspectActivityFeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProspectActivityFeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProspectActivityFeedListQuery({
 *   variables: {
 *      prospectId: // value for 'prospectId'
 *      nextPageCursor: // value for 'nextPageCursor'
 *      activityFeedFilter: // value for 'activityFeedFilter'
 *   },
 * });
 */
export function useGetProspectActivityFeedListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables> & ({ variables: GraphqlTypes.GetProspectActivityFeedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>(GetProspectActivityFeedListDocument, options);
      }
export function useGetProspectActivityFeedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>(GetProspectActivityFeedListDocument, options);
        }
// @ts-ignore
export function useGetProspectActivityFeedListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>;
export function useGetProspectActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProspectActivityFeedListQuery | undefined, GraphqlTypes.GetProspectActivityFeedListQueryVariables>;
export function useGetProspectActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>(GetProspectActivityFeedListDocument, options);
        }
export type GetProspectActivityFeedListQueryHookResult = ReturnType<typeof useGetProspectActivityFeedListQuery>;
export type GetProspectActivityFeedListLazyQueryHookResult = ReturnType<typeof useGetProspectActivityFeedListLazyQuery>;
export type GetProspectActivityFeedListSuspenseQueryHookResult = ReturnType<typeof useGetProspectActivityFeedListSuspenseQuery>;
export type GetProspectActivityFeedListQueryResult = Apollo.QueryResult<GraphqlTypes.GetProspectActivityFeedListQuery, GraphqlTypes.GetProspectActivityFeedListQueryVariables>;
export const GetPositionActivityFeedListDocument = gql`
    query GetPositionActivityFeedList($positionId: ID!, $nextPageCursor: String, $activityFeedFilter: ActivityFeedFilterInput) {
  positionActivityFeeds(
    positionId: $positionId
    nextPageCursor: $nextPageCursor
    activityFeedFilter: $activityFeedFilter
  ) {
    items {
      ...PositionActivityFeedFields
    }
    nextPageCursor
  }
}
    ${PositionActivityFeedFieldsFragmentDoc}`;

/**
 * __useGetPositionActivityFeedListQuery__
 *
 * To run a query within a React component, call `useGetPositionActivityFeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionActivityFeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionActivityFeedListQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      nextPageCursor: // value for 'nextPageCursor'
 *      activityFeedFilter: // value for 'activityFeedFilter'
 *   },
 * });
 */
export function useGetPositionActivityFeedListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables> & ({ variables: GraphqlTypes.GetPositionActivityFeedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>(GetPositionActivityFeedListDocument, options);
      }
export function useGetPositionActivityFeedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>(GetPositionActivityFeedListDocument, options);
        }
// @ts-ignore
export function useGetPositionActivityFeedListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>;
export function useGetPositionActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionActivityFeedListQuery | undefined, GraphqlTypes.GetPositionActivityFeedListQueryVariables>;
export function useGetPositionActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>(GetPositionActivityFeedListDocument, options);
        }
export type GetPositionActivityFeedListQueryHookResult = ReturnType<typeof useGetPositionActivityFeedListQuery>;
export type GetPositionActivityFeedListLazyQueryHookResult = ReturnType<typeof useGetPositionActivityFeedListLazyQuery>;
export type GetPositionActivityFeedListSuspenseQueryHookResult = ReturnType<typeof useGetPositionActivityFeedListSuspenseQuery>;
export type GetPositionActivityFeedListQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionActivityFeedListQuery, GraphqlTypes.GetPositionActivityFeedListQueryVariables>;
export const GetLeadActivityFeedListDocument = gql`
    query GetLeadActivityFeedList($leadId: ID!, $nextPageCursor: String, $activityFeedFilter: ActivityFeedFilterInput) {
  leadActivityFeeds(
    leadId: $leadId
    nextPageCursor: $nextPageCursor
    activityFeedFilter: $activityFeedFilter
  ) {
    items {
      ...LeadActivityFeedFields
    }
    nextPageCursor
  }
}
    ${LeadActivityFeedFieldsFragmentDoc}`;

/**
 * __useGetLeadActivityFeedListQuery__
 *
 * To run a query within a React component, call `useGetLeadActivityFeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadActivityFeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadActivityFeedListQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *      nextPageCursor: // value for 'nextPageCursor'
 *      activityFeedFilter: // value for 'activityFeedFilter'
 *   },
 * });
 */
export function useGetLeadActivityFeedListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables> & ({ variables: GraphqlTypes.GetLeadActivityFeedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>(GetLeadActivityFeedListDocument, options);
      }
export function useGetLeadActivityFeedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>(GetLeadActivityFeedListDocument, options);
        }
// @ts-ignore
export function useGetLeadActivityFeedListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>;
export function useGetLeadActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLeadActivityFeedListQuery | undefined, GraphqlTypes.GetLeadActivityFeedListQueryVariables>;
export function useGetLeadActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>(GetLeadActivityFeedListDocument, options);
        }
export type GetLeadActivityFeedListQueryHookResult = ReturnType<typeof useGetLeadActivityFeedListQuery>;
export type GetLeadActivityFeedListLazyQueryHookResult = ReturnType<typeof useGetLeadActivityFeedListLazyQuery>;
export type GetLeadActivityFeedListSuspenseQueryHookResult = ReturnType<typeof useGetLeadActivityFeedListSuspenseQuery>;
export type GetLeadActivityFeedListQueryResult = Apollo.QueryResult<GraphqlTypes.GetLeadActivityFeedListQuery, GraphqlTypes.GetLeadActivityFeedListQueryVariables>;
export const GetDashboardActivityFeedListDocument = gql`
    query GetDashboardActivityFeedList($nextPageCursor: String, $activityFeedFilter: ActivityFeedFilterInput) {
  activityFeeds(
    nextPageCursor: $nextPageCursor
    activityFeedFilter: $activityFeedFilter
    limit: 10
  ) {
    items {
      ...DashboardActivityFeedFields
    }
    nextPageCursor
  }
}
    ${DashboardActivityFeedFieldsFragmentDoc}`;

/**
 * __useGetDashboardActivityFeedListQuery__
 *
 * To run a query within a React component, call `useGetDashboardActivityFeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardActivityFeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardActivityFeedListQuery({
 *   variables: {
 *      nextPageCursor: // value for 'nextPageCursor'
 *      activityFeedFilter: // value for 'activityFeedFilter'
 *   },
 * });
 */
export function useGetDashboardActivityFeedListQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>(GetDashboardActivityFeedListDocument, options);
      }
export function useGetDashboardActivityFeedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>(GetDashboardActivityFeedListDocument, options);
        }
// @ts-ignore
export function useGetDashboardActivityFeedListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>;
export function useGetDashboardActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDashboardActivityFeedListQuery | undefined, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>;
export function useGetDashboardActivityFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>(GetDashboardActivityFeedListDocument, options);
        }
export type GetDashboardActivityFeedListQueryHookResult = ReturnType<typeof useGetDashboardActivityFeedListQuery>;
export type GetDashboardActivityFeedListLazyQueryHookResult = ReturnType<typeof useGetDashboardActivityFeedListLazyQuery>;
export type GetDashboardActivityFeedListSuspenseQueryHookResult = ReturnType<typeof useGetDashboardActivityFeedListSuspenseQuery>;
export type GetDashboardActivityFeedListQueryResult = Apollo.QueryResult<GraphqlTypes.GetDashboardActivityFeedListQuery, GraphqlTypes.GetDashboardActivityFeedListQueryVariables>;
export const GetIntegrationDetailsByIdDocument = gql`
    query GetIntegrationDetailsById($integrationDetailsId: Int!) {
  integrationDetailsById(integrationDetailsId: $integrationDetailsId) {
    id
    createdBy
    user {
      id
      fullName
    }
    configurationOptions
    provenance
  }
}
    `;

/**
 * __useGetIntegrationDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetIntegrationDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationDetailsByIdQuery({
 *   variables: {
 *      integrationDetailsId: // value for 'integrationDetailsId'
 *   },
 * });
 */
export function useGetIntegrationDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables> & ({ variables: GraphqlTypes.GetIntegrationDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>(GetIntegrationDetailsByIdDocument, options);
      }
export function useGetIntegrationDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>(GetIntegrationDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetIntegrationDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>;
export function useGetIntegrationDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationDetailsByIdQuery | undefined, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>;
export function useGetIntegrationDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>(GetIntegrationDetailsByIdDocument, options);
        }
export type GetIntegrationDetailsByIdQueryHookResult = ReturnType<typeof useGetIntegrationDetailsByIdQuery>;
export type GetIntegrationDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetIntegrationDetailsByIdLazyQuery>;
export type GetIntegrationDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationDetailsByIdSuspenseQuery>;
export type GetIntegrationDetailsByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationDetailsByIdQuery, GraphqlTypes.GetIntegrationDetailsByIdQueryVariables>;
export const GetCrmNotificationListsDocument = gql`
    query GetCrmNotificationLists {
  crmNotificationLists {
    id
    objectType
    objectId
    label
    textMuted
  }
}
    `;

/**
 * __useGetCrmNotificationListsQuery__
 *
 * To run a query within a React component, call `useGetCrmNotificationListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmNotificationListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmNotificationListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCrmNotificationListsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>(GetCrmNotificationListsDocument, options);
      }
export function useGetCrmNotificationListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>(GetCrmNotificationListsDocument, options);
        }
// @ts-ignore
export function useGetCrmNotificationListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>;
export function useGetCrmNotificationListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCrmNotificationListsQuery | undefined, GraphqlTypes.GetCrmNotificationListsQueryVariables>;
export function useGetCrmNotificationListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>(GetCrmNotificationListsDocument, options);
        }
export type GetCrmNotificationListsQueryHookResult = ReturnType<typeof useGetCrmNotificationListsQuery>;
export type GetCrmNotificationListsLazyQueryHookResult = ReturnType<typeof useGetCrmNotificationListsLazyQuery>;
export type GetCrmNotificationListsSuspenseQueryHookResult = ReturnType<typeof useGetCrmNotificationListsSuspenseQuery>;
export type GetCrmNotificationListsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCrmNotificationListsQuery, GraphqlTypes.GetCrmNotificationListsQueryVariables>;
export const GetCalendarEventForActivityFeedDocument = gql`
    query GetCalendarEventForActivityFeed($id: ID!) {
  calendarEvent(id: $id) {
    id
    title
    description
    location
    startDatetime
    endDatetime
    isAllDay
    timezone
    calendarId
    primaryMeetingUrl
    createdAt
    conferenceProvider
    integrationId
    provenance
    arenaId
    CompositeExternalId
    user {
      id
      fullName
      emailAddress
    }
    contacts {
      id
      fullName
      contactType
      primaryEmail {
        emailAddress
      }
      thumbnail {
        photoUrl(width: 64, height: 64)
      }
      company {
        id
        fullName
      }
    }
    users {
      id
      fullName
      emailAddress
    }
    offerings {
      id
      name
    }
    entities {
      id
      name
    }
    attachments {
      documentId
      documentName
      documentVersion {
        id
        downloadUrl
      }
    }
    notes {
      id
      text
      createdAt
      editedAt
      owner {
        id
        fullName
      }
      editedBy {
        id
        fullName
      }
    }
    __typename
  }
}
    `;

/**
 * __useGetCalendarEventForActivityFeedQuery__
 *
 * To run a query within a React component, call `useGetCalendarEventForActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarEventForActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarEventForActivityFeedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCalendarEventForActivityFeedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables> & ({ variables: GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>(GetCalendarEventForActivityFeedDocument, options);
      }
export function useGetCalendarEventForActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>(GetCalendarEventForActivityFeedDocument, options);
        }
// @ts-ignore
export function useGetCalendarEventForActivityFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>;
export function useGetCalendarEventForActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCalendarEventForActivityFeedQuery | undefined, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>;
export function useGetCalendarEventForActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>(GetCalendarEventForActivityFeedDocument, options);
        }
export type GetCalendarEventForActivityFeedQueryHookResult = ReturnType<typeof useGetCalendarEventForActivityFeedQuery>;
export type GetCalendarEventForActivityFeedLazyQueryHookResult = ReturnType<typeof useGetCalendarEventForActivityFeedLazyQuery>;
export type GetCalendarEventForActivityFeedSuspenseQueryHookResult = ReturnType<typeof useGetCalendarEventForActivityFeedSuspenseQuery>;
export type GetCalendarEventForActivityFeedQueryResult = Apollo.QueryResult<GraphqlTypes.GetCalendarEventForActivityFeedQuery, GraphqlTypes.GetCalendarEventForActivityFeedQueryVariables>;
export const ConfigureExternalSsoDocument = gql`
    mutation ConfigureExternalSso {
  configureExternalSso {
    __typename
    ... on ExternalSsoConfigurationOutput {
      url
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ConfigureExternalSsoMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigureExternalSsoMutation, GraphqlTypes.ConfigureExternalSsoMutationVariables>;

/**
 * __useConfigureExternalSsoMutation__
 *
 * To run a mutation, you first call `useConfigureExternalSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureExternalSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureExternalSsoMutation, { data, loading, error }] = useConfigureExternalSsoMutation({
 *   variables: {
 *   },
 * });
 */
export function useConfigureExternalSsoMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigureExternalSsoMutation, GraphqlTypes.ConfigureExternalSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigureExternalSsoMutation, GraphqlTypes.ConfigureExternalSsoMutationVariables>(ConfigureExternalSsoDocument, options);
      }
export type ConfigureExternalSsoMutationHookResult = ReturnType<typeof useConfigureExternalSsoMutation>;
export type ConfigureExternalSsoMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigureExternalSsoMutation>;
export type ConfigureExternalSsoMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigureExternalSsoMutation, GraphqlTypes.ConfigureExternalSsoMutationVariables>;
export const GetSsoDetailsDocument = gql`
    query GetSsoDetails {
  currentArena {
    id
    hasExternalSsoConfigured
  }
}
    `;

/**
 * __useGetSsoDetailsQuery__
 *
 * To run a query within a React component, call `useGetSsoDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSsoDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>(GetSsoDetailsDocument, options);
      }
export function useGetSsoDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>(GetSsoDetailsDocument, options);
        }
// @ts-ignore
export function useGetSsoDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>;
export function useGetSsoDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSsoDetailsQuery | undefined, GraphqlTypes.GetSsoDetailsQueryVariables>;
export function useGetSsoDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>(GetSsoDetailsDocument, options);
        }
export type GetSsoDetailsQueryHookResult = ReturnType<typeof useGetSsoDetailsQuery>;
export type GetSsoDetailsLazyQueryHookResult = ReturnType<typeof useGetSsoDetailsLazyQuery>;
export type GetSsoDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSsoDetailsSuspenseQuery>;
export type GetSsoDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSsoDetailsQuery, GraphqlTypes.GetSsoDetailsQueryVariables>;
export const UpsertLabelDisplaySettingsDocument = gql`
    mutation UpsertLabelDisplaySettings($input: UpsertLabelDisplaySettingInput!) {
  upsertLabelDisplaySetting(input: $input) {
    ... on LabelDisplaySettingsObjectType {
      id
      fieldName
      singular
      plural
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpsertLabelDisplaySettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertLabelDisplaySettingsMutation, GraphqlTypes.UpsertLabelDisplaySettingsMutationVariables>;

/**
 * __useUpsertLabelDisplaySettingsMutation__
 *
 * To run a mutation, you first call `useUpsertLabelDisplaySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLabelDisplaySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLabelDisplaySettingsMutation, { data, loading, error }] = useUpsertLabelDisplaySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLabelDisplaySettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertLabelDisplaySettingsMutation, GraphqlTypes.UpsertLabelDisplaySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertLabelDisplaySettingsMutation, GraphqlTypes.UpsertLabelDisplaySettingsMutationVariables>(UpsertLabelDisplaySettingsDocument, options);
      }
export type UpsertLabelDisplaySettingsMutationHookResult = ReturnType<typeof useUpsertLabelDisplaySettingsMutation>;
export type UpsertLabelDisplaySettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertLabelDisplaySettingsMutation>;
export type UpsertLabelDisplaySettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertLabelDisplaySettingsMutation, GraphqlTypes.UpsertLabelDisplaySettingsMutationVariables>;
export const DeleteLabelDisplaySettingDocument = gql`
    mutation DeleteLabelDisplaySetting($input: DeleteLabelDisplaySettingInput!) {
  deleteLabelDisplaySetting(input: $input) {
    ... on DeleteLabelDisplaySettingResponse {
      success
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DeleteLabelDisplaySettingMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteLabelDisplaySettingMutation, GraphqlTypes.DeleteLabelDisplaySettingMutationVariables>;

/**
 * __useDeleteLabelDisplaySettingMutation__
 *
 * To run a mutation, you first call `useDeleteLabelDisplaySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLabelDisplaySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLabelDisplaySettingMutation, { data, loading, error }] = useDeleteLabelDisplaySettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLabelDisplaySettingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteLabelDisplaySettingMutation, GraphqlTypes.DeleteLabelDisplaySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteLabelDisplaySettingMutation, GraphqlTypes.DeleteLabelDisplaySettingMutationVariables>(DeleteLabelDisplaySettingDocument, options);
      }
export type DeleteLabelDisplaySettingMutationHookResult = ReturnType<typeof useDeleteLabelDisplaySettingMutation>;
export type DeleteLabelDisplaySettingMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteLabelDisplaySettingMutation>;
export type DeleteLabelDisplaySettingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteLabelDisplaySettingMutation, GraphqlTypes.DeleteLabelDisplaySettingMutationVariables>;
export const GetLabelDisplaySettingsDocument = gql`
    query GetLabelDisplaySettings {
  currentArena {
    labelDisplaySettings {
      ... on LabelDisplaySettingsObjectType {
        id
        fieldName
        singular
        plural
        variants {
          id
          variantName
          investmentEntities {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLabelDisplaySettingsQuery__
 *
 * To run a query within a React component, call `useGetLabelDisplaySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelDisplaySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelDisplaySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLabelDisplaySettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>(GetLabelDisplaySettingsDocument, options);
      }
export function useGetLabelDisplaySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>(GetLabelDisplaySettingsDocument, options);
        }
// @ts-ignore
export function useGetLabelDisplaySettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>;
export function useGetLabelDisplaySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLabelDisplaySettingsQuery | undefined, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>;
export function useGetLabelDisplaySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>(GetLabelDisplaySettingsDocument, options);
        }
export type GetLabelDisplaySettingsQueryHookResult = ReturnType<typeof useGetLabelDisplaySettingsQuery>;
export type GetLabelDisplaySettingsLazyQueryHookResult = ReturnType<typeof useGetLabelDisplaySettingsLazyQuery>;
export type GetLabelDisplaySettingsSuspenseQueryHookResult = ReturnType<typeof useGetLabelDisplaySettingsSuspenseQuery>;
export type GetLabelDisplaySettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetLabelDisplaySettingsQuery, GraphqlTypes.GetLabelDisplaySettingsQueryVariables>;
export const GetInvestmentEntitiesForLabelSettingsDocument = gql`
    query GetInvestmentEntitiesForLabelSettings {
  investmentEntitiesUnsorted {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetInvestmentEntitiesForLabelSettingsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesForLabelSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesForLabelSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesForLabelSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvestmentEntitiesForLabelSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>(GetInvestmentEntitiesForLabelSettingsDocument, options);
      }
export function useGetInvestmentEntitiesForLabelSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>(GetInvestmentEntitiesForLabelSettingsDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesForLabelSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>;
export function useGetInvestmentEntitiesForLabelSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery | undefined, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>;
export function useGetInvestmentEntitiesForLabelSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>(GetInvestmentEntitiesForLabelSettingsDocument, options);
        }
export type GetInvestmentEntitiesForLabelSettingsQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesForLabelSettingsQuery>;
export type GetInvestmentEntitiesForLabelSettingsLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesForLabelSettingsLazyQuery>;
export type GetInvestmentEntitiesForLabelSettingsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesForLabelSettingsSuspenseQuery>;
export type GetInvestmentEntitiesForLabelSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQuery, GraphqlTypes.GetInvestmentEntitiesForLabelSettingsQueryVariables>;
export const RestartBankAccountVerificationDocument = gql`
    mutation RestartBankAccountVerification($input: RestartBankAccountVerificationInput!) {
  restartBankAccountVerification(restartBankAccountVerificationInput: $input) {
    id
    verificationStatus
  }
}
    `;
export type RestartBankAccountVerificationMutationFn = Apollo.MutationFunction<GraphqlTypes.RestartBankAccountVerificationMutation, GraphqlTypes.RestartBankAccountVerificationMutationVariables>;

/**
 * __useRestartBankAccountVerificationMutation__
 *
 * To run a mutation, you first call `useRestartBankAccountVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartBankAccountVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartBankAccountVerificationMutation, { data, loading, error }] = useRestartBankAccountVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestartBankAccountVerificationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RestartBankAccountVerificationMutation, GraphqlTypes.RestartBankAccountVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RestartBankAccountVerificationMutation, GraphqlTypes.RestartBankAccountVerificationMutationVariables>(RestartBankAccountVerificationDocument, options);
      }
export type RestartBankAccountVerificationMutationHookResult = ReturnType<typeof useRestartBankAccountVerificationMutation>;
export type RestartBankAccountVerificationMutationResult = Apollo.MutationResult<GraphqlTypes.RestartBankAccountVerificationMutation>;
export type RestartBankAccountVerificationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RestartBankAccountVerificationMutation, GraphqlTypes.RestartBankAccountVerificationMutationVariables>;
export const InitiateBankAccountVerificationDocument = gql`
    mutation InitiateBankAccountVerification($input: InitiateBankAccountVerificationInput!) {
  initiateBankAccountVerification(initiateBankAccountVerificationInput: $input) {
    id
    verificationStatus
  }
}
    `;
export type InitiateBankAccountVerificationMutationFn = Apollo.MutationFunction<GraphqlTypes.InitiateBankAccountVerificationMutation, GraphqlTypes.InitiateBankAccountVerificationMutationVariables>;

/**
 * __useInitiateBankAccountVerificationMutation__
 *
 * To run a mutation, you first call `useInitiateBankAccountVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateBankAccountVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateBankAccountVerificationMutation, { data, loading, error }] = useInitiateBankAccountVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateBankAccountVerificationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.InitiateBankAccountVerificationMutation, GraphqlTypes.InitiateBankAccountVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.InitiateBankAccountVerificationMutation, GraphqlTypes.InitiateBankAccountVerificationMutationVariables>(InitiateBankAccountVerificationDocument, options);
      }
export type InitiateBankAccountVerificationMutationHookResult = ReturnType<typeof useInitiateBankAccountVerificationMutation>;
export type InitiateBankAccountVerificationMutationResult = Apollo.MutationResult<GraphqlTypes.InitiateBankAccountVerificationMutation>;
export type InitiateBankAccountVerificationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.InitiateBankAccountVerificationMutation, GraphqlTypes.InitiateBankAccountVerificationMutationVariables>;
export const CompleteBankAccountAchVerificationDocument = gql`
    mutation CompleteBankAccountAchVerification($input: CompleteBankAccountAchVerificationInput!) {
  completeBankAccountAchVerification(
    completeBankAccountAchVerificationInput: $input
  ) {
    id
    verificationStatus
  }
}
    `;
export type CompleteBankAccountAchVerificationMutationFn = Apollo.MutationFunction<GraphqlTypes.CompleteBankAccountAchVerificationMutation, GraphqlTypes.CompleteBankAccountAchVerificationMutationVariables>;

/**
 * __useCompleteBankAccountAchVerificationMutation__
 *
 * To run a mutation, you first call `useCompleteBankAccountAchVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteBankAccountAchVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeBankAccountAchVerificationMutation, { data, loading, error }] = useCompleteBankAccountAchVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteBankAccountAchVerificationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CompleteBankAccountAchVerificationMutation, GraphqlTypes.CompleteBankAccountAchVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CompleteBankAccountAchVerificationMutation, GraphqlTypes.CompleteBankAccountAchVerificationMutationVariables>(CompleteBankAccountAchVerificationDocument, options);
      }
export type CompleteBankAccountAchVerificationMutationHookResult = ReturnType<typeof useCompleteBankAccountAchVerificationMutation>;
export type CompleteBankAccountAchVerificationMutationResult = Apollo.MutationResult<GraphqlTypes.CompleteBankAccountAchVerificationMutation>;
export type CompleteBankAccountAchVerificationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CompleteBankAccountAchVerificationMutation, GraphqlTypes.CompleteBankAccountAchVerificationMutationVariables>;
export const GetBankAccountsDocument = gql`
    query GetBankAccounts($input: BankAccountsInput!) {
  bankAccounts(input: $input) {
    id
    verificationStatus
  }
}
    `;

/**
 * __useGetBankAccountsQuery__
 *
 * To run a query within a React component, call `useGetBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables> & ({ variables: GraphqlTypes.GetBankAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>(GetBankAccountsDocument, options);
      }
export function useGetBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>(GetBankAccountsDocument, options);
        }
// @ts-ignore
export function useGetBankAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>;
export function useGetBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBankAccountsQuery | undefined, GraphqlTypes.GetBankAccountsQueryVariables>;
export function useGetBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>(GetBankAccountsDocument, options);
        }
export type GetBankAccountsQueryHookResult = ReturnType<typeof useGetBankAccountsQuery>;
export type GetBankAccountsLazyQueryHookResult = ReturnType<typeof useGetBankAccountsLazyQuery>;
export type GetBankAccountsSuspenseQueryHookResult = ReturnType<typeof useGetBankAccountsSuspenseQuery>;
export type GetBankAccountsQueryResult = Apollo.QueryResult<GraphqlTypes.GetBankAccountsQuery, GraphqlTypes.GetBankAccountsQueryVariables>;
export const GetPaymentApplicationForBankAccountVerificationDocument = gql`
    query GetPaymentApplicationForBankAccountVerification($arenaId: ID!) {
  paymentsApplication(objectType: ARENA, objectId: $arenaId) {
    id
    status
  }
}
    `;

/**
 * __useGetPaymentApplicationForBankAccountVerificationQuery__
 *
 * To run a query within a React component, call `useGetPaymentApplicationForBankAccountVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentApplicationForBankAccountVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentApplicationForBankAccountVerificationQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPaymentApplicationForBankAccountVerificationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables> & ({ variables: GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>(GetPaymentApplicationForBankAccountVerificationDocument, options);
      }
export function useGetPaymentApplicationForBankAccountVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>(GetPaymentApplicationForBankAccountVerificationDocument, options);
        }
// @ts-ignore
export function useGetPaymentApplicationForBankAccountVerificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>;
export function useGetPaymentApplicationForBankAccountVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery | undefined, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>;
export function useGetPaymentApplicationForBankAccountVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>(GetPaymentApplicationForBankAccountVerificationDocument, options);
        }
export type GetPaymentApplicationForBankAccountVerificationQueryHookResult = ReturnType<typeof useGetPaymentApplicationForBankAccountVerificationQuery>;
export type GetPaymentApplicationForBankAccountVerificationLazyQueryHookResult = ReturnType<typeof useGetPaymentApplicationForBankAccountVerificationLazyQuery>;
export type GetPaymentApplicationForBankAccountVerificationSuspenseQueryHookResult = ReturnType<typeof useGetPaymentApplicationForBankAccountVerificationSuspenseQuery>;
export type GetPaymentApplicationForBankAccountVerificationQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQuery, GraphqlTypes.GetPaymentApplicationForBankAccountVerificationQueryVariables>;
export const EnableAutomatedPaymentsForEntityDocument = gql`
    mutation EnableAutomatedPaymentsForEntity($entityId: Int!) {
  enableAutomatedPaymentForEntity(entityId: $entityId) {
    entity {
      id
      automatedPaymentsEnabled
    }
  }
}
    `;
export type EnableAutomatedPaymentsForEntityMutationFn = Apollo.MutationFunction<GraphqlTypes.EnableAutomatedPaymentsForEntityMutation, GraphqlTypes.EnableAutomatedPaymentsForEntityMutationVariables>;

/**
 * __useEnableAutomatedPaymentsForEntityMutation__
 *
 * To run a mutation, you first call `useEnableAutomatedPaymentsForEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAutomatedPaymentsForEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAutomatedPaymentsForEntityMutation, { data, loading, error }] = useEnableAutomatedPaymentsForEntityMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEnableAutomatedPaymentsForEntityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EnableAutomatedPaymentsForEntityMutation, GraphqlTypes.EnableAutomatedPaymentsForEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EnableAutomatedPaymentsForEntityMutation, GraphqlTypes.EnableAutomatedPaymentsForEntityMutationVariables>(EnableAutomatedPaymentsForEntityDocument, options);
      }
export type EnableAutomatedPaymentsForEntityMutationHookResult = ReturnType<typeof useEnableAutomatedPaymentsForEntityMutation>;
export type EnableAutomatedPaymentsForEntityMutationResult = Apollo.MutationResult<GraphqlTypes.EnableAutomatedPaymentsForEntityMutation>;
export type EnableAutomatedPaymentsForEntityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EnableAutomatedPaymentsForEntityMutation, GraphqlTypes.EnableAutomatedPaymentsForEntityMutationVariables>;
export const GetPaymentApplicationStatusDocument = gql`
    query GetPaymentApplicationStatus($objectType: ObjectType!, $objectId: ID!) {
  paymentsApplication(objectType: $objectType, objectId: $objectId) {
    id
    status
    profileId
  }
}
    `;

/**
 * __useGetPaymentApplicationStatusQuery__
 *
 * To run a query within a React component, call `useGetPaymentApplicationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentApplicationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentApplicationStatusQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetPaymentApplicationStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables> & ({ variables: GraphqlTypes.GetPaymentApplicationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>(GetPaymentApplicationStatusDocument, options);
      }
export function useGetPaymentApplicationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>(GetPaymentApplicationStatusDocument, options);
        }
// @ts-ignore
export function useGetPaymentApplicationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>;
export function useGetPaymentApplicationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationStatusQuery | undefined, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>;
export function useGetPaymentApplicationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>(GetPaymentApplicationStatusDocument, options);
        }
export type GetPaymentApplicationStatusQueryHookResult = ReturnType<typeof useGetPaymentApplicationStatusQuery>;
export type GetPaymentApplicationStatusLazyQueryHookResult = ReturnType<typeof useGetPaymentApplicationStatusLazyQuery>;
export type GetPaymentApplicationStatusSuspenseQueryHookResult = ReturnType<typeof useGetPaymentApplicationStatusSuspenseQuery>;
export type GetPaymentApplicationStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentApplicationStatusQuery, GraphqlTypes.GetPaymentApplicationStatusQueryVariables>;
export const GetPaymentApplicationProfileIdDocument = gql`
    query GetPaymentApplicationProfileId($objectType: ObjectType!, $objectId: ID!) {
  paymentsApplication(objectType: $objectType, objectId: $objectId) {
    id
    profileId
  }
}
    `;

/**
 * __useGetPaymentApplicationProfileIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentApplicationProfileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentApplicationProfileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentApplicationProfileIdQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetPaymentApplicationProfileIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables> & ({ variables: GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>(GetPaymentApplicationProfileIdDocument, options);
      }
export function useGetPaymentApplicationProfileIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>(GetPaymentApplicationProfileIdDocument, options);
        }
// @ts-ignore
export function useGetPaymentApplicationProfileIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>;
export function useGetPaymentApplicationProfileIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationProfileIdQuery | undefined, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>;
export function useGetPaymentApplicationProfileIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>(GetPaymentApplicationProfileIdDocument, options);
        }
export type GetPaymentApplicationProfileIdQueryHookResult = ReturnType<typeof useGetPaymentApplicationProfileIdQuery>;
export type GetPaymentApplicationProfileIdLazyQueryHookResult = ReturnType<typeof useGetPaymentApplicationProfileIdLazyQuery>;
export type GetPaymentApplicationProfileIdSuspenseQueryHookResult = ReturnType<typeof useGetPaymentApplicationProfileIdSuspenseQuery>;
export type GetPaymentApplicationProfileIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentApplicationProfileIdQuery, GraphqlTypes.GetPaymentApplicationProfileIdQueryVariables>;
export const CreatePaymentBatchDocument = gql`
    mutation CreatePaymentBatch($createPaymentBatchInput: CreatePaymentBatchInput!) {
  createPaymentBatch(createPaymentBatchInput: $createPaymentBatchInput) {
    id
    objectId
    status
    payments {
      id
      status
      objectId
      direction
    }
  }
}
    `;
export type CreatePaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePaymentBatchMutation, GraphqlTypes.CreatePaymentBatchMutationVariables>;

/**
 * __useCreatePaymentBatchMutation__
 *
 * To run a mutation, you first call `useCreatePaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentBatchMutation, { data, loading, error }] = useCreatePaymentBatchMutation({
 *   variables: {
 *      createPaymentBatchInput: // value for 'createPaymentBatchInput'
 *   },
 * });
 */
export function useCreatePaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePaymentBatchMutation, GraphqlTypes.CreatePaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePaymentBatchMutation, GraphqlTypes.CreatePaymentBatchMutationVariables>(CreatePaymentBatchDocument, options);
      }
export type CreatePaymentBatchMutationHookResult = ReturnType<typeof useCreatePaymentBatchMutation>;
export type CreatePaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePaymentBatchMutation>;
export type CreatePaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePaymentBatchMutation, GraphqlTypes.CreatePaymentBatchMutationVariables>;
export const GetPaymentBatchesForPaymentInitiationDocument = gql`
    query GetPaymentBatchesForPaymentInitiation($distributionBatchId: ID!) {
  paymentBatches(distributionBatchId: $distributionBatchId) {
    id
    status
    payments {
      id
      status
      objectId
      direction
    }
  }
}
    `;

/**
 * __useGetPaymentBatchesForPaymentInitiationQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchesForPaymentInitiationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchesForPaymentInitiationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchesForPaymentInitiationQuery({
 *   variables: {
 *      distributionBatchId: // value for 'distributionBatchId'
 *   },
 * });
 */
export function useGetPaymentBatchesForPaymentInitiationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>(GetPaymentBatchesForPaymentInitiationDocument, options);
      }
export function useGetPaymentBatchesForPaymentInitiationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>(GetPaymentBatchesForPaymentInitiationDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchesForPaymentInitiationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>;
export function useGetPaymentBatchesForPaymentInitiationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery | undefined, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>;
export function useGetPaymentBatchesForPaymentInitiationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>(GetPaymentBatchesForPaymentInitiationDocument, options);
        }
export type GetPaymentBatchesForPaymentInitiationQueryHookResult = ReturnType<typeof useGetPaymentBatchesForPaymentInitiationQuery>;
export type GetPaymentBatchesForPaymentInitiationLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchesForPaymentInitiationLazyQuery>;
export type GetPaymentBatchesForPaymentInitiationSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchesForPaymentInitiationSuspenseQuery>;
export type GetPaymentBatchesForPaymentInitiationQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchesForPaymentInitiationQuery, GraphqlTypes.GetPaymentBatchesForPaymentInitiationQueryVariables>;
export const GetAchDebitLimitDetailsDocument = gql`
    query GetAchDebitLimitDetails($scheduledProcessDate: DateTime!, $distributionBatchId: ID!) {
  achDebitLimitDetails(
    scheduledProcessDate: $scheduledProcessDate
    distributionBatchId: $distributionBatchId
  ) {
    consumed
    limit
    limitType
  }
}
    `;

/**
 * __useGetAchDebitLimitDetailsQuery__
 *
 * To run a query within a React component, call `useGetAchDebitLimitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchDebitLimitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchDebitLimitDetailsQuery({
 *   variables: {
 *      scheduledProcessDate: // value for 'scheduledProcessDate'
 *      distributionBatchId: // value for 'distributionBatchId'
 *   },
 * });
 */
export function useGetAchDebitLimitDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables> & ({ variables: GraphqlTypes.GetAchDebitLimitDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>(GetAchDebitLimitDetailsDocument, options);
      }
export function useGetAchDebitLimitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>(GetAchDebitLimitDetailsDocument, options);
        }
// @ts-ignore
export function useGetAchDebitLimitDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>;
export function useGetAchDebitLimitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAchDebitLimitDetailsQuery | undefined, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>;
export function useGetAchDebitLimitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>(GetAchDebitLimitDetailsDocument, options);
        }
export type GetAchDebitLimitDetailsQueryHookResult = ReturnType<typeof useGetAchDebitLimitDetailsQuery>;
export type GetAchDebitLimitDetailsLazyQueryHookResult = ReturnType<typeof useGetAchDebitLimitDetailsLazyQuery>;
export type GetAchDebitLimitDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAchDebitLimitDetailsSuspenseQuery>;
export type GetAchDebitLimitDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAchDebitLimitDetailsQuery, GraphqlTypes.GetAchDebitLimitDetailsQueryVariables>;
export const GetDistributionBatchDocument = gql`
    query GetDistributionBatch($distributionBatchId: ID!, $picrCasesEnabled: Boolean!) {
  distributionBatch(id: $distributionBatchId) {
    id
    description
    entity {
      id
      name
      currency {
        ...CurrencyFieldsFederation
      }
    }
    instances {
      id
      amountDistributed {
        monies
      }
      netAmountAdjustments {
        monies
      }
      amountPayable {
        monies
      }
      hasPayment
      position {
        id
        entityCurrency
        account {
          id
          gpTitle
        }
        hasPendingPaymentPrefChangeRequests
        hasPassedPicrComplianceChecks @include(if: $picrCasesEnabled)
        paymentPref {
          id
          paymentMethod
          verificationStatus
          wireHasIntermediary
          wireHasInternationalBeneficiaryAddress
          watchlistStatus {
            id
            status
          }
          paymentPrefFull {
            ... on WirePaymentPrefObjectType {
              id
              referenceToBeneficiary
              wireBbi {
                field0
                field1
                field2
                field3
              }
            }
            ... on AchPaymentPrefObjectType {
              id
            }
            ... on CheckPaymentPrefObjectType {
              id
            }
          }
        }
        paymentPrefUpdatedAt
      }
    }
  }
}
    ${CurrencyFieldsFederationFragmentDoc}`;

/**
 * __useGetDistributionBatchQuery__
 *
 * To run a query within a React component, call `useGetDistributionBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionBatchQuery({
 *   variables: {
 *      distributionBatchId: // value for 'distributionBatchId'
 *      picrCasesEnabled: // value for 'picrCasesEnabled'
 *   },
 * });
 */
export function useGetDistributionBatchQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables> & ({ variables: GraphqlTypes.GetDistributionBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>(GetDistributionBatchDocument, options);
      }
export function useGetDistributionBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>(GetDistributionBatchDocument, options);
        }
// @ts-ignore
export function useGetDistributionBatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>;
export function useGetDistributionBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchQuery | undefined, GraphqlTypes.GetDistributionBatchQueryVariables>;
export function useGetDistributionBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>(GetDistributionBatchDocument, options);
        }
export type GetDistributionBatchQueryHookResult = ReturnType<typeof useGetDistributionBatchQuery>;
export type GetDistributionBatchLazyQueryHookResult = ReturnType<typeof useGetDistributionBatchLazyQuery>;
export type GetDistributionBatchSuspenseQueryHookResult = ReturnType<typeof useGetDistributionBatchSuspenseQuery>;
export type GetDistributionBatchQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionBatchQuery, GraphqlTypes.GetDistributionBatchQueryVariables>;
export const LinkBeneficialOwnerDocument = gql`
    mutation LinkBeneficialOwner($entityId: Int!, $childProfileId: Int!, $percentage: Float!) {
  linkBeneficialOwner(
    entityId: $entityId
    childProfileId: $childProfileId
    percentage: $percentage
  ) {
    id
    percentOwnership
    childProfile {
      id
    }
  }
}
    `;
export type LinkBeneficialOwnerMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkBeneficialOwnerMutation, GraphqlTypes.LinkBeneficialOwnerMutationVariables>;

/**
 * __useLinkBeneficialOwnerMutation__
 *
 * To run a mutation, you first call `useLinkBeneficialOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkBeneficialOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkBeneficialOwnerMutation, { data, loading, error }] = useLinkBeneficialOwnerMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      childProfileId: // value for 'childProfileId'
 *      percentage: // value for 'percentage'
 *   },
 * });
 */
export function useLinkBeneficialOwnerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkBeneficialOwnerMutation, GraphqlTypes.LinkBeneficialOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkBeneficialOwnerMutation, GraphqlTypes.LinkBeneficialOwnerMutationVariables>(LinkBeneficialOwnerDocument, options);
      }
export type LinkBeneficialOwnerMutationHookResult = ReturnType<typeof useLinkBeneficialOwnerMutation>;
export type LinkBeneficialOwnerMutationResult = Apollo.MutationResult<GraphqlTypes.LinkBeneficialOwnerMutation>;
export type LinkBeneficialOwnerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkBeneficialOwnerMutation, GraphqlTypes.LinkBeneficialOwnerMutationVariables>;
export const UnlinkBeneficialOwnerDocument = gql`
    mutation UnlinkBeneficialOwner($entityId: Int!, $childProfileId: Int!, $relationshipType: ProfileRelationshipEnum!) {
  unlinkRelationship(
    entityId: $entityId
    childProfileId: $childProfileId
    relationshipType: $relationshipType
  )
}
    `;
export type UnlinkBeneficialOwnerMutationFn = Apollo.MutationFunction<GraphqlTypes.UnlinkBeneficialOwnerMutation, GraphqlTypes.UnlinkBeneficialOwnerMutationVariables>;

/**
 * __useUnlinkBeneficialOwnerMutation__
 *
 * To run a mutation, you first call `useUnlinkBeneficialOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkBeneficialOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkBeneficialOwnerMutation, { data, loading, error }] = useUnlinkBeneficialOwnerMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      childProfileId: // value for 'childProfileId'
 *      relationshipType: // value for 'relationshipType'
 *   },
 * });
 */
export function useUnlinkBeneficialOwnerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UnlinkBeneficialOwnerMutation, GraphqlTypes.UnlinkBeneficialOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UnlinkBeneficialOwnerMutation, GraphqlTypes.UnlinkBeneficialOwnerMutationVariables>(UnlinkBeneficialOwnerDocument, options);
      }
export type UnlinkBeneficialOwnerMutationHookResult = ReturnType<typeof useUnlinkBeneficialOwnerMutation>;
export type UnlinkBeneficialOwnerMutationResult = Apollo.MutationResult<GraphqlTypes.UnlinkBeneficialOwnerMutation>;
export type UnlinkBeneficialOwnerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UnlinkBeneficialOwnerMutation, GraphqlTypes.UnlinkBeneficialOwnerMutationVariables>;
export const ComplianceProfileDocument = gql`
    query ComplianceProfile($id: Int!) {
  complianceProfile(id: $id) {
    ...EntityProfile
  }
}
    ${EntityProfileFragmentDoc}`;

/**
 * __useComplianceProfileQuery__
 *
 * To run a query within a React component, call `useComplianceProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useComplianceProfileQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables> & ({ variables: GraphqlTypes.ComplianceProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>(ComplianceProfileDocument, options);
      }
export function useComplianceProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>(ComplianceProfileDocument, options);
        }
// @ts-ignore
export function useComplianceProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>;
export function useComplianceProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ComplianceProfileQuery | undefined, GraphqlTypes.ComplianceProfileQueryVariables>;
export function useComplianceProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>(ComplianceProfileDocument, options);
        }
export type ComplianceProfileQueryHookResult = ReturnType<typeof useComplianceProfileQuery>;
export type ComplianceProfileLazyQueryHookResult = ReturnType<typeof useComplianceProfileLazyQuery>;
export type ComplianceProfileSuspenseQueryHookResult = ReturnType<typeof useComplianceProfileSuspenseQuery>;
export type ComplianceProfileQueryResult = Apollo.QueryResult<GraphqlTypes.ComplianceProfileQuery, GraphqlTypes.ComplianceProfileQueryVariables>;
export const LinkArenaPaymentApplicationControllerDocument = gql`
    mutation LinkArenaPaymentApplicationController($entityId: Int!, $childProfileId: Int!, $title: String!) {
  linkControllingPerson(
    entityId: $entityId
    childProfileId: $childProfileId
    title: $title
  ) {
    id
    parentProfileId
    childProfileId
    relationshipType
    title
  }
}
    `;
export type LinkArenaPaymentApplicationControllerMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkArenaPaymentApplicationControllerMutation, GraphqlTypes.LinkArenaPaymentApplicationControllerMutationVariables>;

/**
 * __useLinkArenaPaymentApplicationControllerMutation__
 *
 * To run a mutation, you first call `useLinkArenaPaymentApplicationControllerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkArenaPaymentApplicationControllerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkArenaPaymentApplicationControllerMutation, { data, loading, error }] = useLinkArenaPaymentApplicationControllerMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      childProfileId: // value for 'childProfileId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useLinkArenaPaymentApplicationControllerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkArenaPaymentApplicationControllerMutation, GraphqlTypes.LinkArenaPaymentApplicationControllerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkArenaPaymentApplicationControllerMutation, GraphqlTypes.LinkArenaPaymentApplicationControllerMutationVariables>(LinkArenaPaymentApplicationControllerDocument, options);
      }
export type LinkArenaPaymentApplicationControllerMutationHookResult = ReturnType<typeof useLinkArenaPaymentApplicationControllerMutation>;
export type LinkArenaPaymentApplicationControllerMutationResult = Apollo.MutationResult<GraphqlTypes.LinkArenaPaymentApplicationControllerMutation>;
export type LinkArenaPaymentApplicationControllerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkArenaPaymentApplicationControllerMutation, GraphqlTypes.LinkArenaPaymentApplicationControllerMutationVariables>;
export const UnlinkArenaPaymentApplicationControllerDocument = gql`
    mutation UnlinkArenaPaymentApplicationController($entityId: Int!, $childProfileId: Int!) {
  unlinkRelationship(
    entityId: $entityId
    childProfileId: $childProfileId
    relationshipType: controller
  )
}
    `;
export type UnlinkArenaPaymentApplicationControllerMutationFn = Apollo.MutationFunction<GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutation, GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutationVariables>;

/**
 * __useUnlinkArenaPaymentApplicationControllerMutation__
 *
 * To run a mutation, you first call `useUnlinkArenaPaymentApplicationControllerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkArenaPaymentApplicationControllerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkArenaPaymentApplicationControllerMutation, { data, loading, error }] = useUnlinkArenaPaymentApplicationControllerMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      childProfileId: // value for 'childProfileId'
 *   },
 * });
 */
export function useUnlinkArenaPaymentApplicationControllerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutation, GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutation, GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutationVariables>(UnlinkArenaPaymentApplicationControllerDocument, options);
      }
export type UnlinkArenaPaymentApplicationControllerMutationHookResult = ReturnType<typeof useUnlinkArenaPaymentApplicationControllerMutation>;
export type UnlinkArenaPaymentApplicationControllerMutationResult = Apollo.MutationResult<GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutation>;
export type UnlinkArenaPaymentApplicationControllerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutation, GraphqlTypes.UnlinkArenaPaymentApplicationControllerMutationVariables>;
export const GetComplianceProfilesDocument = gql`
    query GetComplianceProfiles($externalId: String!, $externalType: String!, $profileKind: ComplianceObjectType) {
  complianceProfiles(
    externalId: $externalId
    externalType: $externalType
    profileKind: $profileKind
  ) {
    edges {
      node {
        id
        firstName
        middleName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetComplianceProfilesQuery__
 *
 * To run a query within a React component, call `useGetComplianceProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceProfilesQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      externalType: // value for 'externalType'
 *      profileKind: // value for 'profileKind'
 *   },
 * });
 */
export function useGetComplianceProfilesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables> & ({ variables: GraphqlTypes.GetComplianceProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>(GetComplianceProfilesDocument, options);
      }
export function useGetComplianceProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>(GetComplianceProfilesDocument, options);
        }
// @ts-ignore
export function useGetComplianceProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>;
export function useGetComplianceProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceProfilesQuery | undefined, GraphqlTypes.GetComplianceProfilesQueryVariables>;
export function useGetComplianceProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>(GetComplianceProfilesDocument, options);
        }
export type GetComplianceProfilesQueryHookResult = ReturnType<typeof useGetComplianceProfilesQuery>;
export type GetComplianceProfilesLazyQueryHookResult = ReturnType<typeof useGetComplianceProfilesLazyQuery>;
export type GetComplianceProfilesSuspenseQueryHookResult = ReturnType<typeof useGetComplianceProfilesSuspenseQuery>;
export type GetComplianceProfilesQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceProfilesQuery, GraphqlTypes.GetComplianceProfilesQueryVariables>;
export const GetCurrentArenaForEntitiesApplicationSelectionDocument = gql`
    query GetCurrentArenaForEntitiesApplicationSelection {
  currentArena {
    id
    allDiligencesConfirmed
    features {
      hasSwiftPayments
    }
  }
}
    `;

/**
 * __useGetCurrentArenaForEntitiesApplicationSelectionQuery__
 *
 * To run a query within a React component, call `useGetCurrentArenaForEntitiesApplicationSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentArenaForEntitiesApplicationSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentArenaForEntitiesApplicationSelectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentArenaForEntitiesApplicationSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>(GetCurrentArenaForEntitiesApplicationSelectionDocument, options);
      }
export function useGetCurrentArenaForEntitiesApplicationSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>(GetCurrentArenaForEntitiesApplicationSelectionDocument, options);
        }
// @ts-ignore
export function useGetCurrentArenaForEntitiesApplicationSelectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>;
export function useGetCurrentArenaForEntitiesApplicationSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery | undefined, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>;
export function useGetCurrentArenaForEntitiesApplicationSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>(GetCurrentArenaForEntitiesApplicationSelectionDocument, options);
        }
export type GetCurrentArenaForEntitiesApplicationSelectionQueryHookResult = ReturnType<typeof useGetCurrentArenaForEntitiesApplicationSelectionQuery>;
export type GetCurrentArenaForEntitiesApplicationSelectionLazyQueryHookResult = ReturnType<typeof useGetCurrentArenaForEntitiesApplicationSelectionLazyQuery>;
export type GetCurrentArenaForEntitiesApplicationSelectionSuspenseQueryHookResult = ReturnType<typeof useGetCurrentArenaForEntitiesApplicationSelectionSuspenseQuery>;
export type GetCurrentArenaForEntitiesApplicationSelectionQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQuery, GraphqlTypes.GetCurrentArenaForEntitiesApplicationSelectionQueryVariables>;
export const GetInvestmentEntitiesForApplicationSelectionDocument = gql`
    query GetInvestmentEntitiesForApplicationSelection($filters: EntitiesFilters, $first: Int, $after: String, $last: Int, $before: String) {
  investmentEntities(
    filters: $filters
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    count
    edges {
      node {
        id
        name
        isFundAdminEntity
        allDiligencesConfirmed
        paymentsApplication {
          id
          status
        }
        bankAccount {
          id
          verificationStatus
        }
        automatedPaymentsEnabled
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetInvestmentEntitiesForApplicationSelectionQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesForApplicationSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesForApplicationSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesForApplicationSelectionQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetInvestmentEntitiesForApplicationSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>(GetInvestmentEntitiesForApplicationSelectionDocument, options);
      }
export function useGetInvestmentEntitiesForApplicationSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>(GetInvestmentEntitiesForApplicationSelectionDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesForApplicationSelectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>;
export function useGetInvestmentEntitiesForApplicationSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery | undefined, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>;
export function useGetInvestmentEntitiesForApplicationSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>(GetInvestmentEntitiesForApplicationSelectionDocument, options);
        }
export type GetInvestmentEntitiesForApplicationSelectionQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesForApplicationSelectionQuery>;
export type GetInvestmentEntitiesForApplicationSelectionLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesForApplicationSelectionLazyQuery>;
export type GetInvestmentEntitiesForApplicationSelectionSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesForApplicationSelectionSuspenseQuery>;
export type GetInvestmentEntitiesForApplicationSelectionQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQuery, GraphqlTypes.GetInvestmentEntitiesForApplicationSelectionQueryVariables>;
export const SubmitEntityPaymentsApplicationDocument = gql`
    mutation SubmitEntityPaymentsApplication($input: SubmitInvestmentEntityPaymentsApplicationInput!) {
  submitInvestmentEntityPaymentsApplication(
    submitInvestmentEntityPaymentsApplicationInput: $input
  ) {
    id
  }
}
    `;
export type SubmitEntityPaymentsApplicationMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitEntityPaymentsApplicationMutation, GraphqlTypes.SubmitEntityPaymentsApplicationMutationVariables>;

/**
 * __useSubmitEntityPaymentsApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitEntityPaymentsApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEntityPaymentsApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEntityPaymentsApplicationMutation, { data, loading, error }] = useSubmitEntityPaymentsApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitEntityPaymentsApplicationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitEntityPaymentsApplicationMutation, GraphqlTypes.SubmitEntityPaymentsApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitEntityPaymentsApplicationMutation, GraphqlTypes.SubmitEntityPaymentsApplicationMutationVariables>(SubmitEntityPaymentsApplicationDocument, options);
      }
export type SubmitEntityPaymentsApplicationMutationHookResult = ReturnType<typeof useSubmitEntityPaymentsApplicationMutation>;
export type SubmitEntityPaymentsApplicationMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitEntityPaymentsApplicationMutation>;
export type SubmitEntityPaymentsApplicationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitEntityPaymentsApplicationMutation, GraphqlTypes.SubmitEntityPaymentsApplicationMutationVariables>;
export const LinkProfileToEntityOwnershipDomicileDocument = gql`
    mutation LinkProfileToEntityOwnershipDomicile($profileId: Int!, $countryId: Int!) {
  linkProfileToEntityOwnershipDomicile(
    profileId: $profileId
    countryId: $countryId
  ) {
    id
  }
}
    `;
export type LinkProfileToEntityOwnershipDomicileMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutation, GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutationVariables>;

/**
 * __useLinkProfileToEntityOwnershipDomicileMutation__
 *
 * To run a mutation, you first call `useLinkProfileToEntityOwnershipDomicileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkProfileToEntityOwnershipDomicileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkProfileToEntityOwnershipDomicileMutation, { data, loading, error }] = useLinkProfileToEntityOwnershipDomicileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useLinkProfileToEntityOwnershipDomicileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutation, GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutation, GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutationVariables>(LinkProfileToEntityOwnershipDomicileDocument, options);
      }
export type LinkProfileToEntityOwnershipDomicileMutationHookResult = ReturnType<typeof useLinkProfileToEntityOwnershipDomicileMutation>;
export type LinkProfileToEntityOwnershipDomicileMutationResult = Apollo.MutationResult<GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutation>;
export type LinkProfileToEntityOwnershipDomicileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutation, GraphqlTypes.LinkProfileToEntityOwnershipDomicileMutationVariables>;
export const LinkProfileToIndustryDocument = gql`
    mutation LinkProfileToIndustry($profileId: Int!, $industryId: Int!) {
  linkProfileToIndustry(profileId: $profileId, industryId: $industryId) {
    id
  }
}
    `;
export type LinkProfileToIndustryMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkProfileToIndustryMutation, GraphqlTypes.LinkProfileToIndustryMutationVariables>;

/**
 * __useLinkProfileToIndustryMutation__
 *
 * To run a mutation, you first call `useLinkProfileToIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkProfileToIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkProfileToIndustryMutation, { data, loading, error }] = useLinkProfileToIndustryMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      industryId: // value for 'industryId'
 *   },
 * });
 */
export function useLinkProfileToIndustryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkProfileToIndustryMutation, GraphqlTypes.LinkProfileToIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkProfileToIndustryMutation, GraphqlTypes.LinkProfileToIndustryMutationVariables>(LinkProfileToIndustryDocument, options);
      }
export type LinkProfileToIndustryMutationHookResult = ReturnType<typeof useLinkProfileToIndustryMutation>;
export type LinkProfileToIndustryMutationResult = Apollo.MutationResult<GraphqlTypes.LinkProfileToIndustryMutation>;
export type LinkProfileToIndustryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkProfileToIndustryMutation, GraphqlTypes.LinkProfileToIndustryMutationVariables>;
export const GetEntityDetailsDocument = gql`
    query GetEntityDetails($providedEntityId: ID!) {
  investmentEntity(entityId: $providedEntityId) {
    id
    name
    taxId
  }
}
    `;

/**
 * __useGetEntityDetailsQuery__
 *
 * To run a query within a React component, call `useGetEntityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityDetailsQuery({
 *   variables: {
 *      providedEntityId: // value for 'providedEntityId'
 *   },
 * });
 */
export function useGetEntityDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables> & ({ variables: GraphqlTypes.GetEntityDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>(GetEntityDetailsDocument, options);
      }
export function useGetEntityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>(GetEntityDetailsDocument, options);
        }
// @ts-ignore
export function useGetEntityDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>;
export function useGetEntityDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityDetailsQuery | undefined, GraphqlTypes.GetEntityDetailsQueryVariables>;
export function useGetEntityDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>(GetEntityDetailsDocument, options);
        }
export type GetEntityDetailsQueryHookResult = ReturnType<typeof useGetEntityDetailsQuery>;
export type GetEntityDetailsLazyQueryHookResult = ReturnType<typeof useGetEntityDetailsLazyQuery>;
export type GetEntityDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEntityDetailsSuspenseQuery>;
export type GetEntityDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityDetailsQuery, GraphqlTypes.GetEntityDetailsQueryVariables>;
export const GetPaymentsApplicationDocument = gql`
    query GetPaymentsApplication($objectType: ObjectType!, $objectId: ID!) {
  paymentsApplication(objectType: $objectType, objectId: $objectId) {
    id
    status
    profileId
  }
}
    `;

/**
 * __useGetPaymentsApplicationQuery__
 *
 * To run a query within a React component, call `useGetPaymentsApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsApplicationQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetPaymentsApplicationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables> & ({ variables: GraphqlTypes.GetPaymentsApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>(GetPaymentsApplicationDocument, options);
      }
export function useGetPaymentsApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>(GetPaymentsApplicationDocument, options);
        }
// @ts-ignore
export function useGetPaymentsApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>;
export function useGetPaymentsApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentsApplicationQuery | undefined, GraphqlTypes.GetPaymentsApplicationQueryVariables>;
export function useGetPaymentsApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>(GetPaymentsApplicationDocument, options);
        }
export type GetPaymentsApplicationQueryHookResult = ReturnType<typeof useGetPaymentsApplicationQuery>;
export type GetPaymentsApplicationLazyQueryHookResult = ReturnType<typeof useGetPaymentsApplicationLazyQuery>;
export type GetPaymentsApplicationSuspenseQueryHookResult = ReturnType<typeof useGetPaymentsApplicationSuspenseQuery>;
export type GetPaymentsApplicationQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentsApplicationQuery, GraphqlTypes.GetPaymentsApplicationQueryVariables>;
export const GetComplianceProfilesForSelectionDocument = gql`
    query GetComplianceProfilesForSelection($externalId: String!, $externalType: String!, $pageArgs: PageArgs) {
  complianceProfiles(
    externalId: $externalId
    externalType: $externalType
    pageArgs: $pageArgs
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        complianceObjectType
        legalName
        firstName
        middleName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetComplianceProfilesForSelectionQuery__
 *
 * To run a query within a React component, call `useGetComplianceProfilesForSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceProfilesForSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceProfilesForSelectionQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      externalType: // value for 'externalType'
 *      pageArgs: // value for 'pageArgs'
 *   },
 * });
 */
export function useGetComplianceProfilesForSelectionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables> & ({ variables: GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>(GetComplianceProfilesForSelectionDocument, options);
      }
export function useGetComplianceProfilesForSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>(GetComplianceProfilesForSelectionDocument, options);
        }
// @ts-ignore
export function useGetComplianceProfilesForSelectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>;
export function useGetComplianceProfilesForSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceProfilesForSelectionQuery | undefined, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>;
export function useGetComplianceProfilesForSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>(GetComplianceProfilesForSelectionDocument, options);
        }
export type GetComplianceProfilesForSelectionQueryHookResult = ReturnType<typeof useGetComplianceProfilesForSelectionQuery>;
export type GetComplianceProfilesForSelectionLazyQueryHookResult = ReturnType<typeof useGetComplianceProfilesForSelectionLazyQuery>;
export type GetComplianceProfilesForSelectionSuspenseQueryHookResult = ReturnType<typeof useGetComplianceProfilesForSelectionSuspenseQuery>;
export type GetComplianceProfilesForSelectionQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceProfilesForSelectionQuery, GraphqlTypes.GetComplianceProfilesForSelectionQueryVariables>;
export const GetComplianceCountriesListDocument = gql`
    query GetComplianceCountriesList {
  complianceCountries {
    id
    name
  }
}
    `;

/**
 * __useGetComplianceCountriesListQuery__
 *
 * To run a query within a React component, call `useGetComplianceCountriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCountriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCountriesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetComplianceCountriesListQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>(GetComplianceCountriesListDocument, options);
      }
export function useGetComplianceCountriesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>(GetComplianceCountriesListDocument, options);
        }
// @ts-ignore
export function useGetComplianceCountriesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>;
export function useGetComplianceCountriesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCountriesListQuery | undefined, GraphqlTypes.GetComplianceCountriesListQueryVariables>;
export function useGetComplianceCountriesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>(GetComplianceCountriesListDocument, options);
        }
export type GetComplianceCountriesListQueryHookResult = ReturnType<typeof useGetComplianceCountriesListQuery>;
export type GetComplianceCountriesListLazyQueryHookResult = ReturnType<typeof useGetComplianceCountriesListLazyQuery>;
export type GetComplianceCountriesListSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCountriesListSuspenseQuery>;
export type GetComplianceCountriesListQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCountriesListQuery, GraphqlTypes.GetComplianceCountriesListQueryVariables>;
export const GetRootComplianceProfileDocument = gql`
    query GetRootComplianceProfile($id: Int!) {
  complianceProfile(id: $id) {
    ...EntityProfile
    beneficialOwners {
      id
      title
      percentOwnership
      childProfile {
        ...IndividualProfile
        ...EntityProfile
      }
    }
    controllingPersons {
      id
      title
      childProfile {
        ...IndividualProfile
        ...EntityProfile
      }
    }
  }
}
    ${EntityProfileFragmentDoc}
${IndividualProfileFragmentDoc}`;

/**
 * __useGetRootComplianceProfileQuery__
 *
 * To run a query within a React component, call `useGetRootComplianceProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRootComplianceProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRootComplianceProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRootComplianceProfileQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables> & ({ variables: GraphqlTypes.GetRootComplianceProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>(GetRootComplianceProfileDocument, options);
      }
export function useGetRootComplianceProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>(GetRootComplianceProfileDocument, options);
        }
// @ts-ignore
export function useGetRootComplianceProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>;
export function useGetRootComplianceProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRootComplianceProfileQuery | undefined, GraphqlTypes.GetRootComplianceProfileQueryVariables>;
export function useGetRootComplianceProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>(GetRootComplianceProfileDocument, options);
        }
export type GetRootComplianceProfileQueryHookResult = ReturnType<typeof useGetRootComplianceProfileQuery>;
export type GetRootComplianceProfileLazyQueryHookResult = ReturnType<typeof useGetRootComplianceProfileLazyQuery>;
export type GetRootComplianceProfileSuspenseQueryHookResult = ReturnType<typeof useGetRootComplianceProfileSuspenseQuery>;
export type GetRootComplianceProfileQueryResult = Apollo.QueryResult<GraphqlTypes.GetRootComplianceProfileQuery, GraphqlTypes.GetRootComplianceProfileQueryVariables>;
export const SubmitArenaPaymentsApplicationDocument = gql`
    mutation SubmitArenaPaymentsApplication($input: SubmitArenaPaymentsApplicationInput!) {
  submitArenaPaymentsApplication(submitArenaPaymentsApplicationInput: $input) {
    id
    status
  }
}
    `;
export type SubmitArenaPaymentsApplicationMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitArenaPaymentsApplicationMutation, GraphqlTypes.SubmitArenaPaymentsApplicationMutationVariables>;

/**
 * __useSubmitArenaPaymentsApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitArenaPaymentsApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitArenaPaymentsApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitArenaPaymentsApplicationMutation, { data, loading, error }] = useSubmitArenaPaymentsApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitArenaPaymentsApplicationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitArenaPaymentsApplicationMutation, GraphqlTypes.SubmitArenaPaymentsApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitArenaPaymentsApplicationMutation, GraphqlTypes.SubmitArenaPaymentsApplicationMutationVariables>(SubmitArenaPaymentsApplicationDocument, options);
      }
export type SubmitArenaPaymentsApplicationMutationHookResult = ReturnType<typeof useSubmitArenaPaymentsApplicationMutation>;
export type SubmitArenaPaymentsApplicationMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitArenaPaymentsApplicationMutation>;
export type SubmitArenaPaymentsApplicationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitArenaPaymentsApplicationMutation, GraphqlTypes.SubmitArenaPaymentsApplicationMutationVariables>;
export const CreatePaymentsApplicationDocument = gql`
    mutation CreatePaymentsApplication($input: CreatePaymentsApplicationInput!) {
  createPaymentsApplication(createPaymentsApplicationInput: $input) {
    id
  }
}
    `;
export type CreatePaymentsApplicationMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePaymentsApplicationMutation, GraphqlTypes.CreatePaymentsApplicationMutationVariables>;

/**
 * __useCreatePaymentsApplicationMutation__
 *
 * To run a mutation, you first call `useCreatePaymentsApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentsApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentsApplicationMutation, { data, loading, error }] = useCreatePaymentsApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentsApplicationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePaymentsApplicationMutation, GraphqlTypes.CreatePaymentsApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePaymentsApplicationMutation, GraphqlTypes.CreatePaymentsApplicationMutationVariables>(CreatePaymentsApplicationDocument, options);
      }
export type CreatePaymentsApplicationMutationHookResult = ReturnType<typeof useCreatePaymentsApplicationMutation>;
export type CreatePaymentsApplicationMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePaymentsApplicationMutation>;
export type CreatePaymentsApplicationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePaymentsApplicationMutation, GraphqlTypes.CreatePaymentsApplicationMutationVariables>;
export const UpsertInstitutionProfileDocument = gql`
    mutation UpsertInstitutionProfile($profileId: Int, $arenaId: Int!, $data: InstitutionProfileInput!, $externalIds: [ProfileExternalObjectInput!], $idDocuments: [DocumentInfoInput!]) {
  upsertInstitutionProfile(
    profileId: $profileId
    arenaId: $arenaId
    data: $data
    externalIds: $externalIds
    idDocuments: $idDocuments
  ) {
    ...EntityProfile
  }
}
    ${EntityProfileFragmentDoc}`;
export type UpsertInstitutionProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertInstitutionProfileMutation, GraphqlTypes.UpsertInstitutionProfileMutationVariables>;

/**
 * __useUpsertInstitutionProfileMutation__
 *
 * To run a mutation, you first call `useUpsertInstitutionProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertInstitutionProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertInstitutionProfileMutation, { data, loading, error }] = useUpsertInstitutionProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      arenaId: // value for 'arenaId'
 *      data: // value for 'data'
 *      externalIds: // value for 'externalIds'
 *      idDocuments: // value for 'idDocuments'
 *   },
 * });
 */
export function useUpsertInstitutionProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertInstitutionProfileMutation, GraphqlTypes.UpsertInstitutionProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertInstitutionProfileMutation, GraphqlTypes.UpsertInstitutionProfileMutationVariables>(UpsertInstitutionProfileDocument, options);
      }
export type UpsertInstitutionProfileMutationHookResult = ReturnType<typeof useUpsertInstitutionProfileMutation>;
export type UpsertInstitutionProfileMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertInstitutionProfileMutation>;
export type UpsertInstitutionProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertInstitutionProfileMutation, GraphqlTypes.UpsertInstitutionProfileMutationVariables>;
export const UpsertIndividualProfileDocument = gql`
    mutation UpsertIndividualProfile($profileId: Int, $arenaId: Int!, $data: IndividualProfileInput!, $externalIds: [ProfileExternalObjectInput!], $idDocuments: [DocumentInfoInput!]) {
  upsertIndividualProfile(
    profileId: $profileId
    arenaId: $arenaId
    data: $data
    externalIds: $externalIds
    idDocuments: $idDocuments
  ) {
    ...IndividualProfile
  }
}
    ${IndividualProfileFragmentDoc}`;
export type UpsertIndividualProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertIndividualProfileMutation, GraphqlTypes.UpsertIndividualProfileMutationVariables>;

/**
 * __useUpsertIndividualProfileMutation__
 *
 * To run a mutation, you first call `useUpsertIndividualProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertIndividualProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertIndividualProfileMutation, { data, loading, error }] = useUpsertIndividualProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      arenaId: // value for 'arenaId'
 *      data: // value for 'data'
 *      externalIds: // value for 'externalIds'
 *      idDocuments: // value for 'idDocuments'
 *   },
 * });
 */
export function useUpsertIndividualProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertIndividualProfileMutation, GraphqlTypes.UpsertIndividualProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertIndividualProfileMutation, GraphqlTypes.UpsertIndividualProfileMutationVariables>(UpsertIndividualProfileDocument, options);
      }
export type UpsertIndividualProfileMutationHookResult = ReturnType<typeof useUpsertIndividualProfileMutation>;
export type UpsertIndividualProfileMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertIndividualProfileMutation>;
export type UpsertIndividualProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertIndividualProfileMutation, GraphqlTypes.UpsertIndividualProfileMutationVariables>;
export const GetRootComplianceProfileNameDocument = gql`
    query GetRootComplianceProfileName($id: Int!) {
  complianceProfile(id: $id) {
    id
    legalName
  }
}
    `;

/**
 * __useGetRootComplianceProfileNameQuery__
 *
 * To run a query within a React component, call `useGetRootComplianceProfileNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRootComplianceProfileNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRootComplianceProfileNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRootComplianceProfileNameQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables> & ({ variables: GraphqlTypes.GetRootComplianceProfileNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>(GetRootComplianceProfileNameDocument, options);
      }
export function useGetRootComplianceProfileNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>(GetRootComplianceProfileNameDocument, options);
        }
// @ts-ignore
export function useGetRootComplianceProfileNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>;
export function useGetRootComplianceProfileNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRootComplianceProfileNameQuery | undefined, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>;
export function useGetRootComplianceProfileNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>(GetRootComplianceProfileNameDocument, options);
        }
export type GetRootComplianceProfileNameQueryHookResult = ReturnType<typeof useGetRootComplianceProfileNameQuery>;
export type GetRootComplianceProfileNameLazyQueryHookResult = ReturnType<typeof useGetRootComplianceProfileNameLazyQuery>;
export type GetRootComplianceProfileNameSuspenseQueryHookResult = ReturnType<typeof useGetRootComplianceProfileNameSuspenseQuery>;
export type GetRootComplianceProfileNameQueryResult = Apollo.QueryResult<GraphqlTypes.GetRootComplianceProfileNameQuery, GraphqlTypes.GetRootComplianceProfileNameQueryVariables>;
export const GetComplianceProfilesWithDuplicateTaxIdDocument = gql`
    query GetComplianceProfilesWithDuplicateTaxId($taxId: String!, $pageArgs: PageArgs) {
  complianceProfiles(taxId: $taxId, pageArgs: $pageArgs) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...EntityProfile
        ...IndividualProfile
        beneficialOwners {
          id
          title
          percentOwnership
          childProfile {
            ...IndividualProfile
            ...EntityProfile
          }
        }
        controllingPersons {
          id
          title
          childProfile {
            ...IndividualProfile
            ...EntityProfile
          }
        }
      }
    }
  }
}
    ${EntityProfileFragmentDoc}
${IndividualProfileFragmentDoc}`;

/**
 * __useGetComplianceProfilesWithDuplicateTaxIdQuery__
 *
 * To run a query within a React component, call `useGetComplianceProfilesWithDuplicateTaxIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceProfilesWithDuplicateTaxIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceProfilesWithDuplicateTaxIdQuery({
 *   variables: {
 *      taxId: // value for 'taxId'
 *      pageArgs: // value for 'pageArgs'
 *   },
 * });
 */
export function useGetComplianceProfilesWithDuplicateTaxIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables> & ({ variables: GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>(GetComplianceProfilesWithDuplicateTaxIdDocument, options);
      }
export function useGetComplianceProfilesWithDuplicateTaxIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>(GetComplianceProfilesWithDuplicateTaxIdDocument, options);
        }
// @ts-ignore
export function useGetComplianceProfilesWithDuplicateTaxIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>;
export function useGetComplianceProfilesWithDuplicateTaxIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery | undefined, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>;
export function useGetComplianceProfilesWithDuplicateTaxIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>(GetComplianceProfilesWithDuplicateTaxIdDocument, options);
        }
export type GetComplianceProfilesWithDuplicateTaxIdQueryHookResult = ReturnType<typeof useGetComplianceProfilesWithDuplicateTaxIdQuery>;
export type GetComplianceProfilesWithDuplicateTaxIdLazyQueryHookResult = ReturnType<typeof useGetComplianceProfilesWithDuplicateTaxIdLazyQuery>;
export type GetComplianceProfilesWithDuplicateTaxIdSuspenseQueryHookResult = ReturnType<typeof useGetComplianceProfilesWithDuplicateTaxIdSuspenseQuery>;
export type GetComplianceProfilesWithDuplicateTaxIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQuery, GraphqlTypes.GetComplianceProfilesWithDuplicateTaxIdQueryVariables>;
export const GetInvestmentEntityForPaymentsOnboardingBannerDocument = gql`
    query GetInvestmentEntityForPaymentsOnboardingBanner($entityId: ID!) {
  investmentEntity(entityId: $entityId) {
    id
    allDiligencesConfirmed
    paymentsApplication {
      id
      status
    }
    bankAccount {
      id
      verificationStatus
    }
  }
}
    `;

/**
 * __useGetInvestmentEntityForPaymentsOnboardingBannerQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityForPaymentsOnboardingBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityForPaymentsOnboardingBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityForPaymentsOnboardingBannerQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetInvestmentEntityForPaymentsOnboardingBannerQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>(GetInvestmentEntityForPaymentsOnboardingBannerDocument, options);
      }
export function useGetInvestmentEntityForPaymentsOnboardingBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>(GetInvestmentEntityForPaymentsOnboardingBannerDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntityForPaymentsOnboardingBannerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>;
export function useGetInvestmentEntityForPaymentsOnboardingBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery | undefined, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>;
export function useGetInvestmentEntityForPaymentsOnboardingBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>(GetInvestmentEntityForPaymentsOnboardingBannerDocument, options);
        }
export type GetInvestmentEntityForPaymentsOnboardingBannerQueryHookResult = ReturnType<typeof useGetInvestmentEntityForPaymentsOnboardingBannerQuery>;
export type GetInvestmentEntityForPaymentsOnboardingBannerLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityForPaymentsOnboardingBannerLazyQuery>;
export type GetInvestmentEntityForPaymentsOnboardingBannerSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntityForPaymentsOnboardingBannerSuspenseQuery>;
export type GetInvestmentEntityForPaymentsOnboardingBannerQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQuery, GraphqlTypes.GetInvestmentEntityForPaymentsOnboardingBannerQueryVariables>;
export const GetPaymentBatchesForDistributionSummaryDocument = gql`
    query GetPaymentBatchesForDistributionSummary($distributionBatchId: ID!) {
  paymentBatches(distributionBatchId: $distributionBatchId) {
    id
    status
    netAmount
    objectId
    positionsCount: objectsCount
    createdAt
    fundingPayment {
      id
      method
    }
  }
}
    `;

/**
 * __useGetPaymentBatchesForDistributionSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchesForDistributionSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchesForDistributionSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchesForDistributionSummaryQuery({
 *   variables: {
 *      distributionBatchId: // value for 'distributionBatchId'
 *   },
 * });
 */
export function useGetPaymentBatchesForDistributionSummaryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>(GetPaymentBatchesForDistributionSummaryDocument, options);
      }
export function useGetPaymentBatchesForDistributionSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>(GetPaymentBatchesForDistributionSummaryDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchesForDistributionSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>;
export function useGetPaymentBatchesForDistributionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery | undefined, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>;
export function useGetPaymentBatchesForDistributionSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>(GetPaymentBatchesForDistributionSummaryDocument, options);
        }
export type GetPaymentBatchesForDistributionSummaryQueryHookResult = ReturnType<typeof useGetPaymentBatchesForDistributionSummaryQuery>;
export type GetPaymentBatchesForDistributionSummaryLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchesForDistributionSummaryLazyQuery>;
export type GetPaymentBatchesForDistributionSummarySuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchesForDistributionSummarySuspenseQuery>;
export type GetPaymentBatchesForDistributionSummaryQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchesForDistributionSummaryQuery, GraphqlTypes.GetPaymentBatchesForDistributionSummaryQueryVariables>;
export const GetPaymentApplicationStatusForCreatePaymentBatchDocument = gql`
    query GetPaymentApplicationStatusForCreatePaymentBatch($objectType: ObjectType!, $objectId: ID!) {
  paymentsApplication(objectType: $objectType, objectId: $objectId) {
    id
    status
    signatoryUserId
  }
}
    `;

/**
 * __useGetPaymentApplicationStatusForCreatePaymentBatchQuery__
 *
 * To run a query within a React component, call `useGetPaymentApplicationStatusForCreatePaymentBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentApplicationStatusForCreatePaymentBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentApplicationStatusForCreatePaymentBatchQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetPaymentApplicationStatusForCreatePaymentBatchQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables> & ({ variables: GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>(GetPaymentApplicationStatusForCreatePaymentBatchDocument, options);
      }
export function useGetPaymentApplicationStatusForCreatePaymentBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>(GetPaymentApplicationStatusForCreatePaymentBatchDocument, options);
        }
// @ts-ignore
export function useGetPaymentApplicationStatusForCreatePaymentBatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>;
export function useGetPaymentApplicationStatusForCreatePaymentBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery | undefined, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>;
export function useGetPaymentApplicationStatusForCreatePaymentBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>(GetPaymentApplicationStatusForCreatePaymentBatchDocument, options);
        }
export type GetPaymentApplicationStatusForCreatePaymentBatchQueryHookResult = ReturnType<typeof useGetPaymentApplicationStatusForCreatePaymentBatchQuery>;
export type GetPaymentApplicationStatusForCreatePaymentBatchLazyQueryHookResult = ReturnType<typeof useGetPaymentApplicationStatusForCreatePaymentBatchLazyQuery>;
export type GetPaymentApplicationStatusForCreatePaymentBatchSuspenseQueryHookResult = ReturnType<typeof useGetPaymentApplicationStatusForCreatePaymentBatchSuspenseQuery>;
export type GetPaymentApplicationStatusForCreatePaymentBatchQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQuery, GraphqlTypes.GetPaymentApplicationStatusForCreatePaymentBatchQueryVariables>;
export const GetInvestmentEntityByIdDocument = gql`
    query GetInvestmentEntityById($entityId: ID!) {
  investmentEntity(entityId: $entityId) {
    id
    isFundAdminEntity
    automatedPaymentsEnabled
  }
}
    `;

/**
 * __useGetInvestmentEntityByIdQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntityByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntityByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntityByIdQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetInvestmentEntityByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntityByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>(GetInvestmentEntityByIdDocument, options);
      }
export function useGetInvestmentEntityByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>(GetInvestmentEntityByIdDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntityByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>;
export function useGetInvestmentEntityByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntityByIdQuery | undefined, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>;
export function useGetInvestmentEntityByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>(GetInvestmentEntityByIdDocument, options);
        }
export type GetInvestmentEntityByIdQueryHookResult = ReturnType<typeof useGetInvestmentEntityByIdQuery>;
export type GetInvestmentEntityByIdLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntityByIdLazyQuery>;
export type GetInvestmentEntityByIdSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntityByIdSuspenseQuery>;
export type GetInvestmentEntityByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntityByIdQuery, GraphqlTypes.GetInvestmentEntityByIdQueryVariables>;
export const DenyPaymentBatchDocument = gql`
    mutation DenyPaymentBatch($denyPaymentBatchInput: DenyPaymentBatchInput!) {
  denyPaymentBatch(denyPaymentBatchInput: $denyPaymentBatchInput) {
    id
    status
    approvals {
      id
      userId
      createdAt
    }
    denial {
      id
      userId
      createdAt
    }
  }
}
    `;
export type DenyPaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.DenyPaymentBatchMutation, GraphqlTypes.DenyPaymentBatchMutationVariables>;

/**
 * __useDenyPaymentBatchMutation__
 *
 * To run a mutation, you first call `useDenyPaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyPaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyPaymentBatchMutation, { data, loading, error }] = useDenyPaymentBatchMutation({
 *   variables: {
 *      denyPaymentBatchInput: // value for 'denyPaymentBatchInput'
 *   },
 * });
 */
export function useDenyPaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DenyPaymentBatchMutation, GraphqlTypes.DenyPaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DenyPaymentBatchMutation, GraphqlTypes.DenyPaymentBatchMutationVariables>(DenyPaymentBatchDocument, options);
      }
export type DenyPaymentBatchMutationHookResult = ReturnType<typeof useDenyPaymentBatchMutation>;
export type DenyPaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.DenyPaymentBatchMutation>;
export type DenyPaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DenyPaymentBatchMutation, GraphqlTypes.DenyPaymentBatchMutationVariables>;
export const ApprovePaymentBatchDocument = gql`
    mutation ApprovePaymentBatch($approvePaymentBatchInput: ApprovePaymentBatchInput!) {
  approvePaymentBatch(approvePaymentBatchInput: $approvePaymentBatchInput) {
    id
    status
    approvals {
      id
      userId
      createdAt
    }
    fundingPayment {
      id
      scheduledProcessDate
    }
  }
}
    `;
export type ApprovePaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.ApprovePaymentBatchMutation, GraphqlTypes.ApprovePaymentBatchMutationVariables>;

/**
 * __useApprovePaymentBatchMutation__
 *
 * To run a mutation, you first call `useApprovePaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePaymentBatchMutation, { data, loading, error }] = useApprovePaymentBatchMutation({
 *   variables: {
 *      approvePaymentBatchInput: // value for 'approvePaymentBatchInput'
 *   },
 * });
 */
export function useApprovePaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApprovePaymentBatchMutation, GraphqlTypes.ApprovePaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApprovePaymentBatchMutation, GraphqlTypes.ApprovePaymentBatchMutationVariables>(ApprovePaymentBatchDocument, options);
      }
export type ApprovePaymentBatchMutationHookResult = ReturnType<typeof useApprovePaymentBatchMutation>;
export type ApprovePaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.ApprovePaymentBatchMutation>;
export type ApprovePaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApprovePaymentBatchMutation, GraphqlTypes.ApprovePaymentBatchMutationVariables>;
export const GetFeatureFlagHasSwiftPaymentsDocument = gql`
    query GetFeatureFlagHasSwiftPayments {
  currentArena {
    id
    features {
      hasSwiftPayments
    }
  }
}
    `;

/**
 * __useGetFeatureFlagHasSwiftPaymentsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagHasSwiftPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagHasSwiftPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagHasSwiftPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagHasSwiftPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>(GetFeatureFlagHasSwiftPaymentsDocument, options);
      }
export function useGetFeatureFlagHasSwiftPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>(GetFeatureFlagHasSwiftPaymentsDocument, options);
        }
// @ts-ignore
export function useGetFeatureFlagHasSwiftPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>;
export function useGetFeatureFlagHasSwiftPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery | undefined, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>;
export function useGetFeatureFlagHasSwiftPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>(GetFeatureFlagHasSwiftPaymentsDocument, options);
        }
export type GetFeatureFlagHasSwiftPaymentsQueryHookResult = ReturnType<typeof useGetFeatureFlagHasSwiftPaymentsQuery>;
export type GetFeatureFlagHasSwiftPaymentsLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagHasSwiftPaymentsLazyQuery>;
export type GetFeatureFlagHasSwiftPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetFeatureFlagHasSwiftPaymentsSuspenseQuery>;
export type GetFeatureFlagHasSwiftPaymentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQuery, GraphqlTypes.GetFeatureFlagHasSwiftPaymentsQueryVariables>;
export const RefundPaymentDocument = gql`
    mutation RefundPayment($refundPaymentInput: RefundPaymentInput!) {
  refundPayment(refundPaymentInput: $refundPaymentInput) {
    id
  }
}
    `;
export type RefundPaymentMutationFn = Apollo.MutationFunction<GraphqlTypes.RefundPaymentMutation, GraphqlTypes.RefundPaymentMutationVariables>;

/**
 * __useRefundPaymentMutation__
 *
 * To run a mutation, you first call `useRefundPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundPaymentMutation, { data, loading, error }] = useRefundPaymentMutation({
 *   variables: {
 *      refundPaymentInput: // value for 'refundPaymentInput'
 *   },
 * });
 */
export function useRefundPaymentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RefundPaymentMutation, GraphqlTypes.RefundPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RefundPaymentMutation, GraphqlTypes.RefundPaymentMutationVariables>(RefundPaymentDocument, options);
      }
export type RefundPaymentMutationHookResult = ReturnType<typeof useRefundPaymentMutation>;
export type RefundPaymentMutationResult = Apollo.MutationResult<GraphqlTypes.RefundPaymentMutation>;
export type RefundPaymentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RefundPaymentMutation, GraphqlTypes.RefundPaymentMutationVariables>;
export const ReissuePaymentDocument = gql`
    mutation ReissuePayment($reissuePaymentInput: ReissuePaymentInput!) {
  reissuePayment(reissuePaymentInput: $reissuePaymentInput) {
    id
  }
}
    `;
export type ReissuePaymentMutationFn = Apollo.MutationFunction<GraphqlTypes.ReissuePaymentMutation, GraphqlTypes.ReissuePaymentMutationVariables>;

/**
 * __useReissuePaymentMutation__
 *
 * To run a mutation, you first call `useReissuePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReissuePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reissuePaymentMutation, { data, loading, error }] = useReissuePaymentMutation({
 *   variables: {
 *      reissuePaymentInput: // value for 'reissuePaymentInput'
 *   },
 * });
 */
export function useReissuePaymentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReissuePaymentMutation, GraphqlTypes.ReissuePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReissuePaymentMutation, GraphqlTypes.ReissuePaymentMutationVariables>(ReissuePaymentDocument, options);
      }
export type ReissuePaymentMutationHookResult = ReturnType<typeof useReissuePaymentMutation>;
export type ReissuePaymentMutationResult = Apollo.MutationResult<GraphqlTypes.ReissuePaymentMutation>;
export type ReissuePaymentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReissuePaymentMutation, GraphqlTypes.ReissuePaymentMutationVariables>;
export const GetFullPaymentPrefsDocument = gql`
    query GetFullPaymentPrefs($id: ID!) {
  paymentPrefs(paymentPrefIds: [$id]) {
    id
    paymentPrefFull {
      ...ReissuePaymentPrefFull
    }
  }
}
    ${ReissuePaymentPrefFullFragmentDoc}`;

/**
 * __useGetFullPaymentPrefsQuery__
 *
 * To run a query within a React component, call `useGetFullPaymentPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullPaymentPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullPaymentPrefsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullPaymentPrefsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables> & ({ variables: GraphqlTypes.GetFullPaymentPrefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>(GetFullPaymentPrefsDocument, options);
      }
export function useGetFullPaymentPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>(GetFullPaymentPrefsDocument, options);
        }
// @ts-ignore
export function useGetFullPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>;
export function useGetFullPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFullPaymentPrefsQuery | undefined, GraphqlTypes.GetFullPaymentPrefsQueryVariables>;
export function useGetFullPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>(GetFullPaymentPrefsDocument, options);
        }
export type GetFullPaymentPrefsQueryHookResult = ReturnType<typeof useGetFullPaymentPrefsQuery>;
export type GetFullPaymentPrefsLazyQueryHookResult = ReturnType<typeof useGetFullPaymentPrefsLazyQuery>;
export type GetFullPaymentPrefsSuspenseQueryHookResult = ReturnType<typeof useGetFullPaymentPrefsSuspenseQuery>;
export type GetFullPaymentPrefsQueryResult = Apollo.QueryResult<GraphqlTypes.GetFullPaymentPrefsQuery, GraphqlTypes.GetFullPaymentPrefsQueryVariables>;
export const GetPaymentWithPaymentPrefFullDocument = gql`
    query GetPaymentWithPaymentPrefFull($id: ID!) {
  payment(id: $id) {
    id
    failureReason
    returnReason
    returnCode
    referenceNumber
    method
    paymentPref {
      id
      verificationStatus
      paymentPrefFull {
        ...ReissuePaymentPrefFull
        ... on AchPaymentPrefObjectType {
          bankInfoRedacted
        }
        ... on WirePaymentPrefObjectType {
          bankInfoRedacted
          beneficiaryAddress {
            street
            street2
            street3
            city
            state {
              id
              name
            }
            country {
              id
              name
            }
            postalCode
            region
          }
          wireBbi {
            field0
            field1
            field2
            field3
          }
          bank {
            address {
              street
              street2
              street3
              city
              state {
                id
                name
              }
              country {
                id
                name
              }
              postalCode
              region
            }
            swiftCode
            intlRoutingCode
          }
          intermediaryBank {
            name
            address {
              street
              street2
              street3
              city
              postalCode
              region
              state {
                id
                name
              }
              country {
                id
                name
              }
            }
            abaNumber
            swiftCode
            intlRoutingCode
          }
        }
      }
    }
    bankAccount {
      id
      bankInfoRedacted
      bankName
    }
  }
}
    ${ReissuePaymentPrefFullFragmentDoc}`;

/**
 * __useGetPaymentWithPaymentPrefFullQuery__
 *
 * To run a query within a React component, call `useGetPaymentWithPaymentPrefFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentWithPaymentPrefFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentWithPaymentPrefFullQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentWithPaymentPrefFullQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables> & ({ variables: GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>(GetPaymentWithPaymentPrefFullDocument, options);
      }
export function useGetPaymentWithPaymentPrefFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>(GetPaymentWithPaymentPrefFullDocument, options);
        }
// @ts-ignore
export function useGetPaymentWithPaymentPrefFullSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>;
export function useGetPaymentWithPaymentPrefFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery | undefined, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>;
export function useGetPaymentWithPaymentPrefFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>(GetPaymentWithPaymentPrefFullDocument, options);
        }
export type GetPaymentWithPaymentPrefFullQueryHookResult = ReturnType<typeof useGetPaymentWithPaymentPrefFullQuery>;
export type GetPaymentWithPaymentPrefFullLazyQueryHookResult = ReturnType<typeof useGetPaymentWithPaymentPrefFullLazyQuery>;
export type GetPaymentWithPaymentPrefFullSuspenseQueryHookResult = ReturnType<typeof useGetPaymentWithPaymentPrefFullSuspenseQuery>;
export type GetPaymentWithPaymentPrefFullQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentWithPaymentPrefFullQuery, GraphqlTypes.GetPaymentWithPaymentPrefFullQueryVariables>;
export const CancelPaymentBatchDocument = gql`
    mutation CancelPaymentBatch($id: ID!) {
  cancelPaymentBatch(id: $id) {
    id
    status
    canceledAt
    canceledByUserId
  }
}
    `;
export type CancelPaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelPaymentBatchMutation, GraphqlTypes.CancelPaymentBatchMutationVariables>;

/**
 * __useCancelPaymentBatchMutation__
 *
 * To run a mutation, you first call `useCancelPaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentBatchMutation, { data, loading, error }] = useCancelPaymentBatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelPaymentBatchMutation, GraphqlTypes.CancelPaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelPaymentBatchMutation, GraphqlTypes.CancelPaymentBatchMutationVariables>(CancelPaymentBatchDocument, options);
      }
export type CancelPaymentBatchMutationHookResult = ReturnType<typeof useCancelPaymentBatchMutation>;
export type CancelPaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.CancelPaymentBatchMutation>;
export type CancelPaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelPaymentBatchMutation, GraphqlTypes.CancelPaymentBatchMutationVariables>;
export const GetPaymentBatchForSummaryDocument = gql`
    query GetPaymentBatchForSummary($id: ID!) {
  paymentBatch(id: $id) {
    id
    createdAt
    creatorId
    netAmount
    objectsCount
    paymentDescription
    status
    requiredApprovalCount
    isDifferentApproverRequired
    canceledAt
    canceledByUserId
    wireFundingInstructions {
      accountAddress {
        line1
        line2
        locality
        region
        postalCode
        country
      }
      accountName
      accountNumber
      amount
      bankAba
      wireObiField
    }
    payments {
      id
      amount
      status
      objectId
      direction
      method
      paymentPref {
        id
        bankInfoRedacted
      }
      bankAccountId
    }
    approvals {
      id
      userId
      createdAt
    }
    denial {
      id
      userId
      createdAt
      reason
    }
    fundingPayment {
      id
      method
      status
      returnCode
      transmittedAt
      scheduledProcessDate
    }
    bankAccount {
      id
      bankName
      bankInfoRedacted
      ownerName
    }
    provider {
      id
      name
    }
    referenceObject {
      ... on DistributionBatchObjectType {
        id
      }
    }
  }
}
    `;

/**
 * __useGetPaymentBatchForSummaryQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchForSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchForSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchForSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentBatchForSummaryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchForSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>(GetPaymentBatchForSummaryDocument, options);
      }
export function useGetPaymentBatchForSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>(GetPaymentBatchForSummaryDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchForSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>;
export function useGetPaymentBatchForSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchForSummaryQuery | undefined, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>;
export function useGetPaymentBatchForSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>(GetPaymentBatchForSummaryDocument, options);
        }
export type GetPaymentBatchForSummaryQueryHookResult = ReturnType<typeof useGetPaymentBatchForSummaryQuery>;
export type GetPaymentBatchForSummaryLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchForSummaryLazyQuery>;
export type GetPaymentBatchForSummarySuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchForSummarySuspenseQuery>;
export type GetPaymentBatchForSummaryQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchForSummaryQuery, GraphqlTypes.GetPaymentBatchForSummaryQueryVariables>;
export const GetDistributionBatchForPaymentBatchSummaryDocument = gql`
    query GetDistributionBatchForPaymentBatchSummary($distributionBatchId: ID!) {
  distributionBatch(id: $distributionBatchId) {
    id
    instances {
      id
      position {
        id
        account {
          id
          gpTitle
        }
        paymentPref {
          id
          bankInfoRedacted
        }
      }
    }
  }
}
    `;

/**
 * __useGetDistributionBatchForPaymentBatchSummaryQuery__
 *
 * To run a query within a React component, call `useGetDistributionBatchForPaymentBatchSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionBatchForPaymentBatchSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionBatchForPaymentBatchSummaryQuery({
 *   variables: {
 *      distributionBatchId: // value for 'distributionBatchId'
 *   },
 * });
 */
export function useGetDistributionBatchForPaymentBatchSummaryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables> & ({ variables: GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>(GetDistributionBatchForPaymentBatchSummaryDocument, options);
      }
export function useGetDistributionBatchForPaymentBatchSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>(GetDistributionBatchForPaymentBatchSummaryDocument, options);
        }
// @ts-ignore
export function useGetDistributionBatchForPaymentBatchSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>;
export function useGetDistributionBatchForPaymentBatchSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery | undefined, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>;
export function useGetDistributionBatchForPaymentBatchSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>(GetDistributionBatchForPaymentBatchSummaryDocument, options);
        }
export type GetDistributionBatchForPaymentBatchSummaryQueryHookResult = ReturnType<typeof useGetDistributionBatchForPaymentBatchSummaryQuery>;
export type GetDistributionBatchForPaymentBatchSummaryLazyQueryHookResult = ReturnType<typeof useGetDistributionBatchForPaymentBatchSummaryLazyQuery>;
export type GetDistributionBatchForPaymentBatchSummarySuspenseQueryHookResult = ReturnType<typeof useGetDistributionBatchForPaymentBatchSummarySuspenseQuery>;
export type GetDistributionBatchForPaymentBatchSummaryQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQuery, GraphqlTypes.GetDistributionBatchForPaymentBatchSummaryQueryVariables>;
export const GetPaymentBatchesOfEntityDocument = gql`
    query GetPaymentBatchesOfEntity($entityId: ID!) {
  investmentEntity(entityId: $entityId) {
    id
    paymentBatches {
      id
      status
      netAmount
      objectId
      positionsCount: objectsCount
      createdAt
      fundingPayment {
        id
        method
      }
      referenceObject {
        ... on DistributionBatchObjectType {
          id
          description
        }
        ... on PayableObjectType {
          id
        }
        ... on CapitalCallBatchObjectType {
          id
        }
        ... on TransactionBatchObjectType {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaymentBatchesOfEntityQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchesOfEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchesOfEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchesOfEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetPaymentBatchesOfEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>(GetPaymentBatchesOfEntityDocument, options);
      }
export function useGetPaymentBatchesOfEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>(GetPaymentBatchesOfEntityDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchesOfEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>;
export function useGetPaymentBatchesOfEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesOfEntityQuery | undefined, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>;
export function useGetPaymentBatchesOfEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>(GetPaymentBatchesOfEntityDocument, options);
        }
export type GetPaymentBatchesOfEntityQueryHookResult = ReturnType<typeof useGetPaymentBatchesOfEntityQuery>;
export type GetPaymentBatchesOfEntityLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchesOfEntityLazyQuery>;
export type GetPaymentBatchesOfEntitySuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchesOfEntitySuspenseQuery>;
export type GetPaymentBatchesOfEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchesOfEntityQuery, GraphqlTypes.GetPaymentBatchesOfEntityQueryVariables>;
export const GetBillingClientIdDocument = gql`
    query GetBillingClientId($arenaId: Int!) {
  getBillingClientId(arenaId: $arenaId)
}
    `;

/**
 * __useGetBillingClientIdQuery__
 *
 * To run a query within a React component, call `useGetBillingClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingClientIdQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetBillingClientIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables> & ({ variables: GraphqlTypes.GetBillingClientIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>(GetBillingClientIdDocument, options);
      }
export function useGetBillingClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>(GetBillingClientIdDocument, options);
        }
// @ts-ignore
export function useGetBillingClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>;
export function useGetBillingClientIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBillingClientIdQuery | undefined, GraphqlTypes.GetBillingClientIdQueryVariables>;
export function useGetBillingClientIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>(GetBillingClientIdDocument, options);
        }
export type GetBillingClientIdQueryHookResult = ReturnType<typeof useGetBillingClientIdQuery>;
export type GetBillingClientIdLazyQueryHookResult = ReturnType<typeof useGetBillingClientIdLazyQuery>;
export type GetBillingClientIdSuspenseQueryHookResult = ReturnType<typeof useGetBillingClientIdSuspenseQuery>;
export type GetBillingClientIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetBillingClientIdQuery, GraphqlTypes.GetBillingClientIdQueryVariables>;
export const BulkDocumentPublishDocument = gql`
    mutation BulkDocumentPublish($entityIds: [String!]!) {
  bulkDocumentPublish(input: {entityIds: $entityIds}) {
    ... on AsyncJobObjectType {
      id
      jobType
      status
      startTime
      endTime
      data
      progress {
        processedCount
        totalCount
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type BulkDocumentPublishMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkDocumentPublishMutation, GraphqlTypes.BulkDocumentPublishMutationVariables>;

/**
 * __useBulkDocumentPublishMutation__
 *
 * To run a mutation, you first call `useBulkDocumentPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDocumentPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDocumentPublishMutation, { data, loading, error }] = useBulkDocumentPublishMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useBulkDocumentPublishMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkDocumentPublishMutation, GraphqlTypes.BulkDocumentPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkDocumentPublishMutation, GraphqlTypes.BulkDocumentPublishMutationVariables>(BulkDocumentPublishDocument, options);
      }
export type BulkDocumentPublishMutationHookResult = ReturnType<typeof useBulkDocumentPublishMutation>;
export type BulkDocumentPublishMutationResult = Apollo.MutationResult<GraphqlTypes.BulkDocumentPublishMutation>;
export type BulkDocumentPublishMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkDocumentPublishMutation, GraphqlTypes.BulkDocumentPublishMutationVariables>;
export const GetEntitiesWithPublishableDocumentsDocument = gql`
    query GetEntitiesWithPublishableDocuments {
  entitiesWithPublishableDocuments {
    id
    name
    documentCount
    latestPublicationDate
  }
}
    `;

/**
 * __useGetEntitiesWithPublishableDocumentsQuery__
 *
 * To run a query within a React component, call `useGetEntitiesWithPublishableDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesWithPublishableDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesWithPublishableDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntitiesWithPublishableDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>(GetEntitiesWithPublishableDocumentsDocument, options);
      }
export function useGetEntitiesWithPublishableDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>(GetEntitiesWithPublishableDocumentsDocument, options);
        }
// @ts-ignore
export function useGetEntitiesWithPublishableDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>;
export function useGetEntitiesWithPublishableDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery | undefined, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>;
export function useGetEntitiesWithPublishableDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>(GetEntitiesWithPublishableDocumentsDocument, options);
        }
export type GetEntitiesWithPublishableDocumentsQueryHookResult = ReturnType<typeof useGetEntitiesWithPublishableDocumentsQuery>;
export type GetEntitiesWithPublishableDocumentsLazyQueryHookResult = ReturnType<typeof useGetEntitiesWithPublishableDocumentsLazyQuery>;
export type GetEntitiesWithPublishableDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesWithPublishableDocumentsSuspenseQuery>;
export type GetEntitiesWithPublishableDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesWithPublishableDocumentsQuery, GraphqlTypes.GetEntitiesWithPublishableDocumentsQueryVariables>;
export const GetPicrComplianceChecksDocument = gql`
    query GetPicrComplianceChecks($positionFilterInput: PositionFilterInput!) {
  positions(positionFilters: $positionFilterInput) {
    edges {
      node {
        id
        hasPassedPicrComplianceChecks
      }
    }
  }
}
    `;

/**
 * __useGetPicrComplianceChecksQuery__
 *
 * To run a query within a React component, call `useGetPicrComplianceChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPicrComplianceChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPicrComplianceChecksQuery({
 *   variables: {
 *      positionFilterInput: // value for 'positionFilterInput'
 *   },
 * });
 */
export function useGetPicrComplianceChecksQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables> & ({ variables: GraphqlTypes.GetPicrComplianceChecksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>(GetPicrComplianceChecksDocument, options);
      }
export function useGetPicrComplianceChecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>(GetPicrComplianceChecksDocument, options);
        }
// @ts-ignore
export function useGetPicrComplianceChecksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>;
export function useGetPicrComplianceChecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPicrComplianceChecksQuery | undefined, GraphqlTypes.GetPicrComplianceChecksQueryVariables>;
export function useGetPicrComplianceChecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>(GetPicrComplianceChecksDocument, options);
        }
export type GetPicrComplianceChecksQueryHookResult = ReturnType<typeof useGetPicrComplianceChecksQuery>;
export type GetPicrComplianceChecksLazyQueryHookResult = ReturnType<typeof useGetPicrComplianceChecksLazyQuery>;
export type GetPicrComplianceChecksSuspenseQueryHookResult = ReturnType<typeof useGetPicrComplianceChecksSuspenseQuery>;
export type GetPicrComplianceChecksQueryResult = Apollo.QueryResult<GraphqlTypes.GetPicrComplianceChecksQuery, GraphqlTypes.GetPicrComplianceChecksQueryVariables>;
export const GetReportTemplateQueryIdDocument = gql`
    query GetReportTemplateQueryId($templateId: Int!) {
  reportTemplate(id: $templateId) {
    id
    arenaId
    currentVersion {
      id
      queryId
    }
  }
}
    `;

/**
 * __useGetReportTemplateQueryIdQuery__
 *
 * To run a query within a React component, call `useGetReportTemplateQueryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplateQueryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplateQueryIdQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetReportTemplateQueryIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables> & ({ variables: GraphqlTypes.GetReportTemplateQueryIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>(GetReportTemplateQueryIdDocument, options);
      }
export function useGetReportTemplateQueryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>(GetReportTemplateQueryIdDocument, options);
        }
// @ts-ignore
export function useGetReportTemplateQueryIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>;
export function useGetReportTemplateQueryIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateQueryIdQuery | undefined, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>;
export function useGetReportTemplateQueryIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>(GetReportTemplateQueryIdDocument, options);
        }
export type GetReportTemplateQueryIdQueryHookResult = ReturnType<typeof useGetReportTemplateQueryIdQuery>;
export type GetReportTemplateQueryIdLazyQueryHookResult = ReturnType<typeof useGetReportTemplateQueryIdLazyQuery>;
export type GetReportTemplateQueryIdSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplateQueryIdSuspenseQuery>;
export type GetReportTemplateQueryIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportTemplateQueryIdQuery, GraphqlTypes.GetReportTemplateQueryIdQueryVariables>;
export const GetQueryDateParametersDocument = gql`
    query GetQueryDateParameters($queryId: Int!, $arenaId: Int) {
  finpubQueryDateParameters(queryId: $queryId, arenaId: $arenaId) {
    parameters
  }
}
    `;

/**
 * __useGetQueryDateParametersQuery__
 *
 * To run a query within a React component, call `useGetQueryDateParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryDateParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryDateParametersQuery({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetQueryDateParametersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables> & ({ variables: GraphqlTypes.GetQueryDateParametersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>(GetQueryDateParametersDocument, options);
      }
export function useGetQueryDateParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>(GetQueryDateParametersDocument, options);
        }
// @ts-ignore
export function useGetQueryDateParametersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>;
export function useGetQueryDateParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryDateParametersQuery | undefined, GraphqlTypes.GetQueryDateParametersQueryVariables>;
export function useGetQueryDateParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>(GetQueryDateParametersDocument, options);
        }
export type GetQueryDateParametersQueryHookResult = ReturnType<typeof useGetQueryDateParametersQuery>;
export type GetQueryDateParametersLazyQueryHookResult = ReturnType<typeof useGetQueryDateParametersLazyQuery>;
export type GetQueryDateParametersSuspenseQueryHookResult = ReturnType<typeof useGetQueryDateParametersSuspenseQuery>;
export type GetQueryDateParametersQueryResult = Apollo.QueryResult<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>;
export const GetCustomReportRequiresDocumentReviewDocument = gql`
    query GetCustomReportRequiresDocumentReview($entityIds: [ID!]!) {
  customReportRequiresDocumentReview(entityIds: $entityIds)
}
    `;

/**
 * __useGetCustomReportRequiresDocumentReviewQuery__
 *
 * To run a query within a React component, call `useGetCustomReportRequiresDocumentReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomReportRequiresDocumentReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomReportRequiresDocumentReviewQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetCustomReportRequiresDocumentReviewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables> & ({ variables: GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>(GetCustomReportRequiresDocumentReviewDocument, options);
      }
export function useGetCustomReportRequiresDocumentReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>(GetCustomReportRequiresDocumentReviewDocument, options);
        }
// @ts-ignore
export function useGetCustomReportRequiresDocumentReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>;
export function useGetCustomReportRequiresDocumentReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery | undefined, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>;
export function useGetCustomReportRequiresDocumentReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>(GetCustomReportRequiresDocumentReviewDocument, options);
        }
export type GetCustomReportRequiresDocumentReviewQueryHookResult = ReturnType<typeof useGetCustomReportRequiresDocumentReviewQuery>;
export type GetCustomReportRequiresDocumentReviewLazyQueryHookResult = ReturnType<typeof useGetCustomReportRequiresDocumentReviewLazyQuery>;
export type GetCustomReportRequiresDocumentReviewSuspenseQueryHookResult = ReturnType<typeof useGetCustomReportRequiresDocumentReviewSuspenseQuery>;
export type GetCustomReportRequiresDocumentReviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetCustomReportRequiresDocumentReviewQuery, GraphqlTypes.GetCustomReportRequiresDocumentReviewQueryVariables>;
export const GetGlTransactionDataDocument = gql`
    query GetGlTransactionData($arenaId: Int!, $queryId: Int, $entityIds: [Int!]) {
  finpubGlTransactionData(
    arenaId: $arenaId
    queryId: $queryId
    entityIds: $entityIds
  ) {
    success
    message
    transactions {
      glTransactionId
      transactionTypeName
      entityId
      entityName
      amount
      description
      effectiveDate
      status
      recipientCount
      positionIds
    }
  }
}
    `;

/**
 * __useGetGlTransactionDataQuery__
 *
 * To run a query within a React component, call `useGetGlTransactionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlTransactionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlTransactionDataQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      queryId: // value for 'queryId'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetGlTransactionDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables> & ({ variables: GraphqlTypes.GetGlTransactionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>(GetGlTransactionDataDocument, options);
      }
export function useGetGlTransactionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>(GetGlTransactionDataDocument, options);
        }
// @ts-ignore
export function useGetGlTransactionDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>;
export function useGetGlTransactionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGlTransactionDataQuery | undefined, GraphqlTypes.GetGlTransactionDataQueryVariables>;
export function useGetGlTransactionDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>(GetGlTransactionDataDocument, options);
        }
export type GetGlTransactionDataQueryHookResult = ReturnType<typeof useGetGlTransactionDataQuery>;
export type GetGlTransactionDataLazyQueryHookResult = ReturnType<typeof useGetGlTransactionDataLazyQuery>;
export type GetGlTransactionDataSuspenseQueryHookResult = ReturnType<typeof useGetGlTransactionDataSuspenseQuery>;
export type GetGlTransactionDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetGlTransactionDataQuery, GraphqlTypes.GetGlTransactionDataQueryVariables>;
export const ResendESignatureDocument = gql`
    mutation ResendESignature($objectInput: ESignatureSendReminderEmailInputObjectType!) {
  resendESignature(objectInput: $objectInput) {
    ... on ESignatureSendReminderEmailRecipientsResponse {
      contacts {
        id
        fullName
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ResendESignatureMutationFn = Apollo.MutationFunction<GraphqlTypes.ResendESignatureMutation, GraphqlTypes.ResendESignatureMutationVariables>;

/**
 * __useResendESignatureMutation__
 *
 * To run a mutation, you first call `useResendESignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendESignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendESignatureMutation, { data, loading, error }] = useResendESignatureMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useResendESignatureMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ResendESignatureMutation, GraphqlTypes.ResendESignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ResendESignatureMutation, GraphqlTypes.ResendESignatureMutationVariables>(ResendESignatureDocument, options);
      }
export type ResendESignatureMutationHookResult = ReturnType<typeof useResendESignatureMutation>;
export type ResendESignatureMutationResult = Apollo.MutationResult<GraphqlTypes.ResendESignatureMutation>;
export type ResendESignatureMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ResendESignatureMutation, GraphqlTypes.ResendESignatureMutationVariables>;
export const DeleteESignatureDocument = gql`
    mutation deleteESignature($objectInput: DeleteESignatureInputObjectType!) {
  deleteESignature(objectInput: $objectInput) {
    ... on ESignatureRequestTemplateObjectType {
      id
      status
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type DeleteESignatureMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteESignatureMutation, GraphqlTypes.DeleteESignatureMutationVariables>;

/**
 * __useDeleteESignatureMutation__
 *
 * To run a mutation, you first call `useDeleteESignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteESignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteESignatureMutation, { data, loading, error }] = useDeleteESignatureMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useDeleteESignatureMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteESignatureMutation, GraphqlTypes.DeleteESignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteESignatureMutation, GraphqlTypes.DeleteESignatureMutationVariables>(DeleteESignatureDocument, options);
      }
export type DeleteESignatureMutationHookResult = ReturnType<typeof useDeleteESignatureMutation>;
export type DeleteESignatureMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteESignatureMutation>;
export type DeleteESignatureMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteESignatureMutation, GraphqlTypes.DeleteESignatureMutationVariables>;
export const EntityDocumentExportJobDocument = gql`
    query EntityDocumentExportJob($jobId: ID!) {
  entityDocumentExportJob(jobId: $jobId) {
    id
    status
    mode
    createdAt
    manifestUrl
    totalDocumentCount
    isExpired
    zipFiles {
      entityId
      zipFileName
      zipPartNumber
      zipPartCount
      sizeBytes
      documentCount
      status
      downloadCount
      downloadUrl
    }
  }
}
    `;

/**
 * __useEntityDocumentExportJobQuery__
 *
 * To run a query within a React component, call `useEntityDocumentExportJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDocumentExportJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDocumentExportJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useEntityDocumentExportJobQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables> & ({ variables: GraphqlTypes.EntityDocumentExportJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>(EntityDocumentExportJobDocument, options);
      }
export function useEntityDocumentExportJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>(EntityDocumentExportJobDocument, options);
        }
// @ts-ignore
export function useEntityDocumentExportJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>;
export function useEntityDocumentExportJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.EntityDocumentExportJobQuery | undefined, GraphqlTypes.EntityDocumentExportJobQueryVariables>;
export function useEntityDocumentExportJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>(EntityDocumentExportJobDocument, options);
        }
export type EntityDocumentExportJobQueryHookResult = ReturnType<typeof useEntityDocumentExportJobQuery>;
export type EntityDocumentExportJobLazyQueryHookResult = ReturnType<typeof useEntityDocumentExportJobLazyQuery>;
export type EntityDocumentExportJobSuspenseQueryHookResult = ReturnType<typeof useEntityDocumentExportJobSuspenseQuery>;
export type EntityDocumentExportJobQueryResult = Apollo.QueryResult<GraphqlTypes.EntityDocumentExportJobQuery, GraphqlTypes.EntityDocumentExportJobQueryVariables>;
export const ReviewChangeRequestDocument = gql`
    mutation ReviewChangeRequest($requestId: StrawberryObjectId!, $requestPayload: ChangeRequestPayload!, $requestStatus: ReviewAction!) {
  reviewChangeRequest(
    objectInput: {requestId: $requestId, requestPayload: $requestPayload, requestStatus: $requestStatus}
  ) {
    ... on ReviewChangeRequestMutationResponse {
      requestId
      requestType
      requestPayload
      status
      actions
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ReviewChangeRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.ReviewChangeRequestMutation, GraphqlTypes.ReviewChangeRequestMutationVariables>;

/**
 * __useReviewChangeRequestMutation__
 *
 * To run a mutation, you first call `useReviewChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewChangeRequestMutation, { data, loading, error }] = useReviewChangeRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      requestPayload: // value for 'requestPayload'
 *      requestStatus: // value for 'requestStatus'
 *   },
 * });
 */
export function useReviewChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReviewChangeRequestMutation, GraphqlTypes.ReviewChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReviewChangeRequestMutation, GraphqlTypes.ReviewChangeRequestMutationVariables>(ReviewChangeRequestDocument, options);
      }
export type ReviewChangeRequestMutationHookResult = ReturnType<typeof useReviewChangeRequestMutation>;
export type ReviewChangeRequestMutationResult = Apollo.MutationResult<GraphqlTypes.ReviewChangeRequestMutation>;
export type ReviewChangeRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReviewChangeRequestMutation, GraphqlTypes.ReviewChangeRequestMutationVariables>;
export const GetReviewChangeRequestDocument = gql`
    query GetReviewChangeRequest($requestId: StrawberryObjectId!) {
  reviewChangeRequest(objectInput: {requestId: $requestId}) {
    ... on ReviewChangeRequestResponse {
      requestId
      requestedAt
      requestType
      status
      note
      changeRequestArena {
        id
        name
      }
      reviewChangeRequest {
        ... on UpdateCommunicationPrefsRequest {
          account {
            id
            name
            isDeleted
            accountContactMaps {
              id
              accountId
              contactId
              isMainContact
              isAdminContact
              label {
                labelText
              }
              communicationPrefs {
                emailDistributionList {
                  id
                  name
                }
              }
            }
          }
          changeRequester {
            id
            fullName
            linkedArenaContact {
              id
              fullName
            }
          }
          contactUnderReview {
            id
            fullName
            isDeleted
          }
          accountContactMap {
            isMainContact
            isAdminContact
            changeRequestCommunicationPrefs {
              emailDistributionList {
                id
                name
              }
            }
            accountContactMapId
            changeRequestLabel {
              labelText
            }
          }
        }
        ... on RemoveContactRequest {
          account {
            id
            name
            isDeleted
            accountContactMaps {
              id
              accountId
              contactId
            }
          }
          changeRequester {
            id
            fullName
            linkedArenaContact {
              id
              fullName
            }
          }
          contactUnderReview {
            id
            fullName
            isDeleted
            hasFullClientAccess
            hasDeleteContactAccess
            salutationName
            primaryEmail {
              emailAddress
            }
            accounts {
              id
              name
            }
            phones {
              phoneNumber
              phoneType
            }
            addresses {
              addressType
              street
              street2
              street3
              region
              city
              state {
                objectName
              }
              postalCode
              country {
                objectName
              }
            }
            companyName
            company {
              id
              fullName
            }
            jobTitle
            prospects {
              count
            }
          }
          removeAccountContactMap: accountContactMap {
            id
            accountId
            accountName
            contactDetails {
              id
              fullName
            }
            isMainContact
            isAdminContact
            label {
              labelText
            }
            communicationPrefs {
              emailDistributionList {
                id
                name
              }
            }
          }
        }
        ... on AddContactRequest {
          account {
            id
            name
            isDeleted
            accountContactMaps {
              id
              accountId
              contactId
            }
          }
          changeRequester {
            id
            fullName
            linkedArenaContact {
              id
              fullName
            }
          }
          addContactUnderReview {
            id
            title
            firstName
            middleName
            lastName
            company
            email
            addressedAs
            jobTitle
            changeRequestContactAddress {
              addressType
              city
              country
              postalCode
              state
              street
              street2
            }
            changeRequestContactPhone {
              phoneType
              phoneNumber
            }
          }
          accountContactMap {
            accountContactMapId
            isMainContact
            isAdminContact
            changeRequestLabel {
              labelText
            }
            changeRequestCommunicationPrefs {
              emailDistributionList {
                id
                name
              }
            }
          }
        }
      }
    }
    ... on QueryErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetReviewChangeRequestQuery__
 *
 * To run a query within a React component, call `useGetReviewChangeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewChangeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewChangeRequestQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetReviewChangeRequestQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables> & ({ variables: GraphqlTypes.GetReviewChangeRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>(GetReviewChangeRequestDocument, options);
      }
export function useGetReviewChangeRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>(GetReviewChangeRequestDocument, options);
        }
// @ts-ignore
export function useGetReviewChangeRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>;
export function useGetReviewChangeRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewChangeRequestQuery | undefined, GraphqlTypes.GetReviewChangeRequestQueryVariables>;
export function useGetReviewChangeRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>(GetReviewChangeRequestDocument, options);
        }
export type GetReviewChangeRequestQueryHookResult = ReturnType<typeof useGetReviewChangeRequestQuery>;
export type GetReviewChangeRequestLazyQueryHookResult = ReturnType<typeof useGetReviewChangeRequestLazyQuery>;
export type GetReviewChangeRequestSuspenseQueryHookResult = ReturnType<typeof useGetReviewChangeRequestSuspenseQuery>;
export type GetReviewChangeRequestQueryResult = Apollo.QueryResult<GraphqlTypes.GetReviewChangeRequestQuery, GraphqlTypes.GetReviewChangeRequestQueryVariables>;
export const GetReviewChangeRequestForRestrictedContactPermissionDocument = gql`
    query GetReviewChangeRequestForRestrictedContactPermission($requestId: StrawberryObjectId!) {
  reviewChangeRequest(objectInput: {requestId: $requestId}) {
    ... on ReviewChangeRequestResponse {
      requestId
      requestedAt
      requestType
      status
      note
      changeRequestArena {
        id
        name
      }
      reviewChangeRequest {
        ... on UpdateCommunicationPrefsRequest {
          account {
            id
            name
            isDeleted
            accountContactMaps {
              id
              accountId
              contactId
            }
          }
          changeRequester {
            id
            fullName
            linkedArenaContact {
              id
              fullName
            }
          }
          contactUnderReview {
            id
            fullName
            isDeleted
          }
          accountContactMap {
            isMainContact
            isAdminContact
            changeRequestCommunicationPrefs {
              emailDistributionList {
                id
                name
              }
            }
            accountContactMapId
            changeRequestLabel {
              labelText
            }
          }
        }
        ... on RemoveContactRequest {
          account {
            id
            name
            isDeleted
            accountContactMaps {
              id
              accountId
              contactId
            }
          }
          changeRequester {
            id
            fullName
            linkedArenaContact {
              id
              fullName
            }
          }
          contactUnderReview {
            id
            fullName
            isDeleted
          }
          removeAccountContactMap: accountContactMap {
            id
            accountId
            accountName
            contactDetails {
              id
              fullName
            }
            isMainContact
            isAdminContact
            label {
              labelText
            }
            communicationPrefs {
              emailDistributionList {
                id
                name
              }
            }
          }
        }
        ... on AddContactRequest {
          account {
            id
            name
            isDeleted
            accountContactMaps {
              id
              accountId
              contactId
            }
          }
          changeRequester {
            id
            fullName
            linkedArenaContact {
              id
              fullName
            }
          }
          addContactUnderReview {
            id
            title
            firstName
            middleName
            lastName
            company
            email
            addressedAs
            jobTitle
            changeRequestContactAddress {
              addressType
              city
              country
              postalCode
              state
              street
              street2
            }
            changeRequestContactPhone {
              phoneType
              phoneNumber
            }
          }
          accountContactMap {
            accountContactMapId
            isMainContact
            isAdminContact
            changeRequestLabel {
              labelText
            }
            changeRequestCommunicationPrefs {
              emailDistributionList {
                id
                name
              }
            }
          }
        }
      }
    }
    ... on QueryErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetReviewChangeRequestForRestrictedContactPermissionQuery__
 *
 * To run a query within a React component, call `useGetReviewChangeRequestForRestrictedContactPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewChangeRequestForRestrictedContactPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewChangeRequestForRestrictedContactPermissionQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetReviewChangeRequestForRestrictedContactPermissionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables> & ({ variables: GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>(GetReviewChangeRequestForRestrictedContactPermissionDocument, options);
      }
export function useGetReviewChangeRequestForRestrictedContactPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>(GetReviewChangeRequestForRestrictedContactPermissionDocument, options);
        }
// @ts-ignore
export function useGetReviewChangeRequestForRestrictedContactPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>;
export function useGetReviewChangeRequestForRestrictedContactPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery | undefined, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>;
export function useGetReviewChangeRequestForRestrictedContactPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>(GetReviewChangeRequestForRestrictedContactPermissionDocument, options);
        }
export type GetReviewChangeRequestForRestrictedContactPermissionQueryHookResult = ReturnType<typeof useGetReviewChangeRequestForRestrictedContactPermissionQuery>;
export type GetReviewChangeRequestForRestrictedContactPermissionLazyQueryHookResult = ReturnType<typeof useGetReviewChangeRequestForRestrictedContactPermissionLazyQuery>;
export type GetReviewChangeRequestForRestrictedContactPermissionSuspenseQueryHookResult = ReturnType<typeof useGetReviewChangeRequestForRestrictedContactPermissionSuspenseQuery>;
export type GetReviewChangeRequestForRestrictedContactPermissionQueryResult = Apollo.QueryResult<GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQuery, GraphqlTypes.GetReviewChangeRequestForRestrictedContactPermissionQueryVariables>;
export const GetPaymentPrefChangeRequestImpactedPositionsListDocument = gql`
    query GetPaymentPrefChangeRequestImpactedPositionsList($requestId: StrawberryObjectId!, $first: Int = 10, $after: String) {
  reviewChangeRequest(objectInput: {requestId: $requestId}) {
    ... on ReviewChangeRequestResponse {
      requestId
      reviewChangeRequest {
        ... on UpdatePositionPaymentPrefRequest {
          impactedPositions {
            ... on AssociatePositionsOfAccountObjectType {
              positions(first: $first, after: $after) {
                ...PositionListForTable
              }
            }
            ... on AssociateLPPositionsOfAccountObjectType {
              positions(first: $first, after: $after) {
                ...PositionListForTable
              }
            }
            ... on AssociateWithPositionObjectType {
              positions(first: $first, after: $after) {
                ...PositionListForTable
              }
            }
            ... on AssociatePositionsWithoutPaymentPrefObjectType {
              positions(first: $first, after: $after) {
                ...PositionListForTable
              }
            }
            ... on AssociatePositionsWithSourcePaymentPrefObjectType {
              positions(first: $first, after: $after) {
                ...PositionListForTable
              }
            }
          }
        }
      }
    }
    ... on QueryErrorResponse {
      errorCode
      message
    }
  }
}
    ${PositionListForTableFragmentDoc}`;

/**
 * __useGetPaymentPrefChangeRequestImpactedPositionsListQuery__
 *
 * To run a query within a React component, call `useGetPaymentPrefChangeRequestImpactedPositionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPrefChangeRequestImpactedPositionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPrefChangeRequestImpactedPositionsListQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPaymentPrefChangeRequestImpactedPositionsListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables> & ({ variables: GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>(GetPaymentPrefChangeRequestImpactedPositionsListDocument, options);
      }
export function useGetPaymentPrefChangeRequestImpactedPositionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>(GetPaymentPrefChangeRequestImpactedPositionsListDocument, options);
        }
// @ts-ignore
export function useGetPaymentPrefChangeRequestImpactedPositionsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>;
export function useGetPaymentPrefChangeRequestImpactedPositionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery | undefined, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>;
export function useGetPaymentPrefChangeRequestImpactedPositionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>(GetPaymentPrefChangeRequestImpactedPositionsListDocument, options);
        }
export type GetPaymentPrefChangeRequestImpactedPositionsListQueryHookResult = ReturnType<typeof useGetPaymentPrefChangeRequestImpactedPositionsListQuery>;
export type GetPaymentPrefChangeRequestImpactedPositionsListLazyQueryHookResult = ReturnType<typeof useGetPaymentPrefChangeRequestImpactedPositionsListLazyQuery>;
export type GetPaymentPrefChangeRequestImpactedPositionsListSuspenseQueryHookResult = ReturnType<typeof useGetPaymentPrefChangeRequestImpactedPositionsListSuspenseQuery>;
export type GetPaymentPrefChangeRequestImpactedPositionsListQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQuery, GraphqlTypes.GetPaymentPrefChangeRequestImpactedPositionsListQueryVariables>;
export const ReviewPaymentPrefChangeRequestDocument = gql`
    mutation ReviewPaymentPrefChangeRequest($requestId: StrawberryObjectId!, $requestPayload: ChangeRequestPayload!, $requestStatus: ReviewAction!) {
  reviewChangeRequest(
    objectInput: {requestId: $requestId, requestPayload: $requestPayload, requestStatus: $requestStatus}
  ) {
    ... on ReviewChangeRequestMutationResponse {
      requestId
      requestType
      status
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ReviewPaymentPrefChangeRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.ReviewPaymentPrefChangeRequestMutation, GraphqlTypes.ReviewPaymentPrefChangeRequestMutationVariables>;

/**
 * __useReviewPaymentPrefChangeRequestMutation__
 *
 * To run a mutation, you first call `useReviewPaymentPrefChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewPaymentPrefChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewPaymentPrefChangeRequestMutation, { data, loading, error }] = useReviewPaymentPrefChangeRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      requestPayload: // value for 'requestPayload'
 *      requestStatus: // value for 'requestStatus'
 *   },
 * });
 */
export function useReviewPaymentPrefChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReviewPaymentPrefChangeRequestMutation, GraphqlTypes.ReviewPaymentPrefChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReviewPaymentPrefChangeRequestMutation, GraphqlTypes.ReviewPaymentPrefChangeRequestMutationVariables>(ReviewPaymentPrefChangeRequestDocument, options);
      }
export type ReviewPaymentPrefChangeRequestMutationHookResult = ReturnType<typeof useReviewPaymentPrefChangeRequestMutation>;
export type ReviewPaymentPrefChangeRequestMutationResult = Apollo.MutationResult<GraphqlTypes.ReviewPaymentPrefChangeRequestMutation>;
export type ReviewPaymentPrefChangeRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReviewPaymentPrefChangeRequestMutation, GraphqlTypes.ReviewPaymentPrefChangeRequestMutationVariables>;
export const GetPaymentPrefChangeRequestDocument = gql`
    query GetPaymentPrefChangeRequest($requestId: StrawberryObjectId!) {
  session {
    impersonating
  }
  currentUser {
    id
  }
  reviewChangeRequest(objectInput: {requestId: $requestId}) {
    ... on ReviewChangeRequestResponse {
      requestId
      requestedAt
      requestType
      status
      note
      riskContextForReview {
        sessionId
        isSuspicious
        arenaId
        userId
        evaluatedAt
        lookupFailed
        triggersFired
        arenaSettingRequired
        userContext {
          userId
          fullName
          usesEmailTwoFa
        }
        eventContext {
          passwordResetAt
          twoFaResetAt
          recoveryCodeUsedAt
        }
        sessionSignals {
          isNewBrowser
          isGeoAnomalous
          isGeoAnomalousSource
          isAnonymizer
          isVpn
          isProxy
          isTor
          isResidentialProxy
          anonymizerKinds
          ipAddress
          ipCity
          ipCountryIso
          ipCountry
          ipLat
          ipLon
          ipAccuracyRadiusKm
        }
        recentLogins {
          locations {
            city
            countryIso
            count
          }
          totalCount
          windowDays
        }
      }
      reviewChangeRequest {
        ... on UpdatePositionPaymentPrefRequest {
          targetPaymentPref {
            id
            ...DetailedPaymentPref
          }
          changeRequester {
            id
            fullName
          }
          impactedPositions {
            ... on AssociatePositionsOfAccountObjectType {
              account {
                ...AccountDetails
              }
              positions {
                count
              }
            }
            ... on AssociateLPPositionsOfAccountObjectType {
              account {
                ...AccountDetails
              }
              positions {
                count
              }
            }
            ... on AssociateWithPositionObjectType {
              account {
                ...AccountDetails
              }
              positions {
                count
              }
            }
            ... on AssociatePositionsWithoutPaymentPrefObjectType {
              account {
                ...AccountDetails
              }
              positions {
                count
              }
            }
            ... on AssociatePositionsWithSourcePaymentPrefObjectType {
              account {
                ...AccountDetails
              }
              positions {
                count
              }
            }
          }
        }
      }
    }
    ... on QueryErrorResponse {
      errorCode
      message
    }
  }
}
    ${DetailedPaymentPrefFragmentDoc}
${AccountDetailsFragmentDoc}`;

/**
 * __useGetPaymentPrefChangeRequestQuery__
 *
 * To run a query within a React component, call `useGetPaymentPrefChangeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPrefChangeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPrefChangeRequestQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetPaymentPrefChangeRequestQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables> & ({ variables: GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>(GetPaymentPrefChangeRequestDocument, options);
      }
export function useGetPaymentPrefChangeRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>(GetPaymentPrefChangeRequestDocument, options);
        }
// @ts-ignore
export function useGetPaymentPrefChangeRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>;
export function useGetPaymentPrefChangeRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentPrefChangeRequestQuery | undefined, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>;
export function useGetPaymentPrefChangeRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>(GetPaymentPrefChangeRequestDocument, options);
        }
export type GetPaymentPrefChangeRequestQueryHookResult = ReturnType<typeof useGetPaymentPrefChangeRequestQuery>;
export type GetPaymentPrefChangeRequestLazyQueryHookResult = ReturnType<typeof useGetPaymentPrefChangeRequestLazyQuery>;
export type GetPaymentPrefChangeRequestSuspenseQueryHookResult = ReturnType<typeof useGetPaymentPrefChangeRequestSuspenseQuery>;
export type GetPaymentPrefChangeRequestQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentPrefChangeRequestQuery, GraphqlTypes.GetPaymentPrefChangeRequestQueryVariables>;
export const GetImportJobsDocument = gql`
    query GetImportJobs($limit: Int, $offset: Int, $filters: BulkImportJobsFilterInput, $sort: BulkImportJobsSortInput) {
  bulkImportJobs(limit: $limit, offset: $offset, filters: $filters, sort: $sort) {
    items {
      id
      fileName
      objectType
      status
      createdAt
      createdBy
      createdByName
    }
    totalCount
    pageSize
    offset
  }
}
    `;

/**
 * __useGetImportJobsQuery__
 *
 * To run a query within a React component, call `useGetImportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportJobsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetImportJobsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>(GetImportJobsDocument, options);
      }
export function useGetImportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>(GetImportJobsDocument, options);
        }
// @ts-ignore
export function useGetImportJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>;
export function useGetImportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobsQuery | undefined, GraphqlTypes.GetImportJobsQueryVariables>;
export function useGetImportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>(GetImportJobsDocument, options);
        }
export type GetImportJobsQueryHookResult = ReturnType<typeof useGetImportJobsQuery>;
export type GetImportJobsLazyQueryHookResult = ReturnType<typeof useGetImportJobsLazyQuery>;
export type GetImportJobsSuspenseQueryHookResult = ReturnType<typeof useGetImportJobsSuspenseQuery>;
export type GetImportJobsQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportJobsQuery, GraphqlTypes.GetImportJobsQueryVariables>;
export const GetImportJobDetailDocument = gql`
    query GetImportJobDetail($id: ID!) {
  bulkImportJob(id: $id) {
    id
    fileName
    objectType
    status
    createdAt
    totalRows
    validRows
    createdCount
    updatedCount
    duplicateRows
    errorCount
    errorMessage
    hasValidationErrorFile
    hasSuccessLog
    hasInputFile
    importTagId
    startedAt
    completedAt
    createdBy
    createdByName
    selectedSheet
  }
}
    `;

/**
 * __useGetImportJobDetailQuery__
 *
 * To run a query within a React component, call `useGetImportJobDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportJobDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportJobDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportJobDetailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables> & ({ variables: GraphqlTypes.GetImportJobDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>(GetImportJobDetailDocument, options);
      }
export function useGetImportJobDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>(GetImportJobDetailDocument, options);
        }
// @ts-ignore
export function useGetImportJobDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>;
export function useGetImportJobDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobDetailQuery | undefined, GraphqlTypes.GetImportJobDetailQueryVariables>;
export function useGetImportJobDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>(GetImportJobDetailDocument, options);
        }
export type GetImportJobDetailQueryHookResult = ReturnType<typeof useGetImportJobDetailQuery>;
export type GetImportJobDetailLazyQueryHookResult = ReturnType<typeof useGetImportJobDetailLazyQuery>;
export type GetImportJobDetailSuspenseQueryHookResult = ReturnType<typeof useGetImportJobDetailSuspenseQuery>;
export type GetImportJobDetailQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportJobDetailQuery, GraphqlTypes.GetImportJobDetailQueryVariables>;
export const GetBulkImportJobCreatorsDocument = gql`
    query GetBulkImportJobCreators {
  bulkImportJobCreators {
    id
    fullName
  }
}
    `;

/**
 * __useGetBulkImportJobCreatorsQuery__
 *
 * To run a query within a React component, call `useGetBulkImportJobCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkImportJobCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkImportJobCreatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBulkImportJobCreatorsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>(GetBulkImportJobCreatorsDocument, options);
      }
export function useGetBulkImportJobCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>(GetBulkImportJobCreatorsDocument, options);
        }
// @ts-ignore
export function useGetBulkImportJobCreatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>;
export function useGetBulkImportJobCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBulkImportJobCreatorsQuery | undefined, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>;
export function useGetBulkImportJobCreatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>(GetBulkImportJobCreatorsDocument, options);
        }
export type GetBulkImportJobCreatorsQueryHookResult = ReturnType<typeof useGetBulkImportJobCreatorsQuery>;
export type GetBulkImportJobCreatorsLazyQueryHookResult = ReturnType<typeof useGetBulkImportJobCreatorsLazyQuery>;
export type GetBulkImportJobCreatorsSuspenseQueryHookResult = ReturnType<typeof useGetBulkImportJobCreatorsSuspenseQuery>;
export type GetBulkImportJobCreatorsQueryResult = Apollo.QueryResult<GraphqlTypes.GetBulkImportJobCreatorsQuery, GraphqlTypes.GetBulkImportJobCreatorsQueryVariables>;
export const BulkImportFieldDefinitionsDocument = gql`
    query BulkImportFieldDefinitions($objectType: String!, $includeExtensionFields: Boolean) {
  bulkImportFieldDefinitions(
    objectType: $objectType
    includeExtensionFields: $includeExtensionFields
  ) {
    name
    displayName
    dataType
    required
    aliases
    description
    supportsMultipleValues
    isCustom
  }
}
    `;

/**
 * __useBulkImportFieldDefinitionsQuery__
 *
 * To run a query within a React component, call `useBulkImportFieldDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkImportFieldDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkImportFieldDefinitionsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      includeExtensionFields: // value for 'includeExtensionFields'
 *   },
 * });
 */
export function useBulkImportFieldDefinitionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables> & ({ variables: GraphqlTypes.BulkImportFieldDefinitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>(BulkImportFieldDefinitionsDocument, options);
      }
export function useBulkImportFieldDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>(BulkImportFieldDefinitionsDocument, options);
        }
// @ts-ignore
export function useBulkImportFieldDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>;
export function useBulkImportFieldDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportFieldDefinitionsQuery | undefined, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>;
export function useBulkImportFieldDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>(BulkImportFieldDefinitionsDocument, options);
        }
export type BulkImportFieldDefinitionsQueryHookResult = ReturnType<typeof useBulkImportFieldDefinitionsQuery>;
export type BulkImportFieldDefinitionsLazyQueryHookResult = ReturnType<typeof useBulkImportFieldDefinitionsLazyQuery>;
export type BulkImportFieldDefinitionsSuspenseQueryHookResult = ReturnType<typeof useBulkImportFieldDefinitionsSuspenseQuery>;
export type BulkImportFieldDefinitionsQueryResult = Apollo.QueryResult<GraphqlTypes.BulkImportFieldDefinitionsQuery, GraphqlTypes.BulkImportFieldDefinitionsQueryVariables>;
export const BulkImportFileValidationDocument = gql`
    query BulkImportFileValidation($fileUuid: String!, $fileName: String!) {
  bulkImportFileValidation(fileUuid: $fileUuid, fileName: $fileName) {
    fileFormat
    sheetNames
  }
}
    `;

/**
 * __useBulkImportFileValidationQuery__
 *
 * To run a query within a React component, call `useBulkImportFileValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkImportFileValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkImportFileValidationQuery({
 *   variables: {
 *      fileUuid: // value for 'fileUuid'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useBulkImportFileValidationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables> & ({ variables: GraphqlTypes.BulkImportFileValidationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>(BulkImportFileValidationDocument, options);
      }
export function useBulkImportFileValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>(BulkImportFileValidationDocument, options);
        }
// @ts-ignore
export function useBulkImportFileValidationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>;
export function useBulkImportFileValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportFileValidationQuery | undefined, GraphqlTypes.BulkImportFileValidationQueryVariables>;
export function useBulkImportFileValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>(BulkImportFileValidationDocument, options);
        }
export type BulkImportFileValidationQueryHookResult = ReturnType<typeof useBulkImportFileValidationQuery>;
export type BulkImportFileValidationLazyQueryHookResult = ReturnType<typeof useBulkImportFileValidationLazyQuery>;
export type BulkImportFileValidationSuspenseQueryHookResult = ReturnType<typeof useBulkImportFileValidationSuspenseQuery>;
export type BulkImportFileValidationQueryResult = Apollo.QueryResult<GraphqlTypes.BulkImportFileValidationQuery, GraphqlTypes.BulkImportFileValidationQueryVariables>;
export const BulkImportTemplatesDocument = gql`
    query BulkImportTemplates($objectType: String!) {
  bulkImportTemplates(objectType: $objectType) {
    id
    name
    importObjectType
    createdBy
  }
}
    `;

/**
 * __useBulkImportTemplatesQuery__
 *
 * To run a query within a React component, call `useBulkImportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkImportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkImportTemplatesQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useBulkImportTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables> & ({ variables: GraphqlTypes.BulkImportTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>(BulkImportTemplatesDocument, options);
      }
export function useBulkImportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>(BulkImportTemplatesDocument, options);
        }
// @ts-ignore
export function useBulkImportTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>;
export function useBulkImportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportTemplatesQuery | undefined, GraphqlTypes.BulkImportTemplatesQueryVariables>;
export function useBulkImportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>(BulkImportTemplatesDocument, options);
        }
export type BulkImportTemplatesQueryHookResult = ReturnType<typeof useBulkImportTemplatesQuery>;
export type BulkImportTemplatesLazyQueryHookResult = ReturnType<typeof useBulkImportTemplatesLazyQuery>;
export type BulkImportTemplatesSuspenseQueryHookResult = ReturnType<typeof useBulkImportTemplatesSuspenseQuery>;
export type BulkImportTemplatesQueryResult = Apollo.QueryResult<GraphqlTypes.BulkImportTemplatesQuery, GraphqlTypes.BulkImportTemplatesQueryVariables>;
export const GenerateBulkImportUploadUrlDocument = gql`
    mutation GenerateBulkImportUploadUrl($fileName: String!, $contentType: String) {
  generateBulkImportUploadUrl(fileName: $fileName, contentType: $contentType) {
    fileUuid
    uploadUrl
    uploadFields
    fileName
  }
}
    `;
export type GenerateBulkImportUploadUrlMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateBulkImportUploadUrlMutation, GraphqlTypes.GenerateBulkImportUploadUrlMutationVariables>;

/**
 * __useGenerateBulkImportUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateBulkImportUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBulkImportUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBulkImportUploadUrlMutation, { data, loading, error }] = useGenerateBulkImportUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useGenerateBulkImportUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateBulkImportUploadUrlMutation, GraphqlTypes.GenerateBulkImportUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateBulkImportUploadUrlMutation, GraphqlTypes.GenerateBulkImportUploadUrlMutationVariables>(GenerateBulkImportUploadUrlDocument, options);
      }
export type GenerateBulkImportUploadUrlMutationHookResult = ReturnType<typeof useGenerateBulkImportUploadUrlMutation>;
export type GenerateBulkImportUploadUrlMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateBulkImportUploadUrlMutation>;
export type GenerateBulkImportUploadUrlMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateBulkImportUploadUrlMutation, GraphqlTypes.GenerateBulkImportUploadUrlMutationVariables>;
export const UpsertImportJobDocument = gql`
    mutation UpsertImportJob($input: UpsertImportJobInput!) {
  upsertImportJob(input: $input) {
    id
    fileName
    objectType
    status
  }
}
    `;
export type UpsertImportJobMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertImportJobMutation, GraphqlTypes.UpsertImportJobMutationVariables>;

/**
 * __useUpsertImportJobMutation__
 *
 * To run a mutation, you first call `useUpsertImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertImportJobMutation, { data, loading, error }] = useUpsertImportJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertImportJobMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertImportJobMutation, GraphqlTypes.UpsertImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertImportJobMutation, GraphqlTypes.UpsertImportJobMutationVariables>(UpsertImportJobDocument, options);
      }
export type UpsertImportJobMutationHookResult = ReturnType<typeof useUpsertImportJobMutation>;
export type UpsertImportJobMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertImportJobMutation>;
export type UpsertImportJobMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertImportJobMutation, GraphqlTypes.UpsertImportJobMutationVariables>;
export const GetImportJobTemplateDocument = gql`
    query GetImportJobTemplate($id: ID!) {
  bulkImportJob(id: $id) {
    id
    fileUuid
    fileName
    importTemplateId
    importTemplate {
      id
      name
      importObjectType
    }
    availableSheets
    selectedSheet
  }
}
    `;

/**
 * __useGetImportJobTemplateQuery__
 *
 * To run a query within a React component, call `useGetImportJobTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportJobTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportJobTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportJobTemplateQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables> & ({ variables: GraphqlTypes.GetImportJobTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>(GetImportJobTemplateDocument, options);
      }
export function useGetImportJobTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>(GetImportJobTemplateDocument, options);
        }
// @ts-ignore
export function useGetImportJobTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>;
export function useGetImportJobTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobTemplateQuery | undefined, GraphqlTypes.GetImportJobTemplateQueryVariables>;
export function useGetImportJobTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>(GetImportJobTemplateDocument, options);
        }
export type GetImportJobTemplateQueryHookResult = ReturnType<typeof useGetImportJobTemplateQuery>;
export type GetImportJobTemplateLazyQueryHookResult = ReturnType<typeof useGetImportJobTemplateLazyQuery>;
export type GetImportJobTemplateSuspenseQueryHookResult = ReturnType<typeof useGetImportJobTemplateSuspenseQuery>;
export type GetImportJobTemplateQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportJobTemplateQuery, GraphqlTypes.GetImportJobTemplateQueryVariables>;
export const GenerateHeaderMappingDocument = gql`
    mutation GenerateHeaderMapping($input: GenerateHeaderMappingInput!) {
  generateHeaderMapping(input: $input) {
    __typename
    mappingSuggestions {
      csvColumn
      fieldName
      displayName
      confidence
      isExactMatch
      matchType
      previewValues
      isSkippedColumn
    }
    message
    messageState
  }
}
    `;
export type GenerateHeaderMappingMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateHeaderMappingMutation, GraphqlTypes.GenerateHeaderMappingMutationVariables>;

/**
 * __useGenerateHeaderMappingMutation__
 *
 * To run a mutation, you first call `useGenerateHeaderMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHeaderMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHeaderMappingMutation, { data, loading, error }] = useGenerateHeaderMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateHeaderMappingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateHeaderMappingMutation, GraphqlTypes.GenerateHeaderMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateHeaderMappingMutation, GraphqlTypes.GenerateHeaderMappingMutationVariables>(GenerateHeaderMappingDocument, options);
      }
export type GenerateHeaderMappingMutationHookResult = ReturnType<typeof useGenerateHeaderMappingMutation>;
export type GenerateHeaderMappingMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateHeaderMappingMutation>;
export type GenerateHeaderMappingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateHeaderMappingMutation, GraphqlTypes.GenerateHeaderMappingMutationVariables>;
export const SaveBulkImportTemplateDocument = gql`
    mutation SaveBulkImportTemplate($input: SaveBulkImportTemplateInput!) {
  saveBulkImportTemplate(input: $input) {
    id
    name
    importObjectType
  }
}
    `;
export type SaveBulkImportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveBulkImportTemplateMutation, GraphqlTypes.SaveBulkImportTemplateMutationVariables>;

/**
 * __useSaveBulkImportTemplateMutation__
 *
 * To run a mutation, you first call `useSaveBulkImportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBulkImportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBulkImportTemplateMutation, { data, loading, error }] = useSaveBulkImportTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBulkImportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveBulkImportTemplateMutation, GraphqlTypes.SaveBulkImportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveBulkImportTemplateMutation, GraphqlTypes.SaveBulkImportTemplateMutationVariables>(SaveBulkImportTemplateDocument, options);
      }
export type SaveBulkImportTemplateMutationHookResult = ReturnType<typeof useSaveBulkImportTemplateMutation>;
export type SaveBulkImportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.SaveBulkImportTemplateMutation>;
export type SaveBulkImportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveBulkImportTemplateMutation, GraphqlTypes.SaveBulkImportTemplateMutationVariables>;
export const DeleteBulkImportTemplateDocument = gql`
    mutation DeleteBulkImportTemplate($templateId: ID!) {
  deleteBulkImportTemplate(templateId: $templateId) {
    success
    message
  }
}
    `;
export type DeleteBulkImportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteBulkImportTemplateMutation, GraphqlTypes.DeleteBulkImportTemplateMutationVariables>;

/**
 * __useDeleteBulkImportTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteBulkImportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBulkImportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBulkImportTemplateMutation, { data, loading, error }] = useDeleteBulkImportTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeleteBulkImportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteBulkImportTemplateMutation, GraphqlTypes.DeleteBulkImportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteBulkImportTemplateMutation, GraphqlTypes.DeleteBulkImportTemplateMutationVariables>(DeleteBulkImportTemplateDocument, options);
      }
export type DeleteBulkImportTemplateMutationHookResult = ReturnType<typeof useDeleteBulkImportTemplateMutation>;
export type DeleteBulkImportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteBulkImportTemplateMutation>;
export type DeleteBulkImportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteBulkImportTemplateMutation, GraphqlTypes.DeleteBulkImportTemplateMutationVariables>;
export const SaveHeaderMappingDocument = gql`
    mutation SaveHeaderMapping($input: SaveHeaderMappingInput!) {
  saveHeaderMapping(input: $input) {
    success
    message
    importJob {
      id
      status
      currentStep
      multiValueFieldsPendingConfig {
        headerMappingId
        jsqHeaderName
        displayName
        csvFileHeaderName
      }
    }
  }
}
    `;
export type SaveHeaderMappingMutationFn = Apollo.MutationFunction<GraphqlTypes.SaveHeaderMappingMutation, GraphqlTypes.SaveHeaderMappingMutationVariables>;

/**
 * __useSaveHeaderMappingMutation__
 *
 * To run a mutation, you first call `useSaveHeaderMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHeaderMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHeaderMappingMutation, { data, loading, error }] = useSaveHeaderMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHeaderMappingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SaveHeaderMappingMutation, GraphqlTypes.SaveHeaderMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SaveHeaderMappingMutation, GraphqlTypes.SaveHeaderMappingMutationVariables>(SaveHeaderMappingDocument, options);
      }
export type SaveHeaderMappingMutationHookResult = ReturnType<typeof useSaveHeaderMappingMutation>;
export type SaveHeaderMappingMutationResult = Apollo.MutationResult<GraphqlTypes.SaveHeaderMappingMutation>;
export type SaveHeaderMappingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SaveHeaderMappingMutation, GraphqlTypes.SaveHeaderMappingMutationVariables>;
export const ConfirmMultiValueFieldSettingsDocument = gql`
    mutation ConfirmMultiValueFieldSettings($input: ConfirmMultiValueFieldSettingsInput!) {
  confirmMultiValueFieldSettings(input: $input) {
    success
    message
    importJob {
      id
      status
    }
  }
}
    `;
export type ConfirmMultiValueFieldSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfirmMultiValueFieldSettingsMutation, GraphqlTypes.ConfirmMultiValueFieldSettingsMutationVariables>;

/**
 * __useConfirmMultiValueFieldSettingsMutation__
 *
 * To run a mutation, you first call `useConfirmMultiValueFieldSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMultiValueFieldSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMultiValueFieldSettingsMutation, { data, loading, error }] = useConfirmMultiValueFieldSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmMultiValueFieldSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfirmMultiValueFieldSettingsMutation, GraphqlTypes.ConfirmMultiValueFieldSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfirmMultiValueFieldSettingsMutation, GraphqlTypes.ConfirmMultiValueFieldSettingsMutationVariables>(ConfirmMultiValueFieldSettingsDocument, options);
      }
export type ConfirmMultiValueFieldSettingsMutationHookResult = ReturnType<typeof useConfirmMultiValueFieldSettingsMutation>;
export type ConfirmMultiValueFieldSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.ConfirmMultiValueFieldSettingsMutation>;
export type ConfirmMultiValueFieldSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfirmMultiValueFieldSettingsMutation, GraphqlTypes.ConfirmMultiValueFieldSettingsMutationVariables>;
export const EnableBulkImportNotificationDocument = gql`
    mutation EnableBulkImportNotification($importJobId: ID!) {
  enableBulkImportNotification(importJobId: $importJobId)
}
    `;
export type EnableBulkImportNotificationMutationFn = Apollo.MutationFunction<GraphqlTypes.EnableBulkImportNotificationMutation, GraphqlTypes.EnableBulkImportNotificationMutationVariables>;

/**
 * __useEnableBulkImportNotificationMutation__
 *
 * To run a mutation, you first call `useEnableBulkImportNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableBulkImportNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableBulkImportNotificationMutation, { data, loading, error }] = useEnableBulkImportNotificationMutation({
 *   variables: {
 *      importJobId: // value for 'importJobId'
 *   },
 * });
 */
export function useEnableBulkImportNotificationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EnableBulkImportNotificationMutation, GraphqlTypes.EnableBulkImportNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EnableBulkImportNotificationMutation, GraphqlTypes.EnableBulkImportNotificationMutationVariables>(EnableBulkImportNotificationDocument, options);
      }
export type EnableBulkImportNotificationMutationHookResult = ReturnType<typeof useEnableBulkImportNotificationMutation>;
export type EnableBulkImportNotificationMutationResult = Apollo.MutationResult<GraphqlTypes.EnableBulkImportNotificationMutation>;
export type EnableBulkImportNotificationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EnableBulkImportNotificationMutation, GraphqlTypes.EnableBulkImportNotificationMutationVariables>;
export const CancelImportDocument = gql`
    mutation CancelImport($importJobId: ID!) {
  cancelImport(importJobId: $importJobId) {
    success
    message
  }
}
    `;
export type CancelImportMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelImportMutation, GraphqlTypes.CancelImportMutationVariables>;

/**
 * __useCancelImportMutation__
 *
 * To run a mutation, you first call `useCancelImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelImportMutation, { data, loading, error }] = useCancelImportMutation({
 *   variables: {
 *      importJobId: // value for 'importJobId'
 *   },
 * });
 */
export function useCancelImportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelImportMutation, GraphqlTypes.CancelImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelImportMutation, GraphqlTypes.CancelImportMutationVariables>(CancelImportDocument, options);
      }
export type CancelImportMutationHookResult = ReturnType<typeof useCancelImportMutation>;
export type CancelImportMutationResult = Apollo.MutationResult<GraphqlTypes.CancelImportMutation>;
export type CancelImportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelImportMutation, GraphqlTypes.CancelImportMutationVariables>;
export const StartImportDocument = gql`
    mutation StartImport($importJobId: ID!, $skipDuplicates: Boolean!) {
  startImport(importJobId: $importJobId, skipDuplicates: $skipDuplicates) {
    success
    message
  }
}
    `;
export type StartImportMutationFn = Apollo.MutationFunction<GraphqlTypes.StartImportMutation, GraphqlTypes.StartImportMutationVariables>;

/**
 * __useStartImportMutation__
 *
 * To run a mutation, you first call `useStartImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImportMutation, { data, loading, error }] = useStartImportMutation({
 *   variables: {
 *      importJobId: // value for 'importJobId'
 *      skipDuplicates: // value for 'skipDuplicates'
 *   },
 * });
 */
export function useStartImportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartImportMutation, GraphqlTypes.StartImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartImportMutation, GraphqlTypes.StartImportMutationVariables>(StartImportDocument, options);
      }
export type StartImportMutationHookResult = ReturnType<typeof useStartImportMutation>;
export type StartImportMutationResult = Apollo.MutationResult<GraphqlTypes.StartImportMutation>;
export type StartImportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartImportMutation, GraphqlTypes.StartImportMutationVariables>;
export const GenerateBulkImportFileDownloadUrlDocument = gql`
    mutation GenerateBulkImportFileDownloadUrl($importJobId: ID!, $fileType: BulkImportFileTypeEnum!) {
  generateBulkImportFileDownloadUrl(
    importJobId: $importJobId
    fileType: $fileType
  )
}
    `;
export type GenerateBulkImportFileDownloadUrlMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateBulkImportFileDownloadUrlMutation, GraphqlTypes.GenerateBulkImportFileDownloadUrlMutationVariables>;

/**
 * __useGenerateBulkImportFileDownloadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateBulkImportFileDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBulkImportFileDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBulkImportFileDownloadUrlMutation, { data, loading, error }] = useGenerateBulkImportFileDownloadUrlMutation({
 *   variables: {
 *      importJobId: // value for 'importJobId'
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useGenerateBulkImportFileDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateBulkImportFileDownloadUrlMutation, GraphqlTypes.GenerateBulkImportFileDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateBulkImportFileDownloadUrlMutation, GraphqlTypes.GenerateBulkImportFileDownloadUrlMutationVariables>(GenerateBulkImportFileDownloadUrlDocument, options);
      }
export type GenerateBulkImportFileDownloadUrlMutationHookResult = ReturnType<typeof useGenerateBulkImportFileDownloadUrlMutation>;
export type GenerateBulkImportFileDownloadUrlMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateBulkImportFileDownloadUrlMutation>;
export type GenerateBulkImportFileDownloadUrlMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateBulkImportFileDownloadUrlMutation, GraphqlTypes.GenerateBulkImportFileDownloadUrlMutationVariables>;
export const GetImportJobProgressDocument = gql`
    query GetImportJobProgress($id: ID!) {
  bulkImportJobProgress(id: $id) {
    id
    status
    processedRows
    totalRows
    percentage
    message
    errorCount
    warningCount
  }
}
    `;

/**
 * __useGetImportJobProgressQuery__
 *
 * To run a query within a React component, call `useGetImportJobProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportJobProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportJobProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportJobProgressQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables> & ({ variables: GraphqlTypes.GetImportJobProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>(GetImportJobProgressDocument, options);
      }
export function useGetImportJobProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>(GetImportJobProgressDocument, options);
        }
// @ts-ignore
export function useGetImportJobProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>;
export function useGetImportJobProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobProgressQuery | undefined, GraphqlTypes.GetImportJobProgressQueryVariables>;
export function useGetImportJobProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>(GetImportJobProgressDocument, options);
        }
export type GetImportJobProgressQueryHookResult = ReturnType<typeof useGetImportJobProgressQuery>;
export type GetImportJobProgressLazyQueryHookResult = ReturnType<typeof useGetImportJobProgressLazyQuery>;
export type GetImportJobProgressSuspenseQueryHookResult = ReturnType<typeof useGetImportJobProgressSuspenseQuery>;
export type GetImportJobProgressQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportJobProgressQuery, GraphqlTypes.GetImportJobProgressQueryVariables>;
export const GetImportJobForRedirectDocument = gql`
    query GetImportJobForRedirect($id: ID!) {
  bulkImportJob(id: $id) {
    id
    status
    enableNotification
  }
}
    `;

/**
 * __useGetImportJobForRedirectQuery__
 *
 * To run a query within a React component, call `useGetImportJobForRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportJobForRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportJobForRedirectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportJobForRedirectQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables> & ({ variables: GraphqlTypes.GetImportJobForRedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>(GetImportJobForRedirectDocument, options);
      }
export function useGetImportJobForRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>(GetImportJobForRedirectDocument, options);
        }
// @ts-ignore
export function useGetImportJobForRedirectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>;
export function useGetImportJobForRedirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobForRedirectQuery | undefined, GraphqlTypes.GetImportJobForRedirectQueryVariables>;
export function useGetImportJobForRedirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>(GetImportJobForRedirectDocument, options);
        }
export type GetImportJobForRedirectQueryHookResult = ReturnType<typeof useGetImportJobForRedirectQuery>;
export type GetImportJobForRedirectLazyQueryHookResult = ReturnType<typeof useGetImportJobForRedirectLazyQuery>;
export type GetImportJobForRedirectSuspenseQueryHookResult = ReturnType<typeof useGetImportJobForRedirectSuspenseQuery>;
export type GetImportJobForRedirectQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportJobForRedirectQuery, GraphqlTypes.GetImportJobForRedirectQueryVariables>;
export const GetImportJobReviewDocument = gql`
    query GetImportJobReview($id: ID!) {
  bulkImportJob(id: $id) {
    id
    fileName
    status
    totalRows
    validRows
    duplicateRows
    errorCount
    hasValidationErrorFile
  }
}
    `;

/**
 * __useGetImportJobReviewQuery__
 *
 * To run a query within a React component, call `useGetImportJobReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportJobReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportJobReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportJobReviewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables> & ({ variables: GraphqlTypes.GetImportJobReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>(GetImportJobReviewDocument, options);
      }
export function useGetImportJobReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>(GetImportJobReviewDocument, options);
        }
// @ts-ignore
export function useGetImportJobReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>;
export function useGetImportJobReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobReviewQuery | undefined, GraphqlTypes.GetImportJobReviewQueryVariables>;
export function useGetImportJobReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>(GetImportJobReviewDocument, options);
        }
export type GetImportJobReviewQueryHookResult = ReturnType<typeof useGetImportJobReviewQuery>;
export type GetImportJobReviewLazyQueryHookResult = ReturnType<typeof useGetImportJobReviewLazyQuery>;
export type GetImportJobReviewSuspenseQueryHookResult = ReturnType<typeof useGetImportJobReviewSuspenseQuery>;
export type GetImportJobReviewQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportJobReviewQuery, GraphqlTypes.GetImportJobReviewQueryVariables>;
export const GetImportJobValidationErrorsDocument = gql`
    query GetImportJobValidationErrors($jobId: ID!, $limit: Int, $offset: Int) {
  bulkImportJobValidationErrors(jobId: $jobId, limit: $limit, offset: $offset) {
    items {
      id
      rowNumber
      errorMessage
    }
    totalCount
    pageSize
    offset
  }
}
    `;

/**
 * __useGetImportJobValidationErrorsQuery__
 *
 * To run a query within a React component, call `useGetImportJobValidationErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportJobValidationErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportJobValidationErrorsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetImportJobValidationErrorsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables> & ({ variables: GraphqlTypes.GetImportJobValidationErrorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>(GetImportJobValidationErrorsDocument, options);
      }
export function useGetImportJobValidationErrorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>(GetImportJobValidationErrorsDocument, options);
        }
// @ts-ignore
export function useGetImportJobValidationErrorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>;
export function useGetImportJobValidationErrorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetImportJobValidationErrorsQuery | undefined, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>;
export function useGetImportJobValidationErrorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>(GetImportJobValidationErrorsDocument, options);
        }
export type GetImportJobValidationErrorsQueryHookResult = ReturnType<typeof useGetImportJobValidationErrorsQuery>;
export type GetImportJobValidationErrorsLazyQueryHookResult = ReturnType<typeof useGetImportJobValidationErrorsLazyQuery>;
export type GetImportJobValidationErrorsSuspenseQueryHookResult = ReturnType<typeof useGetImportJobValidationErrorsSuspenseQuery>;
export type GetImportJobValidationErrorsQueryResult = Apollo.QueryResult<GraphqlTypes.GetImportJobValidationErrorsQuery, GraphqlTypes.GetImportJobValidationErrorsQueryVariables>;
export const BulkImportHeaderValidationDocument = gql`
    query BulkImportHeaderValidation($objectType: String!, $headers: [String!]!, $importJobId: ID!) {
  bulkImportHeaderValidation(
    objectType: $objectType
    headers: $headers
    importJobId: $importJobId
  )
}
    `;

/**
 * __useBulkImportHeaderValidationQuery__
 *
 * To run a query within a React component, call `useBulkImportHeaderValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkImportHeaderValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkImportHeaderValidationQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      headers: // value for 'headers'
 *      importJobId: // value for 'importJobId'
 *   },
 * });
 */
export function useBulkImportHeaderValidationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables> & ({ variables: GraphqlTypes.BulkImportHeaderValidationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>(BulkImportHeaderValidationDocument, options);
      }
export function useBulkImportHeaderValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>(BulkImportHeaderValidationDocument, options);
        }
// @ts-ignore
export function useBulkImportHeaderValidationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>;
export function useBulkImportHeaderValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.BulkImportHeaderValidationQuery | undefined, GraphqlTypes.BulkImportHeaderValidationQueryVariables>;
export function useBulkImportHeaderValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>(BulkImportHeaderValidationDocument, options);
        }
export type BulkImportHeaderValidationQueryHookResult = ReturnType<typeof useBulkImportHeaderValidationQuery>;
export type BulkImportHeaderValidationLazyQueryHookResult = ReturnType<typeof useBulkImportHeaderValidationLazyQuery>;
export type BulkImportHeaderValidationSuspenseQueryHookResult = ReturnType<typeof useBulkImportHeaderValidationSuspenseQuery>;
export type BulkImportHeaderValidationQueryResult = Apollo.QueryResult<GraphqlTypes.BulkImportHeaderValidationQuery, GraphqlTypes.BulkImportHeaderValidationQueryVariables>;
export const GetBulkImportObjectTypesDocument = gql`
    query GetBulkImportObjectTypes {
  bulkImportObjectTypes {
    name
    displayName
    supportsCreate
  }
}
    `;

/**
 * __useGetBulkImportObjectTypesQuery__
 *
 * To run a query within a React component, call `useGetBulkImportObjectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkImportObjectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkImportObjectTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBulkImportObjectTypesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>(GetBulkImportObjectTypesDocument, options);
      }
export function useGetBulkImportObjectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>(GetBulkImportObjectTypesDocument, options);
        }
// @ts-ignore
export function useGetBulkImportObjectTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>;
export function useGetBulkImportObjectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBulkImportObjectTypesQuery | undefined, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>;
export function useGetBulkImportObjectTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>(GetBulkImportObjectTypesDocument, options);
        }
export type GetBulkImportObjectTypesQueryHookResult = ReturnType<typeof useGetBulkImportObjectTypesQuery>;
export type GetBulkImportObjectTypesLazyQueryHookResult = ReturnType<typeof useGetBulkImportObjectTypesLazyQuery>;
export type GetBulkImportObjectTypesSuspenseQueryHookResult = ReturnType<typeof useGetBulkImportObjectTypesSuspenseQuery>;
export type GetBulkImportObjectTypesQueryResult = Apollo.QueryResult<GraphqlTypes.GetBulkImportObjectTypesQuery, GraphqlTypes.GetBulkImportObjectTypesQueryVariables>;
export const GetIntegrationDetailsDocument = gql`
    query GetIntegrationDetails($provenance: String!) {
  integrationDetails(provenance: $provenance) {
    connectionStatusDetails
    connectionStatus
    provenance
    configurationStatus
    configurationOptions
    configurationStatusDetails
  }
}
    `;

/**
 * __useGetIntegrationDetailsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationDetailsQuery({
 *   variables: {
 *      provenance: // value for 'provenance'
 *   },
 * });
 */
export function useGetIntegrationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables> & ({ variables: GraphqlTypes.GetIntegrationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>(GetIntegrationDetailsDocument, options);
      }
export function useGetIntegrationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>(GetIntegrationDetailsDocument, options);
        }
// @ts-ignore
export function useGetIntegrationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>;
export function useGetIntegrationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationDetailsQuery | undefined, GraphqlTypes.GetIntegrationDetailsQueryVariables>;
export function useGetIntegrationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>(GetIntegrationDetailsDocument, options);
        }
export type GetIntegrationDetailsQueryHookResult = ReturnType<typeof useGetIntegrationDetailsQuery>;
export type GetIntegrationDetailsLazyQueryHookResult = ReturnType<typeof useGetIntegrationDetailsLazyQuery>;
export type GetIntegrationDetailsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationDetailsSuspenseQuery>;
export type GetIntegrationDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationDetailsQuery, GraphqlTypes.GetIntegrationDetailsQueryVariables>;
export const GetIntegrationListDocument = gql`
    query GetIntegrationList($provenance: [String!]!) {
  integrationList(provenance: $provenance) {
    connectionStatusDetails
    connectionStatus
    provenance
  }
}
    `;

/**
 * __useGetIntegrationListQuery__
 *
 * To run a query within a React component, call `useGetIntegrationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationListQuery({
 *   variables: {
 *      provenance: // value for 'provenance'
 *   },
 * });
 */
export function useGetIntegrationListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables> & ({ variables: GraphqlTypes.GetIntegrationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>(GetIntegrationListDocument, options);
      }
export function useGetIntegrationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>(GetIntegrationListDocument, options);
        }
// @ts-ignore
export function useGetIntegrationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>;
export function useGetIntegrationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationListQuery | undefined, GraphqlTypes.GetIntegrationListQueryVariables>;
export function useGetIntegrationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>(GetIntegrationListDocument, options);
        }
export type GetIntegrationListQueryHookResult = ReturnType<typeof useGetIntegrationListQuery>;
export type GetIntegrationListLazyQueryHookResult = ReturnType<typeof useGetIntegrationListLazyQuery>;
export type GetIntegrationListSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationListSuspenseQuery>;
export type GetIntegrationListQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationListQuery, GraphqlTypes.GetIntegrationListQueryVariables>;
export const GetIntegrationFfDocument = gql`
    query GetIntegrationFF {
  devFeatures {
    hubspotIntegration
    preqinIntegration
    sftpDocumentPosting
  }
}
    `;

/**
 * __useGetIntegrationFfQuery__
 *
 * To run a query within a React component, call `useGetIntegrationFfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationFfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationFfQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationFfQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>(GetIntegrationFfDocument, options);
      }
export function useGetIntegrationFfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>(GetIntegrationFfDocument, options);
        }
// @ts-ignore
export function useGetIntegrationFfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>;
export function useGetIntegrationFfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationFfQuery | undefined, GraphqlTypes.GetIntegrationFfQueryVariables>;
export function useGetIntegrationFfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>(GetIntegrationFfDocument, options);
        }
export type GetIntegrationFfQueryHookResult = ReturnType<typeof useGetIntegrationFfQuery>;
export type GetIntegrationFfLazyQueryHookResult = ReturnType<typeof useGetIntegrationFfLazyQuery>;
export type GetIntegrationFfSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationFfSuspenseQuery>;
export type GetIntegrationFfQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationFfQuery, GraphqlTypes.GetIntegrationFfQueryVariables>;
export const CreateInvestranDomainArenaMappingDocument = gql`
    mutation CreateInvestranDomainArenaMapping($input: CreateInvestranDomainArenaMappingInput!) {
  createInvestranDomainArenaMapping(input: $input) {
    success
    mapping {
      arenaId
      domainId
      domainName
      createdAt
    }
  }
}
    `;
export type CreateInvestranDomainArenaMappingMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateInvestranDomainArenaMappingMutation, GraphqlTypes.CreateInvestranDomainArenaMappingMutationVariables>;

/**
 * __useCreateInvestranDomainArenaMappingMutation__
 *
 * To run a mutation, you first call `useCreateInvestranDomainArenaMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvestranDomainArenaMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvestranDomainArenaMappingMutation, { data, loading, error }] = useCreateInvestranDomainArenaMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvestranDomainArenaMappingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateInvestranDomainArenaMappingMutation, GraphqlTypes.CreateInvestranDomainArenaMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateInvestranDomainArenaMappingMutation, GraphqlTypes.CreateInvestranDomainArenaMappingMutationVariables>(CreateInvestranDomainArenaMappingDocument, options);
      }
export type CreateInvestranDomainArenaMappingMutationHookResult = ReturnType<typeof useCreateInvestranDomainArenaMappingMutation>;
export type CreateInvestranDomainArenaMappingMutationResult = Apollo.MutationResult<GraphqlTypes.CreateInvestranDomainArenaMappingMutation>;
export type CreateInvestranDomainArenaMappingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateInvestranDomainArenaMappingMutation, GraphqlTypes.CreateInvestranDomainArenaMappingMutationVariables>;
export const GetInvestranDomainArenaMappingDocument = gql`
    query GetInvestranDomainArenaMapping($input: InvestranDomainArenaMappingInput!) {
  investranDomainArenaMapping(input: $input) {
    arenaId
    domainId
    domainName
    createdAt
  }
}
    `;

/**
 * __useGetInvestranDomainArenaMappingQuery__
 *
 * To run a query within a React component, call `useGetInvestranDomainArenaMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestranDomainArenaMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestranDomainArenaMappingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInvestranDomainArenaMappingQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables> & ({ variables: GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>(GetInvestranDomainArenaMappingDocument, options);
      }
export function useGetInvestranDomainArenaMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>(GetInvestranDomainArenaMappingDocument, options);
        }
// @ts-ignore
export function useGetInvestranDomainArenaMappingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>;
export function useGetInvestranDomainArenaMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestranDomainArenaMappingQuery | undefined, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>;
export function useGetInvestranDomainArenaMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>(GetInvestranDomainArenaMappingDocument, options);
        }
export type GetInvestranDomainArenaMappingQueryHookResult = ReturnType<typeof useGetInvestranDomainArenaMappingQuery>;
export type GetInvestranDomainArenaMappingLazyQueryHookResult = ReturnType<typeof useGetInvestranDomainArenaMappingLazyQuery>;
export type GetInvestranDomainArenaMappingSuspenseQueryHookResult = ReturnType<typeof useGetInvestranDomainArenaMappingSuspenseQuery>;
export type GetInvestranDomainArenaMappingQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestranDomainArenaMappingQuery, GraphqlTypes.GetInvestranDomainArenaMappingQueryVariables>;
export const ReviewMatchResultsDocument = gql`
    mutation ReviewMatchResults($input: BatchMatchConfirmInput!) {
  confirmMarketLensMatch(input: $input) {
    __typename
    ... on ConfirmMarketLensMatchObject {
      success
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type ReviewMatchResultsMutationFn = Apollo.MutationFunction<GraphqlTypes.ReviewMatchResultsMutation, GraphqlTypes.ReviewMatchResultsMutationVariables>;

/**
 * __useReviewMatchResultsMutation__
 *
 * To run a mutation, you first call `useReviewMatchResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewMatchResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewMatchResultsMutation, { data, loading, error }] = useReviewMatchResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewMatchResultsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReviewMatchResultsMutation, GraphqlTypes.ReviewMatchResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReviewMatchResultsMutation, GraphqlTypes.ReviewMatchResultsMutationVariables>(ReviewMatchResultsDocument, options);
      }
export type ReviewMatchResultsMutationHookResult = ReturnType<typeof useReviewMatchResultsMutation>;
export type ReviewMatchResultsMutationResult = Apollo.MutationResult<GraphqlTypes.ReviewMatchResultsMutation>;
export type ReviewMatchResultsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReviewMatchResultsMutation, GraphqlTypes.ReviewMatchResultsMutationVariables>;
export const MarketLensManageContactPermissionDocument = gql`
    query MarketLensManageContactPermission {
  currentUser {
    id
    userPermissions {
      canManageContact
    }
  }
}
    `;

/**
 * __useMarketLensManageContactPermissionQuery__
 *
 * To run a query within a React component, call `useMarketLensManageContactPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketLensManageContactPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketLensManageContactPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketLensManageContactPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>(MarketLensManageContactPermissionDocument, options);
      }
export function useMarketLensManageContactPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>(MarketLensManageContactPermissionDocument, options);
        }
// @ts-ignore
export function useMarketLensManageContactPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>;
export function useMarketLensManageContactPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensManageContactPermissionQuery | undefined, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>;
export function useMarketLensManageContactPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>(MarketLensManageContactPermissionDocument, options);
        }
export type MarketLensManageContactPermissionQueryHookResult = ReturnType<typeof useMarketLensManageContactPermissionQuery>;
export type MarketLensManageContactPermissionLazyQueryHookResult = ReturnType<typeof useMarketLensManageContactPermissionLazyQuery>;
export type MarketLensManageContactPermissionSuspenseQueryHookResult = ReturnType<typeof useMarketLensManageContactPermissionSuspenseQuery>;
export type MarketLensManageContactPermissionQueryResult = Apollo.QueryResult<GraphqlTypes.MarketLensManageContactPermissionQuery, GraphqlTypes.MarketLensManageContactPermissionQueryVariables>;
export const MarketLensMatchingSummaryDataDocument = gql`
    query MarketLensMatchingSummaryData($arenaId: ID!) {
  matchSummary(arenaId: $arenaId) {
    __typename
    ... on MatchSummary {
      totalProcessed
      totalMatched
      totalImported
      totalPending
      totalRejected
      readyForAutoMatch
      readyForManualReview
      autoMatchThreshold
      noMatchThreshold
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useMarketLensMatchingSummaryDataQuery__
 *
 * To run a query within a React component, call `useMarketLensMatchingSummaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketLensMatchingSummaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketLensMatchingSummaryDataQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useMarketLensMatchingSummaryDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables> & ({ variables: GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>(MarketLensMatchingSummaryDataDocument, options);
      }
export function useMarketLensMatchingSummaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>(MarketLensMatchingSummaryDataDocument, options);
        }
// @ts-ignore
export function useMarketLensMatchingSummaryDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>;
export function useMarketLensMatchingSummaryDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensMatchingSummaryDataQuery | undefined, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>;
export function useMarketLensMatchingSummaryDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>(MarketLensMatchingSummaryDataDocument, options);
        }
export type MarketLensMatchingSummaryDataQueryHookResult = ReturnType<typeof useMarketLensMatchingSummaryDataQuery>;
export type MarketLensMatchingSummaryDataLazyQueryHookResult = ReturnType<typeof useMarketLensMatchingSummaryDataLazyQuery>;
export type MarketLensMatchingSummaryDataSuspenseQueryHookResult = ReturnType<typeof useMarketLensMatchingSummaryDataSuspenseQuery>;
export type MarketLensMatchingSummaryDataQueryResult = Apollo.QueryResult<GraphqlTypes.MarketLensMatchingSummaryDataQuery, GraphqlTypes.MarketLensMatchingSummaryDataQueryVariables>;
export const GetContactsInWorkspaceDocument = gql`
    query GetContactsInWorkspace {
  contacts(offset: 0, limit: 1) {
    totalCount
    rows {
      id
    }
  }
}
    `;

/**
 * __useGetContactsInWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetContactsInWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsInWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsInWorkspaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactsInWorkspaceQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>(GetContactsInWorkspaceDocument, options);
      }
export function useGetContactsInWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>(GetContactsInWorkspaceDocument, options);
        }
// @ts-ignore
export function useGetContactsInWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>;
export function useGetContactsInWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsInWorkspaceQuery | undefined, GraphqlTypes.GetContactsInWorkspaceQueryVariables>;
export function useGetContactsInWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>(GetContactsInWorkspaceDocument, options);
        }
export type GetContactsInWorkspaceQueryHookResult = ReturnType<typeof useGetContactsInWorkspaceQuery>;
export type GetContactsInWorkspaceLazyQueryHookResult = ReturnType<typeof useGetContactsInWorkspaceLazyQuery>;
export type GetContactsInWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetContactsInWorkspaceSuspenseQuery>;
export type GetContactsInWorkspaceQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsInWorkspaceQuery, GraphqlTypes.GetContactsInWorkspaceQueryVariables>;
export const MarketLensMatchResultsByCompanyDocument = gql`
    query MarketLensMatchResultsByCompany($arenaId: ID!, $contactType: ContactType, $statuses: [MatchStatus!], $minConfidence: Float, $maxConfidence: Float, $offset: Int, $limit: Int) {
  matchResultsByCompany(
    arenaId: $arenaId
    contactType: $contactType
    statuses: $statuses
    minConfidence: $minConfidence
    maxConfidence: $maxConfidence
    offset: $offset
    limit: $limit
  ) {
    __typename
    ... on MatchResultsByCompanyConnection {
      totalCount
      filteredCount
      page
      pageSize
      totalPages
      items {
        contactId
        items {
          id
          arenaId
          contactId
          contactType
          marketLensGuid
          confidenceScore
          status
          marketLensContact {
            personGuid
            firstName
            lastName
            email
            phone
            currentFirmName
            currentFirmGuid
            currentJobTitle
            city
            state
            country
            matchResult {
              id
              arenaId
              contactId
              status
              confidenceScore
            }
            matchResults {
              id
              arenaId
              contactId
              status
            }
          }
          marketLensFirm {
            firmGuid
            firmName
            city
            state
            country
            website
            investorType
            investorSubType
            familyOfficeSubType
            contactCount
          }
        }
      }
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useMarketLensMatchResultsByCompanyQuery__
 *
 * To run a query within a React component, call `useMarketLensMatchResultsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketLensMatchResultsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketLensMatchResultsByCompanyQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      contactType: // value for 'contactType'
 *      statuses: // value for 'statuses'
 *      minConfidence: // value for 'minConfidence'
 *      maxConfidence: // value for 'maxConfidence'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketLensMatchResultsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables> & ({ variables: GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>(MarketLensMatchResultsByCompanyDocument, options);
      }
export function useMarketLensMatchResultsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>(MarketLensMatchResultsByCompanyDocument, options);
        }
// @ts-ignore
export function useMarketLensMatchResultsByCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>;
export function useMarketLensMatchResultsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensMatchResultsByCompanyQuery | undefined, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>;
export function useMarketLensMatchResultsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>(MarketLensMatchResultsByCompanyDocument, options);
        }
export type MarketLensMatchResultsByCompanyQueryHookResult = ReturnType<typeof useMarketLensMatchResultsByCompanyQuery>;
export type MarketLensMatchResultsByCompanyLazyQueryHookResult = ReturnType<typeof useMarketLensMatchResultsByCompanyLazyQuery>;
export type MarketLensMatchResultsByCompanySuspenseQueryHookResult = ReturnType<typeof useMarketLensMatchResultsByCompanySuspenseQuery>;
export type MarketLensMatchResultsByCompanyQueryResult = Apollo.QueryResult<GraphqlTypes.MarketLensMatchResultsByCompanyQuery, GraphqlTypes.MarketLensMatchResultsByCompanyQueryVariables>;
export const MarketLensMatchResultsByCompanyIdsDocument = gql`
    query MarketLensMatchResultsByCompanyIds($arenaId: ID!, $contactType: ContactType, $statuses: [MatchStatus!], $minConfidence: Float, $maxConfidence: Float, $offset: Int, $limit: Int) {
  matchResultsByCompany(
    arenaId: $arenaId
    contactType: $contactType
    statuses: $statuses
    minConfidence: $minConfidence
    maxConfidence: $maxConfidence
    offset: $offset
    limit: $limit
  ) {
    __typename
    ... on MatchResultsByCompanyConnection {
      filteredCount
      totalPages
      items {
        contactId
        items {
          id
          contactId
        }
      }
    }
    ... on ValidationError {
      message
      field
    }
  }
}
    `;

/**
 * __useMarketLensMatchResultsByCompanyIdsQuery__
 *
 * To run a query within a React component, call `useMarketLensMatchResultsByCompanyIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketLensMatchResultsByCompanyIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketLensMatchResultsByCompanyIdsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      contactType: // value for 'contactType'
 *      statuses: // value for 'statuses'
 *      minConfidence: // value for 'minConfidence'
 *      maxConfidence: // value for 'maxConfidence'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMarketLensMatchResultsByCompanyIdsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables> & ({ variables: GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>(MarketLensMatchResultsByCompanyIdsDocument, options);
      }
export function useMarketLensMatchResultsByCompanyIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>(MarketLensMatchResultsByCompanyIdsDocument, options);
        }
// @ts-ignore
export function useMarketLensMatchResultsByCompanyIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>;
export function useMarketLensMatchResultsByCompanyIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery | undefined, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>;
export function useMarketLensMatchResultsByCompanyIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>(MarketLensMatchResultsByCompanyIdsDocument, options);
        }
export type MarketLensMatchResultsByCompanyIdsQueryHookResult = ReturnType<typeof useMarketLensMatchResultsByCompanyIdsQuery>;
export type MarketLensMatchResultsByCompanyIdsLazyQueryHookResult = ReturnType<typeof useMarketLensMatchResultsByCompanyIdsLazyQuery>;
export type MarketLensMatchResultsByCompanyIdsSuspenseQueryHookResult = ReturnType<typeof useMarketLensMatchResultsByCompanyIdsSuspenseQuery>;
export type MarketLensMatchResultsByCompanyIdsQueryResult = Apollo.QueryResult<GraphqlTypes.MarketLensMatchResultsByCompanyIdsQuery, GraphqlTypes.MarketLensMatchResultsByCompanyIdsQueryVariables>;
export const GetJsqContactsByIdDocument = gql`
    query GetJsqContactsById($contactIds: [ID!]!, $first: Int!, $after: String) {
  contactsById(contactIds: $contactIds, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        fullName
        jobTitle
        websiteUrl
        companyName
        company {
          id
          fullName
        }
        emails {
          id
          emailAddress
          emailType
          isPrimary
        }
        phones {
          id
          phoneNumber
          phoneType
        }
        addresses {
          addressType
          street
          street2
          street3
          city
          region
          postalCode
          state {
            objectName
          }
          country {
            objectName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetJsqContactsByIdQuery__
 *
 * To run a query within a React component, call `useGetJsqContactsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJsqContactsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJsqContactsByIdQuery({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetJsqContactsByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables> & ({ variables: GraphqlTypes.GetJsqContactsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>(GetJsqContactsByIdDocument, options);
      }
export function useGetJsqContactsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>(GetJsqContactsByIdDocument, options);
        }
// @ts-ignore
export function useGetJsqContactsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>;
export function useGetJsqContactsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetJsqContactsByIdQuery | undefined, GraphqlTypes.GetJsqContactsByIdQueryVariables>;
export function useGetJsqContactsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>(GetJsqContactsByIdDocument, options);
        }
export type GetJsqContactsByIdQueryHookResult = ReturnType<typeof useGetJsqContactsByIdQuery>;
export type GetJsqContactsByIdLazyQueryHookResult = ReturnType<typeof useGetJsqContactsByIdLazyQuery>;
export type GetJsqContactsByIdSuspenseQueryHookResult = ReturnType<typeof useGetJsqContactsByIdSuspenseQuery>;
export type GetJsqContactsByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetJsqContactsByIdQuery, GraphqlTypes.GetJsqContactsByIdQueryVariables>;
export const DisablePreqinConnectionDocument = gql`
    mutation DisablePreqinConnection($disablePreqinConnectionInput: DisableProvenanceConnectionInput!) {
  disableProvenanceConnection(
    disableProvenanceConnectionInput: $disablePreqinConnectionInput
  ) {
    ... on DisableProvenanceConnectionResponse {
      ... on MutationErrorResponse {
        errorCode
        message
      }
      ... on DisableProvenanceConnectionSuccessResponse {
        success
        job {
          id
        }
      }
    }
  }
}
    `;
export type DisablePreqinConnectionMutationFn = Apollo.MutationFunction<GraphqlTypes.DisablePreqinConnectionMutation, GraphqlTypes.DisablePreqinConnectionMutationVariables>;

/**
 * __useDisablePreqinConnectionMutation__
 *
 * To run a mutation, you first call `useDisablePreqinConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisablePreqinConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disablePreqinConnectionMutation, { data, loading, error }] = useDisablePreqinConnectionMutation({
 *   variables: {
 *      disablePreqinConnectionInput: // value for 'disablePreqinConnectionInput'
 *   },
 * });
 */
export function useDisablePreqinConnectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DisablePreqinConnectionMutation, GraphqlTypes.DisablePreqinConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DisablePreqinConnectionMutation, GraphqlTypes.DisablePreqinConnectionMutationVariables>(DisablePreqinConnectionDocument, options);
      }
export type DisablePreqinConnectionMutationHookResult = ReturnType<typeof useDisablePreqinConnectionMutation>;
export type DisablePreqinConnectionMutationResult = Apollo.MutationResult<GraphqlTypes.DisablePreqinConnectionMutation>;
export type DisablePreqinConnectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DisablePreqinConnectionMutation, GraphqlTypes.DisablePreqinConnectionMutationVariables>;
export const ConfigurePreqinConnectionDocument = gql`
    mutation ConfigurePreqinConnection($connectionInput: PreqinCredentialsInput!) {
  configurePreqinIntegration(connectionInput: $connectionInput) {
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on PreqinSuccessResponse {
      success
    }
  }
}
    `;
export type ConfigurePreqinConnectionMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigurePreqinConnectionMutation, GraphqlTypes.ConfigurePreqinConnectionMutationVariables>;

/**
 * __useConfigurePreqinConnectionMutation__
 *
 * To run a mutation, you first call `useConfigurePreqinConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigurePreqinConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configurePreqinConnectionMutation, { data, loading, error }] = useConfigurePreqinConnectionMutation({
 *   variables: {
 *      connectionInput: // value for 'connectionInput'
 *   },
 * });
 */
export function useConfigurePreqinConnectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigurePreqinConnectionMutation, GraphqlTypes.ConfigurePreqinConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigurePreqinConnectionMutation, GraphqlTypes.ConfigurePreqinConnectionMutationVariables>(ConfigurePreqinConnectionDocument, options);
      }
export type ConfigurePreqinConnectionMutationHookResult = ReturnType<typeof useConfigurePreqinConnectionMutation>;
export type ConfigurePreqinConnectionMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigurePreqinConnectionMutation>;
export type ConfigurePreqinConnectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigurePreqinConnectionMutation, GraphqlTypes.ConfigurePreqinConnectionMutationVariables>;
export const GetPreqinCredentialsDocument = gql`
    query GetPreqinCredentials {
  integrationPreqinConnection {
    username
    apiKey
    assetClass
  }
}
    `;

/**
 * __useGetPreqinCredentialsQuery__
 *
 * To run a query within a React component, call `useGetPreqinCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreqinCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreqinCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreqinCredentialsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>(GetPreqinCredentialsDocument, options);
      }
export function useGetPreqinCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>(GetPreqinCredentialsDocument, options);
        }
// @ts-ignore
export function useGetPreqinCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>;
export function useGetPreqinCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreqinCredentialsQuery | undefined, GraphqlTypes.GetPreqinCredentialsQueryVariables>;
export function useGetPreqinCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>(GetPreqinCredentialsDocument, options);
        }
export type GetPreqinCredentialsQueryHookResult = ReturnType<typeof useGetPreqinCredentialsQuery>;
export type GetPreqinCredentialsLazyQueryHookResult = ReturnType<typeof useGetPreqinCredentialsLazyQuery>;
export type GetPreqinCredentialsSuspenseQueryHookResult = ReturnType<typeof useGetPreqinCredentialsSuspenseQuery>;
export type GetPreqinCredentialsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPreqinCredentialsQuery, GraphqlTypes.GetPreqinCredentialsQueryVariables>;
export const UpsertSftpConnectionDocument = gql`
    mutation UpsertSftpConnection($sftpConnectionInput: UpsertSftpConnectionInput!) {
  upsertSftpConnection(sftpConnectionInput: $sftpConnectionInput) {
    __typename
    ... on SftpConnectionObjectType {
      id
      enabled
      notificationEmail
      documentIngestState
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UpsertSftpConnectionMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertSftpConnectionMutation, GraphqlTypes.UpsertSftpConnectionMutationVariables>;

/**
 * __useUpsertSftpConnectionMutation__
 *
 * To run a mutation, you first call `useUpsertSftpConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSftpConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSftpConnectionMutation, { data, loading, error }] = useUpsertSftpConnectionMutation({
 *   variables: {
 *      sftpConnectionInput: // value for 'sftpConnectionInput'
 *   },
 * });
 */
export function useUpsertSftpConnectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertSftpConnectionMutation, GraphqlTypes.UpsertSftpConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertSftpConnectionMutation, GraphqlTypes.UpsertSftpConnectionMutationVariables>(UpsertSftpConnectionDocument, options);
      }
export type UpsertSftpConnectionMutationHookResult = ReturnType<typeof useUpsertSftpConnectionMutation>;
export type UpsertSftpConnectionMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertSftpConnectionMutation>;
export type UpsertSftpConnectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertSftpConnectionMutation, GraphqlTypes.UpsertSftpConnectionMutationVariables>;
export const CreateSftpUserDocument = gql`
    mutation CreateSftpUser($input: CreateSftpUserInput!) {
  createSftpUser(sftpUserInput: $input) {
    __typename
    ... on SftpUserObjectType {
      id
      name
      username
      publicKey
      status
      createdAt
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type CreateSftpUserMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateSftpUserMutation, GraphqlTypes.CreateSftpUserMutationVariables>;

/**
 * __useCreateSftpUserMutation__
 *
 * To run a mutation, you first call `useCreateSftpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSftpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSftpUserMutation, { data, loading, error }] = useCreateSftpUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSftpUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateSftpUserMutation, GraphqlTypes.CreateSftpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateSftpUserMutation, GraphqlTypes.CreateSftpUserMutationVariables>(CreateSftpUserDocument, options);
      }
export type CreateSftpUserMutationHookResult = ReturnType<typeof useCreateSftpUserMutation>;
export type CreateSftpUserMutationResult = Apollo.MutationResult<GraphqlTypes.CreateSftpUserMutation>;
export type CreateSftpUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateSftpUserMutation, GraphqlTypes.CreateSftpUserMutationVariables>;
export const UpdateSftpUserDocument = gql`
    mutation UpdateSftpUser($input: UpdateSftpUserInput!) {
  updateSftpUser(sftpUserInput: $input) {
    __typename
    ... on SftpUserObjectType {
      id
      name
      username
      publicKey
      status
      createdAt
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpdateSftpUserMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateSftpUserMutation, GraphqlTypes.UpdateSftpUserMutationVariables>;

/**
 * __useUpdateSftpUserMutation__
 *
 * To run a mutation, you first call `useUpdateSftpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSftpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSftpUserMutation, { data, loading, error }] = useUpdateSftpUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSftpUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateSftpUserMutation, GraphqlTypes.UpdateSftpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateSftpUserMutation, GraphqlTypes.UpdateSftpUserMutationVariables>(UpdateSftpUserDocument, options);
      }
export type UpdateSftpUserMutationHookResult = ReturnType<typeof useUpdateSftpUserMutation>;
export type UpdateSftpUserMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateSftpUserMutation>;
export type UpdateSftpUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateSftpUserMutation, GraphqlTypes.UpdateSftpUserMutationVariables>;
export const DeleteSftpUserDocument = gql`
    mutation DeleteSftpUser($id: ID!) {
  deleteSftpUser(id: $id) {
    __typename
    ... on SftpUserObjectType {
      id
      name
      username
      status
      createdAt
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type DeleteSftpUserMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteSftpUserMutation, GraphqlTypes.DeleteSftpUserMutationVariables>;

/**
 * __useDeleteSftpUserMutation__
 *
 * To run a mutation, you first call `useDeleteSftpUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSftpUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSftpUserMutation, { data, loading, error }] = useDeleteSftpUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSftpUserMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteSftpUserMutation, GraphqlTypes.DeleteSftpUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteSftpUserMutation, GraphqlTypes.DeleteSftpUserMutationVariables>(DeleteSftpUserDocument, options);
      }
export type DeleteSftpUserMutationHookResult = ReturnType<typeof useDeleteSftpUserMutation>;
export type DeleteSftpUserMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteSftpUserMutation>;
export type DeleteSftpUserMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteSftpUserMutation, GraphqlTypes.DeleteSftpUserMutationVariables>;
export const SftpConnectionDocument = gql`
    query SftpConnection {
  sftpConnection {
    id
    enabled
    notificationEmail
    documentIngestState
  }
}
    `;

/**
 * __useSftpConnectionQuery__
 *
 * To run a query within a React component, call `useSftpConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSftpConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSftpConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSftpConnectionQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>(SftpConnectionDocument, options);
      }
export function useSftpConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>(SftpConnectionDocument, options);
        }
// @ts-ignore
export function useSftpConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>;
export function useSftpConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SftpConnectionQuery | undefined, GraphqlTypes.SftpConnectionQueryVariables>;
export function useSftpConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>(SftpConnectionDocument, options);
        }
export type SftpConnectionQueryHookResult = ReturnType<typeof useSftpConnectionQuery>;
export type SftpConnectionLazyQueryHookResult = ReturnType<typeof useSftpConnectionLazyQuery>;
export type SftpConnectionSuspenseQueryHookResult = ReturnType<typeof useSftpConnectionSuspenseQuery>;
export type SftpConnectionQueryResult = Apollo.QueryResult<GraphqlTypes.SftpConnectionQuery, GraphqlTypes.SftpConnectionQueryVariables>;
export const SftpImportServerAwsConfigDocument = gql`
    query SftpImportServerAwsConfig {
  sftpImportServerAwsConfig {
    sftpImportServerAwsHost
    sftpImportServerAwsPort
  }
}
    `;

/**
 * __useSftpImportServerAwsConfigQuery__
 *
 * To run a query within a React component, call `useSftpImportServerAwsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSftpImportServerAwsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSftpImportServerAwsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSftpImportServerAwsConfigQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>(SftpImportServerAwsConfigDocument, options);
      }
export function useSftpImportServerAwsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>(SftpImportServerAwsConfigDocument, options);
        }
// @ts-ignore
export function useSftpImportServerAwsConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>;
export function useSftpImportServerAwsConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SftpImportServerAwsConfigQuery | undefined, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>;
export function useSftpImportServerAwsConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>(SftpImportServerAwsConfigDocument, options);
        }
export type SftpImportServerAwsConfigQueryHookResult = ReturnType<typeof useSftpImportServerAwsConfigQuery>;
export type SftpImportServerAwsConfigLazyQueryHookResult = ReturnType<typeof useSftpImportServerAwsConfigLazyQuery>;
export type SftpImportServerAwsConfigSuspenseQueryHookResult = ReturnType<typeof useSftpImportServerAwsConfigSuspenseQuery>;
export type SftpImportServerAwsConfigQueryResult = Apollo.QueryResult<GraphqlTypes.SftpImportServerAwsConfigQuery, GraphqlTypes.SftpImportServerAwsConfigQueryVariables>;
export const GetAllSftpUsersDocument = gql`
    query GetAllSftpUsers {
  sftpUsers {
    id
    resourceId
    name
    username
    publicKey
    status
    createdAt
  }
}
    `;

/**
 * __useGetAllSftpUsersQuery__
 *
 * To run a query within a React component, call `useGetAllSftpUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSftpUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSftpUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSftpUsersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>(GetAllSftpUsersDocument, options);
      }
export function useGetAllSftpUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>(GetAllSftpUsersDocument, options);
        }
// @ts-ignore
export function useGetAllSftpUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>;
export function useGetAllSftpUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllSftpUsersQuery | undefined, GraphqlTypes.GetAllSftpUsersQueryVariables>;
export function useGetAllSftpUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>(GetAllSftpUsersDocument, options);
        }
export type GetAllSftpUsersQueryHookResult = ReturnType<typeof useGetAllSftpUsersQuery>;
export type GetAllSftpUsersLazyQueryHookResult = ReturnType<typeof useGetAllSftpUsersLazyQuery>;
export type GetAllSftpUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllSftpUsersSuspenseQuery>;
export type GetAllSftpUsersQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllSftpUsersQuery, GraphqlTypes.GetAllSftpUsersQueryVariables>;
export const GetAllSftpUsersIncludingDeletedDocument = gql`
    query GetAllSftpUsersIncludingDeleted($includeDeleted: Boolean!) {
  sftpUsers(includeDeleted: $includeDeleted) {
    id
    resourceId
    name
    username
    publicKey
    status
    createdAt
  }
}
    `;

/**
 * __useGetAllSftpUsersIncludingDeletedQuery__
 *
 * To run a query within a React component, call `useGetAllSftpUsersIncludingDeletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSftpUsersIncludingDeletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSftpUsersIncludingDeletedQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useGetAllSftpUsersIncludingDeletedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables> & ({ variables: GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>(GetAllSftpUsersIncludingDeletedDocument, options);
      }
export function useGetAllSftpUsersIncludingDeletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>(GetAllSftpUsersIncludingDeletedDocument, options);
        }
// @ts-ignore
export function useGetAllSftpUsersIncludingDeletedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>;
export function useGetAllSftpUsersIncludingDeletedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery | undefined, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>;
export function useGetAllSftpUsersIncludingDeletedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>(GetAllSftpUsersIncludingDeletedDocument, options);
        }
export type GetAllSftpUsersIncludingDeletedQueryHookResult = ReturnType<typeof useGetAllSftpUsersIncludingDeletedQuery>;
export type GetAllSftpUsersIncludingDeletedLazyQueryHookResult = ReturnType<typeof useGetAllSftpUsersIncludingDeletedLazyQuery>;
export type GetAllSftpUsersIncludingDeletedSuspenseQueryHookResult = ReturnType<typeof useGetAllSftpUsersIncludingDeletedSuspenseQuery>;
export type GetAllSftpUsersIncludingDeletedQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllSftpUsersIncludingDeletedQuery, GraphqlTypes.GetAllSftpUsersIncludingDeletedQueryVariables>;
export const GetSftpUserDocument = gql`
    query GetSftpUser($id: ID!) {
  sftpUser(id: $id) {
    id
    resourceId
    name
    username
    publicKey
    status
    createdAt
  }
}
    `;

/**
 * __useGetSftpUserQuery__
 *
 * To run a query within a React component, call `useGetSftpUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSftpUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSftpUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSftpUserQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables> & ({ variables: GraphqlTypes.GetSftpUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>(GetSftpUserDocument, options);
      }
export function useGetSftpUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>(GetSftpUserDocument, options);
        }
// @ts-ignore
export function useGetSftpUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>;
export function useGetSftpUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSftpUserQuery | undefined, GraphqlTypes.GetSftpUserQueryVariables>;
export function useGetSftpUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>(GetSftpUserDocument, options);
        }
export type GetSftpUserQueryHookResult = ReturnType<typeof useGetSftpUserQuery>;
export type GetSftpUserLazyQueryHookResult = ReturnType<typeof useGetSftpUserLazyQuery>;
export type GetSftpUserSuspenseQueryHookResult = ReturnType<typeof useGetSftpUserSuspenseQuery>;
export type GetSftpUserQueryResult = Apollo.QueryResult<GraphqlTypes.GetSftpUserQuery, GraphqlTypes.GetSftpUserQueryVariables>;
export const GetIntegrationHubspotOauthUrlDocument = gql`
    query GetIntegrationHubspotOauthUrl {
  integrationHubspotOauthUrl {
    url
  }
}
    `;

/**
 * __useGetIntegrationHubspotOauthUrlQuery__
 *
 * To run a query within a React component, call `useGetIntegrationHubspotOauthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationHubspotOauthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationHubspotOauthUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationHubspotOauthUrlQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>(GetIntegrationHubspotOauthUrlDocument, options);
      }
export function useGetIntegrationHubspotOauthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>(GetIntegrationHubspotOauthUrlDocument, options);
        }
// @ts-ignore
export function useGetIntegrationHubspotOauthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>;
export function useGetIntegrationHubspotOauthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery | undefined, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>;
export function useGetIntegrationHubspotOauthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>(GetIntegrationHubspotOauthUrlDocument, options);
        }
export type GetIntegrationHubspotOauthUrlQueryHookResult = ReturnType<typeof useGetIntegrationHubspotOauthUrlQuery>;
export type GetIntegrationHubspotOauthUrlLazyQueryHookResult = ReturnType<typeof useGetIntegrationHubspotOauthUrlLazyQuery>;
export type GetIntegrationHubspotOauthUrlSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationHubspotOauthUrlSuspenseQuery>;
export type GetIntegrationHubspotOauthUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationHubspotOauthUrlQuery, GraphqlTypes.GetIntegrationHubspotOauthUrlQueryVariables>;
export const ConfigureIntegrationDocument = gql`
    mutation ConfigureIntegration($configureIntegrationInput: ConfigureIntegrationInput!) {
  configureIntegration(configureIntegrationInput: $configureIntegrationInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on ConfigureIntegrationObject {
      job {
        id
        status
        data
        jobType
      }
    }
  }
}
    `;
export type ConfigureIntegrationMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigureIntegrationMutation, GraphqlTypes.ConfigureIntegrationMutationVariables>;

/**
 * __useConfigureIntegrationMutation__
 *
 * To run a mutation, you first call `useConfigureIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureIntegrationMutation, { data, loading, error }] = useConfigureIntegrationMutation({
 *   variables: {
 *      configureIntegrationInput: // value for 'configureIntegrationInput'
 *   },
 * });
 */
export function useConfigureIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigureIntegrationMutation, GraphqlTypes.ConfigureIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigureIntegrationMutation, GraphqlTypes.ConfigureIntegrationMutationVariables>(ConfigureIntegrationDocument, options);
      }
export type ConfigureIntegrationMutationHookResult = ReturnType<typeof useConfigureIntegrationMutation>;
export type ConfigureIntegrationMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigureIntegrationMutation>;
export type ConfigureIntegrationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigureIntegrationMutation, GraphqlTypes.ConfigureIntegrationMutationVariables>;
export const GetIntegrationConfigurationDetailsDocument = gql`
    query GetIntegrationConfigurationDetails($provenance: String!) {
  integrationDetails(provenance: $provenance) {
    configurationStatus
    configurationOptions
  }
}
    `;

/**
 * __useGetIntegrationConfigurationDetailsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationConfigurationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationConfigurationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationConfigurationDetailsQuery({
 *   variables: {
 *      provenance: // value for 'provenance'
 *   },
 * });
 */
export function useGetIntegrationConfigurationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables> & ({ variables: GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>(GetIntegrationConfigurationDetailsDocument, options);
      }
export function useGetIntegrationConfigurationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>(GetIntegrationConfigurationDetailsDocument, options);
        }
// @ts-ignore
export function useGetIntegrationConfigurationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>;
export function useGetIntegrationConfigurationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIntegrationConfigurationDetailsQuery | undefined, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>;
export function useGetIntegrationConfigurationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>(GetIntegrationConfigurationDetailsDocument, options);
        }
export type GetIntegrationConfigurationDetailsQueryHookResult = ReturnType<typeof useGetIntegrationConfigurationDetailsQuery>;
export type GetIntegrationConfigurationDetailsLazyQueryHookResult = ReturnType<typeof useGetIntegrationConfigurationDetailsLazyQuery>;
export type GetIntegrationConfigurationDetailsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationConfigurationDetailsSuspenseQuery>;
export type GetIntegrationConfigurationDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetIntegrationConfigurationDetailsQuery, GraphqlTypes.GetIntegrationConfigurationDetailsQueryVariables>;
export const DisableIntegrationDocument = gql`
    mutation DisableIntegration($disableIntegrationInput: DisableIntegrationInput!) {
  disableIntegration(disableIntegrationInput: $disableIntegrationInput) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on DisableIntegrationObject {
      job {
        id
        status
        data
        jobType
      }
    }
  }
}
    `;
export type DisableIntegrationMutationFn = Apollo.MutationFunction<GraphqlTypes.DisableIntegrationMutation, GraphqlTypes.DisableIntegrationMutationVariables>;

/**
 * __useDisableIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableIntegrationMutation, { data, loading, error }] = useDisableIntegrationMutation({
 *   variables: {
 *      disableIntegrationInput: // value for 'disableIntegrationInput'
 *   },
 * });
 */
export function useDisableIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DisableIntegrationMutation, GraphqlTypes.DisableIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DisableIntegrationMutation, GraphqlTypes.DisableIntegrationMutationVariables>(DisableIntegrationDocument, options);
      }
export type DisableIntegrationMutationHookResult = ReturnType<typeof useDisableIntegrationMutation>;
export type DisableIntegrationMutationResult = Apollo.MutationResult<GraphqlTypes.DisableIntegrationMutation>;
export type DisableIntegrationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DisableIntegrationMutation, GraphqlTypes.DisableIntegrationMutationVariables>;
export const ExportGlScheduleOfInvestmentDocument = gql`
    mutation ExportGlScheduleOfInvestment($input: EntitySoiInput!) {
  downloadSoiSpreadsheet(input: $input)
}
    `;
export type ExportGlScheduleOfInvestmentMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportGlScheduleOfInvestmentMutation, GraphqlTypes.ExportGlScheduleOfInvestmentMutationVariables>;

/**
 * __useExportGlScheduleOfInvestmentMutation__
 *
 * To run a mutation, you first call `useExportGlScheduleOfInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportGlScheduleOfInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportGlScheduleOfInvestmentMutation, { data, loading, error }] = useExportGlScheduleOfInvestmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportGlScheduleOfInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportGlScheduleOfInvestmentMutation, GraphqlTypes.ExportGlScheduleOfInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportGlScheduleOfInvestmentMutation, GraphqlTypes.ExportGlScheduleOfInvestmentMutationVariables>(ExportGlScheduleOfInvestmentDocument, options);
      }
export type ExportGlScheduleOfInvestmentMutationHookResult = ReturnType<typeof useExportGlScheduleOfInvestmentMutation>;
export type ExportGlScheduleOfInvestmentMutationResult = Apollo.MutationResult<GraphqlTypes.ExportGlScheduleOfInvestmentMutation>;
export type ExportGlScheduleOfInvestmentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportGlScheduleOfInvestmentMutation, GraphqlTypes.ExportGlScheduleOfInvestmentMutationVariables>;
export const GetScheduleOfInvestmentsDocument = gql`
    query GetScheduleOfInvestments($entitySoiInput: EntitySoiInput!) {
  scheduleOfInvestments(input: $entitySoiInput) {
    totals {
      ...InvestmentTotalsFields
    }
    investments {
      opcoId
      name
      currency
      totals {
        ...InvestmentTotalsFields
      }
      positionsOwned {
        id
        name
        status
        totals {
          ...InvestmentTotalsFields
        }
        lots {
          ...InvestmentTotalsFields
        }
      }
    }
  }
}
    ${InvestmentTotalsFieldsFragmentDoc}`;

/**
 * __useGetScheduleOfInvestmentsQuery__
 *
 * To run a query within a React component, call `useGetScheduleOfInvestmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleOfInvestmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleOfInvestmentsQuery({
 *   variables: {
 *      entitySoiInput: // value for 'entitySoiInput'
 *   },
 * });
 */
export function useGetScheduleOfInvestmentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables> & ({ variables: GraphqlTypes.GetScheduleOfInvestmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>(GetScheduleOfInvestmentsDocument, options);
      }
export function useGetScheduleOfInvestmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>(GetScheduleOfInvestmentsDocument, options);
        }
// @ts-ignore
export function useGetScheduleOfInvestmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>;
export function useGetScheduleOfInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetScheduleOfInvestmentsQuery | undefined, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>;
export function useGetScheduleOfInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>(GetScheduleOfInvestmentsDocument, options);
        }
export type GetScheduleOfInvestmentsQueryHookResult = ReturnType<typeof useGetScheduleOfInvestmentsQuery>;
export type GetScheduleOfInvestmentsLazyQueryHookResult = ReturnType<typeof useGetScheduleOfInvestmentsLazyQuery>;
export type GetScheduleOfInvestmentsSuspenseQueryHookResult = ReturnType<typeof useGetScheduleOfInvestmentsSuspenseQuery>;
export type GetScheduleOfInvestmentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetScheduleOfInvestmentsQuery, GraphqlTypes.GetScheduleOfInvestmentsQueryVariables>;
export const SetAnnouncementReadStatusDocument = gql`
    mutation setAnnouncementReadStatus($announcementIds: [Int!]!, $readStatus: AnnouncementReadStatus!) {
  setAnnouncementReadStatus(
    announcementIds: $announcementIds
    readStatus: $readStatus
  )
}
    `;
export type SetAnnouncementReadStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.SetAnnouncementReadStatusMutation, GraphqlTypes.SetAnnouncementReadStatusMutationVariables>;

/**
 * __useSetAnnouncementReadStatusMutation__
 *
 * To run a mutation, you first call `useSetAnnouncementReadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAnnouncementReadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAnnouncementReadStatusMutation, { data, loading, error }] = useSetAnnouncementReadStatusMutation({
 *   variables: {
 *      announcementIds: // value for 'announcementIds'
 *      readStatus: // value for 'readStatus'
 *   },
 * });
 */
export function useSetAnnouncementReadStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetAnnouncementReadStatusMutation, GraphqlTypes.SetAnnouncementReadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetAnnouncementReadStatusMutation, GraphqlTypes.SetAnnouncementReadStatusMutationVariables>(SetAnnouncementReadStatusDocument, options);
      }
export type SetAnnouncementReadStatusMutationHookResult = ReturnType<typeof useSetAnnouncementReadStatusMutation>;
export type SetAnnouncementReadStatusMutationResult = Apollo.MutationResult<GraphqlTypes.SetAnnouncementReadStatusMutation>;
export type SetAnnouncementReadStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetAnnouncementReadStatusMutation, GraphqlTypes.SetAnnouncementReadStatusMutationVariables>;
export const SetAllAnnouncementReadStatusDocument = gql`
    mutation setAllAnnouncementReadStatus($arenaId: GlobalID!, $readStatus: AnnouncementReadStatus!) {
  setAllAnnouncementReadStatus(arenaId: $arenaId, readStatus: $readStatus)
}
    `;
export type SetAllAnnouncementReadStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.SetAllAnnouncementReadStatusMutation, GraphqlTypes.SetAllAnnouncementReadStatusMutationVariables>;

/**
 * __useSetAllAnnouncementReadStatusMutation__
 *
 * To run a mutation, you first call `useSetAllAnnouncementReadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAllAnnouncementReadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAllAnnouncementReadStatusMutation, { data, loading, error }] = useSetAllAnnouncementReadStatusMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      readStatus: // value for 'readStatus'
 *   },
 * });
 */
export function useSetAllAnnouncementReadStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetAllAnnouncementReadStatusMutation, GraphqlTypes.SetAllAnnouncementReadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetAllAnnouncementReadStatusMutation, GraphqlTypes.SetAllAnnouncementReadStatusMutationVariables>(SetAllAnnouncementReadStatusDocument, options);
      }
export type SetAllAnnouncementReadStatusMutationHookResult = ReturnType<typeof useSetAllAnnouncementReadStatusMutation>;
export type SetAllAnnouncementReadStatusMutationResult = Apollo.MutationResult<GraphqlTypes.SetAllAnnouncementReadStatusMutation>;
export type SetAllAnnouncementReadStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetAllAnnouncementReadStatusMutation, GraphqlTypes.SetAllAnnouncementReadStatusMutationVariables>;
export const GetEntitiesForGridDocument = gql`
    query getEntitiesForGrid($postId: Int) {
  entitiesGrid(postId: $postId) {
    rows {
      id
      name
      entityCollection
      positionCount
      isShared
    }
    totalCount
  }
}
    `;

/**
 * __useGetEntitiesForGridQuery__
 *
 * To run a query within a React component, call `useGetEntitiesForGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesForGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesForGridQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetEntitiesForGridQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>(GetEntitiesForGridDocument, options);
      }
export function useGetEntitiesForGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>(GetEntitiesForGridDocument, options);
        }
// @ts-ignore
export function useGetEntitiesForGridSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>;
export function useGetEntitiesForGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesForGridQuery | undefined, GraphqlTypes.GetEntitiesForGridQueryVariables>;
export function useGetEntitiesForGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>(GetEntitiesForGridDocument, options);
        }
export type GetEntitiesForGridQueryHookResult = ReturnType<typeof useGetEntitiesForGridQuery>;
export type GetEntitiesForGridLazyQueryHookResult = ReturnType<typeof useGetEntitiesForGridLazyQuery>;
export type GetEntitiesForGridSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesForGridSuspenseQuery>;
export type GetEntitiesForGridQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesForGridQuery, GraphqlTypes.GetEntitiesForGridQueryVariables>;
export const GetPostsForGridDocument = gql`
    query GetPostsForGrid($limit: Int, $offset: Int, $objectId: String, $objectType: Int, $sort: [String!], $postFilter: PostFilterInput) {
  postsPageGrid(
    limit: $limit
    offset: $offset
    objectId: $objectId
    objectType: $objectType
    sort: $sort
    postFilter: $postFilter
  ) {
    rows {
      id
      title
      publishingDate
      topic
      status
      entities {
        id
        name
      }
      views
    }
    filteredCount
    totalCount
  }
}
    `;

/**
 * __useGetPostsForGridQuery__
 *
 * To run a query within a React component, call `useGetPostsForGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsForGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsForGridQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      objectId: // value for 'objectId'
 *      objectType: // value for 'objectType'
 *      sort: // value for 'sort'
 *      postFilter: // value for 'postFilter'
 *   },
 * });
 */
export function useGetPostsForGridQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>(GetPostsForGridDocument, options);
      }
export function useGetPostsForGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>(GetPostsForGridDocument, options);
        }
// @ts-ignore
export function useGetPostsForGridSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>;
export function useGetPostsForGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostsForGridQuery | undefined, GraphqlTypes.GetPostsForGridQueryVariables>;
export function useGetPostsForGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>(GetPostsForGridDocument, options);
        }
export type GetPostsForGridQueryHookResult = ReturnType<typeof useGetPostsForGridQuery>;
export type GetPostsForGridLazyQueryHookResult = ReturnType<typeof useGetPostsForGridLazyQuery>;
export type GetPostsForGridSuspenseQueryHookResult = ReturnType<typeof useGetPostsForGridSuspenseQuery>;
export type GetPostsForGridQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostsForGridQuery, GraphqlTypes.GetPostsForGridQueryVariables>;
export const GetPostTopicsDocument = gql`
    query GetPostTopics($objectId: String) {
  postTopics(objectId: $objectId)
}
    `;

/**
 * __useGetPostTopicsQuery__
 *
 * To run a query within a React component, call `useGetPostTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostTopicsQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetPostTopicsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>(GetPostTopicsDocument, options);
      }
export function useGetPostTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>(GetPostTopicsDocument, options);
        }
// @ts-ignore
export function useGetPostTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>;
export function useGetPostTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostTopicsQuery | undefined, GraphqlTypes.GetPostTopicsQueryVariables>;
export function useGetPostTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>(GetPostTopicsDocument, options);
        }
export type GetPostTopicsQueryHookResult = ReturnType<typeof useGetPostTopicsQuery>;
export type GetPostTopicsLazyQueryHookResult = ReturnType<typeof useGetPostTopicsLazyQuery>;
export type GetPostTopicsSuspenseQueryHookResult = ReturnType<typeof useGetPostTopicsSuspenseQuery>;
export type GetPostTopicsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostTopicsQuery, GraphqlTypes.GetPostTopicsQueryVariables>;
export const GetPostEntitiesDocument = gql`
    query GetPostEntities($objectId: String) {
  postEntities(objectId: $objectId) {
    id
    name
  }
}
    `;

/**
 * __useGetPostEntitiesQuery__
 *
 * To run a query within a React component, call `useGetPostEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostEntitiesQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useGetPostEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>(GetPostEntitiesDocument, options);
      }
export function useGetPostEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>(GetPostEntitiesDocument, options);
        }
// @ts-ignore
export function useGetPostEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>;
export function useGetPostEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostEntitiesQuery | undefined, GraphqlTypes.GetPostEntitiesQueryVariables>;
export function useGetPostEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>(GetPostEntitiesDocument, options);
        }
export type GetPostEntitiesQueryHookResult = ReturnType<typeof useGetPostEntitiesQuery>;
export type GetPostEntitiesLazyQueryHookResult = ReturnType<typeof useGetPostEntitiesLazyQuery>;
export type GetPostEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetPostEntitiesSuspenseQuery>;
export type GetPostEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostEntitiesQuery, GraphqlTypes.GetPostEntitiesQueryVariables>;
export const UpsertPostDocument = gql`
    mutation upsertPost($objectInput: UpsertPostInput!) {
  upsertPost(objectInput: $objectInput) {
    ... on PostObjectType {
      id
      title
      subtitle
      topic
      publishingDate
      status
      featuredImageUrl
      primaryMediaUrl
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UpsertPostMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertPostMutation, GraphqlTypes.UpsertPostMutationVariables>;

/**
 * __useUpsertPostMutation__
 *
 * To run a mutation, you first call `useUpsertPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPostMutation, { data, loading, error }] = useUpsertPostMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpsertPostMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertPostMutation, GraphqlTypes.UpsertPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertPostMutation, GraphqlTypes.UpsertPostMutationVariables>(UpsertPostDocument, options);
      }
export type UpsertPostMutationHookResult = ReturnType<typeof useUpsertPostMutation>;
export type UpsertPostMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertPostMutation>;
export type UpsertPostMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertPostMutation, GraphqlTypes.UpsertPostMutationVariables>;
export const SharePostDocument = gql`
    mutation sharePost($objectInput: UpdatePostSharingInput!) {
  updatePostSharing(objectInput: $objectInput) {
    ... on PostObjectType {
      id
      title
      subtitle
      topic
      publishingDate
      status
      sharedEntities {
        edges {
          node {
            id
            name
          }
        }
      }
      featuredImageUrl
      primaryMediaUrl
      sharingSettings {
        permsAllPositions
        permsAllPosActiveOnly
        permsAllPosDirectOnly
        permsAllPosStartDate
        permsAllPosEndDate
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SharePostMutationFn = Apollo.MutationFunction<GraphqlTypes.SharePostMutation, GraphqlTypes.SharePostMutationVariables>;

/**
 * __useSharePostMutation__
 *
 * To run a mutation, you first call `useSharePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePostMutation, { data, loading, error }] = useSharePostMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useSharePostMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SharePostMutation, GraphqlTypes.SharePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SharePostMutation, GraphqlTypes.SharePostMutationVariables>(SharePostDocument, options);
      }
export type SharePostMutationHookResult = ReturnType<typeof useSharePostMutation>;
export type SharePostMutationResult = Apollo.MutationResult<GraphqlTypes.SharePostMutation>;
export type SharePostMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SharePostMutation, GraphqlTypes.SharePostMutationVariables>;
export const BulkUpdatePostSharingDocument = gql`
    mutation bulkUpdatePostSharing($objectInput: BulkUpdatePostSharingInput!) {
  bulkUpdatePostSharing(objectInput: $objectInput) {
    ... on AsyncJobObjectType {
      id
      jobType
      status
      startTime
      endTime
      data
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type BulkUpdatePostSharingMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkUpdatePostSharingMutation, GraphqlTypes.BulkUpdatePostSharingMutationVariables>;

/**
 * __useBulkUpdatePostSharingMutation__
 *
 * To run a mutation, you first call `useBulkUpdatePostSharingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdatePostSharingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdatePostSharingMutation, { data, loading, error }] = useBulkUpdatePostSharingMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useBulkUpdatePostSharingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkUpdatePostSharingMutation, GraphqlTypes.BulkUpdatePostSharingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkUpdatePostSharingMutation, GraphqlTypes.BulkUpdatePostSharingMutationVariables>(BulkUpdatePostSharingDocument, options);
      }
export type BulkUpdatePostSharingMutationHookResult = ReturnType<typeof useBulkUpdatePostSharingMutation>;
export type BulkUpdatePostSharingMutationResult = Apollo.MutationResult<GraphqlTypes.BulkUpdatePostSharingMutation>;
export type BulkUpdatePostSharingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkUpdatePostSharingMutation, GraphqlTypes.BulkUpdatePostSharingMutationVariables>;
export const UpdatePostStatusDocument = gql`
    mutation updatePostStatus($postId: ID!, $status: PostStatus!) {
  updatePostStatus(postId: $postId, status: $status) {
    ... on PostObjectType {
      id
      status
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UpdatePostStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePostStatusMutation, GraphqlTypes.UpdatePostStatusMutationVariables>;

/**
 * __useUpdatePostStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePostStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostStatusMutation, { data, loading, error }] = useUpdatePostStatusMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdatePostStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePostStatusMutation, GraphqlTypes.UpdatePostStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePostStatusMutation, GraphqlTypes.UpdatePostStatusMutationVariables>(UpdatePostStatusDocument, options);
      }
export type UpdatePostStatusMutationHookResult = ReturnType<typeof useUpdatePostStatusMutation>;
export type UpdatePostStatusMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePostStatusMutation>;
export type UpdatePostStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePostStatusMutation, GraphqlTypes.UpdatePostStatusMutationVariables>;
export const DeletePostDocument = gql`
    mutation deletePost($postId: ID!) {
  deletePost(postId: $postId) {
    ... on PostObjectType {
      id
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<GraphqlTypes.DeletePostMutation, GraphqlTypes.DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeletePostMutation, GraphqlTypes.DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeletePostMutation, GraphqlTypes.DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<GraphqlTypes.DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeletePostMutation, GraphqlTypes.DeletePostMutationVariables>;
export const UndeletePostDocument = gql`
    mutation undeletePost($postId: ID!) {
  undeletePost(postId: $postId) {
    ... on PostObjectType {
      id
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UndeletePostMutationFn = Apollo.MutationFunction<GraphqlTypes.UndeletePostMutation, GraphqlTypes.UndeletePostMutationVariables>;

/**
 * __useUndeletePostMutation__
 *
 * To run a mutation, you first call `useUndeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeletePostMutation, { data, loading, error }] = useUndeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useUndeletePostMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UndeletePostMutation, GraphqlTypes.UndeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UndeletePostMutation, GraphqlTypes.UndeletePostMutationVariables>(UndeletePostDocument, options);
      }
export type UndeletePostMutationHookResult = ReturnType<typeof useUndeletePostMutation>;
export type UndeletePostMutationResult = Apollo.MutationResult<GraphqlTypes.UndeletePostMutation>;
export type UndeletePostMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UndeletePostMutation, GraphqlTypes.UndeletePostMutationVariables>;
export const GetPostByIdDocument = gql`
    query getPostByID($postId: Int!, $includeDeleted: Boolean) {
  post(postId: $postId, includeDeleted: $includeDeleted) {
    id
    title
    subtitle
    topic
    publishingDate
    status
    featuredImageUrl
    headerImageUrl
    primaryMediaUrl
    contentText
    contentHtml
    headerBgColorHexCode
    author
    totalViews
    uniqueViews
    titleFontHexCode
    modifiedAt
    createdAt
    isNotDeleted
    engagements {
      edges {
        node {
          id
          firstViewed
          lastViewed
          numberOfViews
          hasContactAccess
          user {
            id
            fullName
            contact {
              id
            }
          }
        }
      }
    }
    sharedEntities {
      edges {
        node {
          id
          name
        }
      }
    }
    relatedEntitiesWithPermissions {
      objectId
      objectType
      objectName
      hasPermission
    }
    sharingSettings {
      permsAllPositions
      permsAllPosActiveOnly
      permsAllPosDirectOnly
      permsAllPosStartDate
      permsAllPosEndDate
    }
  }
}
    `;

/**
 * __useGetPostByIdQuery__
 *
 * To run a query within a React component, call `useGetPostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useGetPostByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables> & ({ variables: GraphqlTypes.GetPostByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
      }
export function useGetPostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
// @ts-ignore
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>;
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostByIdQuery | undefined, GraphqlTypes.GetPostByIdQueryVariables>;
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
export type GetPostByIdQueryHookResult = ReturnType<typeof useGetPostByIdQuery>;
export type GetPostByIdLazyQueryHookResult = ReturnType<typeof useGetPostByIdLazyQuery>;
export type GetPostByIdSuspenseQueryHookResult = ReturnType<typeof useGetPostByIdSuspenseQuery>;
export type GetPostByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostByIdQuery, GraphqlTypes.GetPostByIdQueryVariables>;
export const GetPostsDocument = gql`
    query getPosts($limit: Int, $offset: Int, $entityId: Int, $permsAllPos: Boolean) {
  posts(
    limit: $limit
    offset: $offset
    entityId: $entityId
    permsAllPos: $permsAllPos
  ) {
    id
    title
    subtitle
    topic
    publishingDate
    status
    sharedEntities {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPostsQuery__
 *
 * To run a query within a React component, call `useGetPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      entityId: // value for 'entityId'
 *      permsAllPos: // value for 'permsAllPos'
 *   },
 * });
 */
export function useGetPostsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>(GetPostsDocument, options);
      }
export function useGetPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>(GetPostsDocument, options);
        }
// @ts-ignore
export function useGetPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>;
export function useGetPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostsQuery | undefined, GraphqlTypes.GetPostsQueryVariables>;
export function useGetPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>(GetPostsDocument, options);
        }
export type GetPostsQueryHookResult = ReturnType<typeof useGetPostsQuery>;
export type GetPostsLazyQueryHookResult = ReturnType<typeof useGetPostsLazyQuery>;
export type GetPostsSuspenseQueryHookResult = ReturnType<typeof useGetPostsSuspenseQuery>;
export type GetPostsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostsQuery, GraphqlTypes.GetPostsQueryVariables>;
export const GetPostSharesDocument = gql`
    query getPostShares($postId: ID!, $includeDeleted: Boolean) {
  getPostShares(postId: $postId, includeDeleted: $includeDeleted) {
    objectId
    objectType
    objectName
    hasPermission
    totalViews
    positions {
      positionId
      positionName
      hasPermission
      totalViews
      contacts {
        contactId
        contactName
        hasPermission
      }
    }
  }
}
    `;

/**
 * __useGetPostSharesQuery__
 *
 * To run a query within a React component, call `useGetPostSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostSharesQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useGetPostSharesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables> & ({ variables: GraphqlTypes.GetPostSharesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>(GetPostSharesDocument, options);
      }
export function useGetPostSharesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>(GetPostSharesDocument, options);
        }
// @ts-ignore
export function useGetPostSharesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>;
export function useGetPostSharesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPostSharesQuery | undefined, GraphqlTypes.GetPostSharesQueryVariables>;
export function useGetPostSharesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>(GetPostSharesDocument, options);
        }
export type GetPostSharesQueryHookResult = ReturnType<typeof useGetPostSharesQuery>;
export type GetPostSharesLazyQueryHookResult = ReturnType<typeof useGetPostSharesLazyQuery>;
export type GetPostSharesSuspenseQueryHookResult = ReturnType<typeof useGetPostSharesSuspenseQuery>;
export type GetPostSharesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPostSharesQuery, GraphqlTypes.GetPostSharesQueryVariables>;
export const GetDynamicSupportingDocumentsBySubscriptionIdDocument = gql`
    query GetDynamicSupportingDocumentsBySubscriptionId($subscriptionId: ID!) {
  subscriptionById(subscriptionId: $subscriptionId) {
    id
    supportingDocumentsResponses {
      ...DynamicSupportingDocLpResponseFields
    }
  }
}
    ${DynamicSupportingDocLpResponseFieldsFragmentDoc}`;

/**
 * __useGetDynamicSupportingDocumentsBySubscriptionIdQuery__
 *
 * To run a query within a React component, call `useGetDynamicSupportingDocumentsBySubscriptionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicSupportingDocumentsBySubscriptionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicSupportingDocumentsBySubscriptionIdQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useGetDynamicSupportingDocumentsBySubscriptionIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables> & ({ variables: GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>(GetDynamicSupportingDocumentsBySubscriptionIdDocument, options);
      }
export function useGetDynamicSupportingDocumentsBySubscriptionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>(GetDynamicSupportingDocumentsBySubscriptionIdDocument, options);
        }
// @ts-ignore
export function useGetDynamicSupportingDocumentsBySubscriptionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>;
export function useGetDynamicSupportingDocumentsBySubscriptionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery | undefined, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>;
export function useGetDynamicSupportingDocumentsBySubscriptionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>(GetDynamicSupportingDocumentsBySubscriptionIdDocument, options);
        }
export type GetDynamicSupportingDocumentsBySubscriptionIdQueryHookResult = ReturnType<typeof useGetDynamicSupportingDocumentsBySubscriptionIdQuery>;
export type GetDynamicSupportingDocumentsBySubscriptionIdLazyQueryHookResult = ReturnType<typeof useGetDynamicSupportingDocumentsBySubscriptionIdLazyQuery>;
export type GetDynamicSupportingDocumentsBySubscriptionIdSuspenseQueryHookResult = ReturnType<typeof useGetDynamicSupportingDocumentsBySubscriptionIdSuspenseQuery>;
export type GetDynamicSupportingDocumentsBySubscriptionIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQuery, GraphqlTypes.GetDynamicSupportingDocumentsBySubscriptionIdQueryVariables>;
export const DownloadDashboardDocument = gql`
    mutation DownloadDashboard($input: DownloadDashboardInput!) {
  downloadDashboard(objectInput: $input)
}
    `;
export type DownloadDashboardMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadDashboardMutation, GraphqlTypes.DownloadDashboardMutationVariables>;

/**
 * __useDownloadDashboardMutation__
 *
 * To run a mutation, you first call `useDownloadDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDashboardMutation, { data, loading, error }] = useDownloadDashboardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadDashboardMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadDashboardMutation, GraphqlTypes.DownloadDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadDashboardMutation, GraphqlTypes.DownloadDashboardMutationVariables>(DownloadDashboardDocument, options);
      }
export type DownloadDashboardMutationHookResult = ReturnType<typeof useDownloadDashboardMutation>;
export type DownloadDashboardMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadDashboardMutation>;
export type DownloadDashboardMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadDashboardMutation, GraphqlTypes.DownloadDashboardMutationVariables>;
export const DismissExportBannerDocument = gql`
    mutation DismissExportBanner($input: DismissDashboardExportBannerInput!) {
  dismissDashboardExportBanner(objectInput: $input) {
    id
    bannerDismissed
  }
}
    `;
export type DismissExportBannerMutationFn = Apollo.MutationFunction<GraphqlTypes.DismissExportBannerMutation, GraphqlTypes.DismissExportBannerMutationVariables>;

/**
 * __useDismissExportBannerMutation__
 *
 * To run a mutation, you first call `useDismissExportBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissExportBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissExportBannerMutation, { data, loading, error }] = useDismissExportBannerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissExportBannerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DismissExportBannerMutation, GraphqlTypes.DismissExportBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DismissExportBannerMutation, GraphqlTypes.DismissExportBannerMutationVariables>(DismissExportBannerDocument, options);
      }
export type DismissExportBannerMutationHookResult = ReturnType<typeof useDismissExportBannerMutation>;
export type DismissExportBannerMutationResult = Apollo.MutationResult<GraphqlTypes.DismissExportBannerMutation>;
export type DismissExportBannerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DismissExportBannerMutation, GraphqlTypes.DismissExportBannerMutationVariables>;
export const GenerateExportDownloadUrlDocument = gql`
    mutation GenerateExportDownloadUrl($input: GenerateExportDownloadUrlInput!) {
  generateExportDownloadUrl(objectInput: $input)
}
    `;
export type GenerateExportDownloadUrlMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateExportDownloadUrlMutation, GraphqlTypes.GenerateExportDownloadUrlMutationVariables>;

/**
 * __useGenerateExportDownloadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateExportDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateExportDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateExportDownloadUrlMutation, { data, loading, error }] = useGenerateExportDownloadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateExportDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateExportDownloadUrlMutation, GraphqlTypes.GenerateExportDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateExportDownloadUrlMutation, GraphqlTypes.GenerateExportDownloadUrlMutationVariables>(GenerateExportDownloadUrlDocument, options);
      }
export type GenerateExportDownloadUrlMutationHookResult = ReturnType<typeof useGenerateExportDownloadUrlMutation>;
export type GenerateExportDownloadUrlMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateExportDownloadUrlMutation>;
export type GenerateExportDownloadUrlMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateExportDownloadUrlMutation, GraphqlTypes.GenerateExportDownloadUrlMutationVariables>;
export const GetReportingDashboardsDocument = gql`
    query GetReportingDashboards($objectInput: GetGroupedDashboardsInput!) {
  getGroupedDashboards(objectInput: $objectInput) {
    createdByYou {
      id
      name
      createdAt
      shareType
      modifiedAt
      createdBy
    }
    sharedWithYou {
      id
      name
      createdAt
      shareType
      modifiedAt
      createdBy
    }
    systemDefaults {
      id
      name
      createdAt
      shareType
      modifiedAt
      createdBy
    }
  }
}
    `;

/**
 * __useGetReportingDashboardsQuery__
 *
 * To run a query within a React component, call `useGetReportingDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingDashboardsQuery({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useGetReportingDashboardsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables> & ({ variables: GraphqlTypes.GetReportingDashboardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>(GetReportingDashboardsDocument, options);
      }
export function useGetReportingDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>(GetReportingDashboardsDocument, options);
        }
// @ts-ignore
export function useGetReportingDashboardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>;
export function useGetReportingDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportingDashboardsQuery | undefined, GraphqlTypes.GetReportingDashboardsQueryVariables>;
export function useGetReportingDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>(GetReportingDashboardsDocument, options);
        }
export type GetReportingDashboardsQueryHookResult = ReturnType<typeof useGetReportingDashboardsQuery>;
export type GetReportingDashboardsLazyQueryHookResult = ReturnType<typeof useGetReportingDashboardsLazyQuery>;
export type GetReportingDashboardsSuspenseQueryHookResult = ReturnType<typeof useGetReportingDashboardsSuspenseQuery>;
export type GetReportingDashboardsQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportingDashboardsQuery, GraphqlTypes.GetReportingDashboardsQueryVariables>;
export const GetExportsJobsDocument = gql`
    query GetExportsJobs($objectInput: GetDashboardExportJobsInput!) {
  getDashboardExportJobs(objectInput: $objectInput) {
    id
    status
    exportType
    s3ObjectKey
    bannerDismissed
    createdAt
    dashboardName
    completedAt
  }
}
    `;

/**
 * __useGetExportsJobsQuery__
 *
 * To run a query within a React component, call `useGetExportsJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportsJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportsJobsQuery({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useGetExportsJobsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables> & ({ variables: GraphqlTypes.GetExportsJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>(GetExportsJobsDocument, options);
      }
export function useGetExportsJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>(GetExportsJobsDocument, options);
        }
// @ts-ignore
export function useGetExportsJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>;
export function useGetExportsJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExportsJobsQuery | undefined, GraphqlTypes.GetExportsJobsQueryVariables>;
export function useGetExportsJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>(GetExportsJobsDocument, options);
        }
export type GetExportsJobsQueryHookResult = ReturnType<typeof useGetExportsJobsQuery>;
export type GetExportsJobsLazyQueryHookResult = ReturnType<typeof useGetExportsJobsLazyQuery>;
export type GetExportsJobsSuspenseQueryHookResult = ReturnType<typeof useGetExportsJobsSuspenseQuery>;
export type GetExportsJobsQueryResult = Apollo.QueryResult<GraphqlTypes.GetExportsJobsQuery, GraphqlTypes.GetExportsJobsQueryVariables>;
export const GetComplianceIndustriesDocument = gql`
    query GetComplianceIndustries {
  complianceIndustries {
    id
    name
  }
}
    `;

/**
 * __useGetComplianceIndustriesQuery__
 *
 * To run a query within a React component, call `useGetComplianceIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetComplianceIndustriesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>(GetComplianceIndustriesDocument, options);
      }
export function useGetComplianceIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>(GetComplianceIndustriesDocument, options);
        }
// @ts-ignore
export function useGetComplianceIndustriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>;
export function useGetComplianceIndustriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceIndustriesQuery | undefined, GraphqlTypes.GetComplianceIndustriesQueryVariables>;
export function useGetComplianceIndustriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>(GetComplianceIndustriesDocument, options);
        }
export type GetComplianceIndustriesQueryHookResult = ReturnType<typeof useGetComplianceIndustriesQuery>;
export type GetComplianceIndustriesLazyQueryHookResult = ReturnType<typeof useGetComplianceIndustriesLazyQuery>;
export type GetComplianceIndustriesSuspenseQueryHookResult = ReturnType<typeof useGetComplianceIndustriesSuspenseQuery>;
export type GetComplianceIndustriesQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceIndustriesQuery, GraphqlTypes.GetComplianceIndustriesQueryVariables>;
export const GetContactPieChartDataDocument = gql`
    query GetContactPieChartData($contactId: ID!, $chartType: ChartWidgetTypeEnum!, $chartIndex: Int, $dimension: String, $measure: String, $entityStatus: PortalPieChartEntityStatusEnum) {
  contactPieChartData(
    contactId: $contactId
    chartType: $chartType
    chartIndex: $chartIndex
    dimension: $dimension
    measure: $measure
    entityStatus: $entityStatus
  ) {
    chartIndex
    slices {
      name
      x
      y
    }
  }
}
    `;

/**
 * __useGetContactPieChartDataQuery__
 *
 * To run a query within a React component, call `useGetContactPieChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactPieChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactPieChartDataQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      chartType: // value for 'chartType'
 *      chartIndex: // value for 'chartIndex'
 *      dimension: // value for 'dimension'
 *      measure: // value for 'measure'
 *      entityStatus: // value for 'entityStatus'
 *   },
 * });
 */
export function useGetContactPieChartDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables> & ({ variables: GraphqlTypes.GetContactPieChartDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>(GetContactPieChartDataDocument, options);
      }
export function useGetContactPieChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>(GetContactPieChartDataDocument, options);
        }
// @ts-ignore
export function useGetContactPieChartDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>;
export function useGetContactPieChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactPieChartDataQuery | undefined, GraphqlTypes.GetContactPieChartDataQueryVariables>;
export function useGetContactPieChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>(GetContactPieChartDataDocument, options);
        }
export type GetContactPieChartDataQueryHookResult = ReturnType<typeof useGetContactPieChartDataQuery>;
export type GetContactPieChartDataLazyQueryHookResult = ReturnType<typeof useGetContactPieChartDataLazyQuery>;
export type GetContactPieChartDataSuspenseQueryHookResult = ReturnType<typeof useGetContactPieChartDataSuspenseQuery>;
export type GetContactPieChartDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactPieChartDataQuery, GraphqlTypes.GetContactPieChartDataQueryVariables>;
export const UpsertPortalChartDocument = gql`
    mutation UpsertPortalChart($input: UpsertPortalChartInput!) {
  upsertPortalChart(input: $input) {
    ... on PortalChartObjectType {
      id
      title
      isTitleVisible
      filterVisibility
      allowFilterVisibility
      numberOfCharts
      createdAt
      modifiedAt
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpsertPortalChartMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertPortalChartMutation, GraphqlTypes.UpsertPortalChartMutationVariables>;

/**
 * __useUpsertPortalChartMutation__
 *
 * To run a mutation, you first call `useUpsertPortalChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortalChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortalChartMutation, { data, loading, error }] = useUpsertPortalChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPortalChartMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertPortalChartMutation, GraphqlTypes.UpsertPortalChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertPortalChartMutation, GraphqlTypes.UpsertPortalChartMutationVariables>(UpsertPortalChartDocument, options);
      }
export type UpsertPortalChartMutationHookResult = ReturnType<typeof useUpsertPortalChartMutation>;
export type UpsertPortalChartMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertPortalChartMutation>;
export type UpsertPortalChartMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertPortalChartMutation, GraphqlTypes.UpsertPortalChartMutationVariables>;
export const GetPortalChartDocument = gql`
    query GetPortalChart($arenaId: ID!) {
  portalChart(arenaId: $arenaId) {
    title
    isTitleVisible
    filterVisibility
    allowFilterVisibility
    numberOfCharts
  }
}
    `;

/**
 * __useGetPortalChartQuery__
 *
 * To run a query within a React component, call `useGetPortalChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalChartQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetPortalChartQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables> & ({ variables: GraphqlTypes.GetPortalChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>(GetPortalChartDocument, options);
      }
export function useGetPortalChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>(GetPortalChartDocument, options);
        }
// @ts-ignore
export function useGetPortalChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>;
export function useGetPortalChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalChartQuery | undefined, GraphqlTypes.GetPortalChartQueryVariables>;
export function useGetPortalChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>(GetPortalChartDocument, options);
        }
export type GetPortalChartQueryHookResult = ReturnType<typeof useGetPortalChartQuery>;
export type GetPortalChartLazyQueryHookResult = ReturnType<typeof useGetPortalChartLazyQuery>;
export type GetPortalChartSuspenseQueryHookResult = ReturnType<typeof useGetPortalChartSuspenseQuery>;
export type GetPortalChartQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalChartQuery, GraphqlTypes.GetPortalChartQueryVariables>;
export const UpsertPortalChartWidgetConfigDocument = gql`
    mutation UpsertPortalChartWidgetConfig($input: UpsertPortalChartWidgetConfigInput!) {
  upsertPortalChartWidgetConfig(input: $input) {
    ... on PortalChartWidgetConfigObjectType {
      id
      chartType
      chartIndex
      title
      isTitleVisible
      dimensions
      measure
      createdAt
      modifiedAt
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type UpsertPortalChartWidgetConfigMutationFn = Apollo.MutationFunction<GraphqlTypes.UpsertPortalChartWidgetConfigMutation, GraphqlTypes.UpsertPortalChartWidgetConfigMutationVariables>;

/**
 * __useUpsertPortalChartWidgetConfigMutation__
 *
 * To run a mutation, you first call `useUpsertPortalChartWidgetConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortalChartWidgetConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortalChartWidgetConfigMutation, { data, loading, error }] = useUpsertPortalChartWidgetConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPortalChartWidgetConfigMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpsertPortalChartWidgetConfigMutation, GraphqlTypes.UpsertPortalChartWidgetConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpsertPortalChartWidgetConfigMutation, GraphqlTypes.UpsertPortalChartWidgetConfigMutationVariables>(UpsertPortalChartWidgetConfigDocument, options);
      }
export type UpsertPortalChartWidgetConfigMutationHookResult = ReturnType<typeof useUpsertPortalChartWidgetConfigMutation>;
export type UpsertPortalChartWidgetConfigMutationResult = Apollo.MutationResult<GraphqlTypes.UpsertPortalChartWidgetConfigMutation>;
export type UpsertPortalChartWidgetConfigMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpsertPortalChartWidgetConfigMutation, GraphqlTypes.UpsertPortalChartWidgetConfigMutationVariables>;
export const GetPortalChartWidgetConfigDocument = gql`
    query GetPortalChartWidgetConfig($arenaId: ID!, $chartType: ChartWidgetTypeEnum!) {
  portalChartWidgetConfig(arenaId: $arenaId, chartType: $chartType) {
    chartIndex
    title
    isTitleVisible
    dimensions
    measure
  }
}
    `;

/**
 * __useGetPortalChartWidgetConfigQuery__
 *
 * To run a query within a React component, call `useGetPortalChartWidgetConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalChartWidgetConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalChartWidgetConfigQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      chartType: // value for 'chartType'
 *   },
 * });
 */
export function useGetPortalChartWidgetConfigQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables> & ({ variables: GraphqlTypes.GetPortalChartWidgetConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>(GetPortalChartWidgetConfigDocument, options);
      }
export function useGetPortalChartWidgetConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>(GetPortalChartWidgetConfigDocument, options);
        }
// @ts-ignore
export function useGetPortalChartWidgetConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>;
export function useGetPortalChartWidgetConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPortalChartWidgetConfigQuery | undefined, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>;
export function useGetPortalChartWidgetConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>(GetPortalChartWidgetConfigDocument, options);
        }
export type GetPortalChartWidgetConfigQueryHookResult = ReturnType<typeof useGetPortalChartWidgetConfigQuery>;
export type GetPortalChartWidgetConfigLazyQueryHookResult = ReturnType<typeof useGetPortalChartWidgetConfigLazyQuery>;
export type GetPortalChartWidgetConfigSuspenseQueryHookResult = ReturnType<typeof useGetPortalChartWidgetConfigSuspenseQuery>;
export type GetPortalChartWidgetConfigQueryResult = Apollo.QueryResult<GraphqlTypes.GetPortalChartWidgetConfigQuery, GraphqlTypes.GetPortalChartWidgetConfigQueryVariables>;
export const GenerateCompliancePresignedUrlsDocument = gql`
    mutation GenerateCompliancePresignedUrls($urlGeneratorInput: [CompliancePresignedUrlInput!]!) {
  complianceGeneratePresignedUrls(urlGeneratorInput: $urlGeneratorInput) {
    s3Url
    objectKey
    fileName
  }
}
    `;
export type GenerateCompliancePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateCompliancePresignedUrlsMutation, GraphqlTypes.GenerateCompliancePresignedUrlsMutationVariables>;

/**
 * __useGenerateCompliancePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useGenerateCompliancePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCompliancePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCompliancePresignedUrlsMutation, { data, loading, error }] = useGenerateCompliancePresignedUrlsMutation({
 *   variables: {
 *      urlGeneratorInput: // value for 'urlGeneratorInput'
 *   },
 * });
 */
export function useGenerateCompliancePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateCompliancePresignedUrlsMutation, GraphqlTypes.GenerateCompliancePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateCompliancePresignedUrlsMutation, GraphqlTypes.GenerateCompliancePresignedUrlsMutationVariables>(GenerateCompliancePresignedUrlsDocument, options);
      }
export type GenerateCompliancePresignedUrlsMutationHookResult = ReturnType<typeof useGenerateCompliancePresignedUrlsMutation>;
export type GenerateCompliancePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateCompliancePresignedUrlsMutation>;
export type GenerateCompliancePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateCompliancePresignedUrlsMutation, GraphqlTypes.GenerateCompliancePresignedUrlsMutationVariables>;